/* eslint-disable */
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  EmailAddress: { input: any; output: any }
  GUID: { input: any; output: any }
  HTML: { input: any; output: any }
  JSON: { input: any; output: any }
}

export type ActionAutomationFlowConfiguration = {
  __typename: 'ActionAutomationFlowConfiguration'
  mutation: Scalars['String']['output']
  mutation_function_call?: Maybe<Scalars['String']['output']>
  mutation_name?: Maybe<Scalars['String']['output']>
}

export enum AddonType {
  /** Gives free unlocks */
  free_unlocks = 'free_unlocks',
}

export type ArchiveJob = {
  __typename: 'ArchiveJob'
  details: ArchiveJobDetails
  sys_id: Scalars['ID']['output']
  timestamps: JobTimestamps
  uuid: Scalars['ID']['output']
}

export type ArchiveJobConnection = IConnection & {
  __typename: 'ArchiveJobConnection'
  nodes: Array<ArchiveJob>
  pagination: Pagination
}

export type ArchiveJobDetails = {
  __typename: 'ArchiveJobDetails'
  assignee?: Maybe<User>
  isJustified: Scalars['Boolean']['output']
  notes?: Maybe<Scalars['String']['output']>
  scheme?: Maybe<Scheme>
  status: JobStatusEnum
  taskId: Scalars['ID']['output']
}

export type Asset = {
  __typename: 'Asset'
  asset_tag?: Maybe<Scalars['String']['output']>
  child_assets?: Maybe<Array<Maybe<ChildAsset>>>
  distance?: Maybe<Scalars['Float']['output']>
  distance_since_service?: Maybe<Scalars['Float']['output']>
  model_frame_type?: Maybe<Scalars['String']['output']>
  model_name: Scalars['String']['output']
  model_sys_id: Scalars['ID']['output']
  scheme_id?: Maybe<Scalars['String']['output']>
  serial_number: Scalars['String']['output']
}

export enum AssetCategory {
  bay = 'bay',
  bike = 'bike',
  dock = 'dock',
  ebike = 'ebike',
  scooter = 'scooter',
  unknown = 'unknown',
}

export type AssetInput = {
  asset_tag: Scalars['String']['input']
  model: Scalars['ID']['input']
  name: Scalars['String']['input']
  serial_number: Scalars['String']['input']
}

export type AssetModel = {
  __typename: 'AssetModel'
  child_assets?: Maybe<Array<Maybe<BaseAssetModel>>>
  model_category: Scalars['String']['output']
  name: Scalars['String']['output']
  sys_id: Scalars['ID']['output']
  type: AssetType
}

export enum AssetType {
  furniture = 'furniture',
  none = 'none',
  vehicle = 'vehicle',
}

export enum AssistConfig {
  assist_config_disable = 'ASSIST_CONFIG_DISABLE',
  assist_config_normal = 'ASSIST_CONFIG_NORMAL',
  assist_config_override = 'ASSIST_CONFIG_OVERRIDE',
}

export enum AssistMode {
  assist_eco = 'ASSIST_ECO',
  assist_none = 'ASSIST_NONE',
  assist_sport = 'ASSIST_SPORT',
  assist_tour = 'ASSIST_TOUR',
  assist_turbo = 'ASSIST_TURBO',
}

export type Attempt = {
  __typename: 'Attempt'
  assignee: User
  created_at: Scalars['DateTime']['output']
  reportedLocation?: Maybe<Scalars['String']['output']>
}

export type AttemptInput = {
  assignee: Scalars['String']['input']
  reportedLocation?: InputMaybe<Scalars['String']['input']>
}

export type Automation = {
  __typename: 'Automation'
  description: Scalars['String']['output']
  jobs: Array<Maybe<AutomationJob>>
  justification_id: Scalars['String']['output']
  side_effects: Array<Maybe<Scalars['String']['output']>>
  taskId: Scalars['String']['output']
}

export type AutomationFilters = {
  justification_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  prefix?: InputMaybe<Scalars['String']['input']>
}

export type AutomationFlow = {
  __typename: 'AutomationFlow'
  configuration: AutomationFlowConfiguration
  dry_run: Scalars['Boolean']['output']
  filters?: Maybe<Array<AutomationFlowFilter>>
  id: Scalars['String']['output']
  table_name: Scalars['String']['output']
  tags: Array<Scalars['String']['output']>
}

export type AutomationFlowConfiguration =
  | ActionAutomationFlowConfiguration
  | JobAutomationFlowConfiguration
  | PublishAutomationFlowConfiguration

export type AutomationFlowFilter = {
  __typename: 'AutomationFlowFilter'
  entries: Array<Scalars['String']['output']>
  filter_type: FilterType
  not__: Scalars['Boolean']['output']
}

export type AutomationJob = {
  __typename: 'AutomationJob'
  created_at?: Maybe<Scalars['DateTime']['output']>
  frame_id: Scalars['String']['output']
  scheme_id: Scalars['Int']['output']
  uuid: Scalars['ID']['output']
}

export type AutomationSource = {
  __typename: 'AutomationSource'
  filters?: Maybe<Array<AutomationFlowFilter>>
  source_type: Scalars['String']['output']
  table_name: Scalars['String']['output']
}

export type Availability = {
  __typename: 'Availability'
  created_at?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  status: AvailabilityStatus
}

export type AvailabilityConnection = IConnection & {
  __typename: 'AvailabilityConnection'
  nodes: Array<Availability>
  pagination: Pagination
}

/** Different availability states of the device */
export enum AvailabilityStatus {
  /** Available */
  available = 'available',
  /** Unavailabile */
  unavailable = 'unavailable',
}

export type BaseAssetModel = {
  __typename: 'BaseAssetModel'
  model_category: Scalars['String']['output']
  name: Scalars['String']['output']
  sys_id: Scalars['ID']['output']
  type: AssetType
}

export enum BatteryGroup {
  a200_p = 'A200P',
  b200 = 'B200',
  bbe1 = 'BBE1',
  bbe2 = 'BBE2',
  ecargo = 'ECARGO',
  es400_a = 'ES400A',
  es400_b = 'ES400B',
  es410 = 'ES410',
}

export type Bike = {
  __typename: 'Bike'
  frame: Frame
  lock_configuration: LockConfiguration
  module?: Maybe<Module>
  scheme: Scheme
  vehicle_id: Scalars['ID']['output']
  vehicle_state_history?: Maybe<VehicleStateEventConnection>
}

export type Bikevehicle_state_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

export type BikeConnection = IConnection & {
  __typename: 'BikeConnection'
  nodes: Array<Bike>
  pagination: Pagination
}

export type BikeWhere = {
  frame?: InputMaybe<RemoteNodeOp>
}

/** The scheme_product's billable_journey_cap, with how much of it this holding has spent */
export type BillableJourneyCapInfo = {
  __typename: 'BillableJourneyCapInfo'
  is_billable: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  /** Always P1D: the cap counts over a calendar day in the scheme timezone */
  period: Scalars['String']['output']
  used: Scalars['Int']['output']
}

export type BooleanOp = {
  eq?: InputMaybe<Scalars['Boolean']['input']>
  is_not_null?: InputMaybe<Scalars['Boolean']['input']>
  is_null?: InputMaybe<Scalars['Boolean']['input']>
  ne?: InputMaybe<Scalars['Boolean']['input']>
}

export type BucketPhotoUrl = {
  __typename: 'BucketPhotoUrl'
  url: Scalars['String']['output']
}

export type Buyable = {
  /** Price in cents */
  amount: Scalars['Int']['output']
  /** Whether the product is on offer */
  is_active: Scalars['Boolean']['output']
  /** Whether product should be shown in public listings */
  is_discoverable?: Maybe<Scalars['Boolean']['output']>
  /** Whether the product should be protected by the role_whitelist */
  is_protected?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  /** Formatted amount */
  price: FormattedAmount
  /** A whitelist of role_types that a user must have in order to purchase the protected product */
  role_whitelist: Array<Scalars['String']['output']>
  /** The period which the scheme product is valid for */
  validity_interval?: Maybe<ValidityInterval>
}

export type CampaignConnection = IConnection & {
  __typename: 'CampaignConnection'
  nodes: Array<CampaignSummary>
  pagination: Pagination
}

export type CampaignDetail = CampaignSummary | EoJPromotion

/** Summary of a campaign, use ID to fetch full object */
export type CampaignSummary = {
  __typename: 'CampaignSummary'
  active: Scalars['Boolean']['output']
  campaign_type: CampaignType
  created_at: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: Scalars['String']['output']
}

export enum CampaignType {
  discount_coupons = 'DISCOUNT_COUPONS',
  gift_vouchers = 'GIFT_VOUCHERS',
  loyalty_program = 'LOYALTY_PROGRAM',
  lucky_draw = 'LUCKY_DRAW',
  promotion = 'PROMOTION',
  referral_program = 'REFERRAL_PROGRAM',
}

export enum CantDeleteCode {
  journey_in_progress = 'journey_in_progress',
  outstanding_balance = 'outstanding_balance',
  user_already_deleted = 'user_already_deleted',
  user_not_found = 'user_not_found',
}

export type Card = {
  __typename: 'Card'
  /** @deprecated Use brand_enum for better typing */
  brand: Scalars['String']['output']
  brand_enum: CardBrandType
  country?: Maybe<Scalars['String']['output']>
  exp_month: Scalars['Int']['output']
  exp_year: Scalars['Int']['output']
  funding?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  last4: Scalars['String']['output']
  type: CardType
}

export enum CardBrandType {
  amex = 'amex',
  diners = 'diners',
  diners_club = 'diners_club',
  discover = 'discover',
  jcb = 'jcb',
  mastercard = 'mastercard',
  unionpay = 'unionpay',
  unknown = 'unknown',
  visa = 'visa',
}

export enum CardType {
  apple_pay = 'apple_pay',
  card = 'card',
  google_pay = 'google_pay',
}

export type ChargeExemption = {
  __typename: 'ChargeExemption'
  added_by_id: Scalars['ID']['output']
  charge_type: ChargeType
  created_at?: Maybe<Scalars['DateTime']['output']>
  scheme_id: Scalars['ID']['output']
  user_id: Scalars['ID']['output']
}

export enum ChargeType {
  cancel_journey_penalty = 'cancel_journey_penalty',
  minute_refund = 'minute_refund',
  minute_topup = 'minute_topup',
  out_of_service_area_charge = 'out_of_service_area_charge',
  out_of_zone_charge = 'out_of_zone_charge',
  partially_locked_in_zone_parking_charge = 'partially_locked_in_zone_parking_charge',
  product_purchase = 'product_purchase',
  tax = 'tax',
  time_based_charge = 'time_based_charge',
  time_based_minute_charge = 'time_based_minute_charge',
  time_based_overflow_charge = 'time_based_overflow_charge',
  time_based_period_pass_charge = 'time_based_period_pass_charge',
  unlock_fee = 'unlock_fee',
  vehicle_not_permitted_in_zone_charge = 'vehicle_not_permitted_in_zone_charge',
  zone_max_capacity_charge = 'zone_max_capacity_charge',
}

export type ChildAsset = {
  __typename: 'ChildAsset'
  distance?: Maybe<Scalars['Float']['output']>
  model_name: Scalars['String']['output']
  model_sys_id: Scalars['ID']['output']
  serial_number?: Maybe<Scalars['String']['output']>
}

export type ChildJob = {
  __typename: 'ChildJob'
  assetCategory: AssetCategory
  assetName: Scalars['String']['output']
  assetTag: Scalars['String']['output']
  uuid?: Maybe<Scalars['ID']['output']>
  vehicle?: Maybe<Vehicle>
}

export enum Component {
  bils_firmware = 'BILS_FIRMWARE',
  core_server = 'CORE_SERVER',
  engineering_app = 'ENGINEERING_APP',
  gbfs_feed = 'GBFS_FEED',
  rider_app = 'RIDER_APP',
}

export type ConnectivityWhere = {
  id?: InputMaybe<ScalarOp>
  is_online?: InputMaybe<BooleanOp>
}

export enum CurrencyPaymentProviderType {
  stripe_customer = 'stripe_customer',
  swift_customer = 'swift_customer',
  trafi_customer = 'trafi_customer',
}

export type CurrencyTransaction = ITransaction & {
  __typename: 'CurrencyTransaction'
  amount_refundable?: Maybe<FormattedAmount>
  amount_refunded?: Maybe<FormattedAmount>
  category: TransactionCategory
  created_at: Scalars['DateTime']['output']
  credit_amount: FormattedAmount
  debit_amount: FormattedAmount
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  meta?: Maybe<TransactionMeta>
  provider_type?: Maybe<CurrencyPaymentProviderType>
  refund_requester?: Maybe<User>
  result?: Maybe<TransactionResult>
  type?: Maybe<TransactionType>
  void: Scalars['Boolean']['output']
}

/** Information about the current zone suspension */
export type CurrentZoneSuspension = IZoneSuspension & {
  __typename: 'CurrentZoneSuspension'
  author_id: Scalars['ID']['output']
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  reason?: Maybe<ZoneSuspensionReason>
  scheme_id: Scalars['ID']['output']
}

export type DeletePermission = {
  __typename: 'DeletePermission'
  can_delete: Scalars['Boolean']['output']
  /** This will be null if deletion is permitted */
  code?: Maybe<CantDeleteCode>
}

export type DeletedZone = IZone & {
  __typename: 'DeletedZone'
  capacity: Scalars['Int']['output']
  centre: Scalars['JSON']['output']
  current_suspension?: Maybe<CurrentZoneSuspension>
  external_id: Scalars['ID']['output']
  geom: Scalars['JSON']['output']
  hiring_capacity_status: HiringCapacityStatus
  is_at_max_overflow_capacity: Scalars['Boolean']['output']
  is_external: Scalars['Boolean']['output']
  is_priority: Scalars['Boolean']['output']
  is_promotional: Scalars['Boolean']['output']
  is_suspended: Scalars['Boolean']['output']
  notes?: Maybe<Scalars['String']['output']>
  parking_capacity_status: ParkingCapacityStatus
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type Deployment = {
  __typename: 'Deployment'
  created_at?: Maybe<Scalars['DateTime']['output']>
  /** Returns all events for deployment */
  event_history?: Maybe<DeploymentEventConnection>
  id: Scalars['ID']['output']
  /** Returns latest events distint by module */
  modules?: Maybe<DeploymentEventConnection>
  version?: Maybe<Firmware>
}

export type Deploymentevent_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

export type DeploymentmodulesArgs = {
  paginate?: InputMaybe<Paginate>
}

export type DeploymentConnection = {
  __typename: 'DeploymentConnection'
  nodes: Array<Deployment>
  pagination: Pagination
}

export type DeploymentEvent = {
  __typename: 'DeploymentEvent'
  created_at?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  module?: Maybe<Module>
  state?: Maybe<DeploymentEventState>
}

export type DeploymentEventConnection = {
  __typename: 'DeploymentEventConnection'
  nodes: Array<Maybe<DeploymentEvent>>
  pagination?: Maybe<Pagination>
}

export enum DeploymentEventState {
  downloading = 'downloading',
  installed = 'installed',
  installing = 'installing',
  pending = 'pending',
  starting = 'starting',
}

export enum Direction {
  asc = 'asc',
  desc = 'desc',
}

export type DiscountCalculations = {
  __typename: 'DiscountCalculations'
  discount: FormattedAmount
  subtotal: FormattedAmount
  total: FormattedAmount
  voucher: Voucher
}

export type DiscountCalculationsV2 = {
  __typename: 'DiscountCalculationsV2'
  discount: FormattedAmount
  promotion?: Maybe<ProductDiscountPromotion>
  subtotal: FormattedAmount
  total: FormattedAmount
  voucher?: Maybe<Voucher>
}

export enum DistanceUnit {
  kilometre = 'kilometre',
  metre = 'metre',
  mile = 'mile',
}

export type DraftServiceArea = IServiceArea & {
  __typename: 'DraftServiceArea'
  applies_to: Array<VehicleType>
  effective_from?: Maybe<Scalars['String']['output']>
  effective_to?: Maybe<Scalars['String']['output']>
  external_id?: Maybe<Scalars['ID']['output']>
  geom: Scalars['JSON']['output']
  is_external?: Maybe<Scalars['Boolean']['output']>
  is_parking_allowed: Scalars['Boolean']['output']
  /** False if it should not be shown in the app */
  is_visible: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  scheme: Scheme
  service_area_type: ServiceAreaType
  speed_limit: Scalars['Float']['output']
}

export type DraftZone = IZone & {
  __typename: 'DraftZone'
  all_commissioned_modules_count: Scalars['Int']['output']
  all_commissioned_vehicles: Array<Vehicle>
  all_commissioned_vehicles_count: Scalars['Int']['output']
  all_modules_count: Scalars['Int']['output']
  capacity: Scalars['Int']['output']
  centre: Scalars['JSON']['output']
  current_suspension?: Maybe<CurrentZoneSuspension>
  external_id: Scalars['ID']['output']
  geom: Scalars['JSON']['output']
  /** @deprecated Use Zone.hireable_vehicles instead */
  hireable_modules: Array<Maybe<Module>>
  /** @deprecated Use Zone.hireable_vehicles_count instead */
  hireable_modules_count: Scalars['Int']['output']
  hireable_vehicles: Array<Maybe<Vehicle>>
  hireable_vehicles_count: Scalars['Int']['output']
  hiring_capacity_status: HiringCapacityStatus
  is_at_max_overflow_capacity: Scalars['Boolean']['output']
  is_external?: Maybe<Scalars['Boolean']['output']>
  is_priority: Scalars['Boolean']['output']
  is_promotional: Scalars['Boolean']['output']
  /** @deprecated Use Zone.hireable_modules_count directly instead */
  locked_modules?: Maybe<ModuleConnection>
  modules?: Maybe<ModuleConnection>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  parking_capacity_status: ParkingCapacityStatus
  permitted_vehicles: Array<VehicleType>
  promotion?: Maybe<Promotion>
  related_modules?: Maybe<Array<Maybe<Module>>>
  scheme: Scheme
  zone_type: ZoneType
}

export type DraftZoneall_commissioned_modules_countArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type DraftZoneall_commissioned_vehiclesArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type DraftZoneall_commissioned_vehicles_countArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type DraftZoneall_modules_countArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type DraftZonehireable_modulesArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type DraftZonehireable_modules_countArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type DraftZonehireable_vehiclesArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type DraftZonehireable_vehicles_countArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type DraftZonelocked_modulesArgs = {
  paginate?: InputMaybe<Paginate>
}

export type DraftZonemodulesArgs = {
  paginate?: InputMaybe<Paginate>
}

export type DraftZonepromotionArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type Drive = {
  __typename: 'Drive'
  battery_health?: Maybe<Scalars['Int']['output']>
  battery_percent?: Maybe<Scalars['Int']['output']>
  battery_voltage?: Maybe<Scalars['Float']['output']>
  estimated_range?: Maybe<Scalars['Int']['output']>
  estimated_range_minutes?: Maybe<Scalars['Int']['output']>
}

export type Driveestimated_rangeArgs = {
  unit?: InputMaybe<DistanceUnit>
}

export type DrivingLicenceCheck = {
  __typename: 'DrivingLicenceCheck'
  id: Scalars['ID']['output']
}

export type EcuError = {
  __typename: 'EcuError'
  cause?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  protection?: Maybe<Scalars['String']['output']>
  solution?: Maybe<Scalars['String']['output']>
}

export type EmailLinkInput = {
  android_install_app?: InputMaybe<Scalars['Boolean']['input']>
  android_package_name?: InputMaybe<Scalars['String']['input']>
  dynamic_link_domain?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  handle_code_in_app?: InputMaybe<Scalars['Boolean']['input']>
  ios_bundle_id?: InputMaybe<Scalars['String']['input']>
  url: Scalars['String']['input']
}

export enum EndJourneyActionType {
  cancel_journey = 'cancel_journey',
  end_journey = 'end_journey',
  void_journey = 'void_journey',
}

export type EndJourneyAdjustmentsInput = {
  ended_at?: InputMaybe<Scalars['DateTime']['input']>
  extra_actions: Array<EndJourneyExtraAction>
  parking_status?: InputMaybe<ParkingStatus>
  vehicle_lock_state?: InputMaybe<VehicleLockState>
}

export enum EndJourneyExtraAction {
  disable_assist = 'disable_assist',
  safe_lock = 'safe_lock',
}

/** Campaign/Promotion/Tier/Metadata */
export type EoJPromotion = {
  __typename: 'EoJPromotion'
  active: Scalars['Boolean']['output']
  banner: Scalars['String']['output']
  campaign_type: CampaignType
  created_at: Scalars['DateTime']['output']
  description: Scalars['String']['output']
  discount?: Maybe<ProductDiscountConfig>
  expiration_date?: Maybe<Scalars['DateTime']['output']>
  /** Not used for validation, a validation rule with 'hardware_type in' must be set. This is for displaying icons in the app */
  hardware_types: Array<ModuleHardware>
  id: Scalars['ID']['output']
  journey_first_free_minutes?: Maybe<Scalars['Int']['output']>
  journey_percent_off_time_based_charges?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  /** Not used for validation, a validation rule with 'scheme_id in' must be set. This is used for managing role based permissions. */
  scheme_ids: Array<Scalars['ID']['output']>
  start_date?: Maybe<Scalars['DateTime']['output']>
  unlock_fee_percent_off?: Maybe<Scalars['Int']['output']>
  validation_rule_ids: Array<Scalars['String']['output']>
  validation_rules: Array<ValidationRule>
  /** Not used for validation, a validation rule with 'vehicle_category in' must be set. This is for displaying icons in the app */
  vehicle_categories: Array<VehicleCategory>
}

export type EoJPromotionInput = {
  banner: Scalars['String']['input']
  description: Scalars['String']['input']
  discount?: InputMaybe<ProductDiscountInput>
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>
  /** Deprecated field, use vehicle_categories instead. */
  hardware_types?: InputMaybe<Array<ModuleHardware>>
  journey_first_free_minutes?: InputMaybe<Scalars['Int']['input']>
  journey_percent_off_time_based_charges?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  scheme_ids: Array<Scalars['ID']['input']>
  start_date?: InputMaybe<Scalars['DateTime']['input']>
  unlock_fee_percent_off?: InputMaybe<Scalars['Int']['input']>
  validation_rule_ids: Array<Scalars['String']['input']>
  vehicle_categories: Array<VehicleCategory>
}

export type ExistingOrWhitelist = {
  __typename: 'ExistingOrWhitelist'
  scheme?: Maybe<Scheme>
  status: Scalars['Boolean']['output']
}

export type Fee = {
  __typename: 'Fee'
  amount: FormattedAmount
  reason?: Maybe<FeeAdjustmentReason>
}

export enum FeeAdjustmentReason {
  addon = 'addon',
  product = 'product',
}

export enum FilterType {
  frame_model = 'frame_model',
  frame_type = 'frame_type',
  hardware_type = 'hardware_type',
  scheme_id = 'scheme_id',
}

export type Firmware = {
  __typename: 'Firmware'
  created_at: Scalars['DateTime']['output']
  formatted_size: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  size: Scalars['Int']['output']
  supported_frame_types?: Maybe<Array<FrameType>>
  supported_hardware?: Maybe<Array<Maybe<ModuleHardwareType>>>
}

export enum FirmwareStatus {
  deployed = 'DEPLOYED',
  in_deployment = 'IN_DEPLOYMENT',
  not_deployed = 'NOT_DEPLOYED',
}

export enum FirmwareType {
  ecu = 'ECU',
  helmet_lock = 'HELMET_LOCK',
  iot = 'IOT',
  meter = 'METER',
  repeater = 'REPEATER',
}

export type FormattedAmount = {
  __typename: 'FormattedAmount'
  amount: Scalars['Int']['output']
  currency_code: Scalars['String']['output']
  formatted_amount: Scalars['String']['output']
  unit: Scalars['String']['output']
}

export type Frame = {
  __typename: 'Frame'
  id: Scalars['ID']['output']
  module?: Maybe<Module>
}

export type FramemoduleArgs = {
  scheme_id: Scalars['ID']['input']
}

export enum FrameType {
  beryl_bike = 'beryl_bike',
  beryl_e_bike = 'beryl_e_bike',
  beryl_e_bike_2 = 'beryl_e_bike_2',
  okai_scooter = 'okai_scooter',
  pashley_tfl = 'pashley_tfl',
  pashley_westmidlands_bike = 'pashley_westmidlands_bike',
  pashley_westmidlands_e_bike = 'pashley_westmidlands_e_bike',
  raleigh_cargo_e_bike = 'raleigh_cargo_e_bike',
  segway_e_bike = 'segway_e_bike',
  segway_e_bike_b200 = 'segway_e_bike_b200',
}

export enum HardwareModel {
  a200_p = 'A200P',
  b200 = 'B200',
  es400 = 'ES400',
  es400_gen2 = 'ES400GEN2',
  es410 = 'ES410',
  es600_gen1 = 'ES600GEN1',
  es600_gen2 = 'ES600GEN2',
}

export enum HiringCapacityStatus {
  available_bikes = 'available_bikes',
  limited_bikes = 'limited_bikes',
  no_bikes = 'no_bikes',
}

export type IConnection = {
  pagination: Pagination
}

export type IInvoice = {
  created_at: Scalars['DateTime']['output']
  currency_balance?: Maybe<FormattedAmount>
  currency_debit?: Maybe<FormattedAmount>
  currency_debit_sub_total?: Maybe<FormattedAmount>
  currency_refundable?: Maybe<FormattedAmount>
  /** Human readable description of the purchase */
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  is_void: Scalars['Boolean']['output']
  minute_debit?: Maybe<FormattedAmount>
  minute_refundable?: Maybe<FormattedAmount>
  next_action?: Maybe<Array<Maybe<PaymentIntent>>>
  scheme?: Maybe<Scheme>
  scheme_product?: Maybe<SchemeProduct>
  status?: Maybe<InvoiceStatus>
  timezone_offset?: Maybe<Scalars['Float']['output']>
  transactions?: Maybe<TransactionConnection>
  user: User
}

export type IInvoiceConnection = {
  __typename: 'IInvoiceConnection'
  nodes: Array<IInvoice>
  pagination: Pagination
}

export type IInvoiceOrderby = {
  created_at?: InputMaybe<Direction>
  description?: InputMaybe<Direction>
  id?: InputMaybe<Direction>
  type?: InputMaybe<Direction>
}

export type IInvoiceWhere = {
  amount?: InputMaybe<ScalarOp>
  description?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
  status?: InputMaybe<ScalarOp>
  type?: InputMaybe<ScalarOp>
  user?: InputMaybe<RemoteNodeOp>
}

export type IModuleState = {
  id: Scalars['ID']['output']
  time: Scalars['DateTime']['output']
}

export type IPromotion = {
  banner: Scalars['String']['output']
  description: Scalars['String']['output']
  expiration_date?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  start_date: Scalars['DateTime']['output']
}

export type ISaving = {
  /** Was the saving real or possible */
  reason: SavingReason
  /** Currency saving */
  saving_amount: FormattedAmount
}

export type IServiceArea = {
  applies_to: Array<VehicleType>
  effective_from?: Maybe<Scalars['String']['output']>
  effective_to?: Maybe<Scalars['String']['output']>
  external_id?: Maybe<Scalars['ID']['output']>
  geom: Scalars['JSON']['output']
  is_external?: Maybe<Scalars['Boolean']['output']>
  is_parking_allowed: Scalars['Boolean']['output']
  /** False if it should not be shown in the app */
  is_visible: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  scheme: Scheme
  service_area_type: ServiceAreaType
  speed_limit: Scalars['Float']['output']
}

export type ITransaction = {
  amount_refundable?: Maybe<FormattedAmount>
  amount_refunded?: Maybe<FormattedAmount>
  category: TransactionCategory
  created_at: Scalars['DateTime']['output']
  credit_amount: FormattedAmount
  debit_amount: FormattedAmount
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  meta?: Maybe<TransactionMeta>
  provider_type?: Maybe<CurrencyPaymentProviderType>
  refund_requester?: Maybe<User>
  result?: Maybe<TransactionResult>
  type?: Maybe<TransactionType>
  void: Scalars['Boolean']['output']
}

export type IZone = {
  capacity: Scalars['Int']['output']
  centre: Scalars['JSON']['output']
  /** Optional further information about this zone suspension */
  current_suspension?: Maybe<CurrentZoneSuspension>
  external_id: Scalars['ID']['output']
  geom: Scalars['JSON']['output']
  hiring_capacity_status: HiringCapacityStatus
  is_at_max_overflow_capacity: Scalars['Boolean']['output']
  is_external?: Maybe<Scalars['Boolean']['output']>
  is_priority: Scalars['Boolean']['output']
  is_promotional: Scalars['Boolean']['output']
  notes?: Maybe<Scalars['String']['output']>
  parking_capacity_status: ParkingCapacityStatus
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type IZoneSuspension = {
  author_id: Scalars['ID']['output']
  id: Scalars['ID']['output']
  /** Freeform information about this zone suspension */
  notes?: Maybe<Scalars['String']['output']>
  reason?: Maybe<ZoneSuspensionReason>
  scheme_id: Scalars['ID']['output']
}

export type Incident = {
  __typename: 'Incident'
  asset_tag?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  number: Scalars['String']['output']
  priority: Scalars['Int']['output']
  service_offering?: Maybe<Scalars['String']['output']>
  state: Scalars['Int']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type IncidentInput = {
  asset_scheme_id?: InputMaybe<Scalars['Int']['input']>
  asset_tag?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  service_offering?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  urgency: Scalars['Int']['input']
  user_id: Scalars['ID']['input']
}

export enum InvoiceStatus {
  fully_refunded = 'fully_refunded',
  outstanding = 'outstanding',
  partially_refunded = 'partially_refunded',
  pending = 'pending',
  settled = 'settled',
  void = 'void',
}

export type IotState = {
  __typename: 'IotState'
  battery_id?: Maybe<Scalars['String']['output']>
  /** To differentiate between beryl bikes and tfl smartbikes using the board hardware type */
  board_hw_type?: Maybe<ModuleHardwareType>
  commit_hash?: Maybe<Scalars['String']['output']>
  debug_mode?: Maybe<Scalars['Boolean']['output']>
  dock_nfc_tag_id?: Maybe<Scalars['String']['output']>
  drive_id?: Maybe<Scalars['String']['output']>
  firmware_version?: Maybe<Scalars['String']['output']>
  hardware_version?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  imei?: Maybe<Scalars['String']['output']>
  imsi?: Maybe<Scalars['String']['output']>
  installed_deployment_id?: Maybe<Scalars['Int']['output']>
  mac_address?: Maybe<Scalars['String']['output']>
  pending_firmware_url?: Maybe<Scalars['String']['output']>
  power_cycles?: Maybe<Scalars['Int']['output']>
  power_mode?: Maybe<Scalars['String']['output']>
  status_accelerometer?: Maybe<Scalars['Int']['output']>
  status_battery_voltage?: Maybe<Scalars['Boolean']['output']>
  status_charging_current?: Maybe<Scalars['Boolean']['output']>
  status_front_light?: Maybe<Scalars['Int']['output']>
  status_generated_power?: Maybe<Scalars['Boolean']['output']>
  status_gnss_module?: Maybe<Scalars['String']['output']>
  status_lock?: Maybe<Scalars['Int']['output']>
  status_rear_light?: Maybe<Scalars['Int']['output']>
  status_supercap_voltage?: Maybe<Scalars['Boolean']['output']>
  status_temp_sensor?: Maybe<Scalars['Int']['output']>
  time: Scalars['DateTime']['output']
  watchdog_resets?: Maybe<Scalars['Int']['output']>
}

export type IotStateWhere = {
  board_hw_type?: InputMaybe<ScalarOp>
  firmware_version?: InputMaybe<ScalarOp>
  hardware_version?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
  power_mode?: InputMaybe<ScalarOp>
}

export type Job = {
  __typename: 'Job'
  attachments?: Maybe<Array<Scalars['ID']['output']>>
  attempts?: Maybe<Array<Attempt>>
  /** @deprecated Use Vehicle instead */
  bike?: Maybe<Bike>
  childJobs?: Maybe<Array<ChildJob>>
  details: JobDetails
  justifications?: Maybe<Array<Justification>>
  tasks?: Maybe<Array<Task>>
  timestamps?: Maybe<JobTimestamps>
  uuid: Scalars['ID']['output']
  vehicle?: Maybe<Vehicle>
}

export type JobAsset = {
  __typename: 'JobAsset'
  assetCategory: AssetCategory
  assetName: Scalars['String']['output']
  assetTag: Scalars['String']['output']
  externalId: Scalars['String']['output']
}

export type JobAutomationFlowConfiguration = {
  __typename: 'JobAutomationFlowConfiguration'
  description: Scalars['String']['output']
  side_effects?: Maybe<Array<Scalars['String']['output']>>
  task_id: Scalars['String']['output']
  use_cleanup?: Maybe<Scalars['Boolean']['output']>
}

export enum JobAutomationSideEffect {
  set_unavailable = 'set_unavailable',
}

export type JobAutomationVehicleInput = {
  frame_id: Scalars['String']['input']
  scheme_id: Scalars['Int']['input']
}

/** VehicleCategory + zone, used for filtering allowable job types */
export enum JobCategory {
  bike = 'bike',
  cargo_ebike = 'cargo_ebike',
  ebike = 'ebike',
  escooter = 'escooter',
  zone = 'zone',
}

export type JobConnection = IConnection & {
  __typename: 'JobConnection'
  nodes: Array<Job>
  pagination: Pagination
}

export type JobDetails = {
  __typename: 'JobDetails'
  allowPhotoUpload?: Maybe<Scalars['Boolean']['output']>
  assetCategory?: Maybe<AssetCategory>
  assetName?: Maybe<Scalars['String']['output']>
  assetTag?: Maybe<Scalars['String']['output']>
  assignee?: Maybe<User>
  batteryGroup?: Maybe<BatteryGroup>
  /** @deprecated use assetTag */
  bikeNumber?: Maybe<Scalars['String']['output']>
  completedBy?: Maybe<User>
  concludingJob?: Maybe<Scalars['ID']['output']>
  createdBy?: Maybe<User>
  description?: Maybe<Scalars['String']['output']>
  initiatingJob?: Maybe<Scalars['ID']['output']>
  isJustified?: Maybe<Scalars['Boolean']['output']>
  isUnlocked?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  locationDescription?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  numberOfAttempts?: Maybe<Scalars['Int']['output']>
  priority?: Maybe<Scalars['String']['output']>
  reportedLocation?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
  scheme?: Maybe<Scheme>
  /** @deprecated Use field `scheme` instead. Remove when tasking client is updated. */
  scheme_id?: Maybe<Scalars['String']['output']>
  status?: Maybe<JobStatusEnum>
  taskId: Scalars['ID']['output']
  updatedBy?: Maybe<User>
  /** @deprecated use assetCategory */
  vehicleType?: Maybe<VehicleType>
  vehicle_id?: Maybe<Scalars['ID']['output']>
}

export type JobDetailsInput = {
  assetTag?: InputMaybe<Scalars['String']['input']>
  assets?: InputMaybe<Scalars['String']['input']>
  assignee?: InputMaybe<Scalars['String']['input']>
  bikeNumber?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  is_unlocked?: InputMaybe<Scalars['Boolean']['input']>
  locationDescription?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  reportedLocation?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  scheme_id?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<JobStatusEnum>
  taskId?: InputMaybe<Scalars['ID']['input']>
}

export type JobFiltersInput = {
  assetCategory?: InputMaybe<Array<InputMaybe<AssetCategory>>>
  assetNameContains?: InputMaybe<Scalars['String']['input']>
  assetTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  assignee?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  batteryGroup?: InputMaybe<Array<InputMaybe<BatteryGroup>>>
  bikeNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  is_unlocked?: InputMaybe<Scalars['Boolean']['input']>
  justification_id?: InputMaybe<Array<Scalars['String']['input']>>
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  scheme_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  status?: InputMaybe<Array<InputMaybe<JobStatusEnum>>>
  taskId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  vehicleType?: InputMaybe<Array<InputMaybe<VehicleType>>>
}

export type JobInput = {
  assetTag?: InputMaybe<Scalars['String']['input']>
  assignee?: InputMaybe<Scalars['String']['input']>
  bikeNumber?: InputMaybe<Scalars['String']['input']>
  childJobs?: InputMaybe<Array<Scalars['ID']['input']>>
  locationDescription?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  reportedLocation?: InputMaybe<Scalars['String']['input']>
  scheme_id?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<JobStatusEnum>
  taskId?: InputMaybe<Scalars['String']['input']>
  /** A JSON object containing the vandalism report details */
  vandalismJson?: InputMaybe<Scalars['JSON']['input']>
}

export enum JobSortField {
  is_unlocked = 'is_unlocked',
  updated_at = 'updated_at',
}

export enum JobStatusEnum {
  blocked = 'blocked',
  complete = 'complete',
  in_progress = 'inProgress',
  new = 'new',
}

export type JobTaskInput = {
  details?: InputMaybe<TaskDetailsInput>
  uuid?: InputMaybe<Scalars['ID']['input']>
}

export type JobTimestamps = {
  __typename: 'JobTimestamps'
  completed_at?: Maybe<Scalars['DateTime']['output']>
  created_at: Scalars['DateTime']['output']
  deleted_at?: Maybe<Scalars['DateTime']['output']>
  last_attempted_at?: Maybe<Scalars['DateTime']['output']>
  updated_at: Scalars['DateTime']['output']
}

export type JobTypes = {
  __typename: 'JobTypes'
  onStreetMechanic: JobTypesAssignmentGroup
  redistributionDriver: JobTypesAssignmentGroup
  securityTeam: JobTypesAssignmentGroup
  workshopMechanic: JobTypesAssignmentGroup
}

export type JobTypesAssignmentGroup = {
  __typename: 'JobTypesAssignmentGroup'
  children: Array<JobTypesChildren>
  label: Scalars['String']['output']
}

export type JobTypesChildren = {
  __typename: 'JobTypesChildren'
  categories: Array<JobCategory>
  code: Scalars['String']['output']
  disabled?: Maybe<Scalars['Boolean']['output']>
  group?: Maybe<JobTypesGroup>
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

export enum JobTypesGroup {
  legacy_jobs = 'LEGACY_JOBS',
  tracking_assets_jobs = 'TRACKING_ASSETS_JOBS',
}

export type JobUpdateInput = {
  details?: InputMaybe<JobDetailsInput>
  tasks?: InputMaybe<Array<JobTaskInput>>
}

/** Container for the id of the updated job */
export type JobUpdateParentResult = {
  __typename: 'JobUpdateParentResult'
  /** The ID of the job that was updated */
  uuid: Scalars['ID']['output']
}

export type Journey = {
  __typename: 'Journey'
  co2_saved?: Maybe<Scalars['Int']['output']>
  completed_at?: Maybe<Scalars['DateTime']['output']>
  confirmed_rewards: Array<VehicleReward>
  /** Human readable description of the journey */
  description?: Maybe<Scalars['String']['output']>
  distance?: Maybe<Scalars['Float']['output']>
  /** How many docks were available at the end of journey zone */
  docks_available?: Maybe<Scalars['Int']['output']>
  /** Journey duration in minutes */
  duration?: Maybe<Scalars['Int']['output']>
  /** Did the journey end in the service area? */
  end_in_service_area?: Maybe<Scalars['Boolean']['output']>
  end_in_zone?: Maybe<Scalars['Boolean']['output']>
  /** Battery level at end of journey */
  end_vehicle_battery_percent?: Maybe<Scalars['Int']['output']>
  end_zone?: Maybe<Zone>
  /** Is the final endpoint known? */
  final_location_known?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  /** Channel which journey was started with */
  initiator?: Maybe<JourneyInitiator>
  /** Client ID which journey was started with */
  initiator_app_name?: Maybe<Scalars['String']['output']>
  /** Unlock method which journey was started with */
  initiator_unlock_method?: Maybe<UnlockMethod>
  insights?: Maybe<JourneyInsights>
  /** The billing info for the journey */
  invoice?: Maybe<JourneyInvoice>
  /** If the journey has been cancelled by us */
  is_cancelled: Scalars['Boolean']['output']
  is_complete: Scalars['Boolean']['output']
  is_error: Scalars['Boolean']['output']
  /** If the journey has been voided by us */
  is_voided: Scalars['Boolean']['output']
  /** The set which the journey belongs to */
  journey_set?: Maybe<JourneySet>
  module: Module
  /** Signed URLs to save or view a photo of the parking, request only if needed. */
  parking_photo: ParkingPhoto
  parking_status?: Maybe<ParkingStatus>
  /** Is pausing enabled for journey */
  pausable: Scalars['Boolean']['output']
  possible_rewards: Array<VehicleReward>
  route?: Maybe<Scalars['JSON']['output']>
  route_V2?: Maybe<Scalars['JSON']['output']>
  scheme?: Maybe<Scheme>
  speed?: Maybe<Scalars['Float']['output']>
  /** Battery level at start of journey */
  start_vehicle_battery_percent?: Maybe<Scalars['Int']['output']>
  start_zone?: Maybe<Zone>
  started_at?: Maybe<Scalars['DateTime']['output']>
  state: JourneyEvent
  state_history: JourneyEventConnection
  timezone_offset?: Maybe<Scalars['Float']['output']>
  user: User
  user_trip_id: Scalars['GUID']['output']
  vehicle: Vehicle
  vehicle_category?: Maybe<VehicleCategory>
  /** Vehicle docked at end of journey */
  vehicle_docked?: Maybe<Scalars['Boolean']['output']>
  /** The lock state of the vehicle at the end of journey */
  vehicle_lock_state?: Maybe<VehicleLockState>
}

export type JourneydistanceArgs = {
  unit?: InputMaybe<DistanceUnit>
}

export type JourneyspeedArgs = {
  unit?: InputMaybe<DistanceUnit>
}

export type Journeystate_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

export type JourneyActualSaving = ISaving & {
  __typename: 'JourneyActualSaving'
  /** How much would it have cost on PaYG */
  payg_amount: FormattedAmount
  /** Was the saving real or possible */
  reason: SavingReason
  /** Currency saving */
  saving_amount: FormattedAmount
}

export type JourneyConnection = IConnection & {
  __typename: 'JourneyConnection'
  nodes: Array<Journey>
  pagination: Pagination
}

export type JourneyEvent = {
  __typename: 'JourneyEvent'
  duration?: Maybe<Scalars['Int']['output']>
  /** When the pause block expires, if the event is a paused state with a duration */
  expires_at?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  /** Whether this event represents a paused state */
  is_paused?: Maybe<Scalars['Boolean']['output']>
  message: Scalars['String']['output']
  time: Scalars['DateTime']['output']
  trigger?: Maybe<Scalars['String']['output']>
}

export type JourneyEventConnection = IConnection & {
  __typename: 'JourneyEventConnection'
  nodes: Array<JourneyEvent>
  pagination: Pagination
}

export enum JourneyInitiator {
  /** Default, If not specified it will be app */
  app = 'app',
  /** Journey started via SMS */
  sms = 'sms',
  /** Journey started via Breeze app */
  trafi = 'trafi',
}

export type JourneyInsights = {
  __typename: 'JourneyInsights'
  id: Scalars['ID']['output']
  journey_id: Scalars['ID']['output']
  rating: Scalars['Float']['output']
  reason_other?: Maybe<Scalars['String']['output']>
  reasons: Array<Scalars['String']['output']>
}

export type JourneyInvoice = IInvoice & {
  __typename: 'JourneyInvoice'
  created_at: Scalars['DateTime']['output']
  currency_balance?: Maybe<FormattedAmount>
  currency_debit?: Maybe<FormattedAmount>
  currency_debit_sub_total?: Maybe<FormattedAmount>
  currency_refundable?: Maybe<FormattedAmount>
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  is_void: Scalars['Boolean']['output']
  journey: Journey
  minute_debit?: Maybe<FormattedAmount>
  minute_refundable?: Maybe<FormattedAmount>
  next_action?: Maybe<Array<Maybe<PaymentIntent>>>
  /** Any possible savings from using a pass, or actual savings it this did use a pass */
  savings?: Maybe<JourneySavings>
  scheme?: Maybe<Scheme>
  scheme_product?: Maybe<SchemeProduct>
  status?: Maybe<InvoiceStatus>
  timezone_offset?: Maybe<Scalars['Float']['output']>
  transactions?: Maybe<TransactionConnection>
  user: User
}

export type JourneyOrderBy = {
  completed_at?: InputMaybe<Direction>
  id?: InputMaybe<Direction>
  started_at?: InputMaybe<Direction>
}

export type JourneyPossibleSaving = ISaving & {
  __typename: 'JourneyPossibleSaving'
  /** Was the saving real or possible */
  reason: SavingReason
  recommended_product: SchemeProduct
  /** Best saving achieved with this product */
  recommended_product_id: Scalars['ID']['output']
  /** Currency saving */
  saving_amount: FormattedAmount
}

export type JourneySavings = JourneyActualSaving | JourneyPossibleSaving

export type JourneySet = {
  __typename: 'JourneySet'
  active_journey_count: Scalars['Int']['output']
  completed_at?: Maybe<Scalars['DateTime']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  is_complete: Scalars['Boolean']['output']
  journey_count: Scalars['Int']['output']
  journeys: Array<Journey>
  scheme: Scheme
  started_at: Scalars['DateTime']['output']
  supports_extension: Scalars['Boolean']['output']
  user: User
}

export type JourneySetConnection = IConnection & {
  __typename: 'JourneySetConnection'
  nodes: Array<JourneySet>
  pagination: Pagination
}

export type JourneyTotals = {
  __typename: 'JourneyTotals'
  /** Total journey count */
  count: Scalars['Int']['output']
  /** Total distance in preferred unit */
  distance: Scalars['Float']['output']
  /** Total duration in minutes */
  duration: Scalars['Int']['output']
}

export type JourneyTotalsdistanceArgs = {
  unit?: InputMaybe<DistanceUnit>
}

export type JourneyWhere = {
  completed_at?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
  module?: InputMaybe<RemoteNodeOp>
  scheme?: InputMaybe<RemoteNodeOp>
  started_at?: InputMaybe<ScalarOp>
  user?: InputMaybe<RemoteNodeOp>
}

export type Justification = {
  __typename: 'Justification'
  description: Scalars['String']['output']
  justification_id: Scalars['String']['output']
  side_effects: Array<Maybe<Scalars['String']['output']>>
  timestamps: Timestamps
}

export type LicenceExpiry = {
  __typename: 'LicenceExpiry'
  expiry_date?: Maybe<Scalars['DateTime']['output']>
  status: LicenceExpiryStatus
}

export enum LicenceExpiryStatus {
  expired = 'expired',
  expired_grace_period = 'expired_grace_period',
  expiring_soon = 'expiring_soon',
  valid = 'valid',
}

export type Location = {
  __typename: 'Location'
  altitude: Scalars['Float']['output']
  id: Scalars['ID']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  max_error?: Maybe<Scalars['Float']['output']>
  parking_status?: Maybe<ParkingStatus>
  time: Scalars['DateTime']['output']
}

export type LocationAreaInput = {
  latitude_max: Scalars['Float']['input']
  latitude_min: Scalars['Float']['input']
  longitude_max: Scalars['Float']['input']
  longitude_min: Scalars['Float']['input']
}

export type LocationInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export enum LockConfiguration {
  electronic_lock = 'electronic_lock',
  front_and_electronic_rear_lock = 'front_and_electronic_rear_lock',
  front_and_rear_lock = 'front_and_rear_lock',
  no_lock = 'no_lock',
  rear_lock = 'rear_lock',
}

export type LockEvent = {
  __typename: 'LockEvent'
  front_lock_state?: Maybe<LockState>
  id: Scalars['ID']['output']
  overall_state?: Maybe<LockState>
  rear_lock_state?: Maybe<LockState>
  source?: Maybe<LockSource>
  time: Scalars['DateTime']['output']
  vehicle_lock_state?: Maybe<VehicleLockState>
}

export type LockEventConnection = IConnection & {
  __typename: 'LockEventConnection'
  nodes: Array<LockEvent>
  pagination: Pagination
}

export enum LockSource {
  journey = 'journey',
  lock_vehicle_worker = 'lock_vehicle_worker',
  operations_client = 'operations_client',
  unknown = 'unknown',
}

export enum LockState {
  lock_failed = 'lock_failed',
  lock_fault = 'lock_fault',
  lock_stuck = 'lock_stuck',
  lock_timeout = 'lock_timeout',
  locked = 'locked',
  not_applicable = 'not_applicable',
  spontaneous_lock = 'spontaneous_lock',
  spontaneous_unlock = 'spontaneous_unlock',
  unknown = 'unknown',
  unlock_failed = 'unlock_failed',
  unlock_timeout = 'unlock_timeout',
  unlocked = 'unlocked',
  waiting_for_lock = 'waiting_for_lock',
  waiting_for_unlock = 'waiting_for_unlock',
}

export type ManufacturingInfoInput = {
  frame_model: Scalars['String']['input']
  frame_year: Scalars['Int']['input']
  module_id: Scalars['ID']['input']
}

export type MaptexConfig = OkaiScooterConfig | SegwayEBikeConfig

export type MetadataSchemaConnection = {
  __typename: 'MetadataSchemaConnection'
  nodes: Array<MetadataSchemaItem>
}

export type MetadataSchemaItem = {
  __typename: 'MetadataSchemaItem'
  properties: Array<MetadataSchemaProperties>
  related_object: MetadataSchemaObjectType
}

/** Voucherify metadata schemas that we're interested in */
export enum MetadataSchemaObjectType {
  customer = 'customer',
  promotion_tier = 'promotion_tier',
  redemption = 'redemption',
}

export type MetadataSchemaProperties = {
  __typename: 'MetadataSchemaProperties'
  array: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  optional: Scalars['Boolean']['output']
  type: MetadataSchemaPropertyType
}

export enum MetadataSchemaPropertyType {
  boolean = 'boolean',
  date = 'date',
  datetime = 'datetime',
  number = 'number',
  string = 'string',
  unknown = 'unknown',
}

export type MinuteRefundCalcs = {
  __typename: 'MinuteRefundCalcs'
  /** Proportion of currency that can be refunded for minutes that haven't been used */
  currency_amount: FormattedAmount
  /** Number of minutes that have been used out of this bundle to balance if voiding */
  minute_adjustment_quantity: Scalars['Int']['output']
}

export type MinuteTransaction = ITransaction & {
  __typename: 'MinuteTransaction'
  amount_refundable?: Maybe<FormattedAmount>
  amount_refunded?: Maybe<FormattedAmount>
  category: TransactionCategory
  created_at: Scalars['DateTime']['output']
  credit_amount: FormattedAmount
  debit_amount: FormattedAmount
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  meta?: Maybe<TransactionMeta>
  provider_type?: Maybe<CurrencyPaymentProviderType>
  refund_requester?: Maybe<User>
  result?: Maybe<TransactionResult>
  scheme_ids?: Maybe<Array<Scalars['ID']['output']>>
  type?: Maybe<TransactionType>
  void: Scalars['Boolean']['output']
}

export type Module = {
  __typename: 'Module'
  availability?: Maybe<Availability>
  availability_history: AvailabilityConnection
  /** @deprecated Use .vehicle instead */
  bike?: Maybe<Bike>
  connectivity?: Maybe<ModuleConnectivity>
  connectivity_history: ModuleConnectivityConnection
  dock_state?: Maybe<ModuleEvent>
  dock_state_history: ModuleEventConnection
  /** The type of hardware this module is associated with */
  hardware_type: ModuleHardware
  id: Scalars['ID']['output']
  /** @deprecated Field no longer supported */
  iot_state?: Maybe<IotState>
  is_commissioned?: Maybe<Scalars['Boolean']['output']>
  is_hireable?: Maybe<Scalars['Boolean']['output']>
  /** Module has neither missing nor workshop tag */
  is_present: Scalars['Boolean']['output']
  journeys: JourneyConnection
  location?: Maybe<Location>
  lock_state?: Maybe<LockEvent>
  lock_state_history: LockEventConnection
  module_state?: Maybe<IModuleState>
  soak_test?: Maybe<SoakSuite>
  tags?: Maybe<Array<ModuleTag>>
  telemetry?: Maybe<Telemetry>
  unlock_id?: Maybe<Scalars['String']['output']>
  vehicle?: Maybe<Vehicle>
  zone_id?: Maybe<Scalars['String']['output']>
}

export type Moduleavailability_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

export type Moduledock_state_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

export type ModulejourneysArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
}

export type Modulelock_state_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

export type ModuleConnection = IConnection & {
  __typename: 'ModuleConnection'
  nodes: Array<Module>
  pagination: Pagination
}

export type ModuleConnectivity = {
  __typename: 'ModuleConnectivity'
  details?: Maybe<ModuleConnectivityDetails>
  id: Scalars['ID']['output']
  is_online: Scalars['Boolean']['output']
  time: Scalars['DateTime']['output']
}

export type ModuleConnectivityConnection = IConnection & {
  __typename: 'ModuleConnectivityConnection'
  nodes: Array<ModuleConnectivity>
  pagination: Pagination
}

export type ModuleConnectivityDetails = {
  __typename: 'ModuleConnectivityDetails'
  error_code?: Maybe<Scalars['Int']['output']>
  error_message?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  last_config_ack_time?: Maybe<Scalars['DateTime']['output']>
  last_config_send_time?: Maybe<Scalars['DateTime']['output']>
  last_error_time?: Maybe<Scalars['DateTime']['output']>
  last_event_time?: Maybe<Scalars['DateTime']['output']>
  last_heartbeat_time?: Maybe<Scalars['DateTime']['output']>
  last_state_time?: Maybe<Scalars['DateTime']['output']>
}

export type ModuleEvent = {
  __typename: 'ModuleEvent'
  id: Scalars['ID']['output']
  message: Scalars['String']['output']
  time: Scalars['DateTime']['output']
}

export type ModuleEventConnection = IConnection & {
  __typename: 'ModuleEventConnection'
  nodes: Array<ModuleEvent>
  pagination: Pagination
}

export enum ModuleHardware {
  bbe = 'bbe',
  beryl_bike = 'beryl_bike',
  bils_e_4g = 'bils_e_4g',
  bils_s_4g = 'bils_s_4g',
  bils_u = 'bils_u',
  scooter = 'scooter',
  smartbike_tfl = 'smartbike_tfl',
}

export enum ModuleHardwareSubtype {
  okai_es400 = 'okai_es400',
  okai_es400_gen1 = 'okai_es400_gen1',
  okai_es410 = 'okai_es410',
  okai_es410_gen3 = 'okai_es410_gen3',
  okai_es600 = 'okai_es600',
  segway_a200p_gen2 = 'segway_a200p_gen2',
  segway_b200_gen3 = 'segway_b200_gen3',
}

export enum ModuleHardwareType {
  /** Beryl bike electric hardware */
  bbe = 'BBE',
  /** Beryl bike hardware */
  beryl_bike = 'BERYL_BIKE',
  /** TFL Smartbike hardware */
  smartbike_tfl = 'SMARTBIKE_TFL',
  /** Undefined hardware */
  undefined_hw = 'UNDEFINED_HW',
  /** Unknown hardware */
  unknown_hw = 'UNKNOWN_HW',
}

export type ModuleInputAdd = {
  hardware_subtype?: InputMaybe<ModuleHardwareSubtype>
  hardware_type: ModuleHardware
  module_id: Scalars['ID']['input']
  public_key: Scalars['String']['input']
  sim_provider?: InputMaybe<SIMProvider>
  unlock_id: Scalars['ID']['input']
}

export type ModuleInputUpdate = {
  module_id: Scalars['ID']['input']
  public_key?: InputMaybe<Scalars['String']['input']>
  sim_provider?: InputMaybe<SIMProvider>
  unlock_id?: InputMaybe<Scalars['ID']['input']>
}

export type ModuleInputUpsert = {
  hardware_subtype?: InputMaybe<ModuleHardwareSubtype>
  hardware_type?: InputMaybe<ModuleHardware>
  meta?: InputMaybe<Scalars['JSON']['input']>
  module_id: Scalars['ID']['input']
  public_key?: InputMaybe<Scalars['String']['input']>
  sim_provider?: InputMaybe<SIMProvider>
  unlock_id?: InputMaybe<Scalars['ID']['input']>
}

export type ModuleOrderby = {
  id?: InputMaybe<Direction>
  telemetry?: InputMaybe<TelemetryOrderby>
}

export type ModuleState = IModuleState & {
  __typename: 'ModuleState'
  assist_config?: Maybe<AssistConfig>
  assist_mode?: Maybe<AssistMode>
  battery_id?: Maybe<Scalars['String']['output']>
  /** To differentiate between beryl bikes and tfl smartbikes using the board hardware type */
  board_hw_type?: Maybe<ModuleHardwareType>
  commit_hash?: Maybe<Scalars['String']['output']>
  debug_mode?: Maybe<Scalars['Boolean']['output']>
  dock_nfc_tag_id?: Maybe<Scalars['String']['output']>
  drive_id?: Maybe<Scalars['String']['output']>
  firmware_version?: Maybe<Scalars['String']['output']>
  hardware_version?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  imei?: Maybe<Scalars['String']['output']>
  imsi?: Maybe<Scalars['String']['output']>
  installed_deployment_id?: Maybe<Scalars['Int']['output']>
  mac_address?: Maybe<Scalars['String']['output']>
  orientation?: Maybe<Scalars['String']['output']>
  pending_firmware_url?: Maybe<Scalars['String']['output']>
  power_cycles?: Maybe<Scalars['Int']['output']>
  power_mode?: Maybe<Scalars['String']['output']>
  status_accelerometer?: Maybe<Scalars['Int']['output']>
  status_battery_voltage?: Maybe<Scalars['Boolean']['output']>
  status_charging_current?: Maybe<Scalars['Boolean']['output']>
  status_front_light?: Maybe<Scalars['Int']['output']>
  status_generated_power?: Maybe<Scalars['Boolean']['output']>
  status_gnss_module?: Maybe<Scalars['String']['output']>
  status_lock?: Maybe<Scalars['Int']['output']>
  status_rear_light?: Maybe<Scalars['Int']['output']>
  status_supercap_voltage?: Maybe<Scalars['Boolean']['output']>
  status_temp_sensor?: Maybe<Scalars['Int']['output']>
  time: Scalars['DateTime']['output']
  watchdog_resets?: Maybe<Scalars['Int']['output']>
}

export type ModuleTag = {
  __typename: 'ModuleTag'
  created_at: Scalars['DateTime']['output']
  deleted?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  module_id: Scalars['ID']['output']
  name: ModuleTagName
}

/** List of acceptable tag names */
export enum ModuleTagName {
  /** Vehicle is being used as part of an event */
  event = 'event',
  /** Ignore battery_level when deciding if vehicle is available */
  low_battery_override = 'low_battery_override',
  /** Flagged for maintenance */
  maintenance = 'maintenance',
  /** Missing */
  missing = 'missing',
  /** Vehicle is vandalised */
  vandalism = 'vandalism',
  /** In workshop */
  workshop = 'workshop',
}

export type ModuleWhere = {
  bike?: InputMaybe<BikeWhere>
  connectivity?: InputMaybe<ConnectivityWhere>
  hardware_type?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
  iot_state?: InputMaybe<IotStateWhere>
  tags?: InputMaybe<TagWhere>
  telemetry?: InputMaybe<TelemetryWhere>
  unlock_id?: InputMaybe<ScalarOp>
  vehicle?: InputMaybe<VehicleWhere>
}

export type Mutation = {
  __typename: 'Mutation'
  /** Activates the SIM card for a module */
  activate_sim: Scalars['Boolean']['output']
  /** Adds a zone to user's favourites */
  add_favourite_zone: OperationResult
  add_manufacturing_info?: Maybe<Scalars['Boolean']['output']>
  /** Add module ('module' is a reserved keyword) */
  add_module: Module
  add_org_scheme?: Maybe<Scalars['Boolean']['output']>
  /** Add permitted vehicle model to a scheme */
  add_permitted_vehicle_model: PermittedVehicleModel
  /** Add registration ID - used for push notifications */
  add_registration_id: Scalars['Boolean']['output']
  /** Adds a user role */
  add_role: Role
  /** Add scheme */
  add_scheme: Scheme
  /** Add scheme accounting information */
  add_scheme_accounting: SchemeAccounting
  /** Adds a SchemeAddon */
  add_scheme_addon: SchemeAddon
  /** Add a scheme availability restriction */
  add_scheme_availability_restriction?: Maybe<SchemeAvailabilityRestriction>
  /** Add scheme group information */
  add_scheme_group: SchemeGroup
  /** Adds a scheme product */
  add_scheme_product: SchemeProduct
  /** Add service area */
  add_service_area?: Maybe<ServiceArea>
  /** Adds a firebase user */
  add_user: User
  /** Buy a scheme addon on session */
  add_user_addon?: Maybe<IInvoice>
  /** Buy a scheme addon instantly either as a gift or with saved payment method */
  add_user_addon_off_session?: Maybe<IInvoice>
  /** Register a user with a device - Syncs with Persona */
  add_user_device: Scalars['Boolean']['output']
  /** Buy a user product */
  add_user_product?: Maybe<UserProduct>
  /** Buy a user product */
  add_user_product_V2?: Maybe<IInvoice>
  /** Add a user to a scheme */
  add_user_scheme: Scalars['Boolean']['output']
  /**
   * Subscribe to a subscription_pass product.
   * off_session charges the saved card now, for ops subscribing on someone's behalf -
   * it fails rather than returning an SCA handshake nobody is there to complete.
   */
  add_user_subscription?: Maybe<UserSubscription>
  /** Add a vehicle */
  add_vehicle?: Maybe<Vehicle>
  /** Add entry to whitelist */
  add_whitelist: Whitelist
  /** Add zone */
  add_zone?: Maybe<Zone>
  adjust_end_journey: Journey
  apply_vehicle_configuration?: Maybe<Scalars['Boolean']['output']>
  archive_restore: Scalars['Boolean']['output']
  /** Block the user's Card fingerprint on Stripe */
  block_user_card_fingerprint: Scalars['Boolean']['output']
  /** Set the user's Persona account to blocked (Naughty) */
  block_user_identity_platform_account: Scalars['Boolean']['output']
  bust_cached_firmware_versions?: Maybe<Scalars['Boolean']['output']>
  /**
   * Cancel a journey - will trigger a journey penalty - usually a module locking will trigger journey end
   * @deprecated Use adjust_end_journey
   */
  cancel_journey: Journey
  /** Cancel a scheduled zone suspension. May affect multiple zones */
  cancel_scheduled_zone_suspension: Scalars['Boolean']['output']
  /**
   * Cancel a subscription now. The refund is opt in: prorate_refund for the unused
   * part of the period, or refund_amount for a figure of your own.
   */
  cancel_user_subscription?: Maybe<UserSubscription>
  /**
   * Commission a bike
   * @deprecated Use commission_V2
   */
  commission: Bike
  /** Commission a bike */
  commission_V2: Vehicle
  /** Commission an asset via ServiceNow */
  commission_asset: Job
  create_charge_exemption: OperationResult
  create_eoj_promotion: EoJPromotion
  create_incident?: Maybe<Incident>
  /** Create a Job */
  create_job?: Maybe<Job>
  /** Create journey insight metadata */
  create_journey_insights: JourneyInsights
  /** Create an onfido check to trigger the document verification process */
  create_onfido_check: Scalars['Boolean']['output']
  /** Create an onfido client sdk token for a given user */
  create_onfido_sdk_token: OnfidoSDKToken
  /** Schedule a zone suspension for the future. May be applied to multiple zones. All zones must be in the same scheme. */
  create_scheduled_zone_suspension: ScheduledZoneSuspension
  /** Create setup_intent for caller */
  create_setup_intent?: Maybe<SetupIntent>
  /** Creates a firebase user */
  create_user: Scalars['ID']['output']
  create_validation_rule: ValidationRule
  /** Decommission a module */
  decommission?: Maybe<Scalars['Boolean']['output']>
  /** Decommission an asset via ServiceNow */
  decommission_asset: Job
  /** Decrypt an email sent by Swift App */
  decrypt_swift_email: Scalars['String']['output']
  delete_charge_exemption: OperationResult
  /** Schedule deletion of a module's IoT device profile */
  delete_device_profile: Scalars['Boolean']['output']
  /** Delete a job */
  delete_job?: Maybe<Scalars['Boolean']['output']>
  delete_ota_configuration_command?: Maybe<OTAConfigurationCommand>
  delete_ota_firmware?: Maybe<OTAFirmware>
  delete_permitted_vehicle_model: Scalars['Boolean']['output']
  /** Disables the onboard geofence functionality on the device */
  disable_onboard_geofencing?: Maybe<Scalars['Boolean']['output']>
  /** Disables server geofencing on the device */
  disable_server_geofencing?: Maybe<Scalars['Boolean']['output']>
  /** Enables the onboard geofence functionality on the device */
  enable_onboard_geofencing?: Maybe<Scalars['Boolean']['output']>
  /** Enables server geofencing on the device */
  enable_server_geofencing?: Maybe<Scalars['Boolean']['output']>
  /** Enables a zone */
  enable_zone?: Maybe<Zone>
  /** End a journey - usually a module locking will trigger journey end */
  end_journey: Journey
  /**
   * Stop a subscription renewing. Access runs to the period end.
   * Returns the subscription as it was - cancel_at follows from the provider.
   */
  end_user_subscription?: Maybe<UserSubscription>
  /** Force add a user's phone number, if they aren't able to add it via Firebase */
  force_add_user_phone_number: Scalars['Boolean']['output']
  /** Instructs a module to go into hibernate mode */
  hibernate: Scalars['Boolean']['output']
  insert_ota_configuration_command?: Maybe<OTAConfigurationCommand>
  /** No longer allow current access token */
  invalidate_access_token: Scalars['Boolean']['output']
  /** Set the has_valid_licence flag for a user to false */
  invalidate_user_licence: User
  job_add_asset: ChildJob
  /** Job automation */
  job_automation?: Maybe<Scalars['Boolean']['output']>
  job_remove_asset: ChildJob
  /** Set a job's parent */
  job_update_parent: JobUpdateParentResult
  /** Locates a module */
  locate?: Maybe<Scalars['Boolean']['output']>
  /** Instructs a module to remotely lock - only supported by scooters and virtualbikes */
  lock: Scalars['Boolean']['output']
  /** Locks a bike in context of journey - currently used for scooters */
  lock_journey: Journey
  /** Move a commissioned device from one scheme to another */
  move_scheme: Vehicle
  ota_geofence_sync?: Maybe<Scalars['Boolean']['output']>
  /** Pause a journey */
  pause_journey: Journey
  promote_ota_firmware?: Maybe<OTAFirmware>
  /** Instructs a module to reboot */
  reboot: Scalars['Boolean']['output']
  /** Amend journey duration and recalculate charges */
  recalculate_journey_invoice?: Maybe<RefundInvoiceResult>
  /**
   * Requests config from IoT device
   * @deprecated Use refresh_ota_device_information
   */
  refresh_config?: Maybe<Scalars['Boolean']['output']>
  refresh_ota_device_information?: Maybe<Scalars['Boolean']['output']>
  refresh_ota_device_information_async?: Maybe<Scalars['Boolean']['output']>
  /** Fully or partially refund currency and minutes on an invoice */
  refund_invoice?: Maybe<RefundInvoiceResult>
  refund_invoice_excess_balance?: Maybe<RefundInvoiceResult>
  refund_invoice_v2?: Maybe<RefundInvoiceResult>
  /** Register job attempt */
  register_job_attempt?: Maybe<Attempt>
  /** Releases a modules battery */
  release_battery?: Maybe<Scalars['Boolean']['output']>
  /** Instructs a module to release lock */
  release_lock: Scalars['Boolean']['output']
  /** Removes a zone from user's favourites */
  remove_favourite_zone: OperationResult
  remove_org_scheme?: Maybe<Scalars['Boolean']['output']>
  /** Removes a card from a payer */
  remove_payer_card?: Maybe<Scalars['Boolean']['output']>
  /** Remove registration ID - used to cancel push notifications on logout */
  remove_registration_id: Scalars['Boolean']['output']
  /** Removes a user role */
  remove_role?: Maybe<Scalars['Boolean']['output']>
  /** Remove a scheme accounting */
  remove_scheme_accounting?: Maybe<Scalars['Boolean']['output']>
  /** Remove a SchemeAddon */
  remove_scheme_addon?: Maybe<Scalars['Boolean']['output']>
  /** Remove a scheme availability restriction */
  remove_scheme_availability_restriction?: Maybe<Scalars['Boolean']['output']>
  /** Remove a scheme group */
  remove_scheme_group?: Maybe<Scalars['Boolean']['output']>
  /** Remove a scheme product */
  remove_scheme_product?: Maybe<Scalars['Boolean']['output']>
  /** Remove a service area */
  remove_service_area?: Maybe<Scalars['Boolean']['output']>
  /** Remove user */
  remove_user?: Maybe<Scalars['Boolean']['output']>
  /** Removes a user's phone number */
  remove_user_phone_number: Scalars['Boolean']['output']
  /** Remove entry in whitelist */
  remove_whitelist?: Maybe<Scalars['Boolean']['output']>
  /** Remove zone */
  remove_zone?: Maybe<Scalars['Boolean']['output']>
  request_delete_user: OperationResult
  /** Resume a journey */
  resume_journey: Journey
  /**
   * Keep a subscription renewing after an end was scheduled, while the period runs.
   * Returns the subscription as it was - cancel_at is cleared by the provider.
   */
  resume_user_subscription?: Maybe<UserSubscription>
  /** Pay a period the provider is still chasing. */
  retry_user_subscription_payment?: Maybe<UserSubscription>
  /** @deprecated Use recalculate_journey_invoice */
  reverse_cancelled_journey?: Maybe<RefundInvoiceResult>
  /** Instructs a vehicle to lock asynchronously, and with a movement failsafe */
  safe_lock: Scalars['Boolean']['output']
  send_custom_notification: Scalars['Boolean']['output']
  /** Send sign in email to specified email address */
  send_sign_in_email_link: Scalars['Boolean']['output']
  /** Send anonymous user_id to user service to generate and push token to mobile */
  send_sign_in_request: Scalars['JSON']['output']
  /** Instructs a module to send telemetry */
  send_telemetry: Scalars['Boolean']['output']
  /** Sets the modules electric assist config */
  set_assist_config: Scalars['Boolean']['output']
  set_device_password?: Maybe<Scalars['Boolean']['output']>
  /** Set Apple Live Activity push token for journey */
  set_live_activity_push_token: Scalars['Boolean']['output']
  set_notification_preference: Array<NotificationTopicGroup>
  /** Set the preferred type of currency payment provider for this payer */
  set_preferred_currency_payment_provider?: Maybe<Scalars['Boolean']['output']>
  /** Set payment token from Swift webview callback */
  set_swift_payment_authorisation?: Maybe<Scalars['Boolean']['output']>
  /** Sets notes on a zone */
  set_zone_notes?: Maybe<Zone>
  /** Set/Unset a zone as priority */
  set_zone_priority: Zone
  /** Set/Unset a zone as promotional */
  set_zone_promotional?: Maybe<Zone>
  /** Settle outstanding charges on an Invoice */
  settle_invoice_V2?: Maybe<IInvoice>
  /** Settle outstanding charges on an Invoice – CORE */
  settle_invoice_off_session?: Maybe<IInvoice>
  /** Set a module to shipping mode */
  shipping?: Maybe<Scalars['Boolean']['output']>
  sideload_module_firmware?: Maybe<Scalars['Boolean']['output']>
  /** Start deployment */
  start_deployment?: Maybe<Deployment>
  /** Start a journey, specifying module_id */
  start_journey_by_module_id: Journey
  /** Start a journey, specifying module_id */
  start_journey_by_module_id_v2: JourneySet
  /** Start a journey, specifying unlock_id */
  start_journey_by_unlock_id: Journey
  /** Start a journey, specifying unlock_id */
  start_journey_by_unlock_id_v2: JourneySet
  subscribe_to_topic: Scalars['Boolean']['output']
  /**
   * Suspends a zone
   * @deprecated Replaced by suspend_zone_with_reason
   */
  suspend_zone?: Maybe<Zone>
  /** Suspends a zone */
  suspend_zone_with_reason?: Maybe<Zone>
  sync_service_areas?: Maybe<ServiceAreaSyncResult>
  /** Sync zones */
  sync_zones?: Maybe<ZoneSyncResult>
  /** Synchronize a user with its Firebase claims */
  synchronize_firebase_user: User
  /** Un-block the user's Card fingerprint on Stripe */
  unblock_user_card_fingerprint: Scalars['Boolean']['output']
  /** Unblock the user's Persona account */
  unblock_user_identity_platform_account: Scalars['Boolean']['output']
  /** Unvoid a transaction */
  unvoid_transaction?: Maybe<ITransaction>
  /** Update a Job */
  update_job?: Maybe<Job>
  /** Update multiple Jobs */
  update_jobs?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Update the user's stored licence expiry date */
  update_licence_expiry_date?: Maybe<Scalars['Boolean']['output']>
  /** Update module ('module' is a reserved keyword) */
  update_module: Module
  /** Update a scheme */
  update_scheme: Scheme
  /** Updates a scheme accounting */
  update_scheme_accounting: SchemeAccounting
  /** Updates a SchemeAddon */
  update_scheme_addon: SchemeAddon
  /** Update a scheme availability restriction */
  update_scheme_availability_restriction?: Maybe<SchemeAvailabilityRestriction>
  /** Updates a scheme group */
  update_scheme_group: SchemeGroup
  /** Updates a schemeProduct */
  update_scheme_product: SchemeProduct
  /** Update service area */
  update_service_area?: Maybe<ServiceArea>
  /** Update service area policy */
  update_service_area_policy?: Maybe<ServiceArea>
  /** Update a Task */
  update_task?: Maybe<Scalars['Boolean']['output']>
  update_vehicle_detail?: Maybe<Vehicle>
  /** Update zone */
  update_zone?: Maybe<Zone>
  upgrade_module_firmwares?: Maybe<Scalars['Boolean']['output']>
  /** Upsert module */
  upsert_module: Module
  upsert_ota_firmware?: Maybe<OTAFirmware>
  validate_product_promotion: ProductDiscountPromotion
  /** Validate a task replacement */
  validate_replacements?: Maybe<Scalars['Boolean']['output']>
  /** Set the has_valid_licence flag for a user to true */
  validate_user_licence: User
  /** Validates a voucher code and returns a voucher with a list of scheme products with discount_calculations attached */
  validate_voucher_code: Voucher
  vehicle_event_end?: Maybe<Scalars['Boolean']['output']>
  vehicle_event_start?: Maybe<Scalars['Boolean']['output']>
  vehicle_located?: Maybe<Scalars['Boolean']['output']>
  vehicle_low_battery_override_end?: Maybe<Scalars['Boolean']['output']>
  vehicle_low_battery_override_start?: Maybe<Scalars['Boolean']['output']>
  vehicle_maintenance_end?: Maybe<Scalars['Boolean']['output']>
  vehicle_maintenance_pick_up?: Maybe<Scalars['Boolean']['output']>
  vehicle_maintenance_start?: Maybe<Scalars['Boolean']['output']>
  vehicle_missing?: Maybe<Scalars['Boolean']['output']>
  vehicle_provider_drop_off?: Maybe<Scalars['Boolean']['output']>
  vehicle_rebalance_cancel?: Maybe<Scalars['Boolean']['output']>
  vehicle_rebalance_pick_up?: Maybe<Scalars['Boolean']['output']>
  vehicle_safe_maintenance_end?: Maybe<Scalars['Boolean']['output']>
  vehicle_vandalism_end?: Maybe<Scalars['Boolean']['output']>
  vehicle_vandalism_start?: Maybe<Scalars['Boolean']['output']>
  /**
   * Void a journey - usually a module locking will trigger journey end
   * @deprecated Use adjust_end_journey
   */
  void_journey: Journey
  /** Void a transaction */
  void_transaction?: Maybe<ITransaction>
}

export type Mutationactivate_simArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationadd_favourite_zoneArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
  zone_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationadd_manufacturing_infoArgs = {
  manufacturing_info: ManufacturingInfoInput
}

export type Mutationadd_moduleArgs = {
  mod: ModuleInputAdd
}

export type Mutationadd_org_schemeArgs = {
  org_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
}

export type Mutationadd_permitted_vehicle_modelArgs = {
  permitted_vehicle_model: PermittedVehicleModelInput
}

export type Mutationadd_registration_idArgs = {
  registration_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationadd_roleArgs = {
  role: RoleInput
}

export type Mutationadd_schemeArgs = {
  scheme: SchemeInput
}

export type Mutationadd_scheme_accountingArgs = {
  scheme_accounting: SchemeAccountingInput
}

export type Mutationadd_scheme_addonArgs = {
  scheme_addon: SchemeAddonInput
}

export type Mutationadd_scheme_availability_restrictionArgs = {
  scheme_availability_restriction: SchemeAvailabilityRestrictionInput
}

export type Mutationadd_scheme_groupArgs = {
  scheme_group: SchemeGroupInput
}

export type Mutationadd_scheme_productArgs = {
  scheme_product: SchemeProductInput
}

export type Mutationadd_service_areaArgs = {
  service_area: ServiceAreaInput
}

export type Mutationadd_userArgs = {
  user: UserInput
}

export type Mutationadd_user_addonArgs = {
  promotion_id?: InputMaybe<Scalars['ID']['input']>
  scheme_addon_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
  voucher_code?: InputMaybe<Scalars['String']['input']>
}

export type Mutationadd_user_addon_off_sessionArgs = {
  free_gift: Scalars['Boolean']['input']
  scheme_addon_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
  voucher_code?: InputMaybe<Scalars['String']['input']>
}

export type Mutationadd_user_deviceArgs = {
  device_vendor_id: Scalars['String']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationadd_user_productArgs = {
  free_gift?: InputMaybe<Scalars['Boolean']['input']>
  reward?: InputMaybe<VehicleRewardType>
  scheme_product_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
  voucher_code?: InputMaybe<Scalars['String']['input']>
  voucher_purchase?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationadd_user_product_V2Args = {
  promotion_id?: InputMaybe<Scalars['ID']['input']>
  scheme_product_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
  voucher_code?: InputMaybe<Scalars['String']['input']>
}

export type Mutationadd_user_schemeArgs = {
  scheme_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationadd_user_subscriptionArgs = {
  off_session?: InputMaybe<Scalars['Boolean']['input']>
  scheme_product_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationadd_vehicleArgs = {
  frame_id: Scalars['ID']['input']
  frame_model?: InputMaybe<Scalars['String']['input']>
  frame_type: FrameType
  frame_year?: InputMaybe<Scalars['Int']['input']>
  hardware_type: ModuleHardware
  propulsion_type: Array<VehiclePropulsionType>
  vehicle_type: VehicleType
}

export type Mutationadd_whitelistArgs = {
  whitelist: WhitelistInput
}

export type Mutationadd_zoneArgs = {
  zone: ZoneInput
}

export type Mutationadjust_end_journeyArgs = {
  action: EndJourneyActionType
  adjustments: EndJourneyAdjustmentsInput
  journey_id: Scalars['ID']['input']
}

export type Mutationapply_vehicle_configurationArgs = {
  dry_run?: InputMaybe<Scalars['Boolean']['input']>
  module_id: Scalars['ID']['input']
}

export type Mutationarchive_restoreArgs = {
  sys_id: Scalars['ID']['input']
}

export type Mutationblock_user_card_fingerprintArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationblock_user_identity_platform_accountArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationbust_cached_firmware_versionsArgs = {
  firmware_types?: InputMaybe<Array<FirmwareType>>
  vehicle_id: Scalars['ID']['input']
}

export type Mutationcancel_journeyArgs = {
  journey_id: Scalars['ID']['input']
  use_movement_check?: InputMaybe<Scalars['Boolean']['input']>
  with_lock_or_raise_job?: InputMaybe<Scalars['Boolean']['input']>
  with_safe_lock?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationcancel_scheduled_zone_suspensionArgs = {
  scheduled_zone_suspension_id: Scalars['ID']['input']
}

export type Mutationcancel_user_subscriptionArgs = {
  prorate_refund?: InputMaybe<Scalars['Boolean']['input']>
  refund_amount?: InputMaybe<Scalars['Int']['input']>
  subscription_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type MutationcommissionArgs = {
  frame_id: Scalars['ID']['input']
  module_id?: InputMaybe<Scalars['ID']['input']>
  scheme_id: Scalars['ID']['input']
}

export type Mutationcommission_V2Args = {
  frame_id: Scalars['ID']['input']
  frame_type: FrameType
  hardware_subtype?: InputMaybe<ModuleHardwareSubtype>
  lock_configuration: LockConfiguration
  module_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
  vehicle_unlock_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationcommission_assetArgs = {
  asset: ParentAsset
  scheme_id: Scalars['ID']['input']
  taskId: Scalars['ID']['input']
  uuid?: InputMaybe<Scalars['ID']['input']>
  zone_id?: InputMaybe<Scalars['String']['input']>
}

export type Mutationcreate_charge_exemptionArgs = {
  scheme_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationcreate_eoj_promotionArgs = {
  promotion: EoJPromotionInput
}

export type Mutationcreate_incidentArgs = {
  incident: IncidentInput
}

export type Mutationcreate_jobArgs = {
  job: JobInput
}

export type Mutationcreate_journey_insightsArgs = {
  journey_id: Scalars['ID']['input']
  rating: Scalars['Float']['input']
  reason_other?: InputMaybe<Scalars['String']['input']>
  reasons: Array<Scalars['String']['input']>
  user_id: Scalars['ID']['input']
}

export type Mutationcreate_onfido_checkArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationcreate_onfido_sdk_tokenArgs = {
  bundle_identifier: Scalars['String']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationcreate_scheduled_zone_suspensionArgs = {
  input: ScheduledZoneSuspensionInput
}

export type Mutationcreate_setup_intentArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationcreate_userArgs = {
  email: Scalars['EmailAddress']['input']
}

export type Mutationcreate_validation_ruleArgs = {
  validation_rules: ValidationRulesInput
}

export type MutationdecommissionArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationdecommission_assetArgs = {
  external_id: Scalars['ID']['input']
}

export type Mutationdecrypt_swift_emailArgs = {
  hash: Scalars['String']['input']
}

export type Mutationdelete_charge_exemptionArgs = {
  scheme_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationdelete_device_profileArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationdelete_jobArgs = {
  job_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationdelete_ota_configuration_commandArgs = {
  id: Scalars['Int']['input']
}

export type Mutationdelete_ota_firmwareArgs = {
  id: Scalars['Int']['input']
}

export type Mutationdelete_permitted_vehicle_modelArgs = {
  permitted_vehicle_model_id: Scalars['ID']['input']
}

export type Mutationdisable_onboard_geofencingArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationdisable_server_geofencingArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationenable_onboard_geofencingArgs = {
  module_id: Scalars['ID']['input']
  only_while_unlocked?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationenable_server_geofencingArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationenable_zoneArgs = {
  zone_id: Scalars['ID']['input']
}

export type Mutationend_journeyArgs = {
  journey_id: Scalars['ID']['input']
  use_movement_check?: InputMaybe<Scalars['Boolean']['input']>
  with_lock_or_raise_job?: InputMaybe<Scalars['Boolean']['input']>
  with_safe_lock?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationend_user_subscriptionArgs = {
  subscription_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationforce_add_user_phone_numberArgs = {
  phone_number: Scalars['String']['input']
  user_id: Scalars['ID']['input']
}

export type MutationhibernateArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationinsert_ota_configuration_commandArgs = {
  input: OTAConfigurationCommandInput
}

export type Mutationinvalidate_user_licenceArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationjob_add_assetArgs = {
  asset_tag: Scalars['ID']['input']
  job_id: Scalars['ID']['input']
}

export type Mutationjob_automationArgs = {
  assets?: InputMaybe<Array<Scalars['String']['input']>>
  description: Scalars['String']['input']
  dry_run: Scalars['Boolean']['input']
  justification_id: Scalars['String']['input']
  results?: InputMaybe<Array<InputMaybe<JobAutomationVehicleInput>>>
  side_effects: Array<InputMaybe<JobAutomationSideEffect>>
  taskId: Scalars['String']['input']
  use_cleanup?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationjob_remove_assetArgs = {
  asset_tag: Scalars['ID']['input']
  job_id: Scalars['ID']['input']
}

export type Mutationjob_update_parentArgs = {
  job_id: Scalars['ID']['input']
  parent_job_id: Scalars['ID']['input']
}

export type MutationlocateArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type MutationlockArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationlock_journeyArgs = {
  journey_id: Scalars['ID']['input']
}

export type Mutationmove_schemeArgs = {
  module_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
}

export type Mutationota_geofence_syncArgs = {
  scheme_id: Scalars['ID']['input']
}

export type Mutationpause_journeyArgs = {
  journey_id: Scalars['ID']['input']
}

export type Mutationpromote_ota_firmwareArgs = {
  id: Scalars['Int']['input']
  status: FirmwareStatus
}

export type MutationrebootArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationrecalculate_journey_invoiceArgs = {
  invoice_id: Scalars['ID']['input']
  refund_request: ReverseCancelledJourneyInput
}

export type Mutationrefresh_configArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationrefresh_ota_device_informationArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationrefresh_ota_device_information_asyncArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationrefund_invoiceArgs = {
  invoice_id: Scalars['ID']['input']
  refund_invoice: RefundInvoiceInput
}

export type Mutationrefund_invoice_excess_balanceArgs = {
  invoice_id: Scalars['ID']['input']
  refund_request: ReverseCancelledJourneyInput
}

export type Mutationrefund_invoice_v2Args = {
  invoice_id: Scalars['ID']['input']
  refund_invoice: RefundInvoiceV2Input
}

export type Mutationregister_job_attemptArgs = {
  attempt: AttemptInput
  job_id: Scalars['ID']['input']
}

export type Mutationrelease_batteryArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationrelease_lockArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationremove_favourite_zoneArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
  zone_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationremove_org_schemeArgs = {
  org_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
}

export type Mutationremove_payer_cardArgs = {
  card_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationremove_registration_idArgs = {
  registration_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationremove_roleArgs = {
  role_id: Scalars['ID']['input']
}

export type Mutationremove_scheme_accountingArgs = {
  scheme_accounting_id: Scalars['ID']['input']
}

export type Mutationremove_scheme_addonArgs = {
  scheme_addon_id: Scalars['ID']['input']
}

export type Mutationremove_scheme_availability_restrictionArgs = {
  scheme_availability_restriction_id: Scalars['ID']['input']
}

export type Mutationremove_scheme_groupArgs = {
  scheme_group_id: Scalars['ID']['input']
}

export type Mutationremove_scheme_productArgs = {
  scheme_product_id: Scalars['ID']['input']
}

export type Mutationremove_service_areaArgs = {
  service_area_id: Scalars['ID']['input']
}

export type Mutationremove_userArgs = {
  user: UserInput
}

export type Mutationremove_user_phone_numberArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationremove_whitelistArgs = {
  whitelist_id: Scalars['ID']['input']
}

export type Mutationremove_zoneArgs = {
  zone_id: Scalars['ID']['input']
}

export type Mutationrequest_delete_userArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationresume_journeyArgs = {
  journey_id: Scalars['ID']['input']
}

export type Mutationresume_user_subscriptionArgs = {
  subscription_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationretry_user_subscription_paymentArgs = {
  subscription_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationreverse_cancelled_journeyArgs = {
  invoice_id: Scalars['ID']['input']
  refund_request: ReverseCancelledJourneyInput
}

export type Mutationsafe_lockArgs = {
  use_movement_check?: InputMaybe<Scalars['Boolean']['input']>
  vehicle_id: Scalars['ID']['input']
}

export type Mutationsend_custom_notificationArgs = {
  body: Scalars['String']['input']
  show_in_app: Scalars['Boolean']['input']
  title: Scalars['String']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationsend_sign_in_email_linkArgs = {
  email_link: EmailLinkInput
}

export type Mutationsend_sign_in_requestArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationsend_telemetryArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationset_assist_configArgs = {
  assist_config: AssistConfig
  module_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Mutationset_device_passwordArgs = {
  hardware_subtype?: InputMaybe<ModuleHardwareSubtype>
  module_id: Scalars['ID']['input']
}

export type Mutationset_live_activity_push_tokenArgs = {
  journey_id: Scalars['ID']['input']
  push_token: Scalars['String']['input']
}

export type Mutationset_notification_preferenceArgs = {
  notification_preference: NotificationPreferenceInput
  scheme_id: Scalars['ID']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationset_preferred_currency_payment_providerArgs = {
  preferred_provider: CurrencyPaymentProviderType
  user_id: Scalars['ID']['input']
}

export type Mutationset_swift_payment_authorisationArgs = {
  always_ask: Scalars['Boolean']['input']
  payment_token: Scalars['String']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationset_zone_notesArgs = {
  notes?: InputMaybe<Scalars['String']['input']>
  zone_id: Scalars['ID']['input']
}

export type Mutationset_zone_priorityArgs = {
  is_priority: Scalars['Boolean']['input']
  zone_id: Scalars['ID']['input']
}

export type Mutationset_zone_promotionalArgs = {
  is_promotional: Scalars['Boolean']['input']
  zone_id: Scalars['ID']['input']
}

export type Mutationsettle_invoice_V2Args = {
  invoice_id: Scalars['ID']['input']
}

export type Mutationsettle_invoice_off_sessionArgs = {
  invoice_id: Scalars['ID']['input']
}

export type MutationshippingArgs = {
  module_id: Scalars['ID']['input']
}

export type Mutationsideload_module_firmwareArgs = {
  firmware_id: Scalars['Int']['input']
  module_id: Scalars['ID']['input']
}

export type Mutationstart_deploymentArgs = {
  module_ids: Array<InputMaybe<Scalars['ID']['input']>>
  version: Scalars['String']['input']
}

export type Mutationstart_journey_by_module_idArgs = {
  initiator?: InputMaybe<JourneyInitiator>
  initiator_unlock_method?: InputMaybe<UnlockMethod>
  module_id: Scalars['ID']['input']
  pausable?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationstart_journey_by_module_id_v2Args = {
  as_group_ride?: InputMaybe<Scalars['Boolean']['input']>
  initiator?: InputMaybe<JourneyInitiator>
  initiator_unlock_method?: InputMaybe<UnlockMethod>
  module_id: Scalars['ID']['input']
}

export type Mutationstart_journey_by_unlock_idArgs = {
  initiator?: InputMaybe<JourneyInitiator>
  initiator_unlock_method?: InputMaybe<UnlockMethod>
  pausable?: InputMaybe<Scalars['Boolean']['input']>
  unlock_id: Scalars['ID']['input']
}

export type Mutationstart_journey_by_unlock_id_v2Args = {
  as_group_ride?: InputMaybe<Scalars['Boolean']['input']>
  initiator?: InputMaybe<JourneyInitiator>
  initiator_unlock_method?: InputMaybe<UnlockMethod>
  unlock_id: Scalars['ID']['input']
}

export type Mutationsubscribe_to_topicArgs = {
  topic: Scalars['String']['input']
  user_id: Scalars['ID']['input']
}

export type Mutationsuspend_zoneArgs = {
  zone_id: Scalars['ID']['input']
}

export type Mutationsuspend_zone_with_reasonArgs = {
  suspension_reason?: InputMaybe<ZoneSuspensionInfoInput>
  zone_id: Scalars['ID']['input']
}

export type Mutationsync_service_areasArgs = {
  dry_run?: InputMaybe<Scalars['Boolean']['input']>
  scheme_id: Scalars['ID']['input']
}

export type Mutationsync_zonesArgs = {
  dry_run?: InputMaybe<Scalars['Boolean']['input']>
  scheme_id: Scalars['ID']['input']
}

export type Mutationsynchronize_firebase_userArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationunblock_user_card_fingerprintArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationunblock_user_identity_platform_accountArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationunvoid_transactionArgs = {
  transaction_id: Scalars['GUID']['input']
}

export type Mutationupdate_jobArgs = {
  job: JobUpdateInput
  job_id: Scalars['ID']['input']
}

export type Mutationupdate_jobsArgs = {
  job: JobUpdateInput
  job_ids: Array<Scalars['ID']['input']>
}

export type Mutationupdate_licence_expiry_dateArgs = {
  expiry_date?: InputMaybe<Scalars['String']['input']>
  user_id: Scalars['ID']['input']
}

export type Mutationupdate_moduleArgs = {
  mod: ModuleInputUpdate
}

export type Mutationupdate_schemeArgs = {
  scheme: SchemeInput
  scheme_id: Scalars['ID']['input']
}

export type Mutationupdate_scheme_accountingArgs = {
  scheme_accounting: SchemeAccountingInput
  scheme_accounting_id: Scalars['ID']['input']
}

export type Mutationupdate_scheme_addonArgs = {
  scheme_addon: SchemeAddonInput
  scheme_addon_id: Scalars['ID']['input']
}

export type Mutationupdate_scheme_availability_restrictionArgs = {
  scheme_availability_restriction: SchemeAvailabilityRestrictionInput
  scheme_availability_restriction_id: Scalars['ID']['input']
}

export type Mutationupdate_scheme_groupArgs = {
  scheme_group: SchemeGroupInput
  scheme_group_id: Scalars['ID']['input']
}

export type Mutationupdate_scheme_productArgs = {
  scheme_product: SchemeProductInput
  scheme_product_id: Scalars['ID']['input']
}

export type Mutationupdate_service_areaArgs = {
  service_area: ServiceAreaInput
  service_area_id: Scalars['ID']['input']
}

export type Mutationupdate_service_area_policyArgs = {
  service_area_id: Scalars['ID']['input']
  service_area_policy: ServiceAreaPolicyInput
}

export type Mutationupdate_taskArgs = {
  job_id?: InputMaybe<Scalars['ID']['input']>
  task: JobTaskInput
}

export type Mutationupdate_vehicle_detailArgs = {
  vehicle_detail: VehicleDetailUpdateInput
  vehicle_id: Scalars['ID']['input']
}

export type Mutationupdate_zoneArgs = {
  zone: ZoneInput
  zone_id: Scalars['ID']['input']
}

export type Mutationupgrade_module_firmwaresArgs = {
  allow_invalid_entities?: InputMaybe<Scalars['Boolean']['input']>
  dry_run?: InputMaybe<Scalars['Boolean']['input']>
  module_id: Scalars['ID']['input']
}

export type Mutationupsert_moduleArgs = {
  mod: ModuleInputUpsert
}

export type Mutationupsert_ota_firmwareArgs = {
  input: OTAFirmwareInput
}

export type Mutationvalidate_product_promotionArgs = {
  promotion_id: Scalars['ID']['input']
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
}

export type Mutationvalidate_replacementsArgs = {
  job_id: Scalars['ID']['input']
  task: JobTaskInput
}

export type Mutationvalidate_user_licenceArgs = {
  user_id: Scalars['ID']['input']
}

export type Mutationvalidate_voucher_codeArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
  voucher_code: Scalars['String']['input']
}

export type Mutationvehicle_event_endArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_event_startArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_locatedArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_low_battery_override_endArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_low_battery_override_startArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_maintenance_endArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_maintenance_pick_upArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_maintenance_startArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_missingArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_provider_drop_offArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_rebalance_cancelArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_rebalance_pick_upArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_safe_maintenance_endArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_vandalism_endArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvehicle_vandalism_startArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Mutationvoid_journeyArgs = {
  journey_id: Scalars['ID']['input']
  use_movement_check?: InputMaybe<Scalars['Boolean']['input']>
  with_lock_or_raise_job?: InputMaybe<Scalars['Boolean']['input']>
  with_safe_lock?: InputMaybe<Scalars['Boolean']['input']>
}

export type Mutationvoid_transactionArgs = {
  transaction_id: Scalars['GUID']['input']
}

export type NearbyZoneResult = {
  __typename: 'NearbyZoneResult'
  distance?: Maybe<Scalars['Float']['output']>
  zone: Zone
}

export type NearbyZoneResultdistanceArgs = {
  unit?: InputMaybe<DistanceUnit>
}

export enum NotificationChannelType {
  email = 'email',
  push = 'push',
}

export type NotificationPreference = {
  __typename: 'NotificationPreference'
  channel: NotificationChannelType
  enabled: Scalars['Boolean']['output']
  mandatory: Scalars['Boolean']['output']
}

export type NotificationPreferenceInput = {
  channel: NotificationChannelType
  enabled: Scalars['Boolean']['input']
  topic: Scalars['String']['input']
}

export type NotificationTopic = {
  __typename: 'NotificationTopic'
  description?: Maybe<Scalars['String']['output']>
  label: Scalars['String']['output']
  preferences: Array<NotificationPreference>
  topic: Scalars['String']['output']
}

export type NotificationTopicGroup = {
  __typename: 'NotificationTopicGroup'
  name: Scalars['String']['output']
  prefix: Scalars['String']['output']
  topics: Array<NotificationTopic>
  updated_at?: Maybe<Scalars['DateTime']['output']>
}

export type OTAConfigurationCommand = {
  __typename: 'OTAConfigurationCommand'
  command?: Maybe<Scalars['String']['output']>
  expected_status_code?: Maybe<Scalars['Int']['output']>
  frame_type?: Maybe<FrameType>
  hardware_model?: Maybe<HardwareModel>
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  scheme_id?: Maybe<Scalars['Int']['output']>
  timeout?: Maybe<Scalars['Int']['output']>
}

export type OTAConfigurationCommandInput = {
  command: Scalars['String']['input']
  expected_status_code?: InputMaybe<Scalars['Int']['input']>
  frame_type?: InputMaybe<FrameType>
  hardware_model?: InputMaybe<HardwareModel>
  name: Scalars['String']['input']
  scheme_id?: InputMaybe<Scalars['Int']['input']>
  timeout?: InputMaybe<Scalars['Int']['input']>
}

export type OTAFirmware = {
  __typename: 'OTAFirmware'
  file_name: Scalars['String']['output']
  firmware_type: FirmwareType
  firmware_version: Scalars['String']['output']
  hardware_model: HardwareModel
  hardware_version: Scalars['String']['output']
  id: Scalars['Int']['output']
  status: FirmwareStatus
}

export type OTAFirmwareInput = {
  file_name: Scalars['String']['input']
  firmware_type: FirmwareType
  firmware_version: Scalars['String']['input']
  hardware_model: HardwareModel
  hardware_version: Scalars['String']['input']
}

export type OTAInformation = {
  __typename: 'OTAInformation'
  config_set_at?: Maybe<Scalars['DateTime']['output']>
  firmware_versions: OTAVersions
  hardware_versions: OTAVersions
  required_firmware_versions: RequiredOTAVersions
  scheme_config_set_at?: Maybe<Scalars['DateTime']['output']>
  server_address: Scalars['String']['output']
  server_port: Scalars['String']['output']
  time: Scalars['DateTime']['output']
}

export type OTAVersions = {
  __typename: 'OTAVersions'
  ecu: Scalars['String']['output']
  helmet_lock?: Maybe<Scalars['String']['output']>
  iot: Scalars['String']['output']
  meter: Scalars['String']['output']
  repeater?: Maybe<Scalars['String']['output']>
}

export type OkaiScooterConfig = {
  __typename: 'OkaiScooterConfig'
  ble_sw?: Maybe<Scalars['String']['output']>
  ecu_fw?: Maybe<Scalars['String']['output']>
  ecu_hw?: Maybe<Scalars['String']['output']>
  iot_hw?: Maybe<Scalars['String']['output']>
  iot_sw?: Maybe<Scalars['String']['output']>
  mdm_hw?: Maybe<Scalars['String']['output']>
  mdm_sw?: Maybe<Scalars['String']['output']>
  server_address?: Maybe<Scalars['String']['output']>
  server_port?: Maybe<Scalars['String']['output']>
  time?: Maybe<Scalars['DateTime']['output']>
}

export type OnfidoApplicant = {
  __typename: 'OnfidoApplicant'
  id: Scalars['ID']['output']
}

export type OnfidoSDKToken = {
  __typename: 'OnfidoSDKToken'
  token: Scalars['String']['output']
}

export type OperationResult = {
  __typename: 'OperationResult'
  code?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type Org = {
  __typename: 'Org'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type OrgConnection = {
  __typename: 'OrgConnection'
  nodes: Array<Org>
  pagination: Pagination
}

export type Paginate = {
  page?: InputMaybe<Scalars['Int']['input']>
  per_page?: InputMaybe<Scalars['Int']['input']>
}

export type Pagination = {
  __typename: 'Pagination'
  has_next: Scalars['Boolean']['output']
  has_prev: Scalars['Boolean']['output']
  page: Scalars['Int']['output']
  pages: Scalars['Int']['output']
  per_page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type ParentAsset = {
  asset_tag: Scalars['String']['input']
  child_assets: Array<InputMaybe<AssetInput>>
  model: Scalars['ID']['input']
  name: Scalars['String']['input']
  serial_number: Scalars['String']['input']
  vehicle_unlock_id?: InputMaybe<Scalars['String']['input']>
}

export enum ParkingCapacityStatus {
  available_space = 'available_space',
  limited_space = 'limited_space',
  no_space = 'no_space',
}

export type ParkingPhoto = {
  __typename: 'ParkingPhoto'
  journey_id: Scalars['ID']['output']
  updated_at?: Maybe<Scalars['DateTime']['output']>
  /** Send a PUT request to this with the file valid for 15 min */
  upload: BucketPhotoUrl
  /** Get request, valid for 1 hour */
  view: BucketPhotoUrl
}

export enum ParkingStatus {
  out_of_service_area = 'out_of_service_area',
  out_of_zone = 'out_of_zone',
  valid = 'valid',
  vehicle_not_permitted = 'vehicle_not_permitted',
  zone_max_capacity = 'zone_max_capacity',
}

export type PartDetail = {
  __typename: 'PartDetail'
  batchNumber?: Maybe<Scalars['String']['output']>
  partName?: Maybe<Scalars['String']['output']>
  serialNumber?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  uuid?: Maybe<Scalars['String']['output']>
}

export type PartInput = {
  batchNumber?: InputMaybe<Scalars['String']['input']>
  partName?: InputMaybe<Scalars['String']['input']>
  serialNumber?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type PauseDurationConfig = {
  __typename: 'PauseDurationConfig'
  bike: Scalars['Int']['output']
  cargo_ebike: Scalars['Int']['output']
  ebike: Scalars['Int']['output']
  escooter: Scalars['Int']['output']
}

export type Payer = {
  __typename: 'Payer'
  created_at: Scalars['DateTime']['output']
  /** @deprecated Use PaymentProvider.default_payment_method */
  default_card?: Maybe<Card>
  deleted?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  preferred_currency_payment_provider_type: CurrencyPaymentProviderType
  providers: Array<PaymentProvider>
  user: User
}

export type PaymentIntent = {
  __typename: 'PaymentIntent'
  client_secret?: Maybe<Scalars['String']['output']>
  /** Indication that there is no more to do on this PaymentIntent. Client secret will not be populated */
  has_next_action?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
}

export type PaymentProvider = {
  __typename: 'PaymentProvider'
  /** Outstanding balance for currency providers. Minute provider should use usable_minute_balance by scheme id */
  balance?: Maybe<FormattedAmount>
  created_at: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  /** Net of minute topups (-debits) with no scheme id. These are debited first and can be used in any scheme */
  legacy_minute_balance?: Maybe<FormattedAmount>
  payer?: Maybe<Payer>
  type: PaymentProviderType
  /** Minute balance per scheme id */
  usable_minute_balance?: Maybe<Array<SchemeBalance>>
}

export enum PaymentProviderType {
  minute_customer = 'minute_customer',
  stripe_customer = 'stripe_customer',
  swift_customer = 'swift_customer',
  trafi_customer = 'trafi_customer',
}

export type PeriodPassBalances = {
  __typename: 'PeriodPassBalances'
  /** Balance from bonus passes */
  bonus_balance: FormattedAmount
  /** Balance for this current pass, other passes might mean more balance is available */
  current_balance: FormattedAmount
  /** Total pass balance available in this scheme */
  total_balance: FormattedAmount
}

export type PeriodPassCapInfo = {
  __typename: 'PeriodPassCapInfo'
  is_billable: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  /** Always P1D: the cap counts over a calendar day in the scheme timezone */
  period: Scalars['String']['output']
  used: Scalars['Int']['output']
}

export type PeriodPassUnlocks = {
  __typename: 'PeriodPassUnlocks'
  hardware_type: ModuleHardware
  limit: Scalars['Int']['output']
  period: Scalars['String']['output']
  used: Scalars['Int']['output']
}

export type PermittedVehicleModel = {
  __typename: 'PermittedVehicleModel'
  created_at: Scalars['DateTime']['output']
  frame_type: FrameType
  id: Scalars['ID']['output']
  scheme: Scheme
  supported_hardware_types: Array<ModuleHardware>
  updated_at: Scalars['DateTime']['output']
}

export type PermittedVehicleModelInput = {
  frame_type: FrameType
  scheme_id: Scalars['ID']['input']
}

export enum ProductAvailability {
  /** Product can only be used in the week */
  weekday = 'weekday',
  /** Product can only be used on the weekend */
  weekend = 'weekend',
}

export type ProductDiscountConfig = {
  __typename: 'ProductDiscountConfig'
  amount_off?: Maybe<Scalars['Int']['output']>
  percent_off?: Maybe<Scalars['Float']['output']>
  type: ProductDiscountType
  unit_off?: Maybe<Scalars['Float']['output']>
  unit_type?: Maybe<Scalars['String']['output']>
}

export type ProductDiscountInput = {
  amount_off?: InputMaybe<Scalars['Int']['input']>
  percent_off?: InputMaybe<Scalars['Float']['input']>
  type: ProductDiscountType
  unit_off?: InputMaybe<Scalars['Float']['input']>
  unit_type?: InputMaybe<Scalars['String']['input']>
}

/** Promotion with product discount metadata */
export type ProductDiscountPromotion = IPromotion & {
  __typename: 'ProductDiscountPromotion'
  banner: Scalars['String']['output']
  description: Scalars['String']['output']
  discount: ProductDiscountConfig
  expiration_date?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  scheme_addons?: Maybe<Array<Maybe<SchemeAddon>>>
  scheme_products?: Maybe<Array<Maybe<SchemeProduct>>>
  start_date: Scalars['DateTime']['output']
}

export enum ProductDiscountType {
  amount = 'AMOUNT',
  percent = 'PERCENT',
  unit = 'UNIT',
}

export enum ProductDisplayCategory {
  minute_pass = 'minute_pass',
  special_pass = 'special_pass',
}

export enum ProductImageVariant {
  /** Image of a commuter */
  commute_1 = 'commute_1',
  /** People having fun variant 1 */
  explore_1 = 'explore_1',
  /** People having fun variant 2 */
  explore_2 = 'explore_2',
}

export type ProductInvoice = IInvoice & {
  __typename: 'ProductInvoice'
  created_at: Scalars['DateTime']['output']
  currency_balance?: Maybe<FormattedAmount>
  currency_debit?: Maybe<FormattedAmount>
  currency_debit_sub_total?: Maybe<FormattedAmount>
  currency_refundable?: Maybe<FormattedAmount>
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  is_void: Scalars['Boolean']['output']
  minute_debit?: Maybe<FormattedAmount>
  /** Calculated amount refundable if this is a partially used minute bundle purchase */
  minute_refund_calcs?: Maybe<MinuteRefundCalcs>
  minute_refundable?: Maybe<FormattedAmount>
  next_action?: Maybe<Array<Maybe<PaymentIntent>>>
  scheme?: Maybe<Scheme>
  scheme_addon?: Maybe<SchemeAddon>
  scheme_product?: Maybe<SchemeProduct>
  status?: Maybe<InvoiceStatus>
  timezone_offset?: Maybe<Scalars['Float']['output']>
  transactions?: Maybe<TransactionConnection>
  user: User
}

/** Used by clients to group similar products in the UI */
export enum ProductType {
  /** Bundle */
  bundle = 'bundle',
  /** Day pass */
  day_pass = 'day_pass',
  /** PAYR */
  payg = 'payg',
  /** Period pass */
  period_pass = 'period_pass',
  /** Subscription pass */
  subscription_pass = 'subscription_pass',
}

export type Promotion = IPromotion & {
  __typename: 'Promotion'
  banner: Scalars['String']['output']
  description: Scalars['String']['output']
  discount: ProductDiscountConfig
  expiration_date?: Maybe<Scalars['DateTime']['output']>
  first_free_minutes?: Maybe<Scalars['Int']['output']>
  hardware_types?: Maybe<Array<ModuleHardware>>
  id: Scalars['ID']['output']
  journey_percent_off_time_based_charges?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  scheme_addons?: Maybe<Array<Maybe<SchemeAddon>>>
  scheme_products?: Maybe<Array<Maybe<SchemeProduct>>>
  start_date: Scalars['DateTime']['output']
  unlock_fee_percent_off?: Maybe<Scalars['Int']['output']>
  vehicle_categories: Array<VehicleCategory>
}

export type PublishAutomationFlowConfiguration = {
  __typename: 'PublishAutomationFlowConfiguration'
  eventType: Scalars['String']['output']
  message_data: Scalars['JSON']['output']
  topic_name: Scalars['String']['output']
}

export type Query = {
  __typename: 'Query'
  active_journey_set?: Maybe<JourneySet>
  /** Returns all active journeys for a user, active journeys being those which are not `is_complete` */
  active_journeys: Array<Journey>
  all_automation_flows: Array<AutomationFlow>
  all_scheme_addons: SchemeAddonConnection
  all_scheme_products: SchemeProductConnection
  /** Get all service_areas regardless of state - super_admin only */
  all_service_areas: ServiceAreaConnection
  /** Get all zones regardless of status - super_admin only */
  all_zones: ZoneConnection
  /** Returns all archived jobs against a given asset */
  archive_jobs: ArchiveJobConnection
  /** Note: external_id will always be unique, so this endpoint returns a single asset */
  asset?: Maybe<Asset>
  asset_by_asset_tag?: Maybe<Asset>
  asset_models?: Maybe<Array<Maybe<AssetModel>>>
  /** Note: serial_number is not necessarily unique, so this endpoint might return multiple assets */
  assets: Array<Asset>
  /** Returns all job automations */
  automations?: Maybe<Array<Maybe<Automation>>>
  /** @deprecated bike is deprecated in favour of vehicle */
  bike?: Maybe<Bike>
  /** @deprecated bike is deprecated in favour of vehicle */
  bikes: BikeConnection
  campaign: CampaignDetail
  campaigns: CampaignConnection
  compatible_ota_firmwares?: Maybe<Array<Maybe<OTAFirmware>>>
  /**
   * Fetches vehicle config
   * @deprecated Use ota_device_information
   */
  config: MaptexConfig
  customers: UserConnection
  deployment?: Maybe<Deployment>
  /** Returns all deployments in desc chronological order */
  deployments: DeploymentConnection
  existing_or_whitelist: ExistingOrWhitelist
  /** Returns all available firmware blobs */
  firmware: Array<Maybe<Firmware>>
  /**
   * Return all modules NOT in a zone that are locked & available & online & in normal power mode.
   * @deprecated Use free_floating_vehicles instead
   */
  free_floating_modules: ModuleConnection
  /** Return all vehicles NOT in a zone that are locked & available & online & in normal power mode. */
  free_floating_vehicles: VehicleConnection
  intercom_hash: Scalars['JSON']['output']
  invoice?: Maybe<IInvoice>
  invoices?: Maybe<IInvoiceConnection>
  /** Returns specific job */
  job?: Maybe<Job>
  job_types: JobTypes
  /** Returns all jobs - use job_filters as job_details_filters is deprecated */
  jobs: JobConnection
  /** Returns all jobs - use job_filters as job_details_filters is deprecated */
  jobs_v2: JobConnection
  journey?: Maybe<Journey>
  journey_insight_reasons: Array<Scalars['String']['output']>
  /** Fetch active journey set for this user */
  journey_set: JourneySet
  journey_sets: JourneySetConnection
  journeys: JourneyConnection
  list_ota_bucket_firmwares?: Maybe<Array<Scalars['String']['output']>>
  metadata_schemas: MetadataSchemaConnection
  module?: Maybe<Module>
  /** Fetches a module by its unlock_id */
  module_by_unlock_id?: Maybe<Module>
  /** @deprecated Use vehicles instead */
  modules: ModuleConnection
  /** List nearby zones to a location point */
  nearby_zones: Array<NearbyZoneResult>
  orgs: OrgConnection
  ota_configuration_command?: Maybe<OTAConfigurationCommand>
  ota_configuration_commands?: Maybe<Array<Maybe<OTAConfigurationCommand>>>
  ota_device_information: OTAInformation
  ota_firmware?: Maybe<OTAFirmware>
  ota_firmwares?: Maybe<Array<Maybe<OTAFirmware>>>
  permitted_vehicle_models: Array<PermittedVehicleModel>
  promotion_validation_rules: ValidationRuleConnection
  receipt?: Maybe<Receipt>
  release_notes: ReleaseNotes
  role_types: Array<RoleType>
  scheme?: Maybe<Scheme>
  scheme_accounting: SchemeAccounting
  scheme_accountings: SchemeAccoutingConnection
  scheme_addon?: Maybe<SchemeAddon>
  scheme_addons: SchemeAddonConnection
  scheme_group: SchemeGroup
  scheme_groups: SchemeGroupConnection
  scheme_job_assets: Array<JobAsset>
  scheme_product?: Maybe<SchemeProduct>
  scheme_product_history?: Maybe<SchemeProductVersion>
  scheme_products: SchemeProductConnection
  schemes?: Maybe<SchemeConnection>
  /** Searches for zones based on search text and Mapbox cross-referenced location */
  search_zones: Array<Zone>
  service_area?: Maybe<ServiceArea>
  service_areas: ServiceAreaConnection
  service_now_oauth_check?: Maybe<ServiceNowOauthCheck>
  service_now_oauth_url?: Maybe<ServiceNowOauthURL>
  service_offerings?: Maybe<Array<Maybe<ServiceOffering>>>
  sourced_automation_flows: Array<SourcedAutomationFlow>
  staff: UserConnection
  /** Returns all available task codes */
  task_codes_list: Array<TaskCodeListItem>
  task_consumable_options: Array<TaskConsumableOption>
  user?: Maybe<User>
  user_favourite_zones: Array<Zone>
  users: UserConnection
  /** Get a vehicle from vehicle_id */
  vehicle?: Maybe<Vehicle>
  vehicle_by_module_id?: Maybe<Vehicle>
  vehicle_by_unlock_id?: Maybe<Vehicle>
  vehicles: VehicleConnection
  whitelist: Whitelist
  whitelists: WhitelistConnection
  workshop_users: UserConnection
  zone?: Maybe<Zone>
  /** @deprecated Use zone_history_changes instead */
  zone_history: ZoneHistoryConnection
  zone_history_changes: ZoneHistoryChangesConnection
  zones: ZoneConnection
}

export type Queryactive_journey_setArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
}

export type Queryactive_journeysArgs = {
  user_id: Scalars['ID']['input']
}

export type Queryall_scheme_addonsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
}

export type Queryall_scheme_productsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
}

export type Queryall_service_areasArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryall_zonesArgs = {
  is_suspended?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<LocationAreaInput>
  order_by?: InputMaybe<Array<InputMaybe<ZoneOrderBy>>>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<Array<InputMaybe<ZoneWhere>>>
}

export type Queryarchive_jobsArgs = {
  asset_tag: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
  sort_field?: InputMaybe<JobSortField>
  sort_order?: InputMaybe<Direction>
}

export type QueryassetArgs = {
  external_id: Scalars['ID']['input']
}

export type Queryasset_by_asset_tagArgs = {
  asset_tag: Scalars['ID']['input']
}

export type QueryassetsArgs = {
  serial_number: Scalars['ID']['input']
}

export type QueryautomationsArgs = {
  filters?: InputMaybe<AutomationFilters>
}

export type QuerybikeArgs = {
  frame_id?: InputMaybe<Scalars['ID']['input']>
  module_id?: InputMaybe<Scalars['ID']['input']>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type QuerybikesArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type QuerycampaignArgs = {
  campaign_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
}

export type QuerycampaignsArgs = {
  scheme_id: Scalars['ID']['input']
}

export type Querycompatible_ota_firmwaresArgs = {
  module_id: Scalars['ID']['input']
}

export type QueryconfigArgs = {
  module_id: Scalars['ID']['input']
}

export type QuerycustomersArgs = {
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
}

export type QuerydeploymentArgs = {
  deployment_id: Scalars['ID']['input']
}

export type QuerydeploymentsArgs = {
  paginate?: InputMaybe<Paginate>
}

export type Queryexisting_or_whitelistArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type Queryfree_floating_modulesArgs = {
  location?: InputMaybe<LocationAreaInput>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryfree_floating_vehiclesArgs = {
  location?: InputMaybe<LocationAreaInput>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryinvoiceArgs = {
  invoice_id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryinvoicesArgs = {
  order_by?: InputMaybe<Array<InputMaybe<IInvoiceOrderby>>>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<Array<InputMaybe<IInvoiceWhere>>>
}

export type QueryjobArgs = {
  job_uuid?: InputMaybe<Scalars['ID']['input']>
}

export type QueryjobsArgs = {
  job_details_filters?: InputMaybe<JobDetailsInput>
  job_filters?: InputMaybe<JobFiltersInput>
  paginate?: InputMaybe<Paginate>
  sort_field?: InputMaybe<JobSortField>
  sort_order?: InputMaybe<Direction>
}

export type Queryjobs_v2Args = {
  job_details_filters?: InputMaybe<JobDetailsInput>
  job_filters?: InputMaybe<JobFiltersInput>
  paginate?: InputMaybe<Paginate>
  sort_field?: InputMaybe<JobSortField>
  sort_order?: InputMaybe<Direction>
}

export type QueryjourneyArgs = {
  journey_id: Scalars['ID']['input']
}

export type Queryjourney_setArgs = {
  id: Scalars['ID']['input']
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryjourney_setsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryjourneysArgs = {
  module_id?: InputMaybe<Scalars['ID']['input']>
  order_by?: InputMaybe<Array<InputMaybe<JourneyOrderBy>>>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<Array<InputMaybe<JourneyWhere>>>
}

export type QuerymoduleArgs = {
  module_id: Scalars['ID']['input']
}

export type Querymodule_by_unlock_idArgs = {
  unlock_id: Scalars['ID']['input']
}

export type QuerymodulesArgs = {
  in_zone?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<LocationAreaInput>
  order_by?: InputMaybe<Array<InputMaybe<ModuleOrderby>>>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<Array<InputMaybe<ModuleWhere>>>
}

export type Querynearby_zonesArgs = {
  location: LocationInput
  scheme_id: Scalars['ID']['input']
  zones_amount?: InputMaybe<Scalars['Int']['input']>
}

export type QueryorgsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryota_configuration_commandArgs = {
  id: Scalars['Int']['input']
}

export type Queryota_device_informationArgs = {
  module_id: Scalars['ID']['input']
}

export type Queryota_firmwareArgs = {
  id: Scalars['Int']['input']
}

export type Querypermitted_vehicle_modelsArgs = {
  scheme_id: Scalars['ID']['input']
}

export type Querypromotion_validation_rulesArgs = {
  paginate?: InputMaybe<Paginate>
}

export type QueryreceiptArgs = {
  invoice_id: Scalars['ID']['input']
}

export type Queryrelease_notesArgs = {
  component: Component
  version: Scalars['String']['input']
}

export type QueryschemeArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  scheme_name?: InputMaybe<Scalars['String']['input']>
}

export type Queryscheme_accountingArgs = {
  scheme_accounting_id: Scalars['ID']['input']
}

export type Queryscheme_addonArgs = {
  scheme_addon_id: Scalars['ID']['input']
}

export type Queryscheme_addonsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
}

export type Queryscheme_groupArgs = {
  scheme_group_id: Scalars['ID']['input']
}

export type Queryscheme_job_assetsArgs = {
  scheme_id: Scalars['ID']['input']
}

export type Queryscheme_productArgs = {
  scheme_product_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryscheme_product_historyArgs = {
  scheme_product_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryscheme_productsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
}

export type QueryschemesArgs = {
  paginate?: InputMaybe<Paginate>
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type Querysearch_zonesArgs = {
  location?: InputMaybe<LocationAreaInput>
  scheme_id: Scalars['ID']['input']
  search_text?: InputMaybe<Scalars['String']['input']>
  zones_amount?: InputMaybe<Scalars['Int']['input']>
}

export type Queryservice_areaArgs = {
  location?: InputMaybe<LocationInput>
  service_area_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryservice_areasArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type QuerystaffArgs = {
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
}

export type Querytask_consumable_optionsArgs = {
  model_sys_id: Scalars['ID']['input']
}

export type QueryuserArgs = {
  user_id: Scalars['ID']['input']
}

export type Queryuser_favourite_zonesArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryusersArgs = {
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
}

export type QueryvehicleArgs = {
  vehicle_id: Scalars['GUID']['input']
}

export type Queryvehicle_by_module_idArgs = {
  module_id: Scalars['ID']['input']
}

export type Queryvehicle_by_unlock_idArgs = {
  unlock_id: Scalars['ID']['input']
}

export type QueryvehiclesArgs = {
  frame_id__like?: InputMaybe<Scalars['String']['input']>
  frame_type?: InputMaybe<Array<FrameType>>
  is_commissioned?: InputMaybe<Scalars['Boolean']['input']>
  is_in_zone?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<LocationAreaInput>
  module_id__like?: InputMaybe<Scalars['String']['input']>
  paginate?: InputMaybe<Paginate>
  propulsion_type?: InputMaybe<Array<VehiclePropulsionType>>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  unlock_id__like?: InputMaybe<Scalars['String']['input']>
  vehicle_category?: InputMaybe<Array<VehicleCategory>>
  vehicle_id__like?: InputMaybe<Scalars['String']['input']>
  vehicle_lock_state?: InputMaybe<Array<VehicleLockState>>
  vehicle_state?: InputMaybe<Array<VehicleState>>
  vehicle_type?: InputMaybe<VehicleType>
}

export type QuerywhitelistArgs = {
  whitelist_id: Scalars['ID']['input']
}

export type QuerywhitelistsArgs = {
  order_by?: InputMaybe<Array<InputMaybe<WhitelistOrderby>>>
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
  where?: InputMaybe<Array<InputMaybe<WhitelistWhere>>>
}

export type Queryworkshop_usersArgs = {
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
}

export type QueryzoneArgs = {
  zone_id: Scalars['ID']['input']
}

export type Queryzone_historyArgs = {
  order_by?: InputMaybe<Array<InputMaybe<ZoneHistoryOrderBy>>>
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<ZoneHistoryWhere>>>
  zone_id?: InputMaybe<Scalars['ID']['input']>
}

export type Queryzone_history_changesArgs = {
  order_by?: InputMaybe<Array<InputMaybe<ZoneHistoryOrderBy>>>
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<ZoneHistoryWhere>>>
  zone_id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryzonesArgs = {
  location?: InputMaybe<LocationAreaInput>
  order_by?: InputMaybe<Array<InputMaybe<ZoneOrderBy>>>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<Array<InputMaybe<ZoneWhere>>>
}

export type QuotumTransaction = ITransaction & {
  __typename: 'QuotumTransaction'
  /** Always null: a unit is whole, so it is voided rather than part refunded */
  amount_refundable?: Maybe<FormattedAmount>
  /** Always null: a unit is whole, so it is voided rather than part refunded */
  amount_refunded?: Maybe<FormattedAmount>
  category: TransactionCategory
  created_at: Scalars['DateTime']['output']
  credit_amount: FormattedAmount
  debit_amount: FormattedAmount
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  /** The journey that spent it */
  journey_id: Scalars['ID']['output']
  /** Calendar day the unit counts against, in the scheme timezone. YYYY-MM-DD */
  local_day: Scalars['String']['output']
  meta?: Maybe<TransactionMeta>
  /** Always null: no payment provider settles a quota unit */
  provider_type?: Maybe<CurrencyPaymentProviderType>
  /** What kind of allowance the unit was spent from */
  quotum_type: QuotumType
  refund_requester?: Maybe<User>
  result?: Maybe<TransactionResult>
  type?: Maybe<TransactionType>
  /** When the journey that spent it started */
  used_at: Scalars['DateTime']['output']
  void: Scalars['Boolean']['output']
}

export enum QuotumType {
  /** A journey against a product's daily journey cap */
  journey = 'journey',
}

export type Receipt = {
  __typename: 'Receipt'
  card_details?: Maybe<Card>
  receipt_url: Scalars['String']['output']
}

export type RefundInvoiceInput = {
  currency_amount: Scalars['Int']['input']
  description: Scalars['String']['input']
  minute_amount: Scalars['Int']['input']
  reason: Scalars['String']['input']
  revoke_product: Scalars['Boolean']['input']
}

export type RefundInvoiceResult = {
  __typename: 'RefundInvoiceResult'
  currency?: Maybe<RefundResultItem>
  minutes?: Maybe<RefundResultItem>
}

export type RefundInvoiceV2Input = {
  description: Scalars['String']['input']
  reason: Scalars['String']['input']
  refund_transactions: Array<RefundInvoiceV2InputTransaction>
  revoke_product: Scalars['Boolean']['input']
}

export type RefundInvoiceV2InputTransaction = {
  amount: Scalars['Int']['input']
  id: Scalars['ID']['input']
}

export type RefundResultItem = {
  __typename: 'RefundResultItem'
  amount?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type ReleaseNotes = {
  __typename: 'ReleaseNotes'
  component: Component
  text: Scalars['HTML']['output']
  updated_at?: Maybe<Scalars['DateTime']['output']>
  version: Scalars['String']['output']
}

export type RemoteNodeOp = {
  id?: InputMaybe<ScalarOp>
}

export type RequiredOTAVersions = {
  __typename: 'RequiredOTAVersions'
  ecu?: Maybe<Scalars['String']['output']>
  helmet_lock?: Maybe<Scalars['String']['output']>
  iot?: Maybe<Scalars['String']['output']>
  meter?: Maybe<Scalars['String']['output']>
  repeater?: Maybe<Scalars['String']['output']>
}

export type ReverseCancelledJourneyInput = {
  /** Amended journey duration in minutes */
  amended_duration?: InputMaybe<Scalars['Int']['input']>
  description: Scalars['String']['input']
}

export type Role = {
  __typename: 'Role'
  id: Scalars['ID']['output']
  org?: Maybe<Org>
  scheme?: Maybe<Scheme>
  type: RoleType
  user: User
}

export type RoleInput = {
  org_id?: InputMaybe<Scalars['ID']['input']>
  role_type_id: Scalars['ID']['input']
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
}

export type RoleType = {
  __typename: 'RoleType'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type RoleTypeWhere = {
  id?: InputMaybe<ScalarOp>
}

export type RoleWhere = {
  type?: InputMaybe<RoleTypeWhere>
}

export enum SIMProvider {
  emnify = 'emnify',
  pelion = 'pelion',
}

export enum SavingReason {
  actual = 'actual',
  possible = 'possible',
}

export type ScalarOp = {
  eq?: InputMaybe<Scalars['String']['input']>
  ge?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  ilike?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  is_not_null?: InputMaybe<Scalars['Boolean']['input']>
  is_null?: InputMaybe<Scalars['Boolean']['input']>
  le?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  ne?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Scheduled zone suspensions can be configured to suspend a zone for a specific time span */
export type ScheduledZoneSuspension = IZoneSuspension & {
  __typename: 'ScheduledZoneSuspension'
  author_id: Scalars['ID']['output']
  /** Enable the zone at this time */
  end_time?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  reason?: Maybe<ZoneSuspensionReason>
  /** Current status of the schedule */
  schedule_status?: Maybe<ScheduledZoneSuspensionStatus>
  scheme_id: Scalars['ID']['output']
  /** Suspend the zone at this time */
  start_time?: Maybe<Scalars['DateTime']['output']>
  /** Time the schedule status was last updated */
  status_updated_at?: Maybe<Scalars['DateTime']['output']>
}

export type ScheduledZoneSuspensionConnection = IConnection & {
  __typename: 'ScheduledZoneSuspensionConnection'
  nodes?: Maybe<Array<Maybe<ScheduledZoneSuspension>>>
  pagination: Pagination
}

export type ScheduledZoneSuspensionInput = {
  end_time: Scalars['DateTime']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  reason: ZoneSuspensionReasonInput
  scheme_id: Scalars['ID']['input']
  start_time: Scalars['DateTime']['input']
  zone_ids: Array<InputMaybe<Scalars['ID']['input']>>
}

/** The status of a scheduled zone suspension */
export enum ScheduledZoneSuspensionStatus {
  cancelled = 'cancelled',
  complete = 'complete',
  in_progress = 'in_progress',
  scheduled = 'scheduled',
}

export type Scheme = {
  __typename: 'Scheme'
  all_scheme_products: SchemeProductConnection
  availability_restriction: SchemeAvailabilityRestrictionConnection
  config: SchemeConfig
  id: Scalars['ID']['output']
  is_discoverable: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  orgs?: Maybe<OrgConnection>
  permitted_vehicle_models: Array<PermittedVehicleModel>
  promotions: Array<Promotion>
  scheme_accounting?: Maybe<SchemeAccounting>
  scheme_products: SchemeProductConnection
  service_areas: ServiceAreaConnection
  timezone: Scalars['String']['output']
  user_simultaneous_journey_limit: Scalars['Int']['output']
  zones: ZoneConnection
}

export type Schemeall_scheme_productsArgs = {
  paginate?: InputMaybe<Paginate>
}

export type SchemepromotionsArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type Schemescheme_productsArgs = {
  paginate?: InputMaybe<Paginate>
}

export type Schemeservice_areasArgs = {
  paginate?: InputMaybe<Paginate>
}

export type SchemezonesArgs = {
  location?: InputMaybe<LocationAreaInput>
  paginate?: InputMaybe<Paginate>
}

export type SchemeAccounting = {
  __typename: 'SchemeAccounting'
  /** A lowercase, 3 character ISO 4217 Currency Code */
  currency: Scalars['String']['output']
  id: Scalars['ID']['output']
  inclusive_of_tax: Scalars['Boolean']['output']
  scheme?: Maybe<Scheme>
  scheme_group?: Maybe<SchemeGroup>
  scheme_pricing_configs: SchemePricingConfigs
  tax_rate?: Maybe<Scalars['Float']['output']>
  /** IANA name, eg Europe/London. The zone daily journey caps reset in */
  timezone: Scalars['String']['output']
}

export type SchemeAccountingInput = {
  currency: Scalars['String']['input']
  inclusive_of_tax: Scalars['Boolean']['input']
  scheme_group_id?: InputMaybe<Scalars['ID']['input']>
  scheme_id: Scalars['ID']['input']
  scheme_pricing_configs?: InputMaybe<SchemePricingConfigsInput>
  tax_rate: Scalars['Float']['input']
  /** IANA name, eg Europe/London. Omit to leave a scheme on the default */
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type SchemeAccoutingConnection = {
  __typename: 'SchemeAccoutingConnection'
  nodes: Array<Maybe<SchemeAccounting>>
  pagination: Pagination
}

export type SchemeAddon = Buyable & {
  __typename: 'SchemeAddon'
  /** Type of addon */
  addon_type: AddonType
  /** Price in cents */
  amount: Scalars['Int']['output']
  /**
   * This field is present if fetching scheme_addons through a valid voucher
   * @deprecated Use discount_calculations_v2
   */
  discount_calculations?: Maybe<DiscountCalculations>
  /** This field is present if fetching scheme_addons through a valid voucher or promotion */
  discount_calculations_v2?: Maybe<DiscountCalculationsV2>
  id: Scalars['ID']['output']
  /** Whether the product is on offer */
  is_active: Scalars['Boolean']['output']
  /** Whether product should be shown in public listings */
  is_discoverable?: Maybe<Scalars['Boolean']['output']>
  /** Whether the product should be protected by the role_whitelist */
  is_protected?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  /** Formatted amount */
  price: FormattedAmount
  /** A whitelist of role_types that a user must have in order to purchase the protected product */
  role_whitelist: Array<Scalars['String']['output']>
  scheme: Scheme
  scheme_accounting: SchemeAccounting
  scheme_id: Scalars['ID']['output']
  /** The period which the scheme product is valid for */
  validity_interval?: Maybe<ValidityInterval>
}

export type SchemeAddonConnection = IConnection & {
  __typename: 'SchemeAddonConnection'
  nodes: Array<SchemeAddon>
  pagination: Pagination
}

export type SchemeAddonInput = {
  addon_type: AddonType
  amount: Scalars['Int']['input']
  is_active: Scalars['Boolean']['input']
  is_discoverable?: InputMaybe<Scalars['Boolean']['input']>
  is_protected?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  role_whitelist?: InputMaybe<Array<Scalars['String']['input']>>
  scheme_id: Scalars['ID']['input']
  validity?: InputMaybe<ValidityInterval>
  /** @deprecated Use validity, which takes only the periods we sell */
  validity_interval?: InputMaybe<Scalars['String']['input']>
}

export type SchemeAvailabilityRestriction = {
  __typename: 'SchemeAvailabilityRestriction'
  end_time: Scalars['String']['output']
  frame_type?: Maybe<FrameType>
  id: Scalars['ID']['output']
  last_status_change_time?: Maybe<Scalars['String']['output']>
  propulsion_type: VehiclePropulsionType
  start_time: Scalars['String']['output']
  vehicle_type: VehicleType
}

export type SchemeAvailabilityRestrictionConnection = IConnection & {
  __typename: 'SchemeAvailabilityRestrictionConnection'
  nodes: Array<SchemeAvailabilityRestriction>
  pagination: Pagination
}

export type SchemeAvailabilityRestrictionInput = {
  end_time: Scalars['String']['input']
  frame_type: FrameType
  propulsion_type: VehiclePropulsionType
  scheme_id: Scalars['ID']['input']
  start_time: Scalars['String']['input']
  vehicle_type: VehicleType
}

export type SchemeBalance = {
  __typename: 'SchemeBalance'
  balance: FormattedAmount
  scheme_id: Scalars['ID']['output']
}

export type SchemeConfig = {
  __typename: 'SchemeConfig'
  /** use rewards_available instead */
  is_max_capacity_zones_enabled: Scalars['Boolean']['output']
  is_parking_photo_enabled: Scalars['Boolean']['output']
  /** @deprecated Field no longer supported */
  is_vehicle_rewards_enabled: Scalars['Boolean']['output']
  pause_duration: PauseDurationConfig
  rewards_available: Array<VehicleRewardType>
  sponsorship_content?: Maybe<SponsorshipContent>
  supported_unlock_methods: Array<UnlockMethod>
}

export type SchemeConnection = IConnection & {
  __typename: 'SchemeConnection'
  nodes: Array<Scheme>
  pagination: Pagination
}

export type SchemeGroup = {
  __typename: 'SchemeGroup'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SchemeGroupConnection = {
  __typename: 'SchemeGroupConnection'
  nodes: Array<Maybe<SchemeGroup>>
  pagination: Pagination
}

export type SchemeGroupInput = {
  name: Scalars['String']['input']
}

export type SchemeInput = {
  id: Scalars['ID']['input']
  /** Should the scheme be discoverable on the public GBFS index */
  is_discoverable?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  /** The timezone where the scheme is located as a string, defaults to Europe/London */
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type SchemePricingConfigs = {
  __typename: 'SchemePricingConfigs'
  /** Fine for parking outside the service area */
  out_of_service_area_parking_charge: FormattedAmount
  /** Fine for not parking in a bay */
  out_of_zone_parking_charge: FormattedAmount
  /** Charge for locking a bike by front lock and leaving rear lock open */
  rear_lock_unlocked_vehicle_charge?: Maybe<FormattedAmount>
  /** Mandatory front lock fine, mostly not enforced */
  undocked_in_zone_parking_charge?: Maybe<FormattedAmount>
  /** Cancelled journey / unlocked vehicle fine, flat fee */
  unlocked_vehicle_charge: FormattedAmount
  /** Parked in bay where vehicle is not permitted */
  vehicle_not_permitted_in_zone_charge?: Maybe<FormattedAmount>
}

export type SchemePricingConfigsInput = {
  /** Fine for parking outside the service area */
  out_of_service_area_parking_charge: Scalars['Int']['input']
  /** Fine for not parking in a bay */
  out_of_zone_parking_charge: Scalars['Int']['input']
  /** Charge for locking a bike by front lock and leaving rear lock open */
  rear_lock_unlocked_vehicle_charge?: InputMaybe<Scalars['Int']['input']>
  /** Fine for not locking the vehicle correctly */
  undocked_in_zone_parking_charge?: InputMaybe<Scalars['Int']['input']>
  /** Cancelled journey / unlocked vehicle fine, flat fee */
  unlocked_vehicle_charge: Scalars['Int']['input']
  /** Fine for parking a vehicle in a bay where that type isn't allowed */
  vehicle_not_permitted_in_zone_charge?: InputMaybe<Scalars['Int']['input']>
}

export type SchemeProduct = Buyable &
  SchemeProductFields & {
    __typename: 'SchemeProduct'
    /** Price in cents */
    amount: Scalars['Int']['output']
    /** Is the product only available in the week/weekend? */
    availability?: Maybe<ProductAvailability>
    /** How many journeys this product bills for one rider per calendar day */
    billable_journey_cap?: Maybe<Scalars['Int']['output']>
    /** Period the cap counts over, in the scheme timezone. Only P1D is supported */
    billable_journey_cap_sub_period?: Maybe<Scalars['String']['output']>
    /** Parameters used by Journey charge calculator defined by vehicle_category */
    configs_v3: SchemeProductConfigByVehicleCategory
    /** Extra details for displaying product information. Only enforced for PeriodPass at the moment */
    details?: Maybe<SchemeProductDetails>
    /**
     * This field is present if fetching scheme_products through a valid voucher
     * @deprecated Use discount_calculations_v2
     */
    discount_calculations?: Maybe<DiscountCalculations>
    /** This field is present if fetching scheme_products through a valid voucher or promotion */
    discount_calculations_v2?: Maybe<DiscountCalculationsV2>
    /** Is this product a period pass that gives minutes or is a special pass? */
    display_category?: Maybe<ProductDisplayCategory>
    /** Is this scheme product gifted when a reward is confirmed? */
    fulfill_rewards: Array<VehicleRewardType>
    id: Scalars['ID']['output']
    /** Whether the product is on offer */
    is_active: Scalars['Boolean']['output']
    /** Is the product available at the moment? */
    is_available: Scalars['Boolean']['output']
    /** Whether product should be shown in public listings */
    is_discoverable?: Maybe<Scalars['Boolean']['output']>
    /** Whether the product should be protected by the role_whitelist */
    is_protected?: Maybe<Scalars['Boolean']['output']>
    name: Scalars['String']['output']
    /** Formatted amount */
    price: FormattedAmount
    product_type: ProductType
    /** Amount of items or minutes */
    quantity: Scalars['Int']['output']
    /** A whitelist of role_types that a user must have in order to purchase the protected product */
    role_whitelist: Array<Scalars['String']['output']>
    scheme_accounting: SchemeAccounting
    scheme_id: Scalars['ID']['output']
    /** Static ID that can be saved by BMan and propagated between environments */
    uuid?: Maybe<Scalars['GUID']['output']>
    /** The period which the scheme product is valid for */
    validity_interval?: Maybe<ValidityInterval>
    /** Veew previous versions of this product */
    versions?: Maybe<Array<SchemeProductVersion>>
    /** Dont charge out of bay fines for this product. E.g. DayPass */
    waive_out_of_zone_parking_charge?: Maybe<Scalars['Boolean']['output']>
  }

export type SchemeProductConfig = {
  __typename: 'SchemeProductConfig'
  /** ISO 8601 duration string to define the period of charge incrementation */
  charge_increment_duration: Scalars['String']['output']
  /** First n minutes covered by unlock fee. Remainder rolls onto the next eligible product */
  journey_minutes_included?: Maybe<Scalars['Int']['output']>
  /** Minute charge percentage to rebate. Used to make certain veichle types cheaper to ride with pre-bought minutes */
  journey_minutes_percent_off: Scalars['Int']['output']
  /** True for minute bundles */
  minutes_chargeable: Scalars['Boolean']['output']
  /** PaYG rate to charge overflow time after minutes are exhausted */
  out_of_bundle_minute_increment_cost: FormattedAmount
  /**
   * Fine for parking outside the service area
   * @deprecated Use SchemeAccounting.scheme_pricing_configs
   */
  out_of_service_area_parking_charge: FormattedAmount
  /**
   * Fine for not parking in a bay
   * @deprecated Use SchemeAccounting.scheme_pricing_configs
   */
  out_of_zone_parking_charge: FormattedAmount
  /** Max number of minutes to charge a single product for a journey */
  period_pass_max_minute_debit?: Maybe<Scalars['Int']['output']>
  /** Sub period for tracking pass included unlocks */
  period_pass_sub_period_for_unlocks?: Maybe<Scalars['String']['output']>
  /** Caped number of unlocks to be covered by the pass, within a sub-period */
  period_pass_unlocks_per_sub_period?: Maybe<Scalars['Int']['output']>
  /** Charge for locking a bike by front lock and leaving rear lock open */
  rear_lock_unlocked_vehicle_charge?: Maybe<FormattedAmount>
  /** Price per time incremnt for PaYG */
  time_increment_cost: FormattedAmount
  /** Current price per time incremnt */
  time_increment_cost_current?: Maybe<FormattedAmount>
  /** Weekend price per time incremnt - if defined */
  time_increment_cost_weekend?: Maybe<FormattedAmount>
  /**
   * Fine for not locking the vehicle correctly
   * @deprecated Use SchemeAccounting.scheme_pricing_configs
   */
  undocked_in_zone_parking_charge: FormattedAmount
  /** Cost in pence to unlock a vehicle */
  unlock_fee: FormattedAmount
  /** Cancelled journey / unlocked vehicle fine, flat fee */
  unlocked_vehicle_charge?: Maybe<FormattedAmount>
  /**
   * Parked in bay where vehicle is not permitted
   * @deprecated Use SchemeAccounting.scheme_pricing_configs
   */
  vehicle_not_permitted_in_zone_charge?: Maybe<FormattedAmount>
}

export type SchemeProductConfigByVehicleCategory = {
  __typename: 'SchemeProductConfigByVehicleCategory'
  bike?: Maybe<SchemeProductConfig>
  cargo_ebike?: Maybe<SchemeProductConfig>
  ebike?: Maybe<SchemeProductConfig>
  escooter?: Maybe<SchemeProductConfig>
}

export type SchemeProductConfigInput = {
  /** The interval at which to incur time_increment_cost Example PT1M */
  charge_increment_duration?: InputMaybe<Scalars['String']['input']>
  /** First n minutes covered by unlock fee. Remainder rolls onto the next eligible product */
  journey_minutes_included?: InputMaybe<Scalars['Int']['input']>
  /** Minute bundle percent discount, for making it cheaper for certain hardware types */
  journey_minutes_percent_off?: InputMaybe<Scalars['Int']['input']>
  /** Indicates whether minutes can be charged */
  minutes_chargeable?: InputMaybe<Scalars['Boolean']['input']>
  /** Cost of minutes when bundle runs out */
  out_of_bundle_minute_increment_cost?: InputMaybe<Scalars['Int']['input']>
  /** Deprecated - Use SchemeAccount.scheme_pricing_configs */
  out_of_service_area_parking_charge?: InputMaybe<Scalars['Int']['input']>
  /** Deprecated - Use SchemeAccount.scheme_pricing_configs */
  out_of_zone_parking_charge?: InputMaybe<Scalars['Int']['input']>
  /** The maximum minutes of journey duration to be debited from a period pass */
  period_pass_max_minute_debit?: InputMaybe<Scalars['Int']['input']>
  /** The smaller time period within the duration of a period pass by which included unlocks are counted */
  period_pass_sub_period_for_unlocks?: InputMaybe<Scalars['String']['input']>
  /** The number of unlocks that are included within a sub-period of the period pass */
  period_pass_unlocks_per_sub_period?: InputMaybe<Scalars['Int']['input']>
  /** The cost per charge_increment_duration */
  time_increment_cost?: InputMaybe<Scalars['Int']['input']>
  /** The cost per charge_increment_duration if it's the weekend */
  time_increment_cost_weekend?: InputMaybe<Scalars['Int']['input']>
  /** Deprecated - Use SchemeAccount.scheme_pricing_configs */
  undocked_in_zone_parking_charge?: InputMaybe<Scalars['Int']['input']>
  /** Price to unlock - pence */
  unlock_fee?: InputMaybe<Scalars['Int']['input']>
}

export type SchemeProductConfigsV3Input = {
  bike?: InputMaybe<SchemeProductConfigInput>
  cargo_ebike?: InputMaybe<SchemeProductConfigInput>
  ebike?: InputMaybe<SchemeProductConfigInput>
  escooter?: InputMaybe<SchemeProductConfigInput>
}

export type SchemeProductConnection = IConnection & {
  __typename: 'SchemeProductConnection'
  nodes: Array<SchemeProduct>
  pagination: Pagination
}

export type SchemeProductDetails = {
  __typename: 'SchemeProductDetails'
  benefit_sentence?: Maybe<Scalars['String']['output']>
  bullets?: Maybe<Array<Scalars['String']['output']>>
  cta_text?: Maybe<Scalars['String']['output']>
  /** Image lookup key */
  image_variant: ProductImageVariant
  sub_title: Scalars['String']['output']
  /** Override SchemeProduct.name */
  title: Scalars['String']['output']
}

export type SchemeProductDetailsInput = {
  benefit_sentence?: InputMaybe<Scalars['String']['input']>
  bullets: Array<Scalars['String']['input']>
  cta_text?: InputMaybe<Scalars['String']['input']>
  image_variant: ProductImageVariant
  sub_title: Scalars['String']['input']
  title: Scalars['String']['input']
}

export type SchemeProductFields = {
  /** Price in cents */
  amount: Scalars['Int']['output']
  /** Is the product only available in the week/weekend? */
  availability?: Maybe<ProductAvailability>
  /** How many journeys this product bills for one rider per calendar day */
  billable_journey_cap?: Maybe<Scalars['Int']['output']>
  /** Period the cap counts over, in the scheme timezone. Only P1D is supported */
  billable_journey_cap_sub_period?: Maybe<Scalars['String']['output']>
  /** Parameters used by Journey charge calculator defined by vehicle_category */
  configs_v3: SchemeProductConfigByVehicleCategory
  /**
   * Extra details for displaying product information. Only enforced for PeriodPass at the moment
   * @deprecated We're removing components that display this
   */
  details?: Maybe<SchemeProductDetails>
  /** This field is present if fetching scheme_products through a valid voucher */
  discount_calculations?: Maybe<DiscountCalculations>
  /** Is this product a period pass that gives minutes or is a special pass? */
  display_category?: Maybe<ProductDisplayCategory>
  /** Is this scheme product gifted when a reward is confirmed? */
  fulfill_rewards: Array<VehicleRewardType>
  /** Whether the product is on offer */
  is_active: Scalars['Boolean']['output']
  /** Is the product available at the moment? */
  is_available: Scalars['Boolean']['output']
  /** Whether product should be shown in public listings */
  is_discoverable?: Maybe<Scalars['Boolean']['output']>
  /** Whether the product should be protected by the role_whitelist */
  is_protected?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  /** Formatted amount */
  price: FormattedAmount
  /** Amount of items or minutes */
  quantity: Scalars['Int']['output']
  /** A whitelist of role_types that a user must have in order to purchase the protected product */
  role_whitelist: Array<Scalars['String']['output']>
  /** The period which the scheme product is valid for */
  validity_interval?: Maybe<ValidityInterval>
  /** Dont charge out of bay fines for this product. E.g. DayPass */
  waive_out_of_zone_parking_charge?: Maybe<Scalars['Boolean']['output']>
}

export type SchemeProductInput = {
  amount: Scalars['Int']['input']
  availability?: InputMaybe<ProductAvailability>
  billable_journey_cap?: InputMaybe<Scalars['Int']['input']>
  billable_journey_cap_sub_period?: InputMaybe<Scalars['String']['input']>
  configs_v3: SchemeProductConfigsV3Input
  details?: InputMaybe<SchemeProductDetailsInput>
  display_category?: InputMaybe<ProductDisplayCategory>
  fulfill_rewards?: InputMaybe<Array<VehicleRewardType>>
  is_active: Scalars['Boolean']['input']
  is_discoverable?: InputMaybe<Scalars['Boolean']['input']>
  is_protected?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  product_type: ProductType
  quantity?: InputMaybe<Scalars['Int']['input']>
  role_whitelist?: InputMaybe<Array<Scalars['String']['input']>>
  scheme_id: Scalars['ID']['input']
  uuid?: InputMaybe<Scalars['GUID']['input']>
  validity?: InputMaybe<ValidityInterval>
  /** @deprecated Use validity, which takes only the periods we sell */
  validity_interval?: InputMaybe<Scalars['String']['input']>
  waive_out_of_zone_parking_charge?: InputMaybe<Scalars['Boolean']['input']>
}

export type SchemeProductVersion = Buyable &
  SchemeProductFields & {
    __typename: 'SchemeProductVersion'
    /** Price in cents */
    amount: Scalars['Int']['output']
    /** Is the product only available in the week/weekend? */
    availability?: Maybe<ProductAvailability>
    /** How many journeys this product bills for one rider per calendar day */
    billable_journey_cap?: Maybe<Scalars['Int']['output']>
    /** Period the cap counts over, in the scheme timezone. Only P1D is supported */
    billable_journey_cap_sub_period?: Maybe<Scalars['String']['output']>
    /** Parameters used by Journey charge calculator defined by vehicle_category */
    configs_v3: SchemeProductConfigByVehicleCategory
    /** Extra details for displaying product information. Only enforced for PeriodPass at the moment */
    details?: Maybe<SchemeProductDetails>
    /**
     * This field is present if fetching scheme_products through a valid voucher
     * @deprecated Use discount_calculations_v2
     */
    discount_calculations?: Maybe<DiscountCalculations>
    /** Is this product a period pass that gives minutes or is a special pass? */
    display_category?: Maybe<ProductDisplayCategory>
    event: VersionEvent
    /** Is this scheme product gifted when a reward is confirmed? */
    fulfill_rewards: Array<VehicleRewardType>
    /** Whether the product is on offer */
    is_active: Scalars['Boolean']['output']
    /** Is the product available at the moment? */
    is_available: Scalars['Boolean']['output']
    /** Whether product should be shown in public listings */
    is_discoverable?: Maybe<Scalars['Boolean']['output']>
    /** Whether the product should be protected by the role_whitelist */
    is_protected?: Maybe<Scalars['Boolean']['output']>
    name: Scalars['String']['output']
    /** Formatted amount */
    price: FormattedAmount
    product_type: ProductType
    published_at: Scalars['DateTime']['output']
    /** Amount of items or minutes */
    quantity: Scalars['Int']['output']
    /** A whitelist of role_types that a user must have in order to purchase the protected product */
    role_whitelist: Array<Scalars['String']['output']>
    scheme_id: Scalars['ID']['output']
    user: User
    user_id?: Maybe<Scalars['ID']['output']>
    /** The period which the scheme product is valid for */
    validity_interval?: Maybe<ValidityInterval>
    version_id: Scalars['GUID']['output']
    /** Dont charge out of bay fines for this product. E.g. DayPass */
    waive_out_of_zone_parking_charge?: Maybe<Scalars['Boolean']['output']>
  }

export type ScooterModuleState = IModuleState & {
  __typename: 'ScooterModuleState'
  battery_id?: Maybe<Scalars['String']['output']>
  ecu_error?: Maybe<EcuError>
  /** The type of geofence the scooter is currently within, if any (onboard geofencing) */
  fence_type?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  ignition_on?: Maybe<Scalars['Boolean']['output']>
  max_speed?: Maybe<Scalars['Int']['output']>
  orientation?: Maybe<Scalars['String']['output']>
  status_charging_current?: Maybe<Scalars['Boolean']['output']>
  status_front_light?: Maybe<Scalars['Boolean']['output']>
  status_rear_light?: Maybe<Scalars['Boolean']['output']>
  time: Scalars['DateTime']['output']
}

export type SegwayEBikeConfig = {
  __typename: 'SegwayEBikeConfig'
  battery_lock_Version?: Maybe<Scalars['String']['output']>
  ble_sw?: Maybe<Scalars['String']['output']>
  bms_version?: Maybe<Scalars['String']['output']>
  cable_lock_version?: Maybe<Scalars['String']['output']>
  charge_port_version?: Maybe<Scalars['String']['output']>
  ecu_version?: Maybe<Scalars['String']['output']>
  gnss_version?: Maybe<Scalars['String']['output']>
  helmet_lock_version?: Maybe<Scalars['String']['output']>
  iot_sw?: Maybe<Scalars['String']['output']>
  meter_version?: Maybe<Scalars['String']['output']>
  monitor_version?: Maybe<Scalars['String']['output']>
  server_address?: Maybe<Scalars['String']['output']>
  server_port?: Maybe<Scalars['String']['output']>
  time?: Maybe<Scalars['DateTime']['output']>
  voice_version?: Maybe<Scalars['String']['output']>
}

export type ServiceArea = IServiceArea & {
  __typename: 'ServiceArea'
  applies_to: Array<VehicleType>
  effective_from?: Maybe<Scalars['String']['output']>
  effective_to?: Maybe<Scalars['String']['output']>
  external_id?: Maybe<Scalars['ID']['output']>
  geom: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  is_external: Scalars['Boolean']['output']
  is_parking_allowed: Scalars['Boolean']['output']
  /** False if it should not be shown in the app */
  is_visible: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  scheme: Scheme
  service_area_type: ServiceAreaType
  speed_limit: Scalars['Float']['output']
}

export type ServiceAreaConnection = IConnection & {
  __typename: 'ServiceAreaConnection'
  geojson: Scalars['JSON']['output']
  nodes: Array<ServiceArea>
  pagination: Pagination
}

export type ServiceAreaConnectionnodesArgs = {
  merge_service_areas?: InputMaybe<Scalars['Boolean']['input']>
  omit_restricted_areas?: InputMaybe<Scalars['Boolean']['input']>
}

export type ServiceAreaInput = {
  effective_from?: InputMaybe<Scalars['String']['input']>
  effective_to?: InputMaybe<Scalars['String']['input']>
  external_id?: InputMaybe<Scalars['ID']['input']>
  geom: Scalars['JSON']['input']
  is_external?: InputMaybe<Scalars['Boolean']['input']>
  is_parking_allowed?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  scheme_id: Scalars['ID']['input']
  service_area_type?: InputMaybe<ServiceAreaType>
  speed_limit?: InputMaybe<Scalars['Float']['input']>
}

export type ServiceAreaPolicyInput = {
  applies_to?: InputMaybe<Array<VehicleType>>
  effective_from?: InputMaybe<Scalars['String']['input']>
  effective_to?: InputMaybe<Scalars['String']['input']>
  is_parking_allowed: Scalars['Boolean']['input']
  /** False if it should not be shown in the app */
  is_visible?: InputMaybe<Scalars['Boolean']['input']>
  service_area_type?: InputMaybe<ServiceAreaType>
  speed_limit: Scalars['Float']['input']
}

export type ServiceAreaSyncResult = {
  __typename: 'ServiceAreaSyncResult'
  added: Array<IServiceArea>
  deleted: Array<ServiceArea>
  dry_run: Scalars['Boolean']['output']
  updated: Array<ServiceArea>
}

export enum ServiceAreaType {
  go_slow = 'go_slow',
  no_go = 'no_go',
  normal = 'normal',
  segment = 'segment',
}

export type ServiceNowOauthCheck = {
  __typename: 'ServiceNowOauthCheck'
  authorized: Scalars['Boolean']['output']
  login_url: Scalars['String']['output']
}

export type ServiceNowOauthURL = {
  __typename: 'ServiceNowOauthURL'
  login_url: Scalars['String']['output']
}

export type ServiceOffering = {
  __typename: 'ServiceOffering'
  name: Scalars['String']['output']
  sys_id: Scalars['ID']['output']
}

export type SetupIntent = {
  __typename: 'SetupIntent'
  client_secret?: Maybe<Scalars['String']['output']>
}

export type SoakSuite = {
  __typename: 'SoakSuite'
  status: SoakTestStatus
  tests: Array<Maybe<SoakTest>>
}

export type SoakTest = {
  __typename: 'SoakTest'
  detail: Scalars['String']['output']
  name: Scalars['String']['output']
  status: SoakTestStatus
}

export enum SoakTestStatus {
  /** Fail */
  fail = 'fail',
  /** In progress */
  in_progress = 'in_progress',
  /** Success */
  success = 'success',
  /** Waiting for data */
  waiting_for_data = 'waiting_for_data',
}

export type SourcedAutomationFlow = {
  __typename: 'SourcedAutomationFlow'
  configuration: AutomationFlowConfiguration
  dry_run: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  source?: Maybe<AutomationSource>
  tags: Array<Scalars['String']['output']>
}

export type SponsorshipContent = {
  __typename: 'SponsorshipContent'
  drawer_cta_text?: Maybe<Scalars['String']['output']>
  sponsor_url?: Maybe<Scalars['String']['output']>
  sponsorship_tile?: Maybe<SponsorshipTile>
}

export type SponsorshipTile = {
  __typename: 'SponsorshipTile'
  image_cta_text?: Maybe<Scalars['String']['output']>
  image_url?: Maybe<Scalars['String']['output']>
}

export type SubscriptionInvoice = IInvoice & {
  __typename: 'SubscriptionInvoice'
  created_at: Scalars['DateTime']['output']
  currency_balance?: Maybe<FormattedAmount>
  currency_debit?: Maybe<FormattedAmount>
  currency_debit_sub_total?: Maybe<FormattedAmount>
  currency_refundable?: Maybe<FormattedAmount>
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  is_void: Scalars['Boolean']['output']
  minute_debit?: Maybe<FormattedAmount>
  minute_refundable?: Maybe<FormattedAmount>
  /** Always empty – the payment was taken before the invoice reached us */
  next_action?: Maybe<Array<Maybe<PaymentIntent>>>
  /** End of the period paid for, before any renewal grace */
  period_end: Scalars['DateTime']['output']
  scheme?: Maybe<Scheme>
  scheme_product?: Maybe<SchemeProduct>
  status?: Maybe<InvoiceStatus>
  timezone_offset?: Maybe<Scalars['Float']['output']>
  transactions?: Maybe<TransactionConnection>
  unused_period_refund?: Maybe<FormattedAmount>
  user: User
}

export enum SubscriptionStatus {
  /** Paying and will renew */
  active = 'active',
  /** Over, whatever ended it */
  ended = 'ended',
  /** Payment failed, still being chased */
  past_due = 'past_due',
  /** Never started, nothing paid for */
  pending = 'pending',
}

export type TagWhere = {
  deleted?: InputMaybe<BooleanOp>
  id?: InputMaybe<ScalarOp>
  name?: InputMaybe<ScalarOp>
}

export type Task = {
  __typename: 'Task'
  details?: Maybe<TaskDetails>
  timestamps?: Maybe<Timestamps>
  uuid: Scalars['ID']['output']
}

export type TaskCodeItem = {
  __typename: 'TaskCodeItem'
  code: Scalars['String']['output']
  reason: TaskCodeReason
}

export type TaskCodeItemInput = {
  code: Scalars['String']['input']
  reason: TaskCodeReason
}

export type TaskCodeListItem = {
  __typename: 'TaskCodeListItem'
  code: Scalars['String']['output']
  description: Scalars['String']['output']
  vehicle_type: Array<ModuleHardware>
}

export enum TaskCodeReason {
  other = 'other',
}

export type TaskConsumable = {
  __typename: 'TaskConsumable'
  quantity: Scalars['Int']['output']
  sku: Scalars['ID']['output']
}

export type TaskConsumableInput = {
  quantity: Scalars['Int']['input']
  sku: Scalars['ID']['input']
}

export type TaskConsumableOption = {
  __typename: 'TaskConsumableOption'
  name: Scalars['String']['output']
  sku: Scalars['ID']['output']
}

export type TaskDetails = {
  __typename: 'TaskDetails'
  allow_parts_tracking: Scalars['Boolean']['output']
  assignee?: Maybe<User>
  consumables?: Maybe<Array<TaskConsumable>>
  description?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  parts?: Maybe<Array<Maybe<PartDetail>>>
  replacements?: Maybe<Array<TaskReplacement>>
  status?: Maybe<TaskStatusEnum>
  task_codes_details?: Maybe<Array<TaskCodeItem>>
  title?: Maybe<Scalars['String']['output']>
}

export type TaskDetailsInput = {
  allow_parts_tracking?: InputMaybe<Scalars['Boolean']['input']>
  assignee?: InputMaybe<Scalars['String']['input']>
  consumables?: InputMaybe<Array<TaskConsumableInput>>
  description?: InputMaybe<Scalars['String']['input']>
  faultIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  notes?: InputMaybe<Scalars['String']['input']>
  parts?: InputMaybe<Array<InputMaybe<PartInput>>>
  replacements?: InputMaybe<Array<TaskReplacementInput>>
  status?: InputMaybe<TaskStatusEnum>
  task_codes_details?: InputMaybe<Array<TaskCodeItemInput>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TaskReplacement = {
  __typename: 'TaskReplacement'
  modelName: Scalars['String']['output']
  modelSysId: Scalars['ID']['output']
  new: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  previous?: Maybe<Scalars['String']['output']>
  reusability?: Maybe<TaskReplacementReusability>
}

export type TaskReplacementInput = {
  modelName: Scalars['String']['input']
  modelSysId: Scalars['ID']['input']
  new: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  previous?: InputMaybe<Scalars['String']['input']>
  reusability?: InputMaybe<TaskReplacementReusability>
}

export enum TaskReplacementReusability {
  non_reusable = 'non_reusable',
  reusable_with_repair = 'reusable_with_repair',
  reusable_without_repair = 'reusable_without_repair',
}

export enum TaskStatusEnum {
  blocked = 'blocked',
  complete = 'complete',
  new = 'new',
}

export type Telemetry = {
  __typename: 'Telemetry'
  altitude?: Maybe<Scalars['Float']['output']>
  ambient_temperature: Scalars['Float']['output']
  battery_percent: Scalars['Float']['output']
  battery_voltage?: Maybe<Scalars['Float']['output']>
  drive?: Maybe<Drive>
  dyno_pulses: Scalars['Int']['output']
  fix_invalid: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  last_fix_time?: Maybe<Scalars['DateTime']['output']>
  latitude?: Maybe<Scalars['Float']['output']>
  longitude?: Maybe<Scalars['Float']['output']>
  max_error?: Maybe<Scalars['Float']['output']>
  time: Scalars['DateTime']['output']
}

export type TelemetryOrderby = {
  altitude?: InputMaybe<Direction>
  ambient_temperature?: InputMaybe<Direction>
  battery_percent?: InputMaybe<Direction>
  battery_voltage?: InputMaybe<Direction>
  dyno_pulses?: InputMaybe<Direction>
  fix_invalid?: InputMaybe<Direction>
  id?: InputMaybe<Direction>
  last_fix_time?: InputMaybe<Direction>
  latitude?: InputMaybe<Direction>
  longitude?: InputMaybe<Direction>
  max_error?: InputMaybe<Direction>
  time?: InputMaybe<Direction>
}

export type TelemetryWhere = {
  altitude?: InputMaybe<ScalarOp>
  battery_percent?: InputMaybe<ScalarOp>
  battery_voltage?: InputMaybe<ScalarOp>
  dyno_pulses?: InputMaybe<ScalarOp>
  fix_invalid?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
  last_fix_time?: InputMaybe<ScalarOp>
  latitude?: InputMaybe<ScalarOp>
  longitude?: InputMaybe<ScalarOp>
  max_error?: InputMaybe<ScalarOp>
  time?: InputMaybe<ScalarOp>
}

export type Timestamps = {
  __typename: 'Timestamps'
  created_at: Scalars['DateTime']['output']
  deleted_at?: Maybe<Scalars['DateTime']['output']>
  updated_at: Scalars['DateTime']['output']
}

export enum TransactionCategory {
  /** If this transaction is a deduction due to a discount */
  discount = 'discount',
  /** Any other transaction not one of the special types */
  generic = 'generic',
  /** If this transaction is a record of a provider refund */
  refund = 'refund',
  /** If this transaction is a record of a provider charge reversal */
  reversal = 'reversal',
  /** This is used by internal services to indicate a transaction used to settled deficit */
  settler = 'settler',
  /** If an amount is too small to charge we waive the transaction */
  waiver = 'waiver',
}

export type TransactionConnection = {
  __typename: 'TransactionConnection'
  nodes: Array<ITransaction>
  pagination: Pagination
}

export type TransactionMeta = {
  __typename: 'TransactionMeta'
  charge_type?: Maybe<TransactionMetaChargeType>
  descriptor?: Maybe<TransactionCategory>
  discount_type?: Maybe<TransactionMetaDiscountType>
  failure_reason?: Maybe<Scalars['String']['output']>
  is_flat_journey_fee?: Maybe<Scalars['Boolean']['output']>
  minutes_charged?: Maybe<Scalars['Int']['output']>
  refund_description?: Maybe<Scalars['String']['output']>
  requester_id?: Maybe<Scalars['ID']['output']>
  time_increment_cost?: Maybe<Scalars['Int']['output']>
  transaction_label?: Maybe<Scalars['String']['output']>
}

export enum TransactionMetaChargeType {
  /** Whenever a penalty is charged for cancelling a journey */
  cancel_journey_penalty = 'cancel_journey_penalty',
  /** Adjustment that brings a journey's currency charges back under a cap */
  currency_charge_cap_adjustment = 'currency_charge_cap_adjustment',
  /** Minutes refunded to a user */
  minute_refund = 'minute_refund',
  /** When ever minutes are credited to an account */
  minute_topup = 'minute_topup',
  out_of_service_area_charge = 'out_of_service_area_charge',
  out_of_zone_charge = 'out_of_zone_charge',
  /** Fee charged when vehicle is parked in a zone, but not front locked. where mandated */
  partially_locked_in_zone_parking_charge = 'partially_locked_in_zone_parking_charge',
  /** Whenever a product is purchased eg minute bundle, day pass */
  product_purchase = 'product_purchase',
  /** One journey spent from a product's daily cap */
  quotum_charge = 'quotum_charge',
  /** Tax (if applicable) */
  tax = 'tax',
  time_based_charge = 'time_based_charge',
  time_based_minute_charge = 'time_based_minute_charge',
  /** If a user exceeds their minute balance while on a journey we make a time based charge */
  time_based_overflow_charge = 'time_based_overflow_charge',
  time_based_period_pass_charge = 'time_based_period_pass_charge',
  /** The minutes a subscription's fare covers, before the rest rolls onward */
  time_based_subscription_charge = 'time_based_subscription_charge',
  /** Fee charged when vehicle is parked in a zone, but not docked */
  undocked_in_zone_parking_charge = 'undocked_in_zone_parking_charge',
  unlock_fee = 'unlock_fee',
  /** Fee charged when vehicle is parked in a zone but the vehicle type is not permitted */
  vehicle_not_permitted_in_zone_charge = 'vehicle_not_permitted_in_zone_charge',
  /** Fee charged when vehicle is parked in a zone at maximum capacity */
  zone_max_capacity_charge = 'zone_max_capacity_charge',
}

export enum TransactionMetaDiscountType {
  /** Pricing adjustment from product. Eg. pedal discount */
  product = 'product',
  /** Promotional discount from marketing */
  promotion = 'promotion',
  /** Product purchase with a voucher */
  voucher = 'voucher',
}

export type TransactionResult = {
  __typename: 'TransactionResult'
  created_at?: Maybe<Scalars['DateTime']['output']>
  failure_code?: Maybe<Scalars['String']['output']>
  failure_message?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  status?: Maybe<TransactionResultType>
}

export enum TransactionResultType {
  /** The transaction failed with provider */
  failed = 'failed',
  /** The tansaction has not been actioned with provider */
  pending = 'pending',
  /** The transaction succeeded with provider */
  succeeded = 'succeeded',
}

export enum TransactionType {
  /** Currency */
  currency_transaction = 'currency_transaction',
  /** Minute */
  minute_transaction = 'minute_transaction',
  /** One unit of a product's quota */
  quotum_transaction = 'quotum_transaction',
}

export enum UnlockMethod {
  manual = 'manual',
  nfc = 'nfc',
  qr = 'qr',
}

export type User = {
  __typename: 'User'
  /** Exemptions from charges in a scheme */
  charge_exemptions: Array<ChargeExemption>
  /** Is the account in a state where we allow deletion */
  delete_permission: DeletePermission
  deleted?: Maybe<Scalars['Boolean']['output']>
  driving_licence_check?: Maybe<DrivingLicenceCheck>
  email?: Maybe<Scalars['String']['output']>
  /** User has verified a Driving licence since we started checking DoB */
  has_birthdate: Scalars['Boolean']['output']
  has_valid_licence: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  /** When was the last time they validated their selfie? ISO8610 */
  identity_checked_at?: Maybe<Scalars['DateTime']['output']>
  /** @deprecated Use top level `intercom_hash` resolver instead. */
  intercom_hash: Scalars['JSON']['output']
  invoices?: Maybe<IInvoiceConnection>
  /** Account disabled on Firebase (via User service) */
  is_blocked: Scalars['Boolean']['output']
  /** User is known to be over 18 */
  is_over_18: Scalars['Boolean']['output']
  is_whitelisted?: Maybe<Scalars['Boolean']['output']>
  /** Lifetime totals */
  journey_totals: JourneyTotals
  journeys: JourneyConnection
  /** Expiry date for driving licence */
  licence_expiry?: Maybe<LicenceExpiry>
  /** Notification preferences for this scheme */
  notification_preferences: Array<NotificationTopicGroup>
  /** The onfido applicant details for a user */
  onfido_applicant?: Maybe<OnfidoApplicant>
  outstanding_invoices?: Maybe<IInvoiceConnection>
  passes?: Maybe<UserProductConnection>
  payer?: Maybe<Payer>
  /** An account has been created for this user on Persona */
  persona_enrolled: Scalars['Boolean']['output']
  /** A device has been enrolled for this user on Persona */
  persona_enrolled_device: Scalars['Boolean']['output']
  phone_number?: Maybe<Scalars['String']['output']>
  /** Returns the best valid promotion for a given scheme */
  promotion?: Maybe<Promotion>
  promotions: Array<Promotion>
  roles?: Maybe<Array<Maybe<Role>>>
  user_addons: UserAddonConnection
  user_products: UserProductConnection
  /** UserScheme associations where the user is active */
  user_schemes: Array<UserScheme>
  /** Subscription passes the user holds or has held, newest first */
  user_subscriptions: Array<UserSubscription>
  /** uuid is a secondary id for external use. eg MDS/DFT */
  uuid: Scalars['GUID']['output']
  wallet?: Maybe<Array<Maybe<Wallet>>>
  wallet_v2: WalletV2
}

export type Usercharge_exemptionsArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type UserinvoicesArgs = {
  order_by?: InputMaybe<IInvoiceOrderby>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<IInvoiceWhere>
}

export type Userjourney_totalsArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type UserjourneysArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id: Scalars['ID']['input']
}

export type Usernotification_preferencesArgs = {
  scheme_id: Scalars['ID']['input']
}

export type Useroutstanding_invoicesArgs = {
  order_by?: InputMaybe<IInvoiceOrderby>
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  where?: InputMaybe<IInvoiceWhere>
}

export type UserpassesArgs = {
  scheme_id: Scalars['ID']['input']
}

export type UserpromotionArgs = {
  scheme_id: Scalars['ID']['input']
}

export type UserpromotionsArgs = {
  scheme_id: Scalars['ID']['input']
}

export type UserrolesArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type Useruser_addonsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type Useruser_productsArgs = {
  paginate?: InputMaybe<Paginate>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type Useruser_subscriptionsArgs = {
  scheme_id?: InputMaybe<Scalars['ID']['input']>
}

export type UserwalletArgs = {
  scheme_id: Scalars['ID']['input']
}

export type Userwallet_v2Args = {
  scheme_id: Scalars['ID']['input']
}

export type UserAddon = {
  __typename: 'UserAddon'
  created_at: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  invoice: ProductInvoice
  scheme_addon: SchemeAddon
  user: User
  valid_until: Scalars['DateTime']['output']
}

export type UserAddonAnnotated = {
  __typename: 'UserAddonAnnotated'
  available_here: Scalars['Boolean']['output']
  created_at: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  invoice: ProductInvoice
  scheme_addon: SchemeAddon
  user: User
  valid_until: Scalars['DateTime']['output']
}

export type UserAddonConnection = IConnection & {
  __typename: 'UserAddonConnection'
  nodes: Array<UserAddon>
  pagination: Pagination
}

export type UserConnection = IConnection & {
  __typename: 'UserConnection'
  nodes: Array<User>
  pagination: Pagination
}

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type UserOrderby = {
  email?: InputMaybe<Direction>
  id?: InputMaybe<Direction>
}

export type UserProduct = {
  __typename: 'UserProduct'
  /** Minute balances for active passes */
  balances?: Maybe<PeriodPassBalances>
  /** Today's journey quota, in the scheme timezone, for any product that caps journeys */
  billable_journey_cap?: Maybe<BillableJourneyCapInfo>
  created_at?: Maybe<Scalars['DateTime']['output']>
  /** What the customer was sold: the period a subscription paid for, before that grace */
  expires_at?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  invoice?: Maybe<IInvoice>
  is_bonus: Scalars['Boolean']['output']
  /**
   * Total period pass minute balance
   * @deprecated Use balances field
   */
  period_pass_balance?: Maybe<FormattedAmount>
  /**
   * Minute balance for this period pass
   * @deprecated Use balances field
   */
  period_pass_current_balance?: Maybe<FormattedAmount>
  /**
   * Today's journey quota, in the scheme timezone, for any product that caps journeys
   * @deprecated Use billable_journey_cap
   */
  period_pass_journey_cap?: Maybe<PeriodPassCapInfo>
  /** Included unlocks used in this sub period */
  period_pass_unlocks?: Maybe<Array<PeriodPassUnlocks>>
  reward?: Maybe<VehicleReward>
  scheme_product: SchemeProduct
  user: User
  /** When access stops, which for a subscription period includes the renewal grace */
  valid_until?: Maybe<Scalars['DateTime']['output']>
}

export type UserProductConnection = {
  __typename: 'UserProductConnection'
  nodes: Array<UserProduct>
  pagination: Pagination
}

export type UserScheme = {
  __typename: 'UserScheme'
  scheme?: Maybe<Scheme>
  scheme_id: Scalars['ID']['output']
  user_id: Scalars['ID']['output']
}

/**
 * Renewal and dunning state for a subscription pass. Access itself is a UserProduct,
 * granted one paid period at a time
 */
export type UserSubscription = {
  __typename: 'UserSubscription'
  /** What each period is billed at, snapshotted when they subscribed */
  amount: FormattedAmount
  /** When it stops renewing, cleared if they resubscribe within the period */
  cancel_at?: Maybe<Scalars['DateTime']['output']>
  /** What a cancellation will refund, once it lands. Only on the cancel mutation */
  cancellation_refund?: Maybe<FormattedAmount>
  created_at: Scalars['DateTime']['output']
  /** End of the period paid for, when it renews */
  current_period_end?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  /** SCA to finish before the first period is paid for */
  next_action?: Maybe<Array<Maybe<PaymentIntent>>>
  scheme_product?: Maybe<SchemeProduct>
  status: SubscriptionStatus
  user: User
}

export type UserWhere = {
  email?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
  phone_number?: InputMaybe<ScalarOp>
  roles?: InputMaybe<RoleWhere>
}

export type ValidationCondition =
  | ValidationConditionContains
  | ValidationConditionEndsWith
  | ValidationConditionIn
  | ValidationConditionIs
  | ValidationConditionLessThan
  | ValidationConditionMoreThan
  | ValidationConditionStartsWith
  | ValidationConditionTimeframe
  | ValidationConditionTimeframeAbsolute

export type ValidationConditionContains = {
  __typename: 'ValidationConditionContains'
  contains: Array<Scalars['String']['output']>
}

export type ValidationConditionEndsWith = {
  __typename: 'ValidationConditionEndsWith'
  ends_with: Array<Scalars['String']['output']>
}

export type ValidationConditionIn = {
  __typename: 'ValidationConditionIn'
  in: Array<Scalars['String']['output']>
}

export type ValidationConditionInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>
  ends_with?: InputMaybe<Array<Scalars['String']['input']>>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  is?: InputMaybe<Array<Scalars['String']['input']>>
  less_than?: InputMaybe<Array<Scalars['String']['input']>>
  more_than?: InputMaybe<Array<Scalars['String']['input']>>
  starts_with?: InputMaybe<Array<Scalars['String']['input']>>
  timeframe?: InputMaybe<Array<Scalars['String']['input']>>
  timeframe_absolute?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ValidationConditionIs = {
  __typename: 'ValidationConditionIs'
  is: Array<Scalars['String']['output']>
}

export type ValidationConditionLessThan = {
  __typename: 'ValidationConditionLessThan'
  less_than: Array<Scalars['String']['output']>
}

export type ValidationConditionMoreThan = {
  __typename: 'ValidationConditionMoreThan'
  more_than: Array<Scalars['String']['output']>
}

export type ValidationConditionStartsWith = {
  __typename: 'ValidationConditionStartsWith'
  starts_with: Array<Scalars['String']['output']>
}

export type ValidationConditionTimeframe = {
  __typename: 'ValidationConditionTimeframe'
  timeframe: Array<Scalars['String']['output']>
}

export type ValidationConditionTimeframeAbsolute = {
  __typename: 'ValidationConditionTimeframeAbsolute'
  timeframe_absolute: Array<Scalars['String']['output']>
}

export type ValidationCriterion = {
  __typename: 'ValidationCriterion'
  /**  List of scalar conditions */
  conditions: ValidationCondition
  name: Scalars['String']['output']
  /**  Property of redemption metadata that must match */
  property: Scalars['String']['output']
}

export type ValidationCriterionInput = {
  conditions: ValidationConditionInput
  name: Scalars['String']['input']
  property: Scalars['String']['input']
}

export type ValidationRule = {
  __typename: 'ValidationRule'
  created_at: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  /**  e.g. (1 AND 2) OR 3 */
  logic: Scalars['String']['output']
  name: Scalars['String']['output']
  /**  List of criteria for this rule */
  rules_list: Array<ValidationCriterion>
}

export type ValidationRuleConnection = IConnection & {
  __typename: 'ValidationRuleConnection'
  nodes: Array<ValidationRule>
  pagination: Pagination
}

export type ValidationRulesInput = {
  logic: Scalars['String']['input']
  name: Scalars['String']['input']
  rules_list: Array<ValidationCriterionInput>
}

/** The periods a purchase can be sold for, each named by the ISO 8601 duration it runs for */
export enum ValidityInterval {
  p1_d = 'P1D',
  p1_m = 'P1M',
  p1_y = 'P1Y',
  p2_d = 'P2D',
  p3_d = 'P3D',
  p3_m = 'P3M',
  p6_m = 'P6M',
  p7_d = 'P7D',
  p14_d = 'P14D',
}

export type Vehicle = {
  __typename: 'Vehicle'
  detail: VehicleDetail
  ebike_estimated_range?: Maybe<Scalars['Float']['output']>
  frame_id: Scalars['ID']['output']
  frame_model?: Maybe<Scalars['String']['output']>
  frame_type: Scalars['String']['output']
  frame_year?: Maybe<Scalars['Int']['output']>
  hardware_type: ModuleHardware
  id: Scalars['GUID']['output']
  jobs: JobConnection
  /** @deprecated Use frame_model */
  model?: Maybe<Scalars['String']['output']>
  propulsion_type: Array<VehiclePropulsionType>
  rewards: Array<VehicleReward>
  state?: Maybe<VehicleStateEvent>
  state_history?: Maybe<VehicleStateEventConnection>
  time: Scalars['DateTime']['output']
  vehicle_category: VehicleCategory
  vehicle_type: VehicleType
}

export type VehiclejobsArgs = {
  job_details_filters?: InputMaybe<JobDetailsInput>
  job_filters?: InputMaybe<JobFiltersInput>
  paginate?: InputMaybe<Paginate>
  sort_field?: InputMaybe<JobSortField>
  sort_order?: InputMaybe<Direction>
}

export type Vehiclestate_historyArgs = {
  paginate?: InputMaybe<Paginate>
}

/**  VehicleType + propulsion_type, used for pricing config */
export enum VehicleCategory {
  bike = 'bike',
  cargo_ebike = 'cargo_ebike',
  ebike = 'ebike',
  escooter = 'escooter',
}

export type VehicleConnection = IConnection & {
  __typename: 'VehicleConnection'
  nodes: Array<Vehicle>
  pagination: Pagination
}

export type VehicleDetail = {
  __typename: 'VehicleDetail'
  id: Scalars['ID']['output']
  lock_configuration: LockConfiguration
  module?: Maybe<Module>
  scheme?: Maybe<Scheme>
  time: Scalars['DateTime']['output']
  vehicle_unlock_id?: Maybe<Scalars['String']['output']>
}

export type VehicleDetailUpdateInput = {
  vehicle_unlock_id?: InputMaybe<Scalars['String']['input']>
}

export enum VehicleLockState {
  front_lock_only = 'front_lock_only',
  lock_fault = 'lock_fault',
  locked = 'locked',
  rear_lock_only = 'rear_lock_only',
  unknown = 'unknown',
  unlocked = 'unlocked',
}

export enum VehiclePropulsionType {
  electric = 'electric',
  electric_assist = 'electric_assist',
  human = 'human',
}

export type VehicleReward = {
  __typename: 'VehicleReward'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
  type: VehicleRewardType
}

export enum VehicleRewardType {
  rescue_stranded = 'rescue_stranded',
  secure_front_lock = 'secure_front_lock',
}

export enum VehicleState {
  available = 'available',
  non_operational = 'non_operational',
  on_trip = 'on_trip',
  rebalancing = 'rebalancing',
  removed = 'removed',
  uninitialised = 'uninitialised',
  unknown = 'unknown',
  waiting_for_location = 'waiting_for_location',
}

export type VehicleStateEvent = {
  __typename: 'VehicleStateEvent'
  frame?: Maybe<Frame>
  id: Scalars['ID']['output']
  journey?: Maybe<Journey>
  location?: Maybe<Scalars['JSON']['output']>
  module: Module
  service_area?: Maybe<ServiceArea>
  state: VehicleState
  time: Scalars['DateTime']['output']
  triggers: Array<Scalars['String']['output']>
  zone?: Maybe<Zone>
}

export type VehicleStateEventConnection = {
  __typename: 'VehicleStateEventConnection'
  nodes: Array<VehicleStateEvent>
  pagination: Pagination
}

/**  Basic vehicle type  */
export enum VehicleType {
  bike = 'bike',
  cargo_bike = 'cargo_bike',
  scooter = 'scooter',
}

export type VehicleWhere = {
  frame_id?: InputMaybe<ScalarOp>
  id?: InputMaybe<ScalarOp>
}

export enum VersionEvent {
  create = 'create',
  delete = 'delete',
  update = 'update',
}

export type Voucher = {
  __typename: 'Voucher'
  campaign?: Maybe<Scalars['String']['output']>
  code: Scalars['ID']['output']
  description?: Maybe<Scalars['String']['output']>
  discount?: Maybe<ProductDiscountConfig>
  expiration_date: Scalars['DateTime']['output']
  scheme_addons?: Maybe<Array<Maybe<SchemeAddon>>>
  scheme_products?: Maybe<Array<Maybe<SchemeProduct>>>
  start_date: Scalars['DateTime']['output']
}

export type Wallet = {
  __typename: 'Wallet'
  item?: Maybe<WalletItem>
  priority?: Maybe<Scalars['Int']['output']>
  product_type?: Maybe<ProductType>
}

export type WalletBalanceBreakdown = {
  __typename: 'WalletBalanceBreakdown'
  balance: FormattedAmount
  breakdown: Array<WalletBalanceBreakdownItem>
  pricing?: Maybe<WalletVehiclePricing>
  unavailable_balance: FormattedAmount
}

export type WalletBalanceBreakdownItem =
  | WalletBreakdownItemBundle
  | WalletBreakdownItemPass

export type WalletBreakdownItemBundle = {
  __typename: 'WalletBreakdownItemBundle'
  balance: FormattedAmount
}

export type WalletBreakdownItemPass = {
  __typename: 'WalletBreakdownItemPass'
  balance: FormattedAmount
  id: Scalars['ID']['output']
  is_bonus: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  quantity: FormattedAmount
  reward?: Maybe<VehicleReward>
  scheme_product: SchemeProduct
  valid_until: Scalars['DateTime']['output']
}

export type WalletItem = PaymentProvider | SchemeProduct | UserProduct

/** The journeys a subscription pass covers, and how many were ridden today */
export type WalletJourneyQuota = {
  __typename: 'WalletJourneyQuota'
  /** How often the quota refills, e.g. daily */
  period: Scalars['String']['output']
  quota: Scalars['Int']['output']
  used: Scalars['Int']['output']
}

export type WalletProduct =
  | WalletProductDayPass
  | WalletProductSpecialPass
  | WalletProductSubscriptionPass

export type WalletProductDayPass = {
  __typename: 'WalletProductDayPass'
  available_here: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  pricing: WalletVehiclePricing
  scheme_product: SchemeProduct
  valid_until: Scalars['DateTime']['output']
}

export type WalletProductSpecialPass = {
  __typename: 'WalletProductSpecialPass'
  available_here: Scalars['Boolean']['output']
  balance: FormattedAmount
  depleated: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  pricing: WalletVehiclePricing
  quantity: FormattedAmount
  scheme_product: SchemeProduct
  valid_until: Scalars['DateTime']['output']
}

/** An active period of a subscription pass */
export type WalletProductSubscriptionPass = {
  __typename: 'WalletProductSubscriptionPass'
  available_here: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  /** Null when the product does not cap journeys */
  journey_quota?: Maybe<WalletJourneyQuota>
  name: Scalars['String']['output']
  /** The end of the period they paid for, before that grace */
  period_end: Scalars['DateTime']['output']
  scheme_product: SchemeProduct
  user_subscription?: Maybe<UserSubscription>
  /** When access stops, which includes the renewal grace */
  valid_until: Scalars['DateTime']['output']
}

export type WalletV2 = {
  __typename: 'WalletV2'
  /**  NOTE: If this is a bundle, it could return any scheme bundle product. So just check product type in this case. */
  active_product: SchemeProduct
  addons: Array<UserAddonAnnotated>
  balance: WalletBalanceBreakdown
  products: Array<WalletProduct>
}

export type WalletVehiclePricing = {
  __typename: 'WalletVehiclePricing'
  bike?: Maybe<WalletVehiclePricingItem>
  cargo_ebike?: Maybe<WalletVehiclePricingItem>
  ebike?: Maybe<WalletVehiclePricingItem>
  escooter?: Maybe<WalletVehiclePricingItem>
}

export type WalletVehiclePricingItem = {
  __typename: 'WalletVehiclePricingItem'
  unlock_fee: Fee
}

export type Whitelist = {
  __typename: 'Whitelist'
  id: Scalars['ID']['output']
  pattern: Scalars['String']['output']
  role_type?: Maybe<Scalars['String']['output']>
  role_type_id?: Maybe<Scalars['Int']['output']>
  scheme: Scheme
}

export type WhitelistConnection = IConnection & {
  __typename: 'WhitelistConnection'
  nodes: Array<Whitelist>
  pagination: Pagination
}

export type WhitelistInput = {
  pattern: Scalars['String']['input']
  role_type_id: Scalars['Int']['input']
  scheme_id: Scalars['ID']['input']
}

export type WhitelistOrderby = {
  id?: InputMaybe<Direction>
  pattern?: InputMaybe<Direction>
}

export type WhitelistWhere = {
  id?: InputMaybe<ScalarOp>
  pattern?: InputMaybe<ScalarOp>
}

export type Zone = IZone & {
  __typename: 'Zone'
  all_commissioned_modules_count: Scalars['Int']['output']
  all_commissioned_vehicles: Array<Vehicle>
  all_commissioned_vehicles_count: Scalars['Int']['output']
  all_modules_count: Scalars['Int']['output']
  capacity: Scalars['Int']['output']
  centre: Scalars['JSON']['output']
  /** Optional further information about this zone suspension */
  current_suspension?: Maybe<CurrentZoneSuspension>
  docked_vehicles_count: Scalars['Int']['output']
  external_id: Scalars['ID']['output']
  geom: Scalars['JSON']['output']
  /** @deprecated Use Zone.hireable_vehicles instead */
  hireable_modules: Array<Maybe<Module>>
  /** @deprecated Use Zone.hireable_vehicles_count instead */
  hireable_modules_count: Scalars['Int']['output']
  hireable_vehicles: Array<Maybe<Vehicle>>
  hireable_vehicles_count: Scalars['Int']['output']
  hiring_capacity_status: HiringCapacityStatus
  id: Scalars['ID']['output']
  is_at_max_overflow_capacity: Scalars['Boolean']['output']
  is_external: Scalars['Boolean']['output']
  is_priority: Scalars['Boolean']['output']
  is_promotional: Scalars['Boolean']['output']
  is_suspended: Scalars['Boolean']['output']
  /** @deprecated Use Zone.hireable_modules_count directly instead */
  locked_modules?: Maybe<ModuleConnection>
  modules?: Maybe<ModuleConnection>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  parking_capacity_status: ParkingCapacityStatus
  permitted_vehicles: Array<VehicleType>
  promotion?: Maybe<Promotion>
  related_modules?: Maybe<Array<Maybe<Module>>>
  /** Scheduled suspensions for this zone */
  scheduled_suspensions?: Maybe<ScheduledZoneSuspensionConnection>
  scheme: Scheme
  zone_type: ZoneType
}

export type Zoneall_commissioned_modules_countArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type Zoneall_commissioned_vehiclesArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type Zoneall_commissioned_vehicles_countArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type Zoneall_modules_countArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type Zonehireable_modulesArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type Zonehireable_modules_countArgs = {
  hardware_type?: InputMaybe<ModuleHardware>
}

export type Zonehireable_vehiclesArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type Zonehireable_vehicles_countArgs = {
  propulsion_type?: InputMaybe<VehiclePropulsionType>
  vehicle_type?: InputMaybe<VehicleType>
}

export type Zonelocked_modulesArgs = {
  paginate?: InputMaybe<Paginate>
}

export type ZonemodulesArgs = {
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<ModuleWhere>>>
}

export type ZonepromotionArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>
}

export type Zonescheduled_suspensionsArgs = {
  paginate?: InputMaybe<Paginate>
}

export type ZoneConnection = IConnection & {
  __typename: 'ZoneConnection'
  geojson: Scalars['JSON']['output']
  nodes: Array<Zone>
  pagination: Pagination
}

export type ZoneHistory = {
  __typename: 'ZoneHistory'
  capacity: Scalars['Int']['output']
  centre: Scalars['JSON']['output']
  external_id: Scalars['ID']['output']
  geom: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  is_external: Scalars['Boolean']['output']
  is_priority: Scalars['Boolean']['output']
  is_promotional?: Maybe<Scalars['Boolean']['output']>
  is_suspended: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  permitted_vehicles: Array<VehicleType>
  scheme?: Maybe<Scheme>
  time?: Maybe<Scalars['DateTime']['output']>
  zone_id: Scalars['ID']['output']
  zone_type: ZoneType
}

export type ZoneHistoryChanges = {
  __typename: 'ZoneHistoryChanges'
  capacity: Scalars['Int']['output']
  /** Optional further information about this zone suspension */
  current_suspension?: Maybe<CurrentZoneSuspension>
  external_id?: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  is_external?: Maybe<Scalars['Boolean']['output']>
  is_priority?: Maybe<Scalars['Boolean']['output']>
  is_promotional?: Maybe<Scalars['Boolean']['output']>
  is_suspended: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  permitted_vehicles: Array<VehicleType>
  scheme?: Maybe<Scheme>
  time?: Maybe<Scalars['DateTime']['output']>
  zone_id: Scalars['ID']['output']
  zone_type: ZoneType
}

export type ZoneHistoryChangesConnection = IConnection & {
  __typename: 'ZoneHistoryChangesConnection'
  nodes: Array<ZoneHistoryChanges>
  pagination: Pagination
}

export type ZoneHistoryConnection = IConnection & {
  __typename: 'ZoneHistoryConnection'
  nodes: Array<ZoneHistory>
  pagination: Pagination
}

export type ZoneHistoryOrderBy = {
  id?: InputMaybe<Direction>
}

export type ZoneHistoryWhere = {
  id?: InputMaybe<ScalarOp>
  is_promotional?: InputMaybe<BooleanOp>
  is_suspended?: InputMaybe<BooleanOp>
  name?: InputMaybe<ScalarOp>
  scheme?: InputMaybe<RemoteNodeOp>
  time?: InputMaybe<ScalarOp>
}

export type ZoneInput = {
  capacity: Scalars['Int']['input']
  centre: Scalars['JSON']['input']
  external_id: Scalars['ID']['input']
  geom: Scalars['JSON']['input']
  is_external?: InputMaybe<Scalars['Boolean']['input']>
  is_priority?: InputMaybe<Scalars['Boolean']['input']>
  is_suspended?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  permitted_vehicles?: InputMaybe<Array<VehicleType>>
  scheme_id: Scalars['ID']['input']
}

export type ZoneOrderBy = {
  id?: InputMaybe<Direction>
}

export type ZoneSuspensionInfoInput = {
  notes?: InputMaybe<Scalars['String']['input']>
  reason: ZoneSuspensionReasonInput
}

/** The reason a zone was suspended */
export enum ZoneSuspensionReason {
  incident = 'incident',
  maintenance = 'maintenance',
  other = 'other',
  permanently_closed = 'permanently_closed',
  scheduled_event = 'scheduled_event',
  unknown = 'unknown',
}

/** Input version of ZoneSuspensionReason */
export enum ZoneSuspensionReasonInput {
  incident = 'incident',
  maintenance = 'maintenance',
  other = 'other',
  permanently_closed = 'permanently_closed',
  scheduled_event = 'scheduled_event',
  unknown = 'unknown',
}

export type ZoneSyncResult = {
  __typename: 'ZoneSyncResult'
  added: Array<IZone>
  deleted: Array<IZone>
  dry_run: Scalars['Boolean']['output']
  updated: Array<Zone>
}

export enum ZoneType {
  normal = 'normal',
  workshop = 'workshop',
}

export type ZoneWhere = {
  id?: InputMaybe<ScalarOp>
  name?: InputMaybe<ScalarOp>
  scheme?: InputMaybe<RemoteNodeOp>
}

export type SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon_price_FormattedAmount =
  { __typename: 'FormattedAmount'; amount: number; formatted_amount: string }

export type SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon =
  {
    __typename: 'SchemeAddon'
    id: string
    scheme_id: string
    addon_type: AddonType
    name: string
    is_active: boolean
    is_protected?: boolean | null
    is_discoverable?: boolean | null
    role_whitelist: Array<string>
    validity_interval?: ValidityInterval | null
    amount: number
    price: SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon_price_FormattedAmount
  }

export type SchemeAddonListQuery_table_SchemeAddonConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type SchemeAddonListQuery_table_SchemeAddonConnection = {
  __typename: 'SchemeAddonConnection'
  nodes: Array<SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon>
  pagination: SchemeAddonListQuery_table_SchemeAddonConnection_pagination_Pagination
}

export type SchemeAddonListQuery_role_types_RoleType = {
  __typename: 'RoleType'
  description?: string | null
}

export type SchemeAddonListQuery_Query = {
  __typename: 'Query'
  table: SchemeAddonListQuery_table_SchemeAddonConnection
  role_types: Array<SchemeAddonListQuery_role_types_RoleType>
}

export type SchemeAddonListQueryVariables = Exact<{
  scheme_id: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
}>

export type SchemeAddonListQuery = SchemeAddonListQuery_Query

export type SchemeAddonQuery_scheme_addon_SchemeAddon = {
  __typename: 'SchemeAddon'
  id: string
  scheme_id: string
  addon_type: AddonType
  name: string
  is_active: boolean
  is_protected?: boolean | null
  is_discoverable?: boolean | null
  role_whitelist: Array<string>
  validity_interval?: ValidityInterval | null
  amount: number
  price: SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon_price_FormattedAmount
}

export type SchemeAddonQuery_Query = {
  __typename: 'Query'
  scheme_addon?: SchemeAddonQuery_scheme_addon_SchemeAddon | null
}

export type SchemeAddonQueryVariables = Exact<{
  schemeAddonId: Scalars['ID']['input']
}>

export type SchemeAddonQuery = SchemeAddonQuery_Query

export type UserAddonListQuery_user_User_table_UserAddonConnection_nodes_UserAddon_scheme_addon_SchemeAddon =
  {
    __typename: 'SchemeAddon'
    id: string
    name: string
    addon_type: AddonType
    scheme_id: string
  }

export type UserAddonListQuery_user_User_table_UserAddonConnection_nodes_UserAddon =
  {
    __typename: 'UserAddon'
    id: string
    valid_until: any
    created_at: any
    scheme_addon: UserAddonListQuery_user_User_table_UserAddonConnection_nodes_UserAddon_scheme_addon_SchemeAddon
  }

export type UserAddonListQuery_user_User_table_UserAddonConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type UserAddonListQuery_user_User_table_UserAddonConnection = {
  __typename: 'UserAddonConnection'
  nodes: Array<UserAddonListQuery_user_User_table_UserAddonConnection_nodes_UserAddon>
  pagination: UserAddonListQuery_user_User_table_UserAddonConnection_pagination_Pagination
}

export type UserAddonListQuery_user_User = {
  __typename: 'User'
  id: string
  table: UserAddonListQuery_user_User_table_UserAddonConnection
}

export type UserAddonListQuery_Query = {
  __typename: 'Query'
  user?: UserAddonListQuery_user_User | null
}

export type UserAddonListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
}>

export type UserAddonListQuery = UserAddonListQuery_Query

export type UpdateSchemeAddonMutation_update_scheme_addon_SchemeAddon = {
  __typename: 'SchemeAddon'
  id: string
}

export type UpdateSchemeAddonMutation_Mutation = {
  __typename: 'Mutation'
  update_scheme_addon: UpdateSchemeAddonMutation_update_scheme_addon_SchemeAddon
}

export type UpdateSchemeAddonMutationVariables = Exact<{
  schemeAddonId: Scalars['ID']['input']
  schemeAddonInput: SchemeAddonInput
}>

export type UpdateSchemeAddonMutation = UpdateSchemeAddonMutation_Mutation

export type CreateSchemeAddonMutation_add_scheme_addon_SchemeAddon = {
  __typename: 'SchemeAddon'
  id: string
}

export type CreateSchemeAddonMutation_Mutation = {
  __typename: 'Mutation'
  add_scheme_addon: CreateSchemeAddonMutation_add_scheme_addon_SchemeAddon
}

export type CreateSchemeAddonMutationVariables = Exact<{
  schemeAddonInput: SchemeAddonInput
}>

export type CreateSchemeAddonMutation = CreateSchemeAddonMutation_Mutation

export type DeleteSchemeAddonMutation_Mutation = {
  __typename: 'Mutation'
  remove_scheme_addon?: boolean | null
}

export type DeleteSchemeAddonMutationVariables = Exact<{
  schemeAddonId: Scalars['ID']['input']
}>

export type DeleteSchemeAddonMutation = DeleteSchemeAddonMutation_Mutation

export type AddonSummaryFragment = {
  __typename: 'SchemeAddon'
  id: string
  scheme_id: string
  addon_type: AddonType
  name: string
  is_active: boolean
  is_protected?: boolean | null
  is_discoverable?: boolean | null
  role_whitelist: Array<string>
  validity_interval?: ValidityInterval | null
  amount: number
  price: SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon_price_FormattedAmount
}

export type EditableAddonFieldsFragment = {
  __typename: 'SchemeAddon'
  name: string
  is_active: boolean
  is_protected?: boolean | null
  is_discoverable?: boolean | null
  role_whitelist: Array<string>
  validity_interval?: ValidityInterval | null
  amount: number
  price: SchemeAddonListQuery_table_SchemeAddonConnection_nodes_SchemeAddon_price_FormattedAmount
}

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_source_AutomationSource_filters_AutomationFlowFilter =
  {
    __typename: 'AutomationFlowFilter'
    not__: boolean
    entries: Array<string>
    filter_type: FilterType
  }

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_source_AutomationSource =
  {
    __typename: 'AutomationSource'
    table_name: string
    source_type: string
    filters?: Array<AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_source_AutomationSource_filters_AutomationFlowFilter> | null
  }

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration_ActionAutomationFlowConfiguration =
  {
    __typename: 'ActionAutomationFlowConfiguration'
    mutation: string
    mutation_name?: string | null
    mutation_function_call?: string | null
  }

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration_JobAutomationFlowConfiguration =
  {
    __typename: 'JobAutomationFlowConfiguration'
    task_id: string
    description: string
    side_effects?: Array<string> | null
    use_cleanup?: boolean | null
  }

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration_PublishAutomationFlowConfiguration =
  {
    __typename: 'PublishAutomationFlowConfiguration'
    topic_name: string
    eventType: string
    message_data: any
  }

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration =

    | AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration_ActionAutomationFlowConfiguration
    | AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration_JobAutomationFlowConfiguration
    | AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration_PublishAutomationFlowConfiguration

export type AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow =
  {
    __typename: 'SourcedAutomationFlow'
    id: string
    tags: Array<string>
    dry_run: boolean
    source?: AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_source_AutomationSource | null
    configuration: AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_configuration
  }

export type AutomationFlowsQuery_Query = {
  __typename: 'Query'
  sourced_automation_flows: Array<AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow>
}

export type AutomationFlowsQueryVariables = Exact<{ [key: string]: never }>

export type AutomationFlowsQuery = AutomationFlowsQuery_Query

export type DashboardAutomationsQuery_automations_Automation_jobs_AutomationJob =
  {
    __typename: 'AutomationJob'
    uuid: string
    frame_id: string
    scheme_id: number
    created_at?: any | null
  }

export type DashboardAutomationsQuery_automations_Automation = {
  __typename: 'Automation'
  justification_id: string
  description: string
  taskId: string
  side_effects: Array<string | null>
  jobs: Array<DashboardAutomationsQuery_automations_Automation_jobs_AutomationJob | null>
}

export type DashboardAutomationsQuery_Query = {
  __typename: 'Query'
  automations?: Array<DashboardAutomationsQuery_automations_Automation | null> | null
}

export type DashboardAutomationsQueryVariables = Exact<{
  filters?: InputMaybe<AutomationFilters>
}>

export type DashboardAutomationsQuery = DashboardAutomationsQuery_Query

export type TriggerDashboardAutomationMutation_Mutation = {
  __typename: 'Mutation'
  job_automation?: boolean | null
}

export type TriggerDashboardAutomationMutationVariables = Exact<{
  justification_id: Scalars['String']['input']
  description: Scalars['String']['input']
  taskId: Scalars['String']['input']
  side_effects: Array<JobAutomationSideEffect>
  results: Array<JobAutomationVehicleInput>
  dry_run: Scalars['Boolean']['input']
}>

export type TriggerDashboardAutomationMutation =
  TriggerDashboardAutomationMutation_Mutation

export type SchemeAvailabilityRestrictionsQuery_scheme_Scheme_availability_restriction_SchemeAvailabilityRestrictionConnection_nodes_SchemeAvailabilityRestriction =
  {
    __typename: 'SchemeAvailabilityRestriction'
    id: string
    vehicle_type: VehicleType
    frame_type?: FrameType | null
    propulsion_type: VehiclePropulsionType
    start_time: string
    end_time: string
    last_status_change_time?: string | null
  }

export type SchemeAvailabilityRestrictionsQuery_scheme_Scheme_availability_restriction_SchemeAvailabilityRestrictionConnection =
  {
    __typename: 'SchemeAvailabilityRestrictionConnection'
    nodes: Array<SchemeAvailabilityRestrictionsQuery_scheme_Scheme_availability_restriction_SchemeAvailabilityRestrictionConnection_nodes_SchemeAvailabilityRestriction>
  }

export type SchemeAvailabilityRestrictionsQuery_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  availability_restriction: SchemeAvailabilityRestrictionsQuery_scheme_Scheme_availability_restriction_SchemeAvailabilityRestrictionConnection
}

export type SchemeAvailabilityRestrictionsQuery_Query = {
  __typename: 'Query'
  scheme?: SchemeAvailabilityRestrictionsQuery_scheme_Scheme | null
}

export type SchemeAvailabilityRestrictionsQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
}>

export type SchemeAvailabilityRestrictionsQuery =
  SchemeAvailabilityRestrictionsQuery_Query

export type AddSchemeAvailabilityRestrictionMutation_add_scheme_availability_restriction_SchemeAvailabilityRestriction =
  {
    __typename: 'SchemeAvailabilityRestriction'
    id: string
    vehicle_type: VehicleType
    frame_type?: FrameType | null
    propulsion_type: VehiclePropulsionType
    start_time: string
    end_time: string
    last_status_change_time?: string | null
  }

export type AddSchemeAvailabilityRestrictionMutation_Mutation = {
  __typename: 'Mutation'
  add_scheme_availability_restriction?: AddSchemeAvailabilityRestrictionMutation_add_scheme_availability_restriction_SchemeAvailabilityRestriction | null
}

export type AddSchemeAvailabilityRestrictionMutationVariables = Exact<{
  scheme_availability_restriction: SchemeAvailabilityRestrictionInput
}>

export type AddSchemeAvailabilityRestrictionMutation =
  AddSchemeAvailabilityRestrictionMutation_Mutation

export type UpdateSchemeAvailabilityRestrictionMutation_update_scheme_availability_restriction_SchemeAvailabilityRestriction =
  {
    __typename: 'SchemeAvailabilityRestriction'
    id: string
    vehicle_type: VehicleType
    frame_type?: FrameType | null
    propulsion_type: VehiclePropulsionType
    start_time: string
    end_time: string
    last_status_change_time?: string | null
  }

export type UpdateSchemeAvailabilityRestrictionMutation_Mutation = {
  __typename: 'Mutation'
  update_scheme_availability_restriction?: UpdateSchemeAvailabilityRestrictionMutation_update_scheme_availability_restriction_SchemeAvailabilityRestriction | null
}

export type UpdateSchemeAvailabilityRestrictionMutationVariables = Exact<{
  id: Scalars['ID']['input']
  scheme_availability_restriction: SchemeAvailabilityRestrictionInput
}>

export type UpdateSchemeAvailabilityRestrictionMutation =
  UpdateSchemeAvailabilityRestrictionMutation_Mutation

export type RemoveSchemeAvailabilityRestrictionMutation_Mutation = {
  __typename: 'Mutation'
  remove_scheme_availability_restriction?: boolean | null
}

export type RemoveSchemeAvailabilityRestrictionMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RemoveSchemeAvailabilityRestrictionMutation =
  RemoveSchemeAvailabilityRestrictionMutation_Mutation

export type AvailabilityRestrictionDataFragment = {
  __typename: 'SchemeAvailabilityRestriction'
  id: string
  vehicle_type: VehicleType
  frame_type?: FrameType | null
  propulsion_type: VehiclePropulsionType
  start_time: string
  end_time: string
  last_status_change_time?: string | null
}

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_version_Firmware =
  { __typename: 'Firmware'; name: string; formatted_size: string }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    scheme?: DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle =
  {
    __typename: 'Vehicle'
    detail: DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail
  }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module =
  {
    __typename: 'Module'
    id: string
    vehicle?: DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle | null
  }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent =
  {
    __typename: 'DeploymentEvent'
    id: string
    created_at?: any | null
    state?: DeploymentEventState | null
    module?: DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module | null
  }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection =
  {
    __typename: 'DeploymentEventConnection'
    nodes: Array<DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent | null>
  }

export type DeploymentListQuery_table_DeploymentConnection_nodes_Deployment = {
  __typename: 'Deployment'
  id: string
  created_at?: any | null
  version?: DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_version_Firmware | null
  modules?: DeploymentListQuery_table_DeploymentConnection_nodes_Deployment_modules_DeploymentEventConnection | null
}

export type DeploymentListQuery_table_DeploymentConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type DeploymentListQuery_table_DeploymentConnection = {
  __typename: 'DeploymentConnection'
  nodes: Array<DeploymentListQuery_table_DeploymentConnection_nodes_Deployment>
  pagination: DeploymentListQuery_table_DeploymentConnection_pagination_Pagination
}

export type DeploymentListQuery_Query = {
  __typename: 'Query'
  table: DeploymentListQuery_table_DeploymentConnection
}

export type DeploymentListQueryVariables = Exact<{
  paginate?: InputMaybe<Paginate>
}>

export type DeploymentListQuery = DeploymentListQuery_Query

export type AllVersionsQuery_firmware_Firmware = {
  __typename: 'Firmware'
  id: string
  name: string
  supported_hardware?: Array<ModuleHardwareType | null> | null
  supported_frame_types?: Array<FrameType> | null
}

export type AllVersionsQuery_Query = {
  __typename: 'Query'
  firmware: Array<AllVersionsQuery_firmware_Firmware | null>
}

export type AllVersionsQueryVariables = Exact<{ [key: string]: never }>

export type AllVersionsQuery = AllVersionsQuery_Query

export type DeploymentQuery_deployment_Deployment_version_Firmware = {
  __typename: 'Firmware'
  name: string
  size: number
  created_at: any
}

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    scheme?: DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle =
  {
    __typename: 'Vehicle'
    id: any
    detail: DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle_detail_VehicleDetail
  }

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module =
  {
    __typename: 'Module'
    id: string
    vehicle?: DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module_vehicle_Vehicle | null
  }

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent =
  {
    __typename: 'DeploymentEvent'
    id: string
    created_at?: any | null
    state?: DeploymentEventState | null
    module?: DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent_module_Module | null
  }

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection =
  {
    __typename: 'DeploymentEventConnection'
    nodes: Array<DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_nodes_DeploymentEvent | null>
    pagination?: DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection_pagination_Pagination | null
  }

export type DeploymentQuery_deployment_Deployment = {
  __typename: 'Deployment'
  id: string
  created_at?: any | null
  version?: DeploymentQuery_deployment_Deployment_version_Firmware | null
  modules?: DeploymentQuery_deployment_Deployment_modules_DeploymentEventConnection | null
}

export type DeploymentQuery_Query = {
  __typename: 'Query'
  deployment?: DeploymentQuery_deployment_Deployment | null
}

export type DeploymentQueryVariables = Exact<{
  id: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
}>

export type DeploymentQuery = DeploymentQuery_Query

export type Start_DeploymentMutation_start_deployment_Deployment = {
  __typename: 'Deployment'
  id: string
}

export type Start_DeploymentMutation_Mutation = {
  __typename: 'Mutation'
  start_deployment?: Start_DeploymentMutation_start_deployment_Deployment | null
}

export type Start_DeploymentMutationVariables = Exact<{
  module_ids: Array<InputMaybe<Scalars['ID']['input']>>
  version: Scalars['String']['input']
}>

export type Start_DeploymentMutation = Start_DeploymentMutation_Mutation

export type InvoiceQuery_invoice_JourneyInvoice_journey_Journey_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type InvoiceQuery_invoice_JourneyInvoice_journey_Journey = {
  __typename: 'Journey'
  id: string
  initiator?: JourneyInitiator | null
  initiator_app_name?: string | null
  duration?: number | null
  scheme?: InvoiceQuery_invoice_JourneyInvoice_journey_Journey_scheme_Scheme | null
}

export type InvoiceQuery_invoice_JourneyInvoice_minute_refundable_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_scheme_product_SchemeProduct_scheme_accounting_SchemeAccounting =
  { __typename: 'SchemeAccounting'; currency: string }

export type InvoiceQuery_invoice_JourneyInvoice_scheme_product_SchemeProduct = {
  __typename: 'SchemeProduct'
  id: string
  name: string
  scheme_accounting: InvoiceQuery_invoice_JourneyInvoice_scheme_product_SchemeProduct_scheme_accounting_SchemeAccounting
}

export type InvoiceQuery_invoice_JourneyInvoice_user_User = {
  __typename: 'User'
  id: string
  email?: string | null
  deleted?: boolean | null
}

export type InvoiceQuery_invoice_JourneyInvoice_minute_debit_FormattedAmount = {
  __typename: 'FormattedAmount'
  unit: string
  amount: number
  formatted_amount: string
  currency_code: string
}

export type InvoiceQuery_invoice_JourneyInvoice_currency_debit_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_currency_refundable_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_currency_balance_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_result_TransactionResult =
  {
    __typename: 'TransactionResult'
    status?: TransactionResultType | null
    failure_message?: string | null
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_debit_amount_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_credit_amount_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_meta_TransactionMeta =
  {
    __typename: 'TransactionMeta'
    descriptor?: TransactionCategory | null
    failure_reason?: string | null
    requester_id?: string | null
    refund_description?: string | null
    transaction_label?: string | null
    charge_type?: TransactionMetaChargeType | null
    minutes_charged?: number | null
    time_increment_cost?: number | null
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_refund_requester_User =
  { __typename: 'User'; id: string; email?: string | null }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refundable_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refunded_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction =
  {
    __typename: 'CurrencyTransaction'
    id: string
    created_at: any
    description: string
    category: TransactionCategory
    provider_type?: CurrencyPaymentProviderType | null
    void: boolean
    type?: TransactionType | null
    result?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_result_TransactionResult | null
    debit_amount: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_debit_amount_FormattedAmount
    credit_amount: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_credit_amount_FormattedAmount
    meta?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_meta_TransactionMeta | null
    refund_requester?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_refund_requester_User | null
    amount_refundable?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refundable_FormattedAmount | null
    amount_refunded?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refunded_FormattedAmount | null
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_MinuteTransaction =
  {
    __typename: 'MinuteTransaction'
    id: string
    created_at: any
    description: string
    category: TransactionCategory
    provider_type?: CurrencyPaymentProviderType | null
    void: boolean
    type?: TransactionType | null
    result?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_result_TransactionResult | null
    debit_amount: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_debit_amount_FormattedAmount
    credit_amount: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_credit_amount_FormattedAmount
    meta?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_meta_TransactionMeta | null
    refund_requester?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_refund_requester_User | null
    amount_refundable?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refundable_FormattedAmount | null
    amount_refunded?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refunded_FormattedAmount | null
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_QuotumTransaction =
  {
    __typename: 'QuotumTransaction'
    id: string
    created_at: any
    description: string
    category: TransactionCategory
    provider_type?: CurrencyPaymentProviderType | null
    void: boolean
    type?: TransactionType | null
    result?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_result_TransactionResult | null
    debit_amount: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_debit_amount_FormattedAmount
    credit_amount: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_credit_amount_FormattedAmount
    meta?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_meta_TransactionMeta | null
    refund_requester?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_refund_requester_User | null
    amount_refundable?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refundable_FormattedAmount | null
    amount_refunded?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction_amount_refunded_FormattedAmount | null
  }

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes =

    | InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_CurrencyTransaction
    | InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_MinuteTransaction
    | InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes_QuotumTransaction

export type InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection =
  {
    __typename: 'TransactionConnection'
    nodes: Array<InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection_nodes>
  }

export type InvoiceQuery_invoice_ProductInvoice_minute_refund_calcs_MinuteRefundCalcs_currency_amount_FormattedAmount =
  { __typename: 'FormattedAmount'; amount: number; formatted_amount: string }

export type InvoiceQuery_invoice_ProductInvoice_minute_refund_calcs_MinuteRefundCalcs =
  {
    __typename: 'MinuteRefundCalcs'
    minute_adjustment_quantity: number
    currency_amount: InvoiceQuery_invoice_ProductInvoice_minute_refund_calcs_MinuteRefundCalcs_currency_amount_FormattedAmount
  }

export type InvoiceQuery_invoice_JourneyInvoice = {
  __typename: 'JourneyInvoice'
  id: string
  created_at: any
  description: string
  status?: InvoiceStatus | null
  journey: InvoiceQuery_invoice_JourneyInvoice_journey_Journey
  minute_refundable?: InvoiceQuery_invoice_JourneyInvoice_minute_refundable_FormattedAmount | null
  scheme_product?: InvoiceQuery_invoice_JourneyInvoice_scheme_product_SchemeProduct | null
  user: InvoiceQuery_invoice_JourneyInvoice_user_User
  minute_debit?: InvoiceQuery_invoice_JourneyInvoice_minute_debit_FormattedAmount | null
  currency_debit?: InvoiceQuery_invoice_JourneyInvoice_currency_debit_FormattedAmount | null
  currency_refundable?: InvoiceQuery_invoice_JourneyInvoice_currency_refundable_FormattedAmount | null
  currency_balance?: InvoiceQuery_invoice_JourneyInvoice_currency_balance_FormattedAmount | null
  transactions?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection | null
}

export type InvoiceQuery_invoice_ProductInvoice = {
  __typename: 'ProductInvoice'
  id: string
  created_at: any
  description: string
  status?: InvoiceStatus | null
  minute_refund_calcs?: InvoiceQuery_invoice_ProductInvoice_minute_refund_calcs_MinuteRefundCalcs | null
  scheme_product?: InvoiceQuery_invoice_JourneyInvoice_scheme_product_SchemeProduct | null
  user: InvoiceQuery_invoice_JourneyInvoice_user_User
  minute_debit?: InvoiceQuery_invoice_JourneyInvoice_minute_debit_FormattedAmount | null
  currency_debit?: InvoiceQuery_invoice_JourneyInvoice_currency_debit_FormattedAmount | null
  currency_refundable?: InvoiceQuery_invoice_JourneyInvoice_currency_refundable_FormattedAmount | null
  currency_balance?: InvoiceQuery_invoice_JourneyInvoice_currency_balance_FormattedAmount | null
  transactions?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection | null
}

export type InvoiceQuery_invoice_SubscriptionInvoice = {
  __typename: 'SubscriptionInvoice'
  id: string
  created_at: any
  description: string
  status?: InvoiceStatus | null
  scheme_product?: InvoiceQuery_invoice_JourneyInvoice_scheme_product_SchemeProduct | null
  user: InvoiceQuery_invoice_JourneyInvoice_user_User
  minute_debit?: InvoiceQuery_invoice_JourneyInvoice_minute_debit_FormattedAmount | null
  currency_debit?: InvoiceQuery_invoice_JourneyInvoice_currency_debit_FormattedAmount | null
  currency_refundable?: InvoiceQuery_invoice_JourneyInvoice_currency_refundable_FormattedAmount | null
  currency_balance?: InvoiceQuery_invoice_JourneyInvoice_currency_balance_FormattedAmount | null
  transactions?: InvoiceQuery_invoice_JourneyInvoice_transactions_TransactionConnection | null
}

export type InvoiceQuery_invoice =
  | InvoiceQuery_invoice_JourneyInvoice
  | InvoiceQuery_invoice_ProductInvoice
  | InvoiceQuery_invoice_SubscriptionInvoice

export type InvoiceQuery_Query = {
  __typename: 'Query'
  invoice?: InvoiceQuery_invoice | null
}

export type InvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InvoiceQuery = InvoiceQuery_Query

export type InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_user_User =
  {
    __typename: 'User'
    id: string
    email?: string | null
    deleted?: boolean | null
  }

export type InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_minute_debit_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string }

export type InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_currency_debit_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string }

export type InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice = {
  __typename: 'JourneyInvoice'
  id: string
  created_at: any
  status?: InvoiceStatus | null
  description?: string
  user: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_user_User
  minute_debit?: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_minute_debit_FormattedAmount | null
  currency_debit?: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_currency_debit_FormattedAmount | null
}

export type InvoiceListQuery_table_IInvoiceConnection_nodes_ProductInvoice = {
  __typename: 'ProductInvoice'
  id: string
  created_at: any
  status?: InvoiceStatus | null
  description?: string
  user: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_user_User
  minute_debit?: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_minute_debit_FormattedAmount | null
  currency_debit?: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_currency_debit_FormattedAmount | null
}

export type InvoiceListQuery_table_IInvoiceConnection_nodes_SubscriptionInvoice =
  {
    __typename: 'SubscriptionInvoice'
    id: string
    created_at: any
    status?: InvoiceStatus | null
    description?: string
    user: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_user_User
    minute_debit?: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_minute_debit_FormattedAmount | null
    currency_debit?: InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice_currency_debit_FormattedAmount | null
  }

export type InvoiceListQuery_table_IInvoiceConnection_nodes =
  | InvoiceListQuery_table_IInvoiceConnection_nodes_JourneyInvoice
  | InvoiceListQuery_table_IInvoiceConnection_nodes_ProductInvoice
  | InvoiceListQuery_table_IInvoiceConnection_nodes_SubscriptionInvoice

export type InvoiceListQuery_table_IInvoiceConnection = {
  __typename: 'IInvoiceConnection'
  nodes: Array<InvoiceListQuery_table_IInvoiceConnection_nodes>
}

export type InvoiceListQuery_Query = {
  __typename: 'Query'
  table?: InvoiceListQuery_table_IInvoiceConnection | null
}

export type InvoiceListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<IInvoiceWhere>>>
  order_by?: InputMaybe<Array<InputMaybe<IInvoiceOrderby>>>
  is_mobile: Scalars['Boolean']['input']
}>

export type InvoiceListQuery = InvoiceListQuery_Query

export type RefundInvoiceMutation_refund_invoice_v2_RefundInvoiceResult_currency_RefundResultItem =
  {
    __typename: 'RefundResultItem'
    amount?: number | null
    status?: string | null
    message?: string | null
  }

export type RefundInvoiceMutation_refund_invoice_v2_RefundInvoiceResult_minutes_RefundResultItem =
  {
    __typename: 'RefundResultItem'
    amount?: number | null
    status?: string | null
    message?: string | null
  }

export type RefundInvoiceMutation_refund_invoice_v2_RefundInvoiceResult = {
  __typename: 'RefundInvoiceResult'
  currency?: RefundInvoiceMutation_refund_invoice_v2_RefundInvoiceResult_currency_RefundResultItem | null
  minutes?: RefundInvoiceMutation_refund_invoice_v2_RefundInvoiceResult_minutes_RefundResultItem | null
}

export type RefundInvoiceMutation_Mutation = {
  __typename: 'Mutation'
  refund_invoice_v2?: RefundInvoiceMutation_refund_invoice_v2_RefundInvoiceResult | null
}

export type RefundInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input']
  description: Scalars['String']['input']
  reason: Scalars['String']['input']
  revoke_product: Scalars['Boolean']['input']
  refund_transactions: Array<RefundInvoiceV2InputTransaction>
}>

export type RefundInvoiceMutation = RefundInvoiceMutation_Mutation

export type RecalculateJourneyInvoiceMutation_recalculate_journey_invoice_RefundInvoiceResult_currency_RefundResultItem =
  {
    __typename: 'RefundResultItem'
    amount?: number | null
    status?: string | null
    message?: string | null
  }

export type RecalculateJourneyInvoiceMutation_recalculate_journey_invoice_RefundInvoiceResult =
  {
    __typename: 'RefundInvoiceResult'
    currency?: RecalculateJourneyInvoiceMutation_recalculate_journey_invoice_RefundInvoiceResult_currency_RefundResultItem | null
  }

export type RecalculateJourneyInvoiceMutation_Mutation = {
  __typename: 'Mutation'
  recalculate_journey_invoice?: RecalculateJourneyInvoiceMutation_recalculate_journey_invoice_RefundInvoiceResult | null
}

export type RecalculateJourneyInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input']
  description: Scalars['String']['input']
  amendedDuration?: InputMaybe<Scalars['Int']['input']>
}>

export type RecalculateJourneyInvoiceMutation =
  RecalculateJourneyInvoiceMutation_Mutation

export type RefundInvoiceExcessBalanceMutation_refund_invoice_excess_balance_RefundInvoiceResult_currency_RefundResultItem =
  {
    __typename: 'RefundResultItem'
    amount?: number | null
    status?: string | null
    message?: string | null
  }

export type RefundInvoiceExcessBalanceMutation_refund_invoice_excess_balance_RefundInvoiceResult =
  {
    __typename: 'RefundInvoiceResult'
    currency?: RefundInvoiceExcessBalanceMutation_refund_invoice_excess_balance_RefundInvoiceResult_currency_RefundResultItem | null
  }

export type RefundInvoiceExcessBalanceMutation_Mutation = {
  __typename: 'Mutation'
  refund_invoice_excess_balance?: RefundInvoiceExcessBalanceMutation_refund_invoice_excess_balance_RefundInvoiceResult | null
}

export type RefundInvoiceExcessBalanceMutationVariables = Exact<{
  id: Scalars['ID']['input']
  description: Scalars['String']['input']
}>

export type RefundInvoiceExcessBalanceMutation =
  RefundInvoiceExcessBalanceMutation_Mutation

export type SettleInvoiceOffSessionMutation_settle_invoice_off_session_JourneyInvoice =
  { __typename: 'JourneyInvoice'; status?: InvoiceStatus | null }

export type SettleInvoiceOffSessionMutation_settle_invoice_off_session_ProductInvoice =
  { __typename: 'ProductInvoice'; status?: InvoiceStatus | null }

export type SettleInvoiceOffSessionMutation_settle_invoice_off_session_SubscriptionInvoice =
  { __typename: 'SubscriptionInvoice'; status?: InvoiceStatus | null }

export type SettleInvoiceOffSessionMutation_settle_invoice_off_session =
  | SettleInvoiceOffSessionMutation_settle_invoice_off_session_JourneyInvoice
  | SettleInvoiceOffSessionMutation_settle_invoice_off_session_ProductInvoice
  | SettleInvoiceOffSessionMutation_settle_invoice_off_session_SubscriptionInvoice

export type SettleInvoiceOffSessionMutation_Mutation = {
  __typename: 'Mutation'
  settle_invoice_off_session?: SettleInvoiceOffSessionMutation_settle_invoice_off_session | null
}

export type SettleInvoiceOffSessionMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type SettleInvoiceOffSessionMutation =
  SettleInvoiceOffSessionMutation_Mutation

export type FormattedAmountFragment = {
  __typename: 'FormattedAmount'
  unit: string
  amount: number
  formatted_amount: string
  currency_code: string
}

export type SchemeJobAssetsQuery_scheme_job_assets_JobAsset = {
  __typename: 'JobAsset'
  assetTag: string
  assetName: string
  assetCategory: AssetCategory
}

export type SchemeJobAssetsQuery_Query = {
  __typename: 'Query'
  scheme_job_assets: Array<SchemeJobAssetsQuery_scheme_job_assets_JobAsset>
}

export type SchemeJobAssetsQueryVariables = Exact<{
  scheme_id: Scalars['ID']['input']
}>

export type SchemeJobAssetsQuery = SchemeJobAssetsQuery_Query

export type JobListQuery_table_JobConnection_nodes_Job_timestamps_JobTimestamps =
  {
    __typename: 'JobTimestamps'
    created_at: any
    updated_at: any
    completed_at?: any | null
  }

export type JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_assignee_User =
  { __typename: 'User'; id: string; email?: string | null }

export type JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_scheme_Scheme =
  { __typename: 'Scheme'; id: string; name: string }

export type JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_createdBy_User =
  { __typename: 'User'; id: string; email?: string | null }

export type JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_updatedBy_User =
  { __typename: 'User'; id: string; email?: string | null }

export type JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_completedBy_User =
  { __typename: 'User'; id: string; email?: string | null }

export type JobListQuery_table_JobConnection_nodes_Job_details_JobDetails = {
  __typename: 'JobDetails'
  priority?: string | null
  assetTag?: string | null
  assetName?: string | null
  assetCategory?: AssetCategory | null
  taskId: string
  description?: string | null
  status?: JobStatusEnum | null
  role?: string | null
  notes?: string | null
  location?: string | null
  reportedLocation?: string | null
  locationDescription?: string | null
  isJustified?: boolean | null
  isUnlocked?: boolean | null
  assignee?: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_assignee_User | null
  scheme?: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_scheme_Scheme | null
  createdBy?: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_createdBy_User | null
  updatedBy?: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_updatedBy_User | null
  completedBy?: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails_completedBy_User | null
}

export type JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle_detail_VehicleDetail_module_Module_location_Location =
  {
    __typename: 'Location'
    id: string
    latitude: number
    longitude: number
    time: any
    max_error?: number | null
  }

export type JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    hardware_type: ModuleHardware
    location?: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle_detail_VehicleDetail_module_Module_location_Location | null
  }

export type JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    module?: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle_detail_VehicleDetail_module_Module | null
  }

export type JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  detail: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle_detail_VehicleDetail
}

export type JobListQuery_table_JobConnection_nodes_Job = {
  __typename: 'Job'
  uuid: string
  timestamps?: JobListQuery_table_JobConnection_nodes_Job_timestamps_JobTimestamps | null
  details: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails
  vehicle?: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle | null
}

export type JobListQuery_table_JobConnection_pagination_Pagination = {
  __typename: 'Pagination'
  total: number
  current: number
  pageSize: number
}

export type JobListQuery_table_JobConnection = {
  __typename: 'JobConnection'
  nodes: Array<JobListQuery_table_JobConnection_nodes_Job>
  pagination: JobListQuery_table_JobConnection_pagination_Pagination
}

export type JobListQuery_Query = {
  __typename: 'Query'
  table: JobListQuery_table_JobConnection
}

export type JobListQueryVariables = Exact<{
  paginate?: InputMaybe<Paginate>
  job_filters?: InputMaybe<JobFiltersInput>
}>

export type JobListQuery = JobListQuery_Query

export type JobQuery_job_Job_tasks_Task_details_TaskDetails_assignee_User = {
  __typename: 'User'
  id: string
  email?: string | null
}

export type JobQuery_job_Job_tasks_Task_details_TaskDetails_task_codes_details_TaskCodeItem =
  { __typename: 'TaskCodeItem'; code: string; reason: TaskCodeReason }

export type JobQuery_job_Job_tasks_Task_details_TaskDetails = {
  __typename: 'TaskDetails'
  title?: string | null
  status?: TaskStatusEnum | null
  description?: string | null
  notes?: string | null
  assignee?: JobQuery_job_Job_tasks_Task_details_TaskDetails_assignee_User | null
  task_codes_details?: Array<JobQuery_job_Job_tasks_Task_details_TaskDetails_task_codes_details_TaskCodeItem> | null
}

export type JobQuery_job_Job_tasks_Task = {
  __typename: 'Task'
  uuid: string
  details?: JobQuery_job_Job_tasks_Task_details_TaskDetails | null
}

export type JobQuery_job_Job_justifications_Justification = {
  __typename: 'Justification'
  justification_id: string
  description: string
}

export type JobQuery_job_Job_attempts_Attempt_assignee_User = {
  __typename: 'User'
  email?: string | null
}

export type JobQuery_job_Job_attempts_Attempt = {
  __typename: 'Attempt'
  created_at: any
  assignee: JobQuery_job_Job_attempts_Attempt_assignee_User
}

export type JobQuery_job_Job = {
  __typename: 'Job'
  uuid: string
  tasks?: Array<JobQuery_job_Job_tasks_Task> | null
  justifications?: Array<JobQuery_job_Job_justifications_Justification> | null
  attempts?: Array<JobQuery_job_Job_attempts_Attempt> | null
  timestamps?: JobListQuery_table_JobConnection_nodes_Job_timestamps_JobTimestamps | null
  details: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails
  vehicle?: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle | null
}

export type JobQuery_Query = {
  __typename: 'Query'
  job?: JobQuery_job_Job | null
}

export type JobQueryVariables = Exact<{
  job_id: Scalars['ID']['input']
}>

export type JobQuery = JobQuery_Query

export type ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails_scheme_Scheme =
  { __typename: 'Scheme'; id: string; name: string }

export type ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails_assignee_User =
  { __typename: 'User'; id: string; email?: string | null }

export type ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails =
  {
    __typename: 'ArchiveJobDetails'
    taskId: string
    notes?: string | null
    status: JobStatusEnum
    isJustified: boolean
    scheme?: ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails_scheme_Scheme | null
    assignee?: ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails_assignee_User | null
  }

export type ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_timestamps_JobTimestamps =
  { __typename: 'JobTimestamps'; created_at: any; updated_at: any }

export type ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob = {
  __typename: 'ArchiveJob'
  sys_id: string
  uuid: string
  details: ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails
  timestamps: ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_timestamps_JobTimestamps
}

export type ArchiveJobListQuery_table_ArchiveJobConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type ArchiveJobListQuery_table_ArchiveJobConnection = {
  __typename: 'ArchiveJobConnection'
  nodes: Array<ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob>
  pagination: ArchiveJobListQuery_table_ArchiveJobConnection_pagination_Pagination
}

export type ArchiveJobListQuery_Query = {
  __typename: 'Query'
  table: ArchiveJobListQuery_table_ArchiveJobConnection
}

export type ArchiveJobListQueryVariables = Exact<{
  paginate?: InputMaybe<Paginate>
  asset_tag: Scalars['ID']['input']
}>

export type ArchiveJobListQuery = ArchiveJobListQuery_Query

export type UnarchiveJobMutation_Mutation = {
  __typename: 'Mutation'
  archive_restore: boolean
}

export type UnarchiveJobMutationVariables = Exact<{
  sys_id: Scalars['ID']['input']
}>

export type UnarchiveJobMutation = UnarchiveJobMutation_Mutation

export type JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup_children_JobTypesChildren =
  {
    __typename: 'JobTypesChildren'
    label: string
    code: string
    categories: Array<JobCategory>
    name: string
    disabled?: boolean | null
  }

export type JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup =
  {
    __typename: 'JobTypesAssignmentGroup'
    label: string
    children: Array<JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup_children_JobTypesChildren>
  }

export type JobTypesQuery_job_types_JobTypes_onStreetMechanic_JobTypesAssignmentGroup =
  {
    __typename: 'JobTypesAssignmentGroup'
    label: string
    children: Array<JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup_children_JobTypesChildren>
  }

export type JobTypesQuery_job_types_JobTypes_workshopMechanic_JobTypesAssignmentGroup =
  {
    __typename: 'JobTypesAssignmentGroup'
    label: string
    children: Array<JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup_children_JobTypesChildren>
  }

export type JobTypesQuery_job_types_JobTypes_securityTeam_JobTypesAssignmentGroup =
  {
    __typename: 'JobTypesAssignmentGroup'
    label: string
    children: Array<JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup_children_JobTypesChildren>
  }

export type JobTypesQuery_job_types_JobTypes = {
  __typename: 'JobTypes'
  redistributionDriver: JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup
  onStreetMechanic: JobTypesQuery_job_types_JobTypes_onStreetMechanic_JobTypesAssignmentGroup
  workshopMechanic: JobTypesQuery_job_types_JobTypes_workshopMechanic_JobTypesAssignmentGroup
  securityTeam: JobTypesQuery_job_types_JobTypes_securityTeam_JobTypesAssignmentGroup
}

export type JobTypesQuery_Query = {
  __typename: 'Query'
  job_types: JobTypesQuery_job_types_JobTypes
}

export type JobTypesQueryVariables = Exact<{ [key: string]: never }>

export type JobTypesQuery = JobTypesQuery_Query

export type TaskCodeQuery_task_codes_list_TaskCodeListItem = {
  __typename: 'TaskCodeListItem'
  code: string
  description: string
  vehicle_type: Array<ModuleHardware>
}

export type TaskCodeQuery_Query = {
  __typename: 'Query'
  task_codes_list: Array<TaskCodeQuery_task_codes_list_TaskCodeListItem>
}

export type TaskCodeQueryVariables = Exact<{ [key: string]: never }>

export type TaskCodeQuery = TaskCodeQuery_Query

export type AssigmentGroupFragment = {
  __typename: 'JobTypesAssignmentGroup'
  label: string
  children: Array<JobTypesQuery_job_types_JobTypes_redistributionDriver_JobTypesAssignmentGroup_children_JobTypesChildren>
}

export type JobBasicFragment = {
  __typename: 'Job'
  uuid: string
  timestamps?: JobListQuery_table_JobConnection_nodes_Job_timestamps_JobTimestamps | null
  details: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails
  vehicle?: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle | null
}

export type JobDetailedFragment = {
  __typename: 'Job'
  uuid: string
  tasks?: Array<JobQuery_job_Job_tasks_Task> | null
  justifications?: Array<JobQuery_job_Job_justifications_Justification> | null
  attempts?: Array<JobQuery_job_Job_attempts_Attempt> | null
  timestamps?: JobListQuery_table_JobConnection_nodes_Job_timestamps_JobTimestamps | null
  details: JobListQuery_table_JobConnection_nodes_Job_details_JobDetails
  vehicle?: JobListQuery_table_JobConnection_nodes_Job_vehicle_Vehicle | null
}

export type ArchiveJobBasicFragment = {
  __typename: 'ArchiveJob'
  sys_id: string
  uuid: string
  details: ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_details_ArchiveJobDetails
  timestamps: ArchiveJobListQuery_table_ArchiveJobConnection_nodes_ArchiveJob_timestamps_JobTimestamps
}

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_possible_rewards_VehicleReward =
  { __typename: 'VehicleReward'; type: VehicleRewardType }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_confirmed_rewards_VehicleReward =
  { __typename: 'VehicleReward'; type: VehicleRewardType }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_parking_photo_ParkingPhoto =
  { __typename: 'ParkingPhoto'; journey_id: string; updated_at?: any | null }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_history_JourneyEventConnection_nodes_JourneyEvent =
  { __typename: 'JourneyEvent'; id: string; time: any; message: string }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_history_JourneyEventConnection =
  {
    __typename: 'JourneyEventConnection'
    nodes: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_history_JourneyEventConnection_nodes_JourneyEvent>
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_config_SchemeConfig =
  {
    __typename: 'SchemeConfig'
    is_vehicle_rewards_enabled: boolean
    is_parking_photo_enabled: boolean
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs =
  {
    __typename: 'SchemePricingConfigs'
    out_of_zone_parking_charge: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount
    out_of_service_area_parking_charge: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount
    undocked_in_zone_parking_charge?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount | null
    unlocked_vehicle_charge: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount
    rear_lock_unlocked_vehicle_charge?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount | null
    vehicle_not_permitted_in_zone_charge?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount | null
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting =
  {
    __typename: 'SchemeAccounting'
    id: string
    scheme_pricing_configs: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme =
  {
    __typename: 'Scheme'
    id: string
    name: string
    config: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_config_SchemeConfig
    scheme_accounting?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting | null
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ModuleState =
  { __typename: 'ModuleState'; assist_config?: AssistConfig | null; id: string }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ScooterModuleState =
  { __typename: 'ScooterModuleState'; id: string }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state =

    | JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ModuleState
    | JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ScooterModuleState

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    module_state?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state | null
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    lock_configuration: LockConfiguration
    module?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module | null
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle =
  {
    __typename: 'Vehicle'
    frame_type: string
    id: any
    propulsion_type: Array<VehiclePropulsionType>
    frame_id: string
    detail: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
  }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_JourneyEvent =
  { __typename: 'JourneyEvent'; id: string; time: any; message: string }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey_user_User =
  { __typename: 'User'; id: string }

export type JourneySetQuery_journey_set_JourneySet_journeys_Journey = {
  __typename: 'Journey'
  id: string
  started_at?: any | null
  completed_at?: any | null
  is_complete: boolean
  is_error: boolean
  end_in_zone?: boolean | null
  duration?: number | null
  initiator?: JourneyInitiator | null
  initiator_app_name?: string | null
  vehicle_docked?: boolean | null
  docks_available?: number | null
  parking_status?: ParkingStatus | null
  vehicle_lock_state?: VehicleLockState | null
  start_vehicle_battery_percent?: number | null
  end_vehicle_battery_percent?: number | null
  distance_in_km?: number | null
  distance_in_mi?: number | null
  speed_in_km?: number | null
  speed_in_mi?: number | null
  possible_rewards: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_possible_rewards_VehicleReward>
  confirmed_rewards: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_confirmed_rewards_VehicleReward>
  parking_photo: JourneySetQuery_journey_set_JourneySet_journeys_Journey_parking_photo_ParkingPhoto
  state_history: JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_history_JourneyEventConnection
  scheme?: JourneySetQuery_journey_set_JourneySet_journeys_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_JourneyEvent
  user: JourneySetQuery_journey_set_JourneySet_journeys_Journey_user_User
}

export type JourneySetQuery_journey_set_JourneySet_user_User = {
  __typename: 'User'
  id: string
  email?: string | null
}

export type JourneySetQuery_journey_set_JourneySet_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type JourneySetQuery_journey_set_JourneySet = {
  __typename: 'JourneySet'
  id: string
  is_complete: boolean
  journey_count: number
  active_journey_count: number
  journeys: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey>
  user: JourneySetQuery_journey_set_JourneySet_user_User
  scheme: JourneySetQuery_journey_set_JourneySet_scheme_Scheme
}

export type JourneySetQuery_Query = {
  __typename: 'Query'
  journey_set: JourneySetQuery_journey_set_JourneySet
}

export type JourneySetQueryVariables = Exact<{
  id: Scalars['ID']['input']
  schemeId?: InputMaybe<Scalars['ID']['input']>
}>

export type JourneySetQuery = JourneySetQuery_Query

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward =
  { __typename: 'VehicleReward'; type: VehicleRewardType }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_location_Location =
  {
    __typename: 'Location'
    id: string
    latitude: number
    longitude: number
    max_error?: number | null
    time: any
  }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_lock_state_LockEvent =
  {
    __typename: 'LockEvent'
    id: string
    time: any
    overall_state?: LockState | null
    vehicle_lock_state?: VehicleLockState | null
  }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_availability_Availability =
  { __typename: 'Availability'; id: string; status: AvailabilityStatus }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry_drive_Drive =
  { __typename: 'Drive'; estimated_range?: number | null }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry =
  {
    __typename: 'Telemetry'
    id: string
    drive?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry_drive_Drive | null
  }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    is_present: boolean
    unlock_id?: string | null
    location?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_location_Location | null
    lock_state?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_lock_state_LockEvent | null
    availability?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_availability_Availability | null
    telemetry?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry | null
  }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string; name: string }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    vehicle_unlock_id?: string | null
    module?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module | null
    scheme?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle =
  {
    __typename: 'Vehicle'
    id: any
    frame_type: string
    frame_id: string
    hardware_type: ModuleHardware
    rewards: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward>
    detail: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
  }

export type JourneySetMapQuery_journey_set_JourneySet_journeys_Journey = {
  __typename: 'Journey'
  id: string
  route?: any | null
  vehicle: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
}

export type JourneySetMapQuery_journey_set_JourneySet = {
  __typename: 'JourneySet'
  id: string
  journeys: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey>
}

export type JourneySetMapQuery_vehicles_VehicleConnection_nodes_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  rewards: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward>
  detail: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
}

export type JourneySetMapQuery_vehicles_VehicleConnection = {
  __typename: 'VehicleConnection'
  nodes: Array<JourneySetMapQuery_vehicles_VehicleConnection_nodes_Vehicle>
}

export type JourneySetMapQuery_all_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  is_suspended: boolean
  is_priority: boolean
  zone_type: ZoneType
  bikes: number
  ebikes: number
  scooters: number
}

export type JourneySetMapQuery_all_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<JourneySetMapQuery_all_zones_ZoneConnection_nodes_Zone>
}

export type JourneySetMapQuery_Query = {
  __typename: 'Query'
  journey_set: JourneySetMapQuery_journey_set_JourneySet
  vehicles?: JourneySetMapQuery_vehicles_VehicleConnection
  all_zones?: JourneySetMapQuery_all_zones_ZoneConnection
}

export type JourneySetMapQueryVariables = Exact<{
  id: Scalars['ID']['input']
  schemeId: Scalars['ID']['input']
  location?: InputMaybe<LocationAreaInput>
  hasLocation: Scalars['Boolean']['input']
}>

export type JourneySetMapQuery = JourneySetMapQuery_Query

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_user_User = {
  __typename: 'User'
  id: string
  email?: string | null
  deleted?: boolean | null
}

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_journey_set_JourneySet =
  { __typename: 'JourneySet'; id: string; journey_count: number }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_config_SchemeConfig =
  {
    __typename: 'SchemeConfig'
    is_vehicle_rewards_enabled: boolean
    is_parking_photo_enabled: boolean
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_service_area_parking_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_undocked_in_zone_parking_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_unlocked_vehicle_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_rear_lock_unlocked_vehicle_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_vehicle_not_permitted_in_zone_charge_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    unit: string
    amount: number
    formatted_amount: string
    currency_code: string
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs =
  {
    __typename: 'SchemePricingConfigs'
    out_of_zone_parking_charge: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_zone_parking_charge_FormattedAmount
    out_of_service_area_parking_charge: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_out_of_service_area_parking_charge_FormattedAmount
    undocked_in_zone_parking_charge?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_undocked_in_zone_parking_charge_FormattedAmount | null
    unlocked_vehicle_charge: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_unlocked_vehicle_charge_FormattedAmount
    rear_lock_unlocked_vehicle_charge?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_rear_lock_unlocked_vehicle_charge_FormattedAmount | null
    vehicle_not_permitted_in_zone_charge?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs_vehicle_not_permitted_in_zone_charge_FormattedAmount | null
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting =
  {
    __typename: 'SchemeAccounting'
    id: string
    scheme_pricing_configs: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme =
  {
    __typename: 'Scheme'
    id: string
    name: string
    config: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_config_SchemeConfig
    scheme_accounting?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting | null
  }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent =
  { __typename: 'JourneyEvent'; id: string; time: any; message: string }

export type JourneyListQuery_table_JourneyConnection_nodes_Journey = {
  __typename: 'Journey'
  id: string
  is_complete: boolean
  user?: JourneyListQuery_table_JourneyConnection_nodes_Journey_user_User
  journey_set?: JourneyListQuery_table_JourneyConnection_nodes_Journey_journey_set_JourneySet | null
  scheme?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent
}

export type JourneyListQuery_table_JourneyConnection = {
  __typename: 'JourneyConnection'
  nodes: Array<JourneyListQuery_table_JourneyConnection_nodes_Journey>
}

export type JourneyListQuery_Query = {
  __typename: 'Query'
  table: JourneyListQuery_table_JourneyConnection
}

export type JourneyListQueryVariables = Exact<{
  module_id?: InputMaybe<Scalars['ID']['input']>
  user_id?: InputMaybe<Scalars['ID']['input']>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  paginate?: InputMaybe<Paginate>
  omit_user: Scalars['Boolean']['input']
  where?: InputMaybe<Array<InputMaybe<JourneyWhere>>>
}>

export type JourneyListQuery = JourneyListQuery_Query

export type JourneyQuery_journey_Journey_module_Module = {
  __typename: 'Module'
  id: string
}

export type JourneyQuery_journey_Journey_invoice_JourneyInvoice = {
  __typename: 'JourneyInvoice'
  id: string
}

export type JourneyQuery_journey_Journey_journey_set_JourneySet = {
  __typename: 'JourneySet'
  id: string
  journey_count: number
  active_journey_count: number
  is_complete: boolean
}

export type JourneyQuery_journey_Journey = {
  __typename: 'Journey'
  id: string
  started_at?: any | null
  completed_at?: any | null
  is_complete: boolean
  is_error: boolean
  end_in_zone?: boolean | null
  duration?: number | null
  initiator?: JourneyInitiator | null
  initiator_app_name?: string | null
  vehicle_docked?: boolean | null
  docks_available?: number | null
  parking_status?: ParkingStatus | null
  vehicle_lock_state?: VehicleLockState | null
  start_vehicle_battery_percent?: number | null
  end_vehicle_battery_percent?: number | null
  distance_in_km?: number | null
  distance_in_mi?: number | null
  speed_in_km?: number | null
  speed_in_mi?: number | null
  module: JourneyQuery_journey_Journey_module_Module
  user: JourneySetQuery_journey_set_JourneySet_journeys_Journey_user_User
  invoice?: JourneyQuery_journey_Journey_invoice_JourneyInvoice | null
  journey_set?: JourneyQuery_journey_Journey_journey_set_JourneySet | null
  possible_rewards: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_possible_rewards_VehicleReward>
  confirmed_rewards: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_confirmed_rewards_VehicleReward>
  parking_photo: JourneySetQuery_journey_set_JourneySet_journeys_Journey_parking_photo_ParkingPhoto
  state_history: JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_history_JourneyEventConnection
  scheme?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent
}

export type JourneyQuery_Query = {
  __typename: 'Query'
  journey?: JourneyQuery_journey_Journey | null
}

export type JourneyQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type JourneyQuery = JourneyQuery_Query

export type JourneyMapQuery_journey_Journey = {
  __typename: 'Journey'
  id: string
  route?: any | null
  vehicle: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
}

export type JourneyMapQuery_vehicles_VehicleConnection = {
  __typename: 'VehicleConnection'
  nodes: Array<JourneySetMapQuery_vehicles_VehicleConnection_nodes_Vehicle>
}

export type JourneyMapQuery_all_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  is_suspended: boolean
  is_priority: boolean
  zone_type: ZoneType
  bikes: number
  ebikes: number
  scooters: number
}

export type JourneyMapQuery_all_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<JourneyMapQuery_all_zones_ZoneConnection_nodes_Zone>
}

export type JourneyMapQuery_Query = {
  __typename: 'Query'
  journey?: JourneyMapQuery_journey_Journey | null
  vehicles?: JourneyMapQuery_vehicles_VehicleConnection
  all_zones?: JourneyMapQuery_all_zones_ZoneConnection
}

export type JourneyMapQueryVariables = Exact<{
  id: Scalars['ID']['input']
  schemeId: Scalars['ID']['input']
  location?: InputMaybe<LocationAreaInput>
  hasLocation: Scalars['Boolean']['input']
}>

export type JourneyMapQuery = JourneyMapQuery_Query

export type JourneyParkingPhotoQuery_journey_Journey_parking_photo_ParkingPhoto_view_BucketPhotoUrl =
  { __typename: 'BucketPhotoUrl'; url: string }

export type JourneyParkingPhotoQuery_journey_Journey_parking_photo_ParkingPhoto =
  {
    __typename: 'ParkingPhoto'
    journey_id: string
    updated_at?: any | null
    view: JourneyParkingPhotoQuery_journey_Journey_parking_photo_ParkingPhoto_view_BucketPhotoUrl
  }

export type JourneyParkingPhotoQuery_journey_Journey_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
}

export type JourneyParkingPhotoQuery_journey_Journey = {
  __typename: 'Journey'
  id: string
  parking_status?: ParkingStatus | null
  vehicle_lock_state?: VehicleLockState | null
  parking_photo: JourneyParkingPhotoQuery_journey_Journey_parking_photo_ParkingPhoto
  vehicle: JourneyParkingPhotoQuery_journey_Journey_vehicle_Vehicle
}

export type JourneyParkingPhotoQuery_Query = {
  __typename: 'Query'
  journey?: JourneyParkingPhotoQuery_journey_Journey | null
}

export type JourneyParkingPhotoQueryVariables = Exact<{
  journeyId: Scalars['ID']['input']
}>

export type JourneyParkingPhotoQuery = JourneyParkingPhotoQuery_Query

export type StartJourneyByModuleIdMutation_start_journey_by_module_id_Journey_state_JourneyEvent =
  { __typename: 'JourneyEvent'; message: string; time: any; id: string }

export type StartJourneyByModuleIdMutation_start_journey_by_module_id_Journey =
  {
    __typename: 'Journey'
    id: string
    is_complete: boolean
    state: StartJourneyByModuleIdMutation_start_journey_by_module_id_Journey_state_JourneyEvent
  }

export type StartJourneyByModuleIdMutation_Mutation = {
  __typename: 'Mutation'
  start_journey_by_module_id: StartJourneyByModuleIdMutation_start_journey_by_module_id_Journey
}

export type StartJourneyByModuleIdMutationVariables = Exact<{
  moduleId: Scalars['ID']['input']
}>

export type StartJourneyByModuleIdMutation =
  StartJourneyByModuleIdMutation_Mutation

export type AdjustEndJourneyMutation_adjust_end_journey_Journey_user_User = {
  __typename: 'User'
  id: string
}

export type AdjustEndJourneyMutation_adjust_end_journey_Journey = {
  __typename: 'Journey'
  id: string
  is_complete: boolean
  scheme?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent
  user: AdjustEndJourneyMutation_adjust_end_journey_Journey_user_User
}

export type AdjustEndJourneyMutation_Mutation = {
  __typename: 'Mutation'
  adjust_end_journey: AdjustEndJourneyMutation_adjust_end_journey_Journey
}

export type AdjustEndJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input']
  actionType: EndJourneyActionType
  extraActions: Array<EndJourneyExtraAction>
  parkingStatus?: InputMaybe<ParkingStatus>
  vehicleLockState?: InputMaybe<VehicleLockState>
  endedAt?: InputMaybe<Scalars['DateTime']['input']>
}>

export type AdjustEndJourneyMutation = AdjustEndJourneyMutation_Mutation

export type ParkingPhotoFragment = {
  __typename: 'Journey'
  parking_status?: ParkingStatus | null
  vehicle_lock_state?: VehicleLockState | null
  parking_photo: JourneyParkingPhotoQuery_journey_Journey_parking_photo_ParkingPhoto
  vehicle: JourneyParkingPhotoQuery_journey_Journey_vehicle_Vehicle
}

export type JourneyStateResponseFragment_Journey_state_JourneyEvent = {
  __typename: 'JourneyEvent'
  id: string
  message: string
  time: any
}

export type JourneyStateResponseFragment = {
  __typename: 'Journey'
  id: string
  is_complete: boolean
  is_error: boolean
  state: JourneyStateResponseFragment_Journey_state_JourneyEvent
}

export type JourneyMapFragment = {
  __typename: 'Journey'
  id: string
  route?: any | null
  vehicle: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
}

export type JourneySetBasicFragment_JourneySet_journeys_Journey = {
  __typename: 'Journey'
  id: string
  is_complete: boolean
  scheme?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent
  user: AdjustEndJourneyMutation_adjust_end_journey_Journey_user_User
}

export type JourneySetBasicFragment = {
  __typename: 'JourneySet'
  id: string
  is_complete: boolean
  journey_count: number
  active_journey_count: number
  user: JourneySetQuery_journey_set_JourneySet_user_User
  scheme: JourneySetQuery_journey_set_JourneySet_scheme_Scheme
  journeys: Array<JourneySetBasicFragment_JourneySet_journeys_Journey>
}

export type JourneySetDetailedFragment = {
  __typename: 'JourneySet'
  id: string
  is_complete: boolean
  journey_count: number
  active_journey_count: number
  journeys: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey>
  user: JourneySetQuery_journey_set_JourneySet_user_User
  scheme: JourneySetQuery_journey_set_JourneySet_scheme_Scheme
}

export type JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ModuleState =
  { __typename: 'ModuleState'; assist_config?: AssistConfig | null; id: string }

export type JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ScooterModuleState =
  { __typename: 'ScooterModuleState'; id: string }

export type JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state =

    | JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ModuleState
    | JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state_ScooterModuleState

export type JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    module_state?: JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_module_state | null
  }

export type JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    lock_configuration: LockConfiguration
    module?: JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module | null
  }

export type JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  propulsion_type: Array<VehiclePropulsionType>
  frame_id: string
  frame_type: string
  detail: JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle_detail_VehicleDetail
}

export type JourneyVehicleDetailsFragment = {
  __typename: 'Journey'
  id: string
  vehicle: JourneyVehicleDetailsFragment_Journey_vehicle_Vehicle
}

export type JourneyPreviewFragment = {
  __typename: 'Journey'
  id: string
  is_complete: boolean
  scheme?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent
  user: AdjustEndJourneyMutation_adjust_end_journey_Journey_user_User
}

export type JourneySummaryFragment = {
  __typename: 'Journey'
  id: string
  started_at?: any | null
  completed_at?: any | null
  is_complete: boolean
  is_error: boolean
  end_in_zone?: boolean | null
  duration?: number | null
  initiator?: JourneyInitiator | null
  initiator_app_name?: string | null
  vehicle_docked?: boolean | null
  docks_available?: number | null
  parking_status?: ParkingStatus | null
  vehicle_lock_state?: VehicleLockState | null
  start_vehicle_battery_percent?: number | null
  end_vehicle_battery_percent?: number | null
  distance_in_km?: number | null
  distance_in_mi?: number | null
  speed_in_km?: number | null
  speed_in_mi?: number | null
  possible_rewards: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_possible_rewards_VehicleReward>
  confirmed_rewards: Array<JourneySetQuery_journey_set_JourneySet_journeys_Journey_confirmed_rewards_VehicleReward>
  parking_photo: JourneySetQuery_journey_set_JourneySet_journeys_Journey_parking_photo_ParkingPhoto
  scheme?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme | null
  vehicle: JourneySetQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle
  state: JourneyListQuery_table_JourneyConnection_nodes_Journey_state_JourneyEvent
  user: AdjustEndJourneyMutation_adjust_end_journey_Journey_user_User
}

export type JourneyHistoryFragment = {
  __typename: 'Journey'
  id: string
  state_history: JourneySetQuery_journey_set_JourneySet_journeys_Journey_state_history_JourneyEventConnection
}

export type AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    scheme?: AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle =
  {
    __typename: 'Vehicle'
    id: any
    detail: AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle_detail_VehicleDetail
  }

export type AllModulesQuery_table_ModuleConnection_nodes_Module = {
  __typename: 'Module'
  id: string
  unlock_id?: string | null
  hardware_type: ModuleHardware
  vehicle?: AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle | null
}

export type AllModulesQuery_table_ModuleConnection_pagination_Pagination = {
  __typename: 'Pagination'
  total: number
  current: number
  pageSize: number
}

export type AllModulesQuery_table_ModuleConnection = {
  __typename: 'ModuleConnection'
  nodes: Array<AllModulesQuery_table_ModuleConnection_nodes_Module>
  pagination: AllModulesQuery_table_ModuleConnection_pagination_Pagination
}

export type AllModulesQuery_Query = {
  __typename: 'Query'
  table: AllModulesQuery_table_ModuleConnection
}

export type AllModulesQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<ModuleWhere>>>
  order_by?: InputMaybe<Array<InputMaybe<ModuleOrderby>>>
}>

export type AllModulesQuery = AllModulesQuery_Query

export type ModuleVehicleCommissionedQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string; name: string }

export type ModuleVehicleCommissionedQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    lock_configuration: LockConfiguration
    vehicle_unlock_id?: string | null
    scheme?: ModuleVehicleCommissionedQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type ModuleVehicleCommissionedQuery_module_Module_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  frame_type: string
  detail: ModuleVehicleCommissionedQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail
}

export type ModuleVehicleCommissionedQuery_module_Module = {
  __typename: 'Module'
  hardware_type: ModuleHardware
  id: string
  vehicle?: ModuleVehicleCommissionedQuery_module_Module_vehicle_Vehicle | null
}

export type ModuleVehicleCommissionedQuery_Query = {
  __typename: 'Query'
  module?: ModuleVehicleCommissionedQuery_module_Module | null
}

export type ModuleVehicleCommissionedQueryVariables = Exact<{
  module_id: Scalars['ID']['input']
}>

export type ModuleVehicleCommissionedQuery =
  ModuleVehicleCommissionedQuery_Query

export type ModuleVehicleQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string; name: string }

export type ModuleVehicleQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_module_Module =
  { __typename: 'Module'; id: string }

export type ModuleVehicleQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    scheme?: ModuleVehicleQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
    module?: ModuleVehicleQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_module_Module | null
  }

export type ModuleVehicleQuery_module_Module_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  frame_type: string
  hardware_type: ModuleHardware
  detail: ModuleVehicleQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail
}

export type ModuleVehicleQuery_module_Module = {
  __typename: 'Module'
  vehicle?: ModuleVehicleQuery_module_Module_vehicle_Vehicle | null
}

export type ModuleVehicleQuery_Query = {
  __typename: 'Query'
  module?: ModuleVehicleQuery_module_Module | null
}

export type ModuleVehicleQueryVariables = Exact<{
  module_id: Scalars['ID']['input']
}>

export type ModuleVehicleQuery = ModuleVehicleQuery_Query

export type ModuleSummaryQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme_config_SchemeConfig =
  { __typename: 'SchemeConfig'; is_vehicle_rewards_enabled: boolean }

export type ModuleSummaryQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme =
  {
    __typename: 'Scheme'
    id: string
    config: ModuleSummaryQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme_config_SchemeConfig
  }

export type ModuleSummaryQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    lock_configuration: LockConfiguration
    scheme?: ModuleSummaryQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type ModuleSummaryQuery_module_Module_vehicle_Vehicle_state_VehicleStateEvent =
  { __typename: 'VehicleStateEvent'; id: string; state: VehicleState }

export type ModuleSummaryQuery_module_Module_vehicle_Vehicle_rewards_VehicleReward =
  { __typename: 'VehicleReward'; type: VehicleRewardType }

export type ModuleSummaryQuery_module_Module_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  frame_type: string
  frame_model?: string | null
  detail: ModuleSummaryQuery_module_Module_vehicle_Vehicle_detail_VehicleDetail
  state?: ModuleSummaryQuery_module_Module_vehicle_Vehicle_state_VehicleStateEvent | null
  rewards: Array<ModuleSummaryQuery_module_Module_vehicle_Vehicle_rewards_VehicleReward>
}

export type ModuleSummaryQuery_module_Module_module_state_ScooterModuleState_ecu_error_EcuError =
  {
    __typename: 'EcuError'
    id: string
    code?: string | null
    name: string
    cause?: string | null
    solution?: string | null
    protection?: string | null
  }

export type ModuleSummaryQuery_module_Module_module_state_ModuleState = {
  __typename: 'ModuleState'
  firmware_version?: string | null
  power_mode?: string | null
  drive_id?: string | null
  battery_id?: string | null
  orientation?: string | null
  dock_nfc_tag_id?: string | null
  assist_config?: AssistConfig | null
  id: string
}

export type ModuleSummaryQuery_module_Module_module_state_ScooterModuleState = {
  __typename: 'ScooterModuleState'
  battery_id?: string | null
  max_speed?: number | null
  orientation?: string | null
  id: string
  ecu_error?: ModuleSummaryQuery_module_Module_module_state_ScooterModuleState_ecu_error_EcuError | null
}

export type ModuleSummaryQuery_module_Module_module_state =
  | ModuleSummaryQuery_module_Module_module_state_ModuleState
  | ModuleSummaryQuery_module_Module_module_state_ScooterModuleState

export type ModuleSummaryQuery_module_Module_lock_state_LockEvent = {
  __typename: 'LockEvent'
  id: string
  time: any
  overall_state?: LockState | null
  vehicle_lock_state?: VehicleLockState | null
}

export type ModuleSummaryQuery_module_Module_dock_state_ModuleEvent = {
  __typename: 'ModuleEvent'
  id: string
  time: any
  message: string
}

export type ModuleSummaryQuery_module_Module_availability_Availability = {
  __typename: 'Availability'
  id: string
  status: AvailabilityStatus
}

export type ModuleSummaryQuery_module_Module_connectivity_ModuleConnectivity = {
  __typename: 'ModuleConnectivity'
  is_online: boolean
}

export type ModuleSummaryQuery_module_Module_location_Location = {
  __typename: 'Location'
  id: string
  time: any
}

export type ModuleSummaryQuery_module_Module_telemetry_Telemetry_drive_Drive = {
  __typename: 'Drive'
  battery_percent?: number | null
}

export type ModuleSummaryQuery_module_Module_telemetry_Telemetry = {
  __typename: 'Telemetry'
  id: string
  battery_percent: number
  drive?: ModuleSummaryQuery_module_Module_telemetry_Telemetry_drive_Drive | null
}

export type ModuleSummaryQuery_module_Module_tags_ModuleTag = {
  __typename: 'ModuleTag'
  id: string
  name: ModuleTagName
  created_at: any
}

export type ModuleSummaryQuery_module_Module = {
  __typename: 'Module'
  id: string
  hardware_type: ModuleHardware
  unlock_id?: string | null
  vehicle?: ModuleSummaryQuery_module_Module_vehicle_Vehicle | null
  module_state?: ModuleSummaryQuery_module_Module_module_state | null
  lock_state?: ModuleSummaryQuery_module_Module_lock_state_LockEvent | null
  dock_state?: ModuleSummaryQuery_module_Module_dock_state_ModuleEvent | null
  availability?: ModuleSummaryQuery_module_Module_availability_Availability | null
  connectivity?: ModuleSummaryQuery_module_Module_connectivity_ModuleConnectivity | null
  location?: ModuleSummaryQuery_module_Module_location_Location | null
  telemetry?: ModuleSummaryQuery_module_Module_telemetry_Telemetry | null
  tags?: Array<ModuleSummaryQuery_module_Module_tags_ModuleTag> | null
}

export type ModuleSummaryQuery_Query = {
  __typename: 'Query'
  module?: ModuleSummaryQuery_module_Module | null
}

export type ModuleSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ModuleSummaryQuery = ModuleSummaryQuery_Query

export type CommissionVehicleMutation_commission_V2_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type CommissionVehicleMutation_commission_V2_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    lock_configuration: LockConfiguration
    vehicle_unlock_id?: string | null
    scheme?: CommissionVehicleMutation_commission_V2_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type CommissionVehicleMutation_commission_V2_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  detail: CommissionVehicleMutation_commission_V2_Vehicle_detail_VehicleDetail
}

export type CommissionVehicleMutation_Mutation = {
  __typename: 'Mutation'
  commission_V2: CommissionVehicleMutation_commission_V2_Vehicle
}

export type CommissionVehicleMutationVariables = Exact<{
  module_id: Scalars['ID']['input']
  frame_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
  lock_configuration: LockConfiguration
  frame_type: FrameType
  vehicle_unlock_id?: InputMaybe<Scalars['ID']['input']>
  hardware_subtype?: InputMaybe<ModuleHardwareSubtype>
}>

export type CommissionVehicleMutation = CommissionVehicleMutation_Mutation

export type ModuleNodeFragment_Module_location_Location = {
  __typename: 'Location'
  id: string
  latitude: number
  longitude: number
  max_error?: number | null
  time: any
}

export type ModuleNodeFragment_Module_lock_state_LockEvent = {
  __typename: 'LockEvent'
  id: string
  time: any
  overall_state?: LockState | null
  vehicle_lock_state?: VehicleLockState | null
}

export type ModuleNodeFragment_Module_vehicle_Vehicle_rewards_VehicleReward = {
  __typename: 'VehicleReward'
  type: VehicleRewardType
}

export type ModuleNodeFragment_Module_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  rewards: Array<ModuleNodeFragment_Module_vehicle_Vehicle_rewards_VehicleReward>
}

export type ModuleNodeFragment = {
  __typename: 'Module'
  id: string
  hardware_type: ModuleHardware
  is_present: boolean
  location?: ModuleNodeFragment_Module_location_Location | null
  lock_state?: ModuleNodeFragment_Module_lock_state_LockEvent | null
  vehicle?: ModuleNodeFragment_Module_vehicle_Vehicle | null
}

export type ModulesNodesFragment_ModuleConnection_nodes_Module_location_Location =
  {
    __typename: 'Location'
    id: string
    latitude: number
    longitude: number
    max_error?: number | null
    time: any
  }

export type ModulesNodesFragment_ModuleConnection_nodes_Module_lock_state_LockEvent =
  {
    __typename: 'LockEvent'
    id: string
    time: any
    overall_state?: LockState | null
    vehicle_lock_state?: VehicleLockState | null
  }

export type ModulesNodesFragment_ModuleConnection_nodes_Module_vehicle_Vehicle_rewards_VehicleReward =
  { __typename: 'VehicleReward'; type: VehicleRewardType }

export type ModulesNodesFragment_ModuleConnection_nodes_Module_vehicle_Vehicle =
  {
    __typename: 'Vehicle'
    id: any
    frame_type: string
    rewards: Array<ModulesNodesFragment_ModuleConnection_nodes_Module_vehicle_Vehicle_rewards_VehicleReward>
  }

export type ModulesNodesFragment_ModuleConnection_nodes_Module = {
  __typename: 'Module'
  id: string
  hardware_type: ModuleHardware
  is_present: boolean
  location?: ModulesNodesFragment_ModuleConnection_nodes_Module_location_Location | null
  lock_state?: ModulesNodesFragment_ModuleConnection_nodes_Module_lock_state_LockEvent | null
  vehicle?: ModulesNodesFragment_ModuleConnection_nodes_Module_vehicle_Vehicle | null
}

export type ModulesNodesFragment = {
  __typename: 'ModuleConnection'
  nodes: Array<ModulesNodesFragment_ModuleConnection_nodes_Module>
}

export type DecommissionVehicleMutation_Mutation = {
  __typename: 'Mutation'
  decommission?: boolean | null
}

export type DecommissionVehicleMutationVariables = Exact<{
  module_id: Scalars['ID']['input']
}>

export type DecommissionVehicleMutation = DecommissionVehicleMutation_Mutation

export type MoveSchemeMutation_move_scheme_Vehicle = {
  __typename: 'Vehicle'
  id: any
}

export type MoveSchemeMutation_Mutation = {
  __typename: 'Mutation'
  move_scheme: MoveSchemeMutation_move_scheme_Vehicle
}

export type MoveSchemeMutationVariables = Exact<{
  module_id: Scalars['ID']['input']
  scheme_id: Scalars['ID']['input']
}>

export type MoveSchemeMutation = MoveSchemeMutation_Mutation

export type ModuleBasicFragment = {
  __typename: 'Module'
  id: string
  unlock_id?: string | null
  hardware_type: ModuleHardware
  vehicle?: AllModulesQuery_table_ModuleConnection_nodes_Module_vehicle_Vehicle | null
}

export type ModuleHistoryQuery_node_Module_lock_state_history_LockEventConnection_nodes_LockEvent =
  {
    __typename: 'LockEvent'
    id: string
    time: any
    overall_state?: LockState | null
    vehicle_lock_state?: VehicleLockState | null
    front_lock_state?: LockState | null
    rear_lock_state?: LockState | null
    source?: LockSource | null
  }

export type ModuleHistoryQuery_node_Module_lock_state_history_LockEventConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type ModuleHistoryQuery_node_Module_lock_state_history_LockEventConnection =
  {
    __typename: 'LockEventConnection'
    nodes: Array<ModuleHistoryQuery_node_Module_lock_state_history_LockEventConnection_nodes_LockEvent>
    pagination: ModuleHistoryQuery_node_Module_lock_state_history_LockEventConnection_pagination_Pagination
  }

export type ModuleHistoryQuery_node_Module = {
  __typename: 'Module'
  id: string
  lock_state_history: ModuleHistoryQuery_node_Module_lock_state_history_LockEventConnection
}

export type ModuleHistoryQuery_Query = {
  __typename: 'Query'
  node?: ModuleHistoryQuery_node_Module | null
}

export type ModuleHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
}>

export type ModuleHistoryQuery = ModuleHistoryQuery_Query

export type OTADeviceInformationQuery_ota_device_information_OTAInformation_hardware_versions_OTAVersions =
  {
    __typename: 'OTAVersions'
    ecu: string
    meter: string
    iot: string
    repeater?: string | null
    helmet_lock?: string | null
  }

export type OTADeviceInformationQuery_ota_device_information_OTAInformation_firmware_versions_OTAVersions =
  {
    __typename: 'OTAVersions'
    ecu: string
    meter: string
    iot: string
    repeater?: string | null
    helmet_lock?: string | null
  }

export type OTADeviceInformationQuery_ota_device_information_OTAInformation_required_firmware_versions_RequiredOTAVersions =
  {
    __typename: 'RequiredOTAVersions'
    ecu?: string | null
    meter?: string | null
    iot?: string | null
    repeater?: string | null
    helmet_lock?: string | null
  }

export type OTADeviceInformationQuery_ota_device_information_OTAInformation = {
  __typename: 'OTAInformation'
  server_address: string
  server_port: string
  config_set_at?: any | null
  scheme_config_set_at?: any | null
  time: any
  hardware_versions: OTADeviceInformationQuery_ota_device_information_OTAInformation_hardware_versions_OTAVersions
  firmware_versions: OTADeviceInformationQuery_ota_device_information_OTAInformation_firmware_versions_OTAVersions
  required_firmware_versions: OTADeviceInformationQuery_ota_device_information_OTAInformation_required_firmware_versions_RequiredOTAVersions
}

export type OTADeviceInformationQuery_Query = {
  __typename: 'Query'
  ota_device_information: OTADeviceInformationQuery_ota_device_information_OTAInformation
}

export type OTADeviceInformationQueryVariables = Exact<{
  module_id: Scalars['ID']['input']
}>

export type OTADeviceInformationQuery = OTADeviceInformationQuery_Query

export type FullOTAFirmwareFragment = {
  __typename: 'OTAFirmware'
  id: number
  file_name: string
  hardware_model: HardwareModel
  hardware_version: string
  firmware_type: FirmwareType
  firmware_version: string
  status: FirmwareStatus
}

export type OTAFirmwaresQuery_ota_firmwares_OTAFirmware = {
  __typename: 'OTAFirmware'
  id: number
  file_name: string
  hardware_model: HardwareModel
  hardware_version: string
  firmware_type: FirmwareType
  firmware_version: string
  status: FirmwareStatus
}

export type OTAFirmwaresQuery_Query = {
  __typename: 'Query'
  ota_firmwares?: Array<OTAFirmwaresQuery_ota_firmwares_OTAFirmware | null> | null
}

export type OTAFirmwaresQueryVariables = Exact<{ [key: string]: never }>

export type OTAFirmwaresQuery = OTAFirmwaresQuery_Query

export type CompatibleOTAFirmwaresQuery_compatible_ota_firmwares_OTAFirmware = {
  __typename: 'OTAFirmware'
  id: number
  file_name: string
  hardware_model: HardwareModel
  hardware_version: string
  firmware_type: FirmwareType
  firmware_version: string
  status: FirmwareStatus
}

export type CompatibleOTAFirmwaresQuery_Query = {
  __typename: 'Query'
  compatible_ota_firmwares?: Array<CompatibleOTAFirmwaresQuery_compatible_ota_firmwares_OTAFirmware | null> | null
}

export type CompatibleOTAFirmwaresQueryVariables = Exact<{
  module_id: Scalars['ID']['input']
}>

export type CompatibleOTAFirmwaresQuery = CompatibleOTAFirmwaresQuery_Query

export type OTAListBucketFirmwaresQuery_Query = {
  __typename: 'Query'
  list_ota_bucket_firmwares?: Array<string> | null
}

export type OTAListBucketFirmwaresQueryVariables = Exact<{
  [key: string]: never
}>

export type OTAListBucketFirmwaresQuery = OTAListBucketFirmwaresQuery_Query

export type UpsertOTAFirmwareMutation_upsert_ota_firmware_OTAFirmware = {
  __typename: 'OTAFirmware'
  id: number
  file_name: string
  hardware_model: HardwareModel
  hardware_version: string
  firmware_type: FirmwareType
  firmware_version: string
  status: FirmwareStatus
}

export type UpsertOTAFirmwareMutation_Mutation = {
  __typename: 'Mutation'
  upsert_ota_firmware?: UpsertOTAFirmwareMutation_upsert_ota_firmware_OTAFirmware | null
}

export type UpsertOTAFirmwareMutationVariables = Exact<{
  input: OTAFirmwareInput
}>

export type UpsertOTAFirmwareMutation = UpsertOTAFirmwareMutation_Mutation

export type PromoteOTAFirmwareMutation_promote_ota_firmware_OTAFirmware = {
  __typename: 'OTAFirmware'
  id: number
  file_name: string
  hardware_model: HardwareModel
  hardware_version: string
  firmware_type: FirmwareType
  firmware_version: string
  status: FirmwareStatus
}

export type PromoteOTAFirmwareMutation_Mutation = {
  __typename: 'Mutation'
  promote_ota_firmware?: PromoteOTAFirmwareMutation_promote_ota_firmware_OTAFirmware | null
}

export type PromoteOTAFirmwareMutationVariables = Exact<{
  id: Scalars['Int']['input']
  status: FirmwareStatus
}>

export type PromoteOTAFirmwareMutation = PromoteOTAFirmwareMutation_Mutation

export type DeleteOTAFirmwareMutation_delete_ota_firmware_OTAFirmware = {
  __typename: 'OTAFirmware'
  id: number
  file_name: string
  hardware_model: HardwareModel
  hardware_version: string
  firmware_type: FirmwareType
  firmware_version: string
  status: FirmwareStatus
}

export type DeleteOTAFirmwareMutation_Mutation = {
  __typename: 'Mutation'
  delete_ota_firmware?: DeleteOTAFirmwareMutation_delete_ota_firmware_OTAFirmware | null
}

export type DeleteOTAFirmwareMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteOTAFirmwareMutation = DeleteOTAFirmwareMutation_Mutation

export type FullOTAConfigurationCommandFragment = {
  __typename: 'OTAConfigurationCommand'
  id: number
  name?: string | null
  command?: string | null
  expected_status_code?: number | null
  hardware_model?: HardwareModel | null
  scheme_id?: number | null
  timeout?: number | null
}

export type OTAConfigurationCommandsQuery_ota_configuration_commands_OTAConfigurationCommand =
  {
    __typename: 'OTAConfigurationCommand'
    id: number
    name?: string | null
    command?: string | null
    expected_status_code?: number | null
    hardware_model?: HardwareModel | null
    scheme_id?: number | null
    timeout?: number | null
  }

export type OTAConfigurationCommandsQuery_Query = {
  __typename: 'Query'
  ota_configuration_commands?: Array<OTAConfigurationCommandsQuery_ota_configuration_commands_OTAConfigurationCommand | null> | null
}

export type OTAConfigurationCommandsQueryVariables = Exact<{
  [key: string]: never
}>

export type OTAConfigurationCommandsQuery = OTAConfigurationCommandsQuery_Query

export type InsertConfigCommandMutation_insert_ota_configuration_command_OTAConfigurationCommand =
  {
    __typename: 'OTAConfigurationCommand'
    id: number
    name?: string | null
    command?: string | null
    expected_status_code?: number | null
    hardware_model?: HardwareModel | null
    scheme_id?: number | null
    timeout?: number | null
  }

export type InsertConfigCommandMutation_Mutation = {
  __typename: 'Mutation'
  insert_ota_configuration_command?: InsertConfigCommandMutation_insert_ota_configuration_command_OTAConfigurationCommand | null
}

export type InsertConfigCommandMutationVariables = Exact<{
  input: OTAConfigurationCommandInput
}>

export type InsertConfigCommandMutation = InsertConfigCommandMutation_Mutation

export type DeleteOTAConfigurationCommandMutation_delete_ota_configuration_command_OTAConfigurationCommand =
  {
    __typename: 'OTAConfigurationCommand'
    id: number
    name?: string | null
    command?: string | null
    expected_status_code?: number | null
    hardware_model?: HardwareModel | null
    scheme_id?: number | null
    timeout?: number | null
  }

export type DeleteOTAConfigurationCommandMutation_Mutation = {
  __typename: 'Mutation'
  delete_ota_configuration_command?: DeleteOTAConfigurationCommandMutation_delete_ota_configuration_command_OTAConfigurationCommand | null
}

export type DeleteOTAConfigurationCommandMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteOTAConfigurationCommandMutation =
  DeleteOTAConfigurationCommandMutation_Mutation

export type SideloadOTAFirmwareMutation_Mutation = {
  __typename: 'Mutation'
  sideload_module_firmware?: boolean | null
}

export type SideloadOTAFirmwareMutationVariables = Exact<{
  module_id: Scalars['ID']['input']
  firmware_id: Scalars['Int']['input']
}>

export type SideloadOTAFirmwareMutation = SideloadOTAFirmwareMutation_Mutation

export type SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_scheme_accounting_SchemeAccounting =
  {
    __typename: 'SchemeAccounting'
    id: string
    scheme_pricing_configs: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs
  }

export type SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_price_FormattedAmount =
  { __typename: 'FormattedAmount'; amount: number; formatted_amount: string }

export type SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct =
  {
    __typename: 'SchemeProduct'
    id: string
    scheme_id: string
    product_type: ProductType
    name: string
    is_active: boolean
    is_protected?: boolean | null
    is_discoverable?: boolean | null
    role_whitelist: Array<string>
    fulfill_rewards: Array<VehicleRewardType>
    validity_interval?: ValidityInterval | null
    billable_journey_cap_sub_period?: string | null
    billable_journey_cap?: number | null
    availability?: ProductAvailability | null
    quantity: number
    amount: number
    display_category?: ProductDisplayCategory | null
    waive_out_of_zone_parking_charge?: boolean | null
    scheme_accounting: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_scheme_accounting_SchemeAccounting
    price: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_price_FormattedAmount
  }

export type SchemeProductListQuery_table_SchemeProductConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type SchemeProductListQuery_table_SchemeProductConnection = {
  __typename: 'SchemeProductConnection'
  nodes: Array<SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct>
  pagination: SchemeProductListQuery_table_SchemeProductConnection_pagination_Pagination
}

export type SchemeProductListQuery_role_types_RoleType = {
  __typename: 'RoleType'
  description?: string | null
}

export type SchemeProductListQuery_Query = {
  __typename: 'Query'
  table: SchemeProductListQuery_table_SchemeProductConnection
  role_types: Array<SchemeProductListQuery_role_types_RoleType>
}

export type SchemeProductListQueryVariables = Exact<{
  scheme_id: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
}>

export type SchemeProductListQuery = SchemeProductListQuery_Query

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string; amount: number }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_weekend_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string; amount: number }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_unlock_fee_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string; amount: number }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig =
  {
    __typename: 'SchemeProductConfig'
    charge_increment_duration: string
    journey_minutes_percent_off: number
    journey_minutes_included?: number | null
    period_pass_max_minute_debit?: number | null
    period_pass_sub_period_for_unlocks?: string | null
    period_pass_unlocks_per_sub_period?: number | null
    time_increment_cost: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_FormattedAmount
    time_increment_cost_weekend?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_weekend_FormattedAmount | null
    unlock_fee: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_unlock_fee_FormattedAmount
  }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_ebike_SchemeProductConfig =
  {
    __typename: 'SchemeProductConfig'
    charge_increment_duration: string
    journey_minutes_percent_off: number
    journey_minutes_included?: number | null
    period_pass_max_minute_debit?: number | null
    period_pass_sub_period_for_unlocks?: string | null
    period_pass_unlocks_per_sub_period?: number | null
    time_increment_cost: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_FormattedAmount
    time_increment_cost_weekend?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_weekend_FormattedAmount | null
    unlock_fee: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_unlock_fee_FormattedAmount
  }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_escooter_SchemeProductConfig =
  {
    __typename: 'SchemeProductConfig'
    charge_increment_duration: string
    journey_minutes_percent_off: number
    journey_minutes_included?: number | null
    period_pass_max_minute_debit?: number | null
    period_pass_sub_period_for_unlocks?: string | null
    period_pass_unlocks_per_sub_period?: number | null
    time_increment_cost: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_FormattedAmount
    time_increment_cost_weekend?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_weekend_FormattedAmount | null
    unlock_fee: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_unlock_fee_FormattedAmount
  }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_cargo_ebike_SchemeProductConfig =
  {
    __typename: 'SchemeProductConfig'
    charge_increment_duration: string
    journey_minutes_percent_off: number
    journey_minutes_included?: number | null
    period_pass_max_minute_debit?: number | null
    period_pass_sub_period_for_unlocks?: string | null
    period_pass_unlocks_per_sub_period?: number | null
    time_increment_cost: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_FormattedAmount
    time_increment_cost_weekend?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_weekend_FormattedAmount | null
    unlock_fee: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_unlock_fee_FormattedAmount
  }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory =
  {
    __typename: 'SchemeProductConfigByVehicleCategory'
    bike?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig | null
    ebike?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_ebike_SchemeProductConfig | null
    escooter?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_escooter_SchemeProductConfig | null
    cargo_ebike?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_cargo_ebike_SchemeProductConfig | null
  }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct =
  {
    __typename: 'SchemeProduct'
    id: string
    product_type: ProductType
    configs_v3: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory
  }

export type SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection =
  {
    __typename: 'SchemeProductConnection'
    nodes: Array<SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct>
  }

export type SchemeProductConfigListQuery_Query = {
  __typename: 'Query'
  all_scheme_products: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection
}

export type SchemeProductConfigListQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
}>

export type SchemeProductConfigListQuery = SchemeProductConfigListQuery_Query

export type SchemeProductQuery_scheme_product_SchemeProduct_versions_SchemeProductVersion_user_User =
  { __typename: 'User'; email?: string | null }

export type SchemeProductQuery_scheme_product_SchemeProduct_versions_SchemeProductVersion =
  {
    __typename: 'SchemeProductVersion'
    version_id: any
    published_at: any
    user_id?: string | null
    event: VersionEvent
    user: SchemeProductQuery_scheme_product_SchemeProduct_versions_SchemeProductVersion_user_User
  }

export type SchemeProductQuery_scheme_product_SchemeProduct_details_SchemeProductDetails =
  {
    __typename: 'SchemeProductDetails'
    title: string
    sub_title: string
    image_variant: ProductImageVariant
    benefit_sentence?: string | null
    cta_text?: string | null
    bullets?: Array<string> | null
  }

export type SchemeProductQuery_scheme_product_SchemeProduct = {
  __typename: 'SchemeProduct'
  id: string
  scheme_id: string
  product_type: ProductType
  name: string
  is_active: boolean
  is_protected?: boolean | null
  is_discoverable?: boolean | null
  role_whitelist: Array<string>
  fulfill_rewards: Array<VehicleRewardType>
  validity_interval?: ValidityInterval | null
  billable_journey_cap_sub_period?: string | null
  billable_journey_cap?: number | null
  availability?: ProductAvailability | null
  quantity: number
  amount: number
  display_category?: ProductDisplayCategory | null
  waive_out_of_zone_parking_charge?: boolean | null
  scheme_accounting: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_scheme_accounting_SchemeAccounting
  versions?: Array<SchemeProductQuery_scheme_product_SchemeProduct_versions_SchemeProductVersion> | null
  details?: SchemeProductQuery_scheme_product_SchemeProduct_details_SchemeProductDetails | null
  configs_v3: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory
  price: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_price_FormattedAmount
}

export type SchemeProductQuery_Query = {
  __typename: 'Query'
  scheme_product?: SchemeProductQuery_scheme_product_SchemeProduct | null
}

export type SchemeProductQueryVariables = Exact<{
  schemeProductId: Scalars['ID']['input']
}>

export type SchemeProductQuery = SchemeProductQuery_Query

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_balances_PeriodPassBalances_total_balance_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    formatted_amount: string
    amount: number
    unit: string
  }

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_balances_PeriodPassBalances_current_balance_FormattedAmount =
  {
    __typename: 'FormattedAmount'
    formatted_amount: string
    amount: number
    unit: string
  }

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_balances_PeriodPassBalances =
  {
    __typename: 'PeriodPassBalances'
    total_balance: UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_balances_PeriodPassBalances_total_balance_FormattedAmount
    current_balance: UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_balances_PeriodPassBalances_current_balance_FormattedAmount
  }

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_period_pass_unlocks_PeriodPassUnlocks =
  {
    __typename: 'PeriodPassUnlocks'
    hardware_type: ModuleHardware
    used: number
    limit: number
    period: string
  }

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_scheme_product_SchemeProduct =
  {
    __typename: 'SchemeProduct'
    id: string
    name: string
    product_type: ProductType
    scheme_id: string
  }

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_billable_journey_cap_BillableJourneyCapInfo =
  {
    __typename: 'BillableJourneyCapInfo'
    limit: number
    used: number
    period: string
    is_billable: boolean
  }

export type UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct =
  {
    __typename: 'UserProduct'
    id: string
    valid_until?: any | null
    created_at?: any | null
    is_bonus: boolean
    balances?: UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_balances_PeriodPassBalances | null
    period_pass_unlocks?: Array<UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_period_pass_unlocks_PeriodPassUnlocks> | null
    scheme_product: UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_scheme_product_SchemeProduct
    billable_journey_cap?: UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct_billable_journey_cap_BillableJourneyCapInfo | null
  }

export type UserProductListQuery_user_User_table_UserProductConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type UserProductListQuery_user_User_table_UserProductConnection = {
  __typename: 'UserProductConnection'
  nodes: Array<UserProductListQuery_user_User_table_UserProductConnection_nodes_UserProduct>
  pagination: UserProductListQuery_user_User_table_UserProductConnection_pagination_Pagination
}

export type UserProductListQuery_user_User = {
  __typename: 'User'
  id: string
  table: UserProductListQuery_user_User_table_UserProductConnection
}

export type UserProductListQuery_Query = {
  __typename: 'Query'
  user?: UserProductListQuery_user_User | null
}

export type UserProductListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
  paginate?: InputMaybe<Paginate>
}>

export type UserProductListQuery = UserProductListQuery_Query

export type ProductSummaryFragment = {
  __typename: 'SchemeProduct'
  id: string
  scheme_id: string
  product_type: ProductType
  name: string
  is_active: boolean
  is_protected?: boolean | null
  is_discoverable?: boolean | null
  role_whitelist: Array<string>
  fulfill_rewards: Array<VehicleRewardType>
  validity_interval?: ValidityInterval | null
  billable_journey_cap_sub_period?: string | null
  billable_journey_cap?: number | null
  availability?: ProductAvailability | null
  quantity: number
  amount: number
  display_category?: ProductDisplayCategory | null
  waive_out_of_zone_parking_charge?: boolean | null
  scheme_accounting: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_scheme_accounting_SchemeAccounting
  price: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_price_FormattedAmount
}

export type EditableProductFieldsFragment = {
  __typename: 'SchemeProduct'
  name: string
  is_active: boolean
  is_protected?: boolean | null
  is_discoverable?: boolean | null
  role_whitelist: Array<string>
  fulfill_rewards: Array<VehicleRewardType>
  validity_interval?: ValidityInterval | null
  billable_journey_cap_sub_period?: string | null
  billable_journey_cap?: number | null
  availability?: ProductAvailability | null
  quantity: number
  amount: number
  display_category?: ProductDisplayCategory | null
  waive_out_of_zone_parking_charge?: boolean | null
  price: SchemeProductListQuery_table_SchemeProductConnection_nodes_SchemeProduct_price_FormattedAmount
}

export type ProductDetailsFragment = {
  __typename: 'SchemeProduct'
  details?: SchemeProductQuery_scheme_product_SchemeProduct_details_SchemeProductDetails | null
}

export type ProductVersionsFragment = {
  __typename: 'SchemeProduct'
  versions?: Array<SchemeProductQuery_scheme_product_SchemeProduct_versions_SchemeProductVersion> | null
}

export type ProductConfigsFragment = {
  __typename: 'SchemeProduct'
  configs_v3: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory
}

export type ProductConfigFragment = {
  __typename: 'SchemeProductConfig'
  charge_increment_duration: string
  journey_minutes_percent_off: number
  journey_minutes_included?: number | null
  period_pass_max_minute_debit?: number | null
  period_pass_sub_period_for_unlocks?: string | null
  period_pass_unlocks_per_sub_period?: number | null
  time_increment_cost: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_FormattedAmount
  time_increment_cost_weekend?: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_time_increment_cost_weekend_FormattedAmount | null
  unlock_fee: SchemeProductConfigListQuery_all_scheme_products_SchemeProductConnection_nodes_SchemeProduct_configs_v3_SchemeProductConfigByVehicleCategory_bike_SchemeProductConfig_unlock_fee_FormattedAmount
}

export type UpdateSchemeProductMutation_update_scheme_product_SchemeProduct = {
  __typename: 'SchemeProduct'
  id: string
}

export type UpdateSchemeProductMutation_Mutation = {
  __typename: 'Mutation'
  update_scheme_product: UpdateSchemeProductMutation_update_scheme_product_SchemeProduct
}

export type UpdateSchemeProductMutationVariables = Exact<{
  schemeProductId: Scalars['ID']['input']
  schemeProductInput: SchemeProductInput
}>

export type UpdateSchemeProductMutation = UpdateSchemeProductMutation_Mutation

export type CreateSchemeProductMutation_add_scheme_product_SchemeProduct = {
  __typename: 'SchemeProduct'
  id: string
}

export type CreateSchemeProductMutation_Mutation = {
  __typename: 'Mutation'
  add_scheme_product: CreateSchemeProductMutation_add_scheme_product_SchemeProduct
}

export type CreateSchemeProductMutationVariables = Exact<{
  schemeProductInput: SchemeProductInput
}>

export type CreateSchemeProductMutation = CreateSchemeProductMutation_Mutation

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionContains =
  { __typename: 'ValidationConditionContains'; contains: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionEndsWith =
  { __typename: 'ValidationConditionEndsWith'; ends_with: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionIn =
  { __typename: 'ValidationConditionIn'; in: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionIs =
  { __typename: 'ValidationConditionIs'; is: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionLessThan =
  { __typename: 'ValidationConditionLessThan'; less_than: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionMoreThan =
  { __typename: 'ValidationConditionMoreThan'; more_than: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionStartsWith =
  { __typename: 'ValidationConditionStartsWith'; starts_with: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionTimeframe =
  { __typename: 'ValidationConditionTimeframe'; timeframe: Array<string> }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionTimeframeAbsolute =
  {
    __typename: 'ValidationConditionTimeframeAbsolute'
    timeframe_absolute: Array<string>
  }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions =

    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionContains
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionEndsWith
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionIn
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionIs
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionLessThan
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionMoreThan
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionStartsWith
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionTimeframe
    | ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions_ValidationConditionTimeframeAbsolute

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion =
  {
    __typename: 'ValidationCriterion'
    name: string
    property: string
    conditions: ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion_conditions
  }

export type ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule =
  {
    __typename: 'ValidationRule'
    id: string
    name: string
    logic: string
    created_at: any
    rules_list: Array<ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion>
  }

export type ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type ListValidationRulesQuery_table_ValidationRuleConnection = {
  __typename: 'ValidationRuleConnection'
  nodes: Array<ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule>
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

export type ListValidationRulesQuery_Query = {
  __typename: 'Query'
  table: ListValidationRulesQuery_table_ValidationRuleConnection
}

export type ListValidationRulesQueryVariables = Exact<{ [key: string]: never }>

export type ListValidationRulesQuery = ListValidationRulesQuery_Query

export type ListCampaignsQuery_table_CampaignConnection_nodes_CampaignSummary =
  {
    __typename: 'CampaignSummary'
    campaign_type: CampaignType
    type: string
    id: string
    name: string
    active: boolean
    created_at: any
  }

export type ListCampaignsQuery_table_CampaignConnection = {
  __typename: 'CampaignConnection'
  nodes: Array<ListCampaignsQuery_table_CampaignConnection_nodes_CampaignSummary>
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

export type ListCampaignsQuery_Query = {
  __typename: 'Query'
  table: ListCampaignsQuery_table_CampaignConnection
}

export type ListCampaignsQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
}>

export type ListCampaignsQuery = ListCampaignsQuery_Query

export type ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection_nodes_MetadataSchemaItem_properties_MetadataSchemaProperties =
  {
    __typename: 'MetadataSchemaProperties'
    name: string
    type: MetadataSchemaPropertyType
    array: boolean
    optional: boolean
  }

export type ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection_nodes_MetadataSchemaItem =
  {
    __typename: 'MetadataSchemaItem'
    related_object: MetadataSchemaObjectType
    properties: Array<ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection_nodes_MetadataSchemaItem_properties_MetadataSchemaProperties>
  }

export type ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection =
  {
    __typename: 'MetadataSchemaConnection'
    nodes: Array<ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection_nodes_MetadataSchemaItem>
  }

export type ListMetadataSchemasQuery_Query = {
  __typename: 'Query'
  metadata_schemas: ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection
}

export type ListMetadataSchemasQueryVariables = Exact<{ [key: string]: never }>

export type ListMetadataSchemasQuery = ListMetadataSchemasQuery_Query

export type GetCampaignQuery_campaign_EoJPromotion_discount_ProductDiscountConfig =
  {
    __typename: 'ProductDiscountConfig'
    type: ProductDiscountType
    percent_off?: number | null
  }

export type GetCampaignQuery_campaign_CampaignSummary = {
  __typename: 'CampaignSummary'
  id: string
  name: string
  campaign_type: CampaignType
  active: boolean
  created_at: any
}

export type GetCampaignQuery_campaign_EoJPromotion = {
  __typename: 'EoJPromotion'
  id: string
  name: string
  campaign_type: CampaignType
  active: boolean
  created_at: any
  description: string
  banner: string
  start_date?: any | null
  expiration_date?: any | null
  validation_rule_ids: Array<string>
  scheme_ids: Array<string>
  hardware_types: Array<ModuleHardware>
  vehicle_categories: Array<VehicleCategory>
  unlock_fee_percent_off?: number | null
  journey_first_free_minutes?: number | null
  journey_percent_off_time_based_charges?: number | null
  discount?: GetCampaignQuery_campaign_EoJPromotion_discount_ProductDiscountConfig | null
}

export type GetCampaignQuery_campaign =
  | GetCampaignQuery_campaign_CampaignSummary
  | GetCampaignQuery_campaign_EoJPromotion

export type GetCampaignQuery_Query = {
  __typename: 'Query'
  campaign: GetCampaignQuery_campaign
}

export type GetCampaignQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
}>

export type GetCampaignQuery = GetCampaignQuery_Query

export type CreateEoJPromotionMutation_create_eoj_promotion_EoJPromotion = {
  __typename: 'EoJPromotion'
  id: string
  name: string
}

export type CreateEoJPromotionMutation_Mutation = {
  __typename: 'Mutation'
  create_eoj_promotion: CreateEoJPromotionMutation_create_eoj_promotion_EoJPromotion
}

export type CreateEoJPromotionMutationVariables = Exact<{
  promotion: EoJPromotionInput
}>

export type CreateEoJPromotionMutation = CreateEoJPromotionMutation_Mutation

export type CreateValidationRulesMutation_create_validation_rule_ValidationRule =
  {
    __typename: 'ValidationRule'
    id: string
    name: string
    logic: string
    created_at: any
    rules_list: Array<ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion>
  }

export type CreateValidationRulesMutation_Mutation = {
  __typename: 'Mutation'
  create_validation_rule: CreateValidationRulesMutation_create_validation_rule_ValidationRule
}

export type CreateValidationRulesMutationVariables = Exact<{
  validationRules: ValidationRulesInput
}>

export type CreateValidationRulesMutation =
  CreateValidationRulesMutation_Mutation

export type ValidationRuleFragment = {
  __typename: 'ValidationRule'
  id: string
  name: string
  logic: string
  created_at: any
  rules_list: Array<ListValidationRulesQuery_table_ValidationRuleConnection_nodes_ValidationRule_rules_list_ValidationCriterion>
}

export type CampaignSummaryFragment = {
  __typename: 'CampaignSummary'
  id: string
  name: string
  type: string
  campaign_type: CampaignType
  active: boolean
  created_at: any
}

export type SchemePickerQuery_schemes_SchemeConnection_nodes_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type SchemePickerQuery_schemes_SchemeConnection = {
  __typename: 'SchemeConnection'
  nodes: Array<SchemePickerQuery_schemes_SchemeConnection_nodes_Scheme>
}

export type SchemePickerQuery_Query = {
  __typename: 'Query'
  schemes?: SchemePickerQuery_schemes_SchemeConnection | null
}

export type SchemePickerQueryVariables = Exact<{ [key: string]: never }>

export type SchemePickerQuery = SchemePickerQuery_Query

export type SchemePickerFieldsFragment = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type SchemeServiceAreaQuery_scheme_Scheme_service_areas_ServiceAreaConnection =
  { __typename: 'ServiceAreaConnection'; geojson: any }

export type SchemeServiceAreaQuery_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  service_areas: SchemeServiceAreaQuery_scheme_Scheme_service_areas_ServiceAreaConnection
}

export type SchemeServiceAreaQuery_Query = {
  __typename: 'Query'
  scheme?: SchemeServiceAreaQuery_scheme_Scheme | null
}

export type SchemeServiceAreaQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
}>

export type SchemeServiceAreaQuery = SchemeServiceAreaQuery_Query

export type SchemePermittedVehiclesQuery_permitted_vehicle_models_PermittedVehicleModel =
  {
    __typename: 'PermittedVehicleModel'
    frame_type: FrameType
    supported_hardware_types: Array<ModuleHardware>
  }

export type SchemePermittedVehiclesQuery_Query = {
  __typename: 'Query'
  permitted_vehicle_models: Array<SchemePermittedVehiclesQuery_permitted_vehicle_models_PermittedVehicleModel>
}

export type SchemePermittedVehiclesQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
}>

export type SchemePermittedVehiclesQuery = SchemePermittedVehiclesQuery_Query

export type SchemeConfigQuery_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  config: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_config_SchemeConfig
  scheme_accounting?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting | null
}

export type SchemeConfigQuery_Query = {
  __typename: 'Query'
  scheme?: SchemeConfigQuery_scheme_Scheme | null
}

export type SchemeConfigQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
}>

export type SchemeConfigQuery = SchemeConfigQuery_Query

export type SchemeConfigFragment = {
  __typename: 'Scheme'
  id: string
  config: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_config_SchemeConfig
  scheme_accounting?: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting | null
}

export type SchemePricingConfigsFragment = {
  __typename: 'SchemeAccounting'
  id: string
  scheme_pricing_configs: JourneyListQuery_table_JourneyConnection_nodes_Journey_scheme_Scheme_scheme_accounting_SchemeAccounting_scheme_pricing_configs_SchemePricingConfigs
}

export type ServiceAreaPolicyQuery_service_area_ServiceArea_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
}

export type ServiceAreaPolicyQuery_service_area_ServiceArea = {
  __typename: 'ServiceArea'
  id: string
  name?: string | null
  service_area_type: ServiceAreaType
  speed_limit: number
  is_parking_allowed: boolean
  is_visible: boolean
  effective_from?: string | null
  effective_to?: string | null
  applies_to: Array<VehicleType>
  scheme: ServiceAreaPolicyQuery_service_area_ServiceArea_scheme_Scheme
}

export type ServiceAreaPolicyQuery_Query = {
  __typename: 'Query'
  service_area?: ServiceAreaPolicyQuery_service_area_ServiceArea | null
}

export type ServiceAreaPolicyQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ServiceAreaPolicyQuery = ServiceAreaPolicyQuery_Query

export type UpdateServiceAreaPolicyMutation_update_service_area_policy_ServiceArea =
  {
    __typename: 'ServiceArea'
    id: string
    speed_limit: number
    service_area_type: ServiceAreaType
    is_parking_allowed: boolean
    is_visible: boolean
    effective_from?: string | null
    effective_to?: string | null
    applies_to: Array<VehicleType>
  }

export type UpdateServiceAreaPolicyMutation_Mutation = {
  __typename: 'Mutation'
  update_service_area_policy?: UpdateServiceAreaPolicyMutation_update_service_area_policy_ServiceArea | null
}

export type UpdateServiceAreaPolicyMutationVariables = Exact<{
  service_area_id: Scalars['ID']['input']
  service_area_policy: ServiceAreaPolicyInput
}>

export type UpdateServiceAreaPolicyMutation =
  UpdateServiceAreaPolicyMutation_Mutation

export type ServiceAreasListQuery_table_ServiceAreaConnection_nodes_ServiceArea_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type ServiceAreasListQuery_table_ServiceAreaConnection_nodes_ServiceArea =
  {
    __typename: 'ServiceArea'
    id: string
    name?: string | null
    service_area_type: ServiceAreaType
    speed_limit: number
    is_parking_allowed: boolean
    is_visible: boolean
    effective_from?: string | null
    effective_to?: string | null
    applies_to: Array<VehicleType>
    scheme: ServiceAreasListQuery_table_ServiceAreaConnection_nodes_ServiceArea_scheme_Scheme
  }

export type ServiceAreasListQuery_table_ServiceAreaConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type ServiceAreasListQuery_table_ServiceAreaConnection = {
  __typename: 'ServiceAreaConnection'
  nodes: Array<ServiceAreasListQuery_table_ServiceAreaConnection_nodes_ServiceArea>
  pagination: ServiceAreasListQuery_table_ServiceAreaConnection_pagination_Pagination
}

export type ServiceAreasListQuery_Query = {
  __typename: 'Query'
  table: ServiceAreasListQuery_table_ServiceAreaConnection
}

export type ServiceAreasListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  paginate?: InputMaybe<Paginate>
}>

export type ServiceAreasListQuery = ServiceAreasListQuery_Query

export type ServiceAreaPolicyFragment = {
  __typename: 'ServiceArea'
  service_area_type: ServiceAreaType
  speed_limit: number
  is_parking_allowed: boolean
  is_visible: boolean
  effective_from?: string | null
  effective_to?: string | null
  applies_to: Array<VehicleType>
}

export type ServiceAreaDiffQuery_service_area_ServiceArea = {
  __typename: 'ServiceArea'
  id: string
  name?: string | null
  geom: any
}

export type ServiceAreaDiffQuery_Query = {
  __typename: 'Query'
  service_area?: ServiceAreaDiffQuery_service_area_ServiceArea | null
}

export type ServiceAreaDiffQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ServiceAreaDiffQuery = ServiceAreaDiffQuery_Query

export type ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_added_DraftServiceArea =
  { __typename: 'DraftServiceArea'; name?: string | null; geom: any }

export type ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_added_ServiceArea =
  { __typename: 'ServiceArea' }

export type ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_added =

    | ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_added_DraftServiceArea
    | ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_added_ServiceArea

export type ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_updated_ServiceArea =
  { __typename: 'ServiceArea'; id: string; name?: string | null; geom: any }

export type ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_deleted_ServiceArea =
  { __typename: 'ServiceArea'; id: string; geom: any; name?: string | null }

export type ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult =
  {
    __typename: 'ServiceAreaSyncResult'
    added: Array<ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_added>
    updated: Array<ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_updated_ServiceArea>
    deleted: Array<ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult_deleted_ServiceArea>
  }

export type ServiceAreasSyncMutation_Mutation = {
  __typename: 'Mutation'
  sync_service_areas?: ServiceAreasSyncMutation_sync_service_areas_ServiceAreaSyncResult | null
}

export type ServiceAreasSyncMutationVariables = Exact<{
  scheme_id: Scalars['ID']['input']
  dry_run?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ServiceAreasSyncMutation = ServiceAreasSyncMutation_Mutation

type Pagination_ArchiveJobConnection_Fragment = {
  __typename: 'ArchiveJobConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_AvailabilityConnection_Fragment = {
  __typename: 'AvailabilityConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_BikeConnection_Fragment = {
  __typename: 'BikeConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_CampaignConnection_Fragment = {
  __typename: 'CampaignConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_JobConnection_Fragment = {
  __typename: 'JobConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_JourneyConnection_Fragment = {
  __typename: 'JourneyConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_JourneyEventConnection_Fragment = {
  __typename: 'JourneyEventConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_JourneySetConnection_Fragment = {
  __typename: 'JourneySetConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_LockEventConnection_Fragment = {
  __typename: 'LockEventConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ModuleConnection_Fragment = {
  __typename: 'ModuleConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ModuleConnectivityConnection_Fragment = {
  __typename: 'ModuleConnectivityConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ModuleEventConnection_Fragment = {
  __typename: 'ModuleEventConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ScheduledZoneSuspensionConnection_Fragment = {
  __typename: 'ScheduledZoneSuspensionConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_SchemeAddonConnection_Fragment = {
  __typename: 'SchemeAddonConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_SchemeAvailabilityRestrictionConnection_Fragment = {
  __typename: 'SchemeAvailabilityRestrictionConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_SchemeConnection_Fragment = {
  __typename: 'SchemeConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_SchemeProductConnection_Fragment = {
  __typename: 'SchemeProductConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ServiceAreaConnection_Fragment = {
  __typename: 'ServiceAreaConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_UserAddonConnection_Fragment = {
  __typename: 'UserAddonConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_UserConnection_Fragment = {
  __typename: 'UserConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ValidationRuleConnection_Fragment = {
  __typename: 'ValidationRuleConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_VehicleConnection_Fragment = {
  __typename: 'VehicleConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_WhitelistConnection_Fragment = {
  __typename: 'WhitelistConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ZoneConnection_Fragment = {
  __typename: 'ZoneConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ZoneHistoryChangesConnection_Fragment = {
  __typename: 'ZoneHistoryChangesConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

type Pagination_ZoneHistoryConnection_Fragment = {
  __typename: 'ZoneHistoryConnection'
  pagination: ListValidationRulesQuery_table_ValidationRuleConnection_pagination_Pagination
}

export type PaginationFragment =
  | Pagination_ArchiveJobConnection_Fragment
  | Pagination_AvailabilityConnection_Fragment
  | Pagination_BikeConnection_Fragment
  | Pagination_CampaignConnection_Fragment
  | Pagination_JobConnection_Fragment
  | Pagination_JourneyConnection_Fragment
  | Pagination_JourneyEventConnection_Fragment
  | Pagination_JourneySetConnection_Fragment
  | Pagination_LockEventConnection_Fragment
  | Pagination_ModuleConnection_Fragment
  | Pagination_ModuleConnectivityConnection_Fragment
  | Pagination_ModuleEventConnection_Fragment
  | Pagination_ScheduledZoneSuspensionConnection_Fragment
  | Pagination_SchemeAddonConnection_Fragment
  | Pagination_SchemeAvailabilityRestrictionConnection_Fragment
  | Pagination_SchemeConnection_Fragment
  | Pagination_SchemeProductConnection_Fragment
  | Pagination_ServiceAreaConnection_Fragment
  | Pagination_UserAddonConnection_Fragment
  | Pagination_UserConnection_Fragment
  | Pagination_ValidationRuleConnection_Fragment
  | Pagination_VehicleConnection_Fragment
  | Pagination_WhitelistConnection_Fragment
  | Pagination_ZoneConnection_Fragment
  | Pagination_ZoneHistoryChangesConnection_Fragment
  | Pagination_ZoneHistoryConnection_Fragment

export type UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription_amount_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string }

export type UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription_scheme_product_SchemeProduct_scheme_accounting_SchemeAccounting =
  { __typename: 'SchemeAccounting'; id: string; currency: string }

export type UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription_scheme_product_SchemeProduct =
  {
    __typename: 'SchemeProduct'
    id: string
    scheme_id: string
    name: string
    scheme_accounting: UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription_scheme_product_SchemeProduct_scheme_accounting_SchemeAccounting
  }

export type UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription =
  {
    __typename: 'UserSubscription'
    id: string
    status: SubscriptionStatus
    created_at: any
    current_period_end?: any | null
    cancel_at?: any | null
    amount: UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription_amount_FormattedAmount
    scheme_product?: UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription_scheme_product_SchemeProduct | null
  }

export type UserSubscriptionListQuery_user_User = {
  __typename: 'User'
  id: string
  user_subscriptions: Array<UserSubscriptionListQuery_user_User_user_subscriptions_UserSubscription>
}

export type UserSubscriptionListQuery_Query = {
  __typename: 'Query'
  user?: UserSubscriptionListQuery_user_User | null
}

export type UserSubscriptionListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  user_id: Scalars['ID']['input']
}>

export type UserSubscriptionListQuery = UserSubscriptionListQuery_Query

export type CancelUserSubscriptionMutation_cancel_user_subscription_UserSubscription_cancellation_refund_FormattedAmount =
  { __typename: 'FormattedAmount'; formatted_amount: string }

export type CancelUserSubscriptionMutation_cancel_user_subscription_UserSubscription =
  {
    __typename: 'UserSubscription'
    id: string
    status: SubscriptionStatus
    cancel_at?: any | null
    current_period_end?: any | null
    cancellation_refund?: CancelUserSubscriptionMutation_cancel_user_subscription_UserSubscription_cancellation_refund_FormattedAmount | null
  }

export type CancelUserSubscriptionMutation_Mutation = {
  __typename: 'Mutation'
  cancel_user_subscription?: CancelUserSubscriptionMutation_cancel_user_subscription_UserSubscription | null
}

export type CancelUserSubscriptionMutationVariables = Exact<{
  user_id: Scalars['ID']['input']
  subscription_id: Scalars['ID']['input']
  prorate_refund?: InputMaybe<Scalars['Boolean']['input']>
  refund_amount?: InputMaybe<Scalars['Int']['input']>
}>

export type CancelUserSubscriptionMutation =
  CancelUserSubscriptionMutation_Mutation

export type UsersListQuery_table_UserConnection_nodes_User_roles_Role_scheme_Scheme =
  { __typename: 'Scheme'; id: string; name: string }

export type UsersListQuery_table_UserConnection_nodes_User_roles_Role_org_Org =
  { __typename: 'Org'; id: string; name: string }

export type UsersListQuery_table_UserConnection_nodes_User_roles_Role_type_RoleType =
  { __typename: 'RoleType'; id: string; description?: string | null }

export type UsersListQuery_table_UserConnection_nodes_User_roles_Role = {
  __typename: 'Role'
  id: string
  scheme?: UsersListQuery_table_UserConnection_nodes_User_roles_Role_scheme_Scheme | null
  org?: UsersListQuery_table_UserConnection_nodes_User_roles_Role_org_Org | null
  type: UsersListQuery_table_UserConnection_nodes_User_roles_Role_type_RoleType
}

export type UsersListQuery_table_UserConnection_nodes_User = {
  __typename: 'User'
  id: string
  email?: string | null
  has_valid_licence: boolean
  is_blocked: boolean
  roles?: Array<UsersListQuery_table_UserConnection_nodes_User_roles_Role | null> | null
}

export type UsersListQuery_table_UserConnection_pagination_Pagination = {
  __typename: 'Pagination'
  total: number
  current: number
  pageSize: number
}

export type UsersListQuery_table_UserConnection = {
  __typename: 'UserConnection'
  nodes: Array<UsersListQuery_table_UserConnection_nodes_User>
  pagination: UsersListQuery_table_UserConnection_pagination_Pagination
}

export type UsersListQuery_Query = {
  __typename: 'Query'
  table: UsersListQuery_table_UserConnection
}

export type UsersListQueryVariables = Exact<{
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
}>

export type UsersListQuery = UsersListQuery_Query

export type StaffListQuery_table_UserConnection = {
  __typename: 'UserConnection'
  nodes: Array<UsersListQuery_table_UserConnection_nodes_User>
  pagination: UsersListQuery_table_UserConnection_pagination_Pagination
}

export type StaffListQuery_Query = {
  __typename: 'Query'
  table: StaffListQuery_table_UserConnection
}

export type StaffListQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
}>

export type StaffListQuery = StaffListQuery_Query

export type CustomerListQuery_table_UserConnection = {
  __typename: 'UserConnection'
  nodes: Array<UsersListQuery_table_UserConnection_nodes_User>
  pagination: UsersListQuery_table_UserConnection_pagination_Pagination
}

export type CustomerListQuery_Query = {
  __typename: 'Query'
  table: CustomerListQuery_table_UserConnection
}

export type CustomerListQueryVariables = Exact<{
  schemeId: Scalars['ID']['input']
  where?: InputMaybe<Array<InputMaybe<UserWhere>>>
  order_by?: InputMaybe<Array<InputMaybe<UserOrderby>>>
  paginate?: InputMaybe<Paginate>
}>

export type CustomerListQuery = CustomerListQuery_Query

export type UserSummaryQuery_user_User_charge_exemptions_ChargeExemption = {
  __typename: 'ChargeExemption'
  charge_type: ChargeType
}

export type UserSummaryQuery_user_User_onfido_applicant_OnfidoApplicant = {
  __typename: 'OnfidoApplicant'
  id: string
}

export type UserSummaryQuery_user_User_driving_licence_check_DrivingLicenceCheck =
  { __typename: 'DrivingLicenceCheck'; id: string }

export type UserSummaryQuery_user_User_roles_Role_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type UserSummaryQuery_user_User_roles_Role_org_Org = {
  __typename: 'Org'
  id: string
  name: string
}

export type UserSummaryQuery_user_User_roles_Role_type_RoleType = {
  __typename: 'RoleType'
  id: string
  description?: string | null
}

export type UserSummaryQuery_user_User_roles_Role = {
  __typename: 'Role'
  id: string
  scheme?: UserSummaryQuery_user_User_roles_Role_scheme_Scheme | null
  org?: UserSummaryQuery_user_User_roles_Role_org_Org | null
  type: UserSummaryQuery_user_User_roles_Role_type_RoleType
}

export type UserSummaryQuery_user_User = {
  __typename: 'User'
  phone_number?: string | null
  has_valid_licence: boolean
  is_over_18: boolean
  has_birthdate: boolean
  identity_checked_at?: any | null
  deleted?: boolean | null
  is_blocked: boolean
  persona_enrolled: boolean
  persona_enrolled_device: boolean
  id: string
  email?: string | null
  charge_exemptions: Array<UserSummaryQuery_user_User_charge_exemptions_ChargeExemption>
  onfido_applicant?: UserSummaryQuery_user_User_onfido_applicant_OnfidoApplicant | null
  driving_licence_check?: UserSummaryQuery_user_User_driving_licence_check_DrivingLicenceCheck | null
  roles?: Array<UserSummaryQuery_user_User_roles_Role | null> | null
}

export type UserSummaryQuery_Query = {
  __typename: 'Query'
  user?: UserSummaryQuery_user_User | null
}

export type UserSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input']
  schemeId: Scalars['ID']['input']
}>

export type UserSummaryQuery = UserSummaryQuery_Query

export type UserActionsQuery_user_User_roles_Role_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type UserActionsQuery_user_User_roles_Role_org_Org = {
  __typename: 'Org'
  id: string
  name: string
}

export type UserActionsQuery_user_User_roles_Role_type_RoleType = {
  __typename: 'RoleType'
  id: string
  description?: string | null
}

export type UserActionsQuery_user_User_roles_Role = {
  __typename: 'Role'
  id: string
  scheme?: UserActionsQuery_user_User_roles_Role_scheme_Scheme | null
  org?: UserActionsQuery_user_User_roles_Role_org_Org | null
  type: UserActionsQuery_user_User_roles_Role_type_RoleType
}

export type UserActionsQuery_user_User = {
  __typename: 'User'
  id: string
  email?: string | null
  is_blocked: boolean
  has_valid_licence: boolean
  persona_enrolled: boolean
  phone_number?: string | null
  roles?: Array<UserActionsQuery_user_User_roles_Role | null> | null
}

export type UserActionsQuery_Query = {
  __typename: 'Query'
  user?: UserActionsQuery_user_User | null
}

export type UserActionsQueryVariables = Exact<{
  user_id: Scalars['ID']['input']
}>

export type UserActionsQuery = UserActionsQuery_Query

export type UserSchemesQuery_user_User_user_schemes_UserScheme_scheme_Scheme = {
  __typename: 'Scheme'
  name: string
}

export type UserSchemesQuery_user_User_user_schemes_UserScheme = {
  __typename: 'UserScheme'
  scheme_id: string
  scheme?: UserSchemesQuery_user_User_user_schemes_UserScheme_scheme_Scheme | null
}

export type UserSchemesQuery_user_User = {
  __typename: 'User'
  id: string
  user_schemes: Array<UserSchemesQuery_user_User_user_schemes_UserScheme>
}

export type UserSchemesQuery_Query = {
  __typename: 'Query'
  user?: UserSchemesQuery_user_User | null
}

export type UserSchemesQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type UserSchemesQuery = UserSchemesQuery_Query

export type UserBasicFragment = {
  __typename: 'User'
  id: string
  email?: string | null
}

export type UserSummaryFieldsFragment = {
  __typename: 'User'
  phone_number?: string | null
  has_valid_licence: boolean
  is_over_18: boolean
  has_birthdate: boolean
  identity_checked_at?: any | null
  deleted?: boolean | null
  is_blocked: boolean
  persona_enrolled: boolean
  persona_enrolled_device: boolean
  id: string
  email?: string | null
  onfido_applicant?: UserSummaryQuery_user_User_onfido_applicant_OnfidoApplicant | null
  driving_licence_check?: UserSummaryQuery_user_User_driving_licence_check_DrivingLicenceCheck | null
  roles?: Array<UserSummaryQuery_user_User_roles_Role | null> | null
}

export type UserListFragment = {
  __typename: 'UserConnection'
  nodes: Array<UsersListQuery_table_UserConnection_nodes_User>
  pagination: UsersListQuery_table_UserConnection_pagination_Pagination
}

export type UserListItemFragment = {
  __typename: 'User'
  id: string
  email?: string | null
  has_valid_licence: boolean
  is_blocked: boolean
  roles?: Array<UsersListQuery_table_UserConnection_nodes_User_roles_Role | null> | null
}

export type BlockUserMutation_Mutation = {
  __typename: 'Mutation'
  block_user_identity_platform_account: boolean
}

export type BlockUserMutationVariables = Exact<{
  user_id: Scalars['ID']['input']
}>

export type BlockUserMutation = BlockUserMutation_Mutation

export type UnBlockUserMutation_Mutation = {
  __typename: 'Mutation'
  unblock_user_identity_platform_account: boolean
}

export type UnBlockUserMutationVariables = Exact<{
  user_id: Scalars['ID']['input']
}>

export type UnBlockUserMutation = UnBlockUserMutation_Mutation

export type BlockUserCardFingerprintMutation_Mutation = {
  __typename: 'Mutation'
  block_user_card_fingerprint: boolean
}

export type BlockUserCardFingerprintMutationVariables = Exact<{
  user_id: Scalars['ID']['input']
}>

export type BlockUserCardFingerprintMutation =
  BlockUserCardFingerprintMutation_Mutation

export type UnBlockUserCardFingerptintMutation_Mutation = {
  __typename: 'Mutation'
  unblock_user_card_fingerprint: boolean
}

export type UnBlockUserCardFingerptintMutationVariables = Exact<{
  user_id: Scalars['ID']['input']
}>

export type UnBlockUserCardFingerptintMutation =
  UnBlockUserCardFingerptintMutation_Mutation

export type ForceAddUserPhoneNumberMutation_Mutation = {
  __typename: 'Mutation'
  force_add_user_phone_number: boolean
}

export type ForceAddUserPhoneNumberMutationVariables = Exact<{
  userId: Scalars['ID']['input']
  phoneNumber: Scalars['String']['input']
}>

export type ForceAddUserPhoneNumberMutation =
  ForceAddUserPhoneNumberMutation_Mutation

export type UpdateUserLicenceExpiryDateMutation_Mutation = {
  __typename: 'Mutation'
  update_licence_expiry_date?: boolean | null
}

export type UpdateUserLicenceExpiryDateMutationVariables = Exact<{
  userId: Scalars['ID']['input']
  expiryDate: Scalars['String']['input']
}>

export type UpdateUserLicenceExpiryDateMutation =
  UpdateUserLicenceExpiryDateMutation_Mutation

export type RemoveRoleMutation_Mutation = {
  __typename: 'Mutation'
  remove_role?: boolean | null
}

export type RemoveRoleMutationVariables = Exact<{
  role_id: Scalars['ID']['input']
}>

export type RemoveRoleMutation = RemoveRoleMutation_Mutation

export type SubscribeToTopicMutation_Mutation = {
  __typename: 'Mutation'
  subscribe_to_topic: boolean
}

export type SubscribeToTopicMutationVariables = Exact<{
  userId: Scalars['ID']['input']
  topic: Scalars['String']['input']
}>

export type SubscribeToTopicMutation = SubscribeToTopicMutation_Mutation

export type SendCustomNotificationMutation_Mutation = {
  __typename: 'Mutation'
  send_custom_notification: boolean
}

export type SendCustomNotificationMutationVariables = Exact<{
  userId: Scalars['ID']['input']
  title: Scalars['String']['input']
  body: Scalars['String']['input']
}>

export type SendCustomNotificationMutation =
  SendCustomNotificationMutation_Mutation

export type GetAllVehiclesQuery_vehicles_VehicleConnection_nodes_Vehicle = {
  __typename: 'Vehicle'
  frame_id: string
}

export type GetAllVehiclesQuery_vehicles_VehicleConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; page: number; pages: number }

export type GetAllVehiclesQuery_vehicles_VehicleConnection = {
  __typename: 'VehicleConnection'
  nodes: Array<GetAllVehiclesQuery_vehicles_VehicleConnection_nodes_Vehicle>
  pagination: GetAllVehiclesQuery_vehicles_VehicleConnection_pagination_Pagination
}

export type GetAllVehiclesQuery_Query = {
  __typename: 'Query'
  vehicles: GetAllVehiclesQuery_vehicles_VehicleConnection
}

export type GetAllVehiclesQueryVariables = Exact<{ [key: string]: never }>

export type GetAllVehiclesQuery = GetAllVehiclesQuery_Query

export type VehicleQuery_vehicle_Vehicle_detail_VehicleDetail_module_Module = {
  __typename: 'Module'
  id: string
}

export type VehicleQuery_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type VehicleQuery_vehicle_Vehicle_detail_VehicleDetail = {
  __typename: 'VehicleDetail'
  module?: VehicleQuery_vehicle_Vehicle_detail_VehicleDetail_module_Module | null
  scheme?: VehicleQuery_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
}

export type VehicleQuery_vehicle_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  frame_type: string
  hardware_type: ModuleHardware
  vehicle_category: VehicleCategory
  detail: VehicleQuery_vehicle_Vehicle_detail_VehicleDetail
}

export type VehicleQuery_Query = {
  __typename: 'Query'
  vehicle?: VehicleQuery_vehicle_Vehicle | null
}

export type VehicleQueryVariables = Exact<{
  vehicle_id: Scalars['GUID']['input']
}>

export type VehicleQuery = VehicleQuery_Query

export type VehiclesMapQuery_vehicles_VehicleConnection = {
  __typename: 'VehicleConnection'
  nodes: Array<JourneySetMapQuery_vehicles_VehicleConnection_nodes_Vehicle>
}

export type VehiclesMapQuery_all_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  is_suspended: boolean
  is_priority: boolean
  zone_type: ZoneType
  bikes: number
  ebikes: number
  scooters: number
}

export type VehiclesMapQuery_all_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<VehiclesMapQuery_all_zones_ZoneConnection_nodes_Zone>
}

export type VehiclesMapQuery_Query = {
  __typename: 'Query'
  vehicles: VehiclesMapQuery_vehicles_VehicleConnection
  all_zones: VehiclesMapQuery_all_zones_ZoneConnection
}

export type VehiclesMapQueryVariables = Exact<{
  location?: InputMaybe<LocationAreaInput>
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  in_zone?: InputMaybe<Scalars['Boolean']['input']>
  vehicle_lock_state?: InputMaybe<Array<VehicleLockState>>
  vehicle_category?: InputMaybe<Array<VehicleCategory>>
  vehicle_state?: InputMaybe<Array<VehicleState>>
  suspended?: InputMaybe<Scalars['Boolean']['input']>
}>

export type VehiclesMapQuery = VehiclesMapQuery_Query

export type VehicleMapQuery_vehicle_by_module_id_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  rewards: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward>
  detail: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
}

export type VehicleMapQuery_vehicles_VehicleConnection = {
  __typename: 'VehicleConnection'
  nodes: Array<JourneySetMapQuery_vehicles_VehicleConnection_nodes_Vehicle>
}

export type VehicleMapQuery_all_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  is_suspended: boolean
  is_priority: boolean
  zone_type: ZoneType
  bikes: number
  ebikes: number
  scooters: number
}

export type VehicleMapQuery_all_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<VehicleMapQuery_all_zones_ZoneConnection_nodes_Zone>
}

export type VehicleMapQuery_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  is_suspended: boolean
  is_priority: boolean
  zone_type: ZoneType
  bikes: number
  ebikes: number
  scooters: number
}

export type VehicleMapQuery_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<VehicleMapQuery_zones_ZoneConnection_nodes_Zone>
}

export type VehicleMapQuery_Query = {
  __typename: 'Query'
  vehicle_by_module_id?: VehicleMapQuery_vehicle_by_module_id_Vehicle | null
  vehicles?: VehicleMapQuery_vehicles_VehicleConnection
  all_zones?: VehicleMapQuery_all_zones_ZoneConnection
  zones?: VehicleMapQuery_zones_ZoneConnection
}

export type VehicleMapQueryVariables = Exact<{
  id: Scalars['ID']['input']
  schemeId?: InputMaybe<Scalars['ID']['input']>
  location?: InputMaybe<LocationAreaInput>
  hasLocation: Scalars['Boolean']['input']
  lacksLocation: Scalars['Boolean']['input']
  showSuspendedBays: Scalars['Boolean']['input']
}>

export type VehicleMapQuery = VehicleMapQuery_Query

export type ZoneVehiclesListQuery_zone_Zone_table_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  rewards: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward>
  detail: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
}

export type ZoneVehiclesListQuery_zone_Zone = {
  __typename: 'Zone'
  id: string
  table: Array<ZoneVehiclesListQuery_zone_Zone_table_Vehicle>
}

export type ZoneVehiclesListQuery_Query = {
  __typename: 'Query'
  zone?: ZoneVehiclesListQuery_zone_Zone | null
}

export type ZoneVehiclesListQueryVariables = Exact<{
  zone_id: Scalars['ID']['input']
}>

export type ZoneVehiclesListQuery = ZoneVehiclesListQuery_Query

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_scheme_Scheme =
  { __typename: 'Scheme'; id: string }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_lock_state_LockEvent =
  {
    __typename: 'LockEvent'
    id: string
    overall_state?: LockState | null
    vehicle_lock_state?: VehicleLockState | null
  }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_iot_state_IotState =
  {
    __typename: 'IotState'
    power_mode?: string | null
    firmware_version?: string | null
    id: string
  }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry_drive_Drive =
  {
    __typename: 'Drive'
    battery_percent?: number | null
    estimated_range?: number | null
  }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry =
  {
    __typename: 'Telemetry'
    id: string
    battery_percent: number
    fix_invalid: boolean
    drive?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry_drive_Drive | null
  }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_availability_Availability =
  { __typename: 'Availability'; id: string; status: AvailabilityStatus }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_connectivity_ModuleConnectivity =
  { __typename: 'ModuleConnectivity'; is_online: boolean }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    unlock_id?: string | null
    hardware_type: ModuleHardware
    is_present: boolean
    lock_state?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_lock_state_LockEvent | null
    iot_state?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_iot_state_IotState | null
    telemetry?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry | null
    availability?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_availability_Availability | null
    connectivity?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module_connectivity_ModuleConnectivity | null
  }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    lock_configuration: LockConfiguration
    vehicle_unlock_id?: string | null
    scheme?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_scheme_Scheme | null
    module?: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail_module_Module | null
  }

export type VehiclesListQuery_table_VehicleConnection_nodes_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  frame_type: string
  detail: VehiclesListQuery_table_VehicleConnection_nodes_Vehicle_detail_VehicleDetail
}

export type VehiclesListQuery_table_VehicleConnection_pagination_Pagination = {
  __typename: 'Pagination'
  total: number
  current: number
  pageSize: number
}

export type VehiclesListQuery_table_VehicleConnection = {
  __typename: 'VehicleConnection'
  nodes: Array<VehiclesListQuery_table_VehicleConnection_nodes_Vehicle>
  pagination: VehiclesListQuery_table_VehicleConnection_pagination_Pagination
}

export type VehiclesListQuery_Query = {
  __typename: 'Query'
  table: VehiclesListQuery_table_VehicleConnection
}

export type VehiclesListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  paginate?: InputMaybe<Paginate>
  is_mobile: Scalars['Boolean']['input']
  lean_query: Scalars['Boolean']['input']
  vehicle_lock_state?: InputMaybe<Array<VehicleLockState>>
  vehicle_category?: InputMaybe<Array<VehicleCategory>>
  vehicle_state?: InputMaybe<Array<VehicleState>>
  frame_id__like?: InputMaybe<Scalars['String']['input']>
  unlock_id__like?: InputMaybe<Scalars['String']['input']>
  module_id__like?: InputMaybe<Scalars['String']['input']>
  vehicle_id__like?: InputMaybe<Scalars['String']['input']>
  frame_type?: InputMaybe<Array<FrameType>>
}>

export type VehiclesListQuery = VehiclesListQuery_Query

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry_drive_Drive =
  {
    __typename: 'Drive'
    battery_percent?: number | null
    estimated_range?: number | null
  }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry =
  {
    __typename: 'Telemetry'
    id: string
    drive?: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry_drive_Drive | null
  }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_tags_ModuleTag =
  { __typename: 'ModuleTag'; id: string; name: ModuleTagName; created_at: any }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_module_state_ModuleState =
  {
    __typename: 'ModuleState'
    assist_config?: AssistConfig | null
    power_mode?: string | null
    id: string
  }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_module_state_ScooterModuleState =
  { __typename: 'ScooterModuleState'; id: string }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_module_state =

    | VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_module_state_ModuleState
    | VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_module_state_ScooterModuleState

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_connectivity_ModuleConnectivity =
  { __typename: 'ModuleConnectivity'; is_online: boolean }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    is_present: boolean
    unlock_id?: string | null
    telemetry?: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_telemetry_Telemetry | null
    tags?: Array<VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_tags_ModuleTag> | null
    module_state?: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_module_state | null
    connectivity?: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module_connectivity_ModuleConnectivity | null
    location?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_location_Location | null
    lock_state?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_lock_state_LockEvent | null
    availability?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_module_Module_availability_Availability | null
  }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    lock_configuration: LockConfiguration
    id: string
    vehicle_unlock_id?: string | null
    module?: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail_module_Module | null
    scheme?: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail_scheme_Scheme | null
  }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle_rewards_VehicleReward =
  { __typename: 'VehicleReward'; type: VehicleRewardType }

export type VehicleLegendQuery_vehicle_by_module_id_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  detail: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail
  rewards: Array<VehicleLegendQuery_vehicle_by_module_id_Vehicle_rewards_VehicleReward>
}

export type VehicleLegendQuery_Query = {
  __typename: 'Query'
  vehicle_by_module_id?: VehicleLegendQuery_vehicle_by_module_id_Vehicle | null
}

export type VehicleLegendQueryVariables = Exact<{
  module_id: Scalars['ID']['input']
}>

export type VehicleLegendQuery = VehicleLegendQuery_Query

export type VehiclesNodesFragment = {
  __typename: 'VehicleConnection'
  nodes: Array<JourneySetMapQuery_vehicles_VehicleConnection_nodes_Vehicle>
}

export type VehicleNodeFragment = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  rewards: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward>
  detail: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
}

export type VehicleLegendNodeFragment = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  detail: VehicleLegendQuery_vehicle_by_module_id_Vehicle_detail_VehicleDetail
  rewards: Array<VehicleLegendQuery_vehicle_by_module_id_Vehicle_rewards_VehicleReward>
}

export type VehicleListFragment = {
  __typename: 'VehicleConnection'
  nodes: Array<VehiclesListQuery_table_VehicleConnection_nodes_Vehicle>
  pagination: VehiclesListQuery_table_VehicleConnection_pagination_Pagination
}

export type ZoneNodeFragment = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  is_suspended: boolean
  is_priority: boolean
  zone_type: ZoneType
  bikes: number
  ebikes: number
  scooters: number
}

export type ZoneSummaryQuery_zone_Zone_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type ZoneSummaryQuery_zone_Zone_current_suspension_CurrentZoneSuspension =
  {
    __typename: 'CurrentZoneSuspension'
    author_id: string
    id: string
    notes?: string | null
    reason?: ZoneSuspensionReason | null
    scheme_id: string
  }

export type ZoneSummaryQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection_nodes_ScheduledZoneSuspension =
  { __typename: 'ScheduledZoneSuspension'; id: string }

export type ZoneSummaryQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection =
  {
    __typename: 'ScheduledZoneSuspensionConnection'
    nodes?: Array<ZoneSummaryQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection_nodes_ScheduledZoneSuspension | null> | null
  }

export type ZoneSummaryQuery_zone_Zone = {
  __typename: 'Zone'
  id: string
  centre: any
  capacity: number
  notes?: string | null
  hireable_vehicles_count: number
  all_commissioned_modules_count: number
  parking_capacity_status: ParkingCapacityStatus
  hiring_capacity_status: HiringCapacityStatus
  permitted_vehicles: Array<VehicleType>
  docked_vehicles_count: number
  zone_type: ZoneType
  name: string
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  hireable_bikes: number
  hireable_ebikes: number
  hireable_scooters: number
  bikes: number
  ebikes: number
  scooters: number
  scheme: ZoneSummaryQuery_zone_Zone_scheme_Scheme
  current_suspension?: ZoneSummaryQuery_zone_Zone_current_suspension_CurrentZoneSuspension | null
  scheduled_suspensions?: ZoneSummaryQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection | null
}

export type ZoneSummaryQuery_Query = {
  __typename: 'Query'
  zone?: ZoneSummaryQuery_zone_Zone | null
}

export type ZoneSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ZoneSummaryQuery = ZoneSummaryQuery_Query

export type ZoneDiffQuery_zone_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  permitted_vehicles: Array<VehicleType>
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
}

export type ZoneDiffQuery_Query = {
  __typename: 'Query'
  zone?: ZoneDiffQuery_zone_Zone | null
}

export type ZoneDiffQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ZoneDiffQuery = ZoneDiffQuery_Query

export type ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_nodes_ZoneHistoryChanges_current_suspension_CurrentZoneSuspension =
  {
    __typename: 'CurrentZoneSuspension'
    author_id: string
    id: string
    notes?: string | null
    reason?: ZoneSuspensionReason | null
    scheme_id: string
  }

export type ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_nodes_ZoneHistoryChanges =
  {
    __typename: 'ZoneHistoryChanges'
    id: string
    capacity: number
    external_id?: string | null
    name?: string | null
    notes?: string | null
    permitted_vehicles: Array<VehicleType>
    time?: any | null
    zone_id: string
    zone_type: ZoneType
    is_suspended: boolean
    is_promotional?: boolean | null
    is_priority?: boolean | null
    current_suspension?: ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_nodes_ZoneHistoryChanges_current_suspension_CurrentZoneSuspension | null
  }

export type ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number; current: number; pageSize: number }

export type ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection =
  {
    __typename: 'ZoneHistoryChangesConnection'
    nodes: Array<ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_nodes_ZoneHistoryChanges>
    pagination: ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_pagination_Pagination
  }

export type ZoneHistoryChangesQuery_Query = {
  __typename: 'Query'
  zone_history_changes: ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection
}

export type ZoneHistoryChangesQueryVariables = Exact<{
  id: Scalars['ID']['input']
  page?: InputMaybe<Scalars['Int']['input']>
  per_page?: InputMaybe<Scalars['Int']['input']>
}>

export type ZoneHistoryChangesQuery = ZoneHistoryChangesQuery_Query

export type ZoneMapQuery_zone_Zone_all_commissioned_vehicles_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_type: string
  frame_id: string
  hardware_type: ModuleHardware
  rewards: Array<JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_rewards_VehicleReward>
  detail: JourneySetMapQuery_journey_set_JourneySet_journeys_Journey_vehicle_Vehicle_detail_VehicleDetail
}

export type ZoneMapQuery_zone_Zone_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
  name: string
}

export type ZoneMapQuery_zone_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  zone_type: ZoneType
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  bikes: number
  ebikes: number
  scooters: number
  all_commissioned_vehicles: Array<ZoneMapQuery_zone_Zone_all_commissioned_vehicles_Vehicle>
  scheme: ZoneMapQuery_zone_Zone_scheme_Scheme
}

export type ZoneMapQuery_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  zone_type: ZoneType
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  bikes: number
  ebikes: number
  scooters: number
  scheme: ZoneMapQuery_zone_Zone_scheme_Scheme
}

export type ZoneMapQuery_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<ZoneMapQuery_zones_ZoneConnection_nodes_Zone>
}

export type ZoneMapQuery_Query = {
  __typename: 'Query'
  zone?: ZoneMapQuery_zone_Zone | null
  zones?: ZoneMapQuery_zones_ZoneConnection
}

export type ZoneMapQueryVariables = Exact<{
  id: Scalars['ID']['input']
  zone_id: Scalars['String']['input']
  hasLocation: Scalars['Boolean']['input']
  location?: InputMaybe<LocationAreaInput>
}>

export type ZoneMapQuery = ZoneMapQuery_Query

export type ZonesListQuery_table_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  all_commissioned_modules_count: number
  hireable_vehicles_count: number
  capacity: number
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
  name: string
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  scheme: ZoneSummaryQuery_zone_Zone_scheme_Scheme
  scheduled_suspensions?: ZoneSummaryQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection | null
}

export type ZonesListQuery_table_ZoneConnection_pagination_Pagination = {
  __typename: 'Pagination'
  total: number
  current: number
  pageSize: number
}

export type ZonesListQuery_table_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<ZonesListQuery_table_ZoneConnection_nodes_Zone>
  pagination: ZonesListQuery_table_ZoneConnection_pagination_Pagination
}

export type ZonesListQuery_enabled_zones_ZoneConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number }

export type ZonesListQuery_enabled_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  pagination: ZonesListQuery_enabled_zones_ZoneConnection_pagination_Pagination
}

export type ZonesListQuery_suspended_zones_ZoneConnection_pagination_Pagination =
  { __typename: 'Pagination'; total: number }

export type ZonesListQuery_suspended_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  pagination: ZonesListQuery_suspended_zones_ZoneConnection_pagination_Pagination
}

export type ZonesListQuery_Query = {
  __typename: 'Query'
  table: ZonesListQuery_table_ZoneConnection
  enabled_zones: ZonesListQuery_enabled_zones_ZoneConnection
  suspended_zones: ZonesListQuery_suspended_zones_ZoneConnection
}

export type ZonesListQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  paginate?: InputMaybe<Paginate>
  where?: InputMaybe<Array<InputMaybe<ZoneWhere>>>
  is_suspended?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ZonesListQuery = ZonesListQuery_Query

export type ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection_nodes_ScheduledZoneSuspension =
  {
    __typename: 'ScheduledZoneSuspension'
    reason?: ZoneSuspensionReason | null
    notes?: string | null
    start_time?: any | null
    end_time?: any | null
    schedule_status?: ScheduledZoneSuspensionStatus | null
    status_updated_at?: any | null
    author_id: string
  }

export type ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection_pagination_Pagination =
  { __typename: 'Pagination'; page: number; pages: number }

export type ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection =
  {
    __typename: 'ScheduledZoneSuspensionConnection'
    nodes?: Array<ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection_nodes_ScheduledZoneSuspension | null> | null
    pagination: ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection_pagination_Pagination
  }

export type ZoneSuspensionsListQuery_zone_Zone = {
  __typename: 'Zone'
  id: string
  current_suspension?: ZoneSummaryQuery_zone_Zone_current_suspension_CurrentZoneSuspension | null
  scheduled_suspensions?: ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection | null
}

export type ZoneSuspensionsListQuery_Query = {
  __typename: 'Query'
  zone?: ZoneSuspensionsListQuery_zone_Zone | null
}

export type ZoneSuspensionsListQueryVariables = Exact<{
  zone_id: Scalars['ID']['input']
}>

export type ZoneSuspensionsListQuery = ZoneSuspensionsListQuery_Query

export type ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle_detail_VehicleDetail_module_Module_availability_Availability =
  { __typename: 'Availability'; id: string; status: AvailabilityStatus }

export type ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle_detail_VehicleDetail_module_Module =
  {
    __typename: 'Module'
    id: string
    availability?: ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle_detail_VehicleDetail_module_Module_availability_Availability | null
  }

export type ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle_detail_VehicleDetail =
  {
    __typename: 'VehicleDetail'
    id: string
    module?: ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle_detail_VehicleDetail_module_Module | null
  }

export type ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle = {
  __typename: 'Vehicle'
  id: any
  frame_id: string
  frame_type: string
  hardware_type: ModuleHardware
  detail: ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle_detail_VehicleDetail
}

export type ZoneLegendQuery_zone_Zone_scheme_Scheme = {
  __typename: 'Scheme'
  id: string
}

export type ZoneLegendQuery_zone_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  capacity: number
  geom: any
  all_commissioned_modules_count: number
  docked_vehicles_count: number
  zone_type: ZoneType
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  bikes: number
  ebikes: number
  scooters: number
  all_commissioned_vehicles: Array<ZoneLegendQuery_zone_Zone_all_commissioned_vehicles_Vehicle>
  scheme: ZoneLegendQuery_zone_Zone_scheme_Scheme
}

export type ZoneLegendQuery_Query = {
  __typename: 'Query'
  zone?: ZoneLegendQuery_zone_Zone | null
}

export type ZoneLegendQueryVariables = Exact<{
  zone_id: Scalars['ID']['input']
}>

export type ZoneLegendQuery = ZoneLegendQuery_Query

export type ZoneOptionsQuery_all_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  zone_type: ZoneType
  name: string
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  scheme: ZoneSummaryQuery_zone_Zone_scheme_Scheme
}

export type ZoneOptionsQuery_all_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<ZoneOptionsQuery_all_zones_ZoneConnection_nodes_Zone>
}

export type ZoneOptionsQuery_Query = {
  __typename: 'Query'
  all_zones: ZoneOptionsQuery_all_zones_ZoneConnection
}

export type ZoneOptionsQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  suspended?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ZoneOptionsQuery = ZoneOptionsQuery_Query

export type ZonesMapQuery_all_zones_ZoneConnection_nodes_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  centre: any
  capacity: number
  geom: any
  zone_type: ZoneType
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
  bikes: number
  ebikes: number
  scooters: number
  scheme: ZoneMapQuery_zone_Zone_scheme_Scheme
}

export type ZonesMapQuery_all_zones_ZoneConnection = {
  __typename: 'ZoneConnection'
  nodes: Array<ZonesMapQuery_all_zones_ZoneConnection_nodes_Zone>
}

export type ZonesMapQuery_Query = {
  __typename: 'Query'
  all_zones: ZonesMapQuery_all_zones_ZoneConnection
}

export type ZonesMapQueryVariables = Exact<{
  scheme_id?: InputMaybe<Scalars['ID']['input']>
  suspended?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ZonesMapQuery = ZonesMapQuery_Query

export type ZoneEnableMutation_updated_zone_Zone = {
  __typename: 'Zone'
  id: string
}

export type ZoneEnableMutation_Mutation = {
  __typename: 'Mutation'
  updated_zone?: ZoneEnableMutation_updated_zone_Zone | null
}

export type ZoneEnableMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ZoneEnableMutation = ZoneEnableMutation_Mutation

export type ZoneSuspendMutation_updated_zone_Zone = {
  __typename: 'Zone'
  id: string
}

export type ZoneSuspendMutation_Mutation = {
  __typename: 'Mutation'
  updated_zone?: ZoneSuspendMutation_updated_zone_Zone | null
}

export type ZoneSuspendMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ZoneSuspendMutation = ZoneSuspendMutation_Mutation

export type ZoneSuspendWithReasonMutation_suspend_zone_with_reason_Zone_current_suspension_CurrentZoneSuspension =
  {
    __typename: 'CurrentZoneSuspension'
    id: string
    author_id: string
    scheme_id: string
    reason?: ZoneSuspensionReason | null
    notes?: string | null
  }

export type ZoneSuspendWithReasonMutation_suspend_zone_with_reason_Zone = {
  __typename: 'Zone'
  id: string
  current_suspension?: ZoneSuspendWithReasonMutation_suspend_zone_with_reason_Zone_current_suspension_CurrentZoneSuspension | null
}

export type ZoneSuspendWithReasonMutation_Mutation = {
  __typename: 'Mutation'
  suspend_zone_with_reason?: ZoneSuspendWithReasonMutation_suspend_zone_with_reason_Zone | null
}

export type ZoneSuspendWithReasonMutationVariables = Exact<{
  id: Scalars['ID']['input']
  suspension_reason: ZoneSuspensionInfoInput
}>

export type ZoneSuspendWithReasonMutation =
  ZoneSuspendWithReasonMutation_Mutation

export type ZoneScheduledSuspendMutation_create_scheduled_zone_suspension_ScheduledZoneSuspension =
  {
    __typename: 'ScheduledZoneSuspension'
    id: string
    author_id: string
    scheme_id: string
    reason?: ZoneSuspensionReason | null
    notes?: string | null
    start_time?: any | null
    end_time?: any | null
    schedule_status?: ScheduledZoneSuspensionStatus | null
    status_updated_at?: any | null
  }

export type ZoneScheduledSuspendMutation_Mutation = {
  __typename: 'Mutation'
  create_scheduled_zone_suspension: ZoneScheduledSuspendMutation_create_scheduled_zone_suspension_ScheduledZoneSuspension
}

export type ZoneScheduledSuspendMutationVariables = Exact<{
  end_time: Scalars['DateTime']['input']
  reason: ZoneSuspensionReasonInput
  notes?: InputMaybe<Scalars['String']['input']>
  scheme_id: Scalars['ID']['input']
  start_time: Scalars['DateTime']['input']
  zone_ids: Array<InputMaybe<Scalars['ID']['input']>>
}>

export type ZoneScheduledSuspendMutation = ZoneScheduledSuspendMutation_Mutation

export type ZoneSetPromotionalMutation_updated_zone_Zone = {
  __typename: 'Zone'
  id: string
}

export type ZoneSetPromotionalMutation_Mutation = {
  __typename: 'Mutation'
  updated_zone?: ZoneSetPromotionalMutation_updated_zone_Zone | null
}

export type ZoneSetPromotionalMutationVariables = Exact<{
  id: Scalars['ID']['input']
  is_promotional: Scalars['Boolean']['input']
}>

export type ZoneSetPromotionalMutation = ZoneSetPromotionalMutation_Mutation

export type ZoneSetPriorityMutation_updated_zone_Zone = {
  __typename: 'Zone'
  id: string
}

export type ZoneSetPriorityMutation_Mutation = {
  __typename: 'Mutation'
  updated_zone: ZoneSetPriorityMutation_updated_zone_Zone
}

export type ZoneSetPriorityMutationVariables = Exact<{
  id: Scalars['ID']['input']
  is_priority: Scalars['Boolean']['input']
}>

export type ZoneSetPriorityMutation = ZoneSetPriorityMutation_Mutation

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_added_DeletedZone = {
  __typename: 'DeletedZone'
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_added_DraftZone = {
  __typename: 'DraftZone'
  name: string
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_added_Zone = {
  __typename: 'Zone'
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_added =
  | ZonesSyncMutation_sync_zones_ZoneSyncResult_added_DeletedZone
  | ZonesSyncMutation_sync_zones_ZoneSyncResult_added_DraftZone
  | ZonesSyncMutation_sync_zones_ZoneSyncResult_added_Zone

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_updated_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted_DeletedZone = {
  __typename: 'DeletedZone'
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted_DraftZone = {
  __typename: 'DraftZone'
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted_Zone = {
  __typename: 'Zone'
  id: string
  name: string
  capacity: number
  geom: any
  centre: any
  permitted_vehicles: Array<VehicleType>
  zone_type: ZoneType
}

export type ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted =
  | ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted_DeletedZone
  | ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted_DraftZone
  | ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted_Zone

export type ZonesSyncMutation_sync_zones_ZoneSyncResult = {
  __typename: 'ZoneSyncResult'
  added: Array<ZonesSyncMutation_sync_zones_ZoneSyncResult_added>
  updated: Array<ZonesSyncMutation_sync_zones_ZoneSyncResult_updated_Zone>
  deleted: Array<ZonesSyncMutation_sync_zones_ZoneSyncResult_deleted>
}

export type ZonesSyncMutation_Mutation = {
  __typename: 'Mutation'
  sync_zones?: ZonesSyncMutation_sync_zones_ZoneSyncResult | null
}

export type ZonesSyncMutationVariables = Exact<{
  scheme_id: Scalars['ID']['input']
  dry_run?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ZonesSyncMutation = ZonesSyncMutation_Mutation

export type ZoneStatusFragment = {
  __typename: 'Zone'
  id: string
  is_external: boolean
  is_promotional: boolean
  is_priority: boolean
  is_suspended: boolean
}

export type ZoneHistoryChangesNodeFragment = {
  __typename: 'ZoneHistoryChanges'
  id: string
  capacity: number
  external_id?: string | null
  name?: string | null
  notes?: string | null
  permitted_vehicles: Array<VehicleType>
  time?: any | null
  zone_id: string
  zone_type: ZoneType
  is_suspended: boolean
  is_promotional?: boolean | null
  is_priority?: boolean | null
  current_suspension?: ZoneHistoryChangesQuery_zone_history_changes_ZoneHistoryChangesConnection_nodes_ZoneHistoryChanges_current_suspension_CurrentZoneSuspension | null
}

export type ZoneInfoFragment = {
  __typename: 'Zone'
  id: string
  centre: any
  capacity: number
  geom: any
  zone_type: ZoneType
  name: string
  bikes: number
  ebikes: number
  scooters: number
  scheme: ZoneSummaryQuery_zone_Zone_scheme_Scheme
}

export type ZoneNameFragment = {
  __typename: 'Zone'
  id: string
  name: string
  scheme: ZoneSummaryQuery_zone_Zone_scheme_Scheme
}

export type ZoneCurrentSuspensionFragment = {
  __typename: 'Zone'
  current_suspension?: ZoneSummaryQuery_zone_Zone_current_suspension_CurrentZoneSuspension | null
}

export type ZoneScheduledSuspensionsFragment = {
  __typename: 'Zone'
  scheduled_suspensions?: ZoneSuspensionsListQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection | null
}

export type FirstZoneScheduledSuspensionFragment = {
  __typename: 'Zone'
  scheduled_suspensions?: ZoneSummaryQuery_zone_Zone_scheduled_suspensions_ScheduledZoneSuspensionConnection | null
}

export const EditableAddonFieldsFragmentDoc = gql`
  fragment EditableAddonFields on SchemeAddon {
    name
    is_active
    is_protected
    is_discoverable
    role_whitelist
    validity_interval
    amount
    price {
      amount
      formatted_amount
    }
  }
`
export const AddonSummaryFragmentDoc = gql`
  fragment AddonSummary on SchemeAddon {
    id
    scheme_id
    addon_type
    ...EditableAddonFields
  }
  ${EditableAddonFieldsFragmentDoc}
`
export const AvailabilityRestrictionDataFragmentDoc = gql`
  fragment AvailabilityRestrictionData on SchemeAvailabilityRestriction {
    id
    vehicle_type
    frame_type
    propulsion_type
    start_time
    end_time
    last_status_change_time
  }
`
export const AssigmentGroupFragmentDoc = gql`
  fragment AssigmentGroup on JobTypesAssignmentGroup {
    label
    children {
      label
      code
      categories
      name
      disabled
    }
  }
`
export const JobBasicFragmentDoc = gql`
  fragment JobBasic on Job {
    uuid
    timestamps {
      created_at
      updated_at
      completed_at
    }
    details {
      assignee {
        id
        email
      }
      priority
      assetTag
      assetName
      assetCategory
      scheme {
        id
        name
      }
      taskId
      description
      status
      role
      notes
      location
      reportedLocation
      locationDescription
      isJustified
      isUnlocked
      createdBy {
        id
        email
      }
      updatedBy {
        id
        email
      }
      completedBy {
        id
        email
      }
    }
    vehicle {
      id
      frame_id
      detail {
        id
        module {
          id
          hardware_type
          location {
            id
            latitude
            longitude
            time
            max_error
          }
        }
      }
    }
  }
`
export const JobDetailedFragmentDoc = gql`
  fragment JobDetailed on Job {
    ...JobBasic
    tasks {
      uuid
      details {
        title
        status
        description
        assignee {
          id
          email
        }
        notes
        task_codes_details {
          code
          reason
        }
      }
    }
    justifications {
      justification_id
      description
    }
    attempts {
      assignee {
        email
      }
      created_at
    }
  }
  ${JobBasicFragmentDoc}
`
export const ArchiveJobBasicFragmentDoc = gql`
  fragment ArchiveJobBasic on ArchiveJob {
    sys_id
    uuid
    details {
      taskId
      scheme {
        id
        name
      }
      notes
      status
      assignee {
        id
        email
      }
      isJustified
    }
    timestamps {
      created_at
      updated_at
    }
  }
`
export const ParkingPhotoFragmentDoc = gql`
  fragment ParkingPhoto on Journey {
    parking_photo {
      journey_id
      updated_at
      view {
        url
      }
    }
    parking_status
    vehicle_lock_state
    vehicle {
      id
      frame_id
    }
  }
`
export const JourneyStateResponseFragmentDoc = gql`
  fragment JourneyStateResponse on Journey {
    id
    is_complete
    is_error
    state {
      id
      message
      time
    }
  }
`
export const VehicleNodeFragmentDoc = gql`
  fragment VehicleNode on Vehicle {
    id
    frame_type
    frame_id
    rewards {
      type
    }
    hardware_type
    detail {
      id
      vehicle_unlock_id
      module {
        id
        is_present
        unlock_id
        location {
          id
          latitude
          longitude
          max_error
          time
        }
        lock_state {
          id
          time
          overall_state
          vehicle_lock_state
        }
        availability {
          id
          status
        }
        telemetry {
          id
          drive {
            estimated_range
          }
        }
      }
      scheme {
        id
        name
      }
    }
  }
`
export const JourneyMapFragmentDoc = gql`
  fragment JourneyMap on Journey {
    id
    route: route_V2
    vehicle {
      ...VehicleNode
    }
  }
  ${VehicleNodeFragmentDoc}
`
export const UserBasicFragmentDoc = gql`
  fragment UserBasic on User {
    id
    email
  }
`
export const SchemePickerFieldsFragmentDoc = gql`
  fragment SchemePickerFields on Scheme {
    id
    name
  }
`
export const FormattedAmountFragmentDoc = gql`
  fragment FormattedAmount on FormattedAmount {
    unit
    amount
    formatted_amount
    currency_code
  }
`
export const SchemePricingConfigsFragmentDoc = gql`
  fragment SchemePricingConfigs on SchemeAccounting {
    id
    scheme_pricing_configs {
      out_of_zone_parking_charge {
        ...FormattedAmount
      }
      out_of_service_area_parking_charge {
        ...FormattedAmount
      }
      undocked_in_zone_parking_charge {
        ...FormattedAmount
      }
      unlocked_vehicle_charge {
        ...FormattedAmount
      }
      rear_lock_unlocked_vehicle_charge {
        ...FormattedAmount
      }
      vehicle_not_permitted_in_zone_charge {
        ...FormattedAmount
      }
    }
  }
  ${FormattedAmountFragmentDoc}
`
export const SchemeConfigFragmentDoc = gql`
  fragment SchemeConfig on Scheme {
    id
    config {
      is_vehicle_rewards_enabled
      is_parking_photo_enabled
    }
    scheme_accounting {
      id
      ...SchemePricingConfigs
    }
  }
  ${SchemePricingConfigsFragmentDoc}
`
export const JourneyVehicleDetailsFragmentDoc = gql`
  fragment JourneyVehicleDetails on Journey {
    id
    vehicle {
      id
      propulsion_type
      frame_id
      frame_type
      detail {
        id
        lock_configuration
        module {
          id
          module_state {
            id
            ... on ModuleState {
              assist_config
            }
          }
        }
      }
    }
  }
`
export const JourneyPreviewFragmentDoc = gql`
  fragment JourneyPreview on Journey {
    id
    is_complete
    scheme {
      id
      name
      ...SchemeConfig
    }
    vehicle {
      frame_type
    }
    ...JourneyVehicleDetails
    state {
      id
      time
      message
    }
    user {
      id
    }
  }
  ${SchemeConfigFragmentDoc}
  ${JourneyVehicleDetailsFragmentDoc}
`
export const JourneySetBasicFragmentDoc = gql`
  fragment JourneySetBasic on JourneySet {
    id
    is_complete
    journey_count
    active_journey_count
    user {
      ...UserBasic
    }
    scheme {
      ...SchemePickerFields
    }
    journeys {
      ...JourneyPreview
    }
  }
  ${UserBasicFragmentDoc}
  ${SchemePickerFieldsFragmentDoc}
  ${JourneyPreviewFragmentDoc}
`
export const JourneySummaryFragmentDoc = gql`
  fragment JourneySummary on Journey {
    id
    ...JourneyPreview
    started_at
    completed_at
    distance_in_km: distance(unit: kilometre)
    distance_in_mi: distance(unit: mile)
    speed_in_km: speed(unit: kilometre)
    speed_in_mi: speed(unit: mile)
    is_complete
    is_error
    end_in_zone
    duration
    initiator
    initiator_app_name
    vehicle_docked
    docks_available
    parking_status
    possible_rewards {
      type
    }
    confirmed_rewards {
      type
    }
    vehicle_lock_state
    start_vehicle_battery_percent
    end_vehicle_battery_percent
    parking_photo {
      journey_id
      updated_at
    }
  }
  ${JourneyPreviewFragmentDoc}
`
export const JourneyHistoryFragmentDoc = gql`
  fragment JourneyHistory on Journey {
    id
    state_history(paginate: { per_page: 200 }) {
      nodes {
        id
        time
        message
      }
    }
  }
`
export const JourneySetDetailedFragmentDoc = gql`
  fragment JourneySetDetailed on JourneySet {
    ...JourneySetBasic
    journeys {
      ...JourneySummary
      ...JourneyHistory
    }
  }
  ${JourneySetBasicFragmentDoc}
  ${JourneySummaryFragmentDoc}
  ${JourneyHistoryFragmentDoc}
`
export const ModuleNodeFragmentDoc = gql`
  fragment ModuleNode on Module {
    id
    hardware_type
    is_present
    location {
      id
      latitude
      longitude
      max_error
      time
    }
    lock_state {
      id
      time
      overall_state
      vehicle_lock_state
    }
    vehicle {
      id
      frame_type
      rewards {
        type
      }
    }
  }
`
export const ModulesNodesFragmentDoc = gql`
  fragment ModulesNodes on ModuleConnection {
    nodes {
      id
      hardware_type
      is_present
      location {
        id
        latitude
        longitude
        max_error
        time
      }
      lock_state {
        id
        time
        overall_state
        vehicle_lock_state
      }
      vehicle {
        id
        frame_type
        rewards {
          type
        }
      }
    }
  }
`
export const ModuleBasicFragmentDoc = gql`
  fragment ModuleBasic on Module {
    id
    unlock_id
    hardware_type
    vehicle {
      id
      detail {
        id
        scheme {
          id
        }
      }
    }
  }
`
export const FullOTAFirmwareFragmentDoc = gql`
  fragment FullOTAFirmware on OTAFirmware {
    id
    file_name
    hardware_model
    hardware_version
    firmware_type
    firmware_version
    status
  }
`
export const FullOTAConfigurationCommandFragmentDoc = gql`
  fragment FullOTAConfigurationCommand on OTAConfigurationCommand {
    id
    name
    command
    expected_status_code
    hardware_model
    scheme_id
    timeout
  }
`
export const EditableProductFieldsFragmentDoc = gql`
  fragment EditableProductFields on SchemeProduct {
    name
    is_active
    is_protected
    is_discoverable
    role_whitelist
    fulfill_rewards
    validity_interval
    billable_journey_cap_sub_period
    billable_journey_cap
    availability
    quantity
    amount
    price {
      amount
      formatted_amount
    }
    display_category
    waive_out_of_zone_parking_charge
  }
`
export const ProductSummaryFragmentDoc = gql`
  fragment ProductSummary on SchemeProduct {
    id
    scheme_id
    product_type
    ...EditableProductFields
    scheme_accounting {
      id
      ...SchemePricingConfigs
    }
  }
  ${EditableProductFieldsFragmentDoc}
  ${SchemePricingConfigsFragmentDoc}
`
export const ProductDetailsFragmentDoc = gql`
  fragment ProductDetails on SchemeProduct {
    details {
      title
      sub_title
      image_variant
      benefit_sentence
      cta_text
      bullets
    }
  }
`
export const ProductVersionsFragmentDoc = gql`
  fragment ProductVersions on SchemeProduct {
    versions {
      version_id
      published_at
      user_id
      event
      user {
        email
      }
    }
  }
`
export const ProductConfigFragmentDoc = gql`
  fragment ProductConfig on SchemeProductConfig {
    charge_increment_duration
    journey_minutes_percent_off
    journey_minutes_included
    period_pass_max_minute_debit
    period_pass_sub_period_for_unlocks
    period_pass_unlocks_per_sub_period
    time_increment_cost {
      formatted_amount
      amount
    }
    time_increment_cost_weekend {
      formatted_amount
      amount
    }
    unlock_fee {
      formatted_amount
      amount
    }
  }
`
export const ProductConfigsFragmentDoc = gql`
  fragment ProductConfigs on SchemeProduct {
    configs_v3 {
      bike {
        ...ProductConfig
      }
      ebike {
        ...ProductConfig
      }
      escooter {
        ...ProductConfig
      }
      cargo_ebike {
        ...ProductConfig
      }
    }
  }
  ${ProductConfigFragmentDoc}
`
export const ValidationRuleFragmentDoc = gql`
  fragment ValidationRule on ValidationRule {
    id
    name
    logic
    created_at
    rules_list {
      name
      property
      conditions {
        ... on ValidationConditionIn {
          in
        }
        ... on ValidationConditionIs {
          is
        }
        ... on ValidationConditionLessThan {
          less_than
        }
        ... on ValidationConditionMoreThan {
          more_than
        }
        ... on ValidationConditionStartsWith {
          starts_with
        }
        ... on ValidationConditionEndsWith {
          ends_with
        }
        ... on ValidationConditionContains {
          contains
        }
        ... on ValidationConditionTimeframe {
          timeframe
        }
        ... on ValidationConditionTimeframeAbsolute {
          timeframe_absolute
        }
      }
    }
  }
`
export const CampaignSummaryFragmentDoc = gql`
  fragment CampaignSummary on CampaignSummary {
    id
    name
    type
    campaign_type
    active
    created_at
  }
`
export const ServiceAreaPolicyFragmentDoc = gql`
  fragment ServiceAreaPolicy on ServiceArea {
    service_area_type
    speed_limit
    is_parking_allowed
    is_visible
    effective_from
    effective_to
    applies_to
  }
`
export const PaginationFragmentDoc = gql`
  fragment Pagination on IConnection {
    pagination {
      current: page
      pageSize: per_page
      total
    }
  }
`
export const UserSummaryFieldsFragmentDoc = gql`
  fragment UserSummaryFields on User {
    ...UserBasic
    phone_number
    has_valid_licence
    is_over_18
    has_birthdate
    identity_checked_at
    deleted
    is_blocked
    persona_enrolled
    persona_enrolled_device
    onfido_applicant {
      id
    }
    driving_licence_check {
      id
    }
    roles {
      id
      scheme {
        id
        name
      }
      org {
        id
        name
      }
      type {
        id
        description
      }
    }
  }
  ${UserBasicFragmentDoc}
`
export const UserListItemFragmentDoc = gql`
  fragment UserListItem on User {
    id
    email
    has_valid_licence
    is_blocked
    roles {
      id
      scheme {
        id
        name
      }
      org {
        id
        name
      }
      type {
        id
        description
      }
    }
  }
`
export const UserListFragmentDoc = gql`
  fragment UserList on UserConnection {
    nodes {
      ...UserListItem
    }
    pagination {
      current: page
      pageSize: per_page
      total
    }
  }
  ${UserListItemFragmentDoc}
`
export const VehiclesNodesFragmentDoc = gql`
  fragment VehiclesNodes on VehicleConnection {
    nodes {
      ...VehicleNode
    }
  }
  ${VehicleNodeFragmentDoc}
`
export const VehicleLegendNodeFragmentDoc = gql`
  fragment VehicleLegendNode on Vehicle {
    ...VehicleNode
    detail {
      lock_configuration
      module {
        telemetry {
          drive {
            battery_percent
          }
        }
        tags {
          id
          name
          created_at
        }
        module_state {
          id
          ... on ModuleState {
            assist_config
            power_mode
          }
        }
        connectivity {
          is_online
        }
      }
    }
    rewards {
      type
    }
  }
  ${VehicleNodeFragmentDoc}
`
export const VehicleListFragmentDoc = gql`
  fragment VehicleList on VehicleConnection {
    nodes {
      id
      frame_id
      frame_type
      detail {
        lock_configuration
        scheme {
          id
        }
        vehicle_unlock_id
        module {
          id
          unlock_id
          hardware_type
          is_present
          lock_state {
            id
            overall_state
            vehicle_lock_state
          }
          iot_state @skip(if: $lean_query) {
            power_mode
            firmware_version
            id
          }
          telemetry @skip(if: $is_mobile) {
            id
            battery_percent
            fix_invalid
            drive {
              battery_percent
              estimated_range
            }
          }
          availability @skip(if: $is_mobile) {
            id
            status
          }
          connectivity @skip(if: $lean_query) {
            is_online
          }
        }
      }
    }
    pagination {
      current: page
      pageSize: per_page
      total
    }
  }
`
export const ZoneNodeFragmentDoc = gql`
  fragment ZoneNode on Zone {
    id
    name
    centre
    capacity
    geom
    is_suspended
    is_priority
    zone_type
    bikes: all_commissioned_vehicles_count(
      vehicle_type: bike
      propulsion_type: human
    )
    ebikes: all_commissioned_vehicles_count(
      vehicle_type: bike
      propulsion_type: electric_assist
    )
    scooters: all_commissioned_vehicles_count(
      vehicle_type: scooter
      propulsion_type: electric
    )
  }
`
export const ZoneStatusFragmentDoc = gql`
  fragment ZoneStatus on Zone {
    __typename
    id
    is_external
    is_promotional
    is_priority
    is_suspended
  }
`
export const ZoneHistoryChangesNodeFragmentDoc = gql`
  fragment ZoneHistoryChangesNode on ZoneHistoryChanges {
    id
    capacity
    external_id
    name
    notes
    permitted_vehicles
    time
    zone_id
    zone_type
    is_suspended
    is_promotional
    is_priority
    current_suspension {
      author_id
      id
      notes
      reason
      scheme_id
    }
  }
`
export const ZoneNameFragmentDoc = gql`
  fragment ZoneName on Zone {
    __typename
    id
    name
    scheme {
      __typename
      id
      name
    }
  }
`
export const ZoneInfoFragmentDoc = gql`
  fragment ZoneInfo on Zone {
    id
    ...ZoneName
    centre
    capacity
    geom
    zone_type
    bikes: all_commissioned_vehicles_count(
      vehicle_type: bike
      propulsion_type: human
    )
    ebikes: all_commissioned_vehicles_count(
      vehicle_type: bike
      propulsion_type: electric_assist
    )
    scooters: all_commissioned_vehicles_count(
      vehicle_type: scooter
      propulsion_type: electric
    )
  }
  ${ZoneNameFragmentDoc}
`
export const ZoneCurrentSuspensionFragmentDoc = gql`
  fragment ZoneCurrentSuspension on Zone {
    current_suspension {
      author_id
      id
      notes
      reason
      scheme_id
    }
  }
`
export const ZoneScheduledSuspensionsFragmentDoc = gql`
  fragment ZoneScheduledSuspensions on Zone {
    scheduled_suspensions(paginate: { page: 1, per_page: 10 }) {
      nodes {
        reason
        notes
        start_time
        end_time
        schedule_status
        status_updated_at
        author_id
      }
      pagination {
        page
        pages
      }
    }
  }
`
export const FirstZoneScheduledSuspensionFragmentDoc = gql`
  fragment FirstZoneScheduledSuspension on Zone {
    scheduled_suspensions(paginate: { page: 1, per_page: 1 }) {
      nodes {
        id
      }
    }
  }
`
export function useAddonSummaryFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<AddonSummaryFragment>({
    fragment: AddonSummaryFragmentDoc,
    fragmentName: 'AddonSummary',
    from: {
      __typename: 'SchemeAddon',
      ...identifiers,
    },
  })
}
export type AddonSummaryFragmentHookResult = ReturnType<
  typeof useAddonSummaryFragment
>
export function useEditableAddonFieldsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<EditableAddonFieldsFragment>({
    fragment: EditableAddonFieldsFragmentDoc,
    fragmentName: 'EditableAddonFields',
    from: {
      __typename: 'SchemeAddon',
      ...identifiers,
    },
  })
}
export type EditableAddonFieldsFragmentHookResult = ReturnType<
  typeof useEditableAddonFieldsFragment
>
export function useAvailabilityRestrictionDataFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<AvailabilityRestrictionDataFragment>({
    fragment: AvailabilityRestrictionDataFragmentDoc,
    fragmentName: 'AvailabilityRestrictionData',
    from: {
      __typename: 'SchemeAvailabilityRestriction',
      ...identifiers,
    },
  })
}
export type AvailabilityRestrictionDataFragmentHookResult = ReturnType<
  typeof useAvailabilityRestrictionDataFragment
>
export function useFormattedAmountFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<FormattedAmountFragment>({
    fragment: FormattedAmountFragmentDoc,
    fragmentName: 'FormattedAmount',
    from: {
      __typename: 'FormattedAmount',
      ...identifiers,
    },
  })
}
export type FormattedAmountFragmentHookResult = ReturnType<
  typeof useFormattedAmountFragment
>
export function useAssigmentGroupFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<AssigmentGroupFragment>({
    fragment: AssigmentGroupFragmentDoc,
    fragmentName: 'AssigmentGroup',
    from: {
      __typename: 'JobTypesAssignmentGroup',
      ...identifiers,
    },
  })
}
export type AssigmentGroupFragmentHookResult = ReturnType<
  typeof useAssigmentGroupFragment
>
export function useJobBasicFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JobBasicFragment>({
    fragment: JobBasicFragmentDoc,
    fragmentName: 'JobBasic',
    from: {
      __typename: 'Job',
      ...identifiers,
    },
  })
}
export type JobBasicFragmentHookResult = ReturnType<typeof useJobBasicFragment>
export function useJobDetailedFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JobDetailedFragment>({
    fragment: JobDetailedFragmentDoc,
    fragmentName: 'JobDetailed',
    from: {
      __typename: 'Job',
      ...identifiers,
    },
  })
}
export type JobDetailedFragmentHookResult = ReturnType<
  typeof useJobDetailedFragment
>
export function useArchiveJobBasicFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ArchiveJobBasicFragment>({
    fragment: ArchiveJobBasicFragmentDoc,
    fragmentName: 'ArchiveJobBasic',
    from: {
      __typename: 'ArchiveJob',
      ...identifiers,
    },
  })
}
export type ArchiveJobBasicFragmentHookResult = ReturnType<
  typeof useArchiveJobBasicFragment
>
export function useParkingPhotoFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ParkingPhotoFragment>({
    fragment: ParkingPhotoFragmentDoc,
    fragmentName: 'ParkingPhoto',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type ParkingPhotoFragmentHookResult = ReturnType<
  typeof useParkingPhotoFragment
>
export function useJourneyStateResponseFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<JourneyStateResponseFragment>({
    fragment: JourneyStateResponseFragmentDoc,
    fragmentName: 'JourneyStateResponse',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type JourneyStateResponseFragmentHookResult = ReturnType<
  typeof useJourneyStateResponseFragment
>
export function useJourneyMapFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JourneyMapFragment>({
    fragment: JourneyMapFragmentDoc,
    fragmentName: 'JourneyMap',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type JourneyMapFragmentHookResult = ReturnType<
  typeof useJourneyMapFragment
>
export function useJourneySetBasicFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JourneySetBasicFragment>({
    fragment: JourneySetBasicFragmentDoc,
    fragmentName: 'JourneySetBasic',
    from: {
      __typename: 'JourneySet',
      ...identifiers,
    },
  })
}
export type JourneySetBasicFragmentHookResult = ReturnType<
  typeof useJourneySetBasicFragment
>
export function useJourneySetDetailedFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<JourneySetDetailedFragment>({
    fragment: JourneySetDetailedFragmentDoc,
    fragmentName: 'JourneySetDetailed',
    from: {
      __typename: 'JourneySet',
      ...identifiers,
    },
  })
}
export type JourneySetDetailedFragmentHookResult = ReturnType<
  typeof useJourneySetDetailedFragment
>
export function useJourneyVehicleDetailsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<JourneyVehicleDetailsFragment>({
    fragment: JourneyVehicleDetailsFragmentDoc,
    fragmentName: 'JourneyVehicleDetails',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type JourneyVehicleDetailsFragmentHookResult = ReturnType<
  typeof useJourneyVehicleDetailsFragment
>
export function useJourneyPreviewFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JourneyPreviewFragment>({
    fragment: JourneyPreviewFragmentDoc,
    fragmentName: 'JourneyPreview',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type JourneyPreviewFragmentHookResult = ReturnType<
  typeof useJourneyPreviewFragment
>
export function useJourneySummaryFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JourneySummaryFragment>({
    fragment: JourneySummaryFragmentDoc,
    fragmentName: 'JourneySummary',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type JourneySummaryFragmentHookResult = ReturnType<
  typeof useJourneySummaryFragment
>
export function useJourneyHistoryFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<JourneyHistoryFragment>({
    fragment: JourneyHistoryFragmentDoc,
    fragmentName: 'JourneyHistory',
    from: {
      __typename: 'Journey',
      ...identifiers,
    },
  })
}
export type JourneyHistoryFragmentHookResult = ReturnType<
  typeof useJourneyHistoryFragment
>
export function useModuleNodeFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ModuleNodeFragment>({
    fragment: ModuleNodeFragmentDoc,
    fragmentName: 'ModuleNode',
    from: {
      __typename: 'Module',
      ...identifiers,
    },
  })
}
export type ModuleNodeFragmentHookResult = ReturnType<
  typeof useModuleNodeFragment
>
export function useModulesNodesFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ModulesNodesFragment>({
    fragment: ModulesNodesFragmentDoc,
    fragmentName: 'ModulesNodes',
    from: {
      __typename: 'ModuleConnection',
      ...identifiers,
    },
  })
}
export type ModulesNodesFragmentHookResult = ReturnType<
  typeof useModulesNodesFragment
>
export function useModuleBasicFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ModuleBasicFragment>({
    fragment: ModuleBasicFragmentDoc,
    fragmentName: 'ModuleBasic',
    from: {
      __typename: 'Module',
      ...identifiers,
    },
  })
}
export type ModuleBasicFragmentHookResult = ReturnType<
  typeof useModuleBasicFragment
>
export function useFullOTAFirmwareFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<FullOTAFirmwareFragment>({
    fragment: FullOTAFirmwareFragmentDoc,
    fragmentName: 'FullOTAFirmware',
    from: {
      __typename: 'OTAFirmware',
      ...identifiers,
    },
  })
}
export type FullOTAFirmwareFragmentHookResult = ReturnType<
  typeof useFullOTAFirmwareFragment
>
export function useFullOTAConfigurationCommandFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<FullOTAConfigurationCommandFragment>({
    fragment: FullOTAConfigurationCommandFragmentDoc,
    fragmentName: 'FullOTAConfigurationCommand',
    from: {
      __typename: 'OTAConfigurationCommand',
      ...identifiers,
    },
  })
}
export type FullOTAConfigurationCommandFragmentHookResult = ReturnType<
  typeof useFullOTAConfigurationCommandFragment
>
export function useProductSummaryFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ProductSummaryFragment>({
    fragment: ProductSummaryFragmentDoc,
    fragmentName: 'ProductSummary',
    from: {
      __typename: 'SchemeProduct',
      ...identifiers,
    },
  })
}
export type ProductSummaryFragmentHookResult = ReturnType<
  typeof useProductSummaryFragment
>
export function useEditableProductFieldsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<EditableProductFieldsFragment>({
    fragment: EditableProductFieldsFragmentDoc,
    fragmentName: 'EditableProductFields',
    from: {
      __typename: 'SchemeProduct',
      ...identifiers,
    },
  })
}
export type EditableProductFieldsFragmentHookResult = ReturnType<
  typeof useEditableProductFieldsFragment
>
export function useProductDetailsFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ProductDetailsFragment>({
    fragment: ProductDetailsFragmentDoc,
    fragmentName: 'ProductDetails',
    from: {
      __typename: 'SchemeProduct',
      ...identifiers,
    },
  })
}
export type ProductDetailsFragmentHookResult = ReturnType<
  typeof useProductDetailsFragment
>
export function useProductVersionsFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ProductVersionsFragment>({
    fragment: ProductVersionsFragmentDoc,
    fragmentName: 'ProductVersions',
    from: {
      __typename: 'SchemeProduct',
      ...identifiers,
    },
  })
}
export type ProductVersionsFragmentHookResult = ReturnType<
  typeof useProductVersionsFragment
>
export function useProductConfigsFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ProductConfigsFragment>({
    fragment: ProductConfigsFragmentDoc,
    fragmentName: 'ProductConfigs',
    from: {
      __typename: 'SchemeProduct',
      ...identifiers,
    },
  })
}
export type ProductConfigsFragmentHookResult = ReturnType<
  typeof useProductConfigsFragment
>
export function useProductConfigFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ProductConfigFragment>({
    fragment: ProductConfigFragmentDoc,
    fragmentName: 'ProductConfig',
    from: {
      __typename: 'SchemeProductConfig',
      ...identifiers,
    },
  })
}
export type ProductConfigFragmentHookResult = ReturnType<
  typeof useProductConfigFragment
>
export function useValidationRuleFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ValidationRuleFragment>({
    fragment: ValidationRuleFragmentDoc,
    fragmentName: 'ValidationRule',
    from: {
      __typename: 'ValidationRule',
      ...identifiers,
    },
  })
}
export type ValidationRuleFragmentHookResult = ReturnType<
  typeof useValidationRuleFragment
>
export function useCampaignSummaryFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<CampaignSummaryFragment>({
    fragment: CampaignSummaryFragmentDoc,
    fragmentName: 'CampaignSummary',
    from: {
      __typename: 'CampaignSummary',
      ...identifiers,
    },
  })
}
export type CampaignSummaryFragmentHookResult = ReturnType<
  typeof useCampaignSummaryFragment
>
export function useSchemePickerFieldsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<SchemePickerFieldsFragment>({
    fragment: SchemePickerFieldsFragmentDoc,
    fragmentName: 'SchemePickerFields',
    from: {
      __typename: 'Scheme',
      ...identifiers,
    },
  })
}
export type SchemePickerFieldsFragmentHookResult = ReturnType<
  typeof useSchemePickerFieldsFragment
>
export function useSchemeConfigFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<SchemeConfigFragment>({
    fragment: SchemeConfigFragmentDoc,
    fragmentName: 'SchemeConfig',
    from: {
      __typename: 'Scheme',
      ...identifiers,
    },
  })
}
export type SchemeConfigFragmentHookResult = ReturnType<
  typeof useSchemeConfigFragment
>
export function useSchemePricingConfigsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<SchemePricingConfigsFragment>({
    fragment: SchemePricingConfigsFragmentDoc,
    fragmentName: 'SchemePricingConfigs',
    from: {
      __typename: 'SchemeAccounting',
      ...identifiers,
    },
  })
}
export type SchemePricingConfigsFragmentHookResult = ReturnType<
  typeof useSchemePricingConfigsFragment
>
export function useServiceAreaPolicyFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<ServiceAreaPolicyFragment>({
    fragment: ServiceAreaPolicyFragmentDoc,
    fragmentName: 'ServiceAreaPolicy',
    from: {
      __typename: 'ServiceArea',
      ...identifiers,
    },
  })
}
export type ServiceAreaPolicyFragmentHookResult = ReturnType<
  typeof useServiceAreaPolicyFragment
>
export function usePaginationFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<PaginationFragment>({
    fragment: PaginationFragmentDoc,
    fragmentName: 'Pagination',
    from: {
      __typename: 'IConnection',
      ...identifiers,
    },
  })
}
export type PaginationFragmentHookResult = ReturnType<
  typeof usePaginationFragment
>
export function useUserBasicFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<UserBasicFragment>({
    fragment: UserBasicFragmentDoc,
    fragmentName: 'UserBasic',
    from: {
      __typename: 'User',
      ...identifiers,
    },
  })
}
export type UserBasicFragmentHookResult = ReturnType<
  typeof useUserBasicFragment
>
export function useUserSummaryFieldsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<UserSummaryFieldsFragment>({
    fragment: UserSummaryFieldsFragmentDoc,
    fragmentName: 'UserSummaryFields',
    from: {
      __typename: 'User',
      ...identifiers,
    },
  })
}
export type UserSummaryFieldsFragmentHookResult = ReturnType<
  typeof useUserSummaryFieldsFragment
>
export function useUserListFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<UserListFragment>({
    fragment: UserListFragmentDoc,
    fragmentName: 'UserList',
    from: {
      __typename: 'UserConnection',
      ...identifiers,
    },
  })
}
export type UserListFragmentHookResult = ReturnType<typeof useUserListFragment>
export function useUserListItemFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<UserListItemFragment>({
    fragment: UserListItemFragmentDoc,
    fragmentName: 'UserListItem',
    from: {
      __typename: 'User',
      ...identifiers,
    },
  })
}
export type UserListItemFragmentHookResult = ReturnType<
  typeof useUserListItemFragment
>
export function useVehiclesNodesFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<VehiclesNodesFragment>({
    fragment: VehiclesNodesFragmentDoc,
    fragmentName: 'VehiclesNodes',
    from: {
      __typename: 'VehicleConnection',
      ...identifiers,
    },
  })
}
export type VehiclesNodesFragmentHookResult = ReturnType<
  typeof useVehiclesNodesFragment
>
export function useVehicleNodeFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<VehicleNodeFragment>({
    fragment: VehicleNodeFragmentDoc,
    fragmentName: 'VehicleNode',
    from: {
      __typename: 'Vehicle',
      ...identifiers,
    },
  })
}
export type VehicleNodeFragmentHookResult = ReturnType<
  typeof useVehicleNodeFragment
>
export function useVehicleLegendNodeFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<VehicleLegendNodeFragment>({
    fragment: VehicleLegendNodeFragmentDoc,
    fragmentName: 'VehicleLegendNode',
    from: {
      __typename: 'Vehicle',
      ...identifiers,
    },
  })
}
export type VehicleLegendNodeFragmentHookResult = ReturnType<
  typeof useVehicleLegendNodeFragment
>
export function useVehicleListFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<VehicleListFragment>({
    fragment: VehicleListFragmentDoc,
    fragmentName: 'VehicleList',
    from: {
      __typename: 'VehicleConnection',
      ...identifiers,
    },
  })
}
export type VehicleListFragmentHookResult = ReturnType<
  typeof useVehicleListFragment
>
export function useZoneNodeFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ZoneNodeFragment>({
    fragment: ZoneNodeFragmentDoc,
    fragmentName: 'ZoneNode',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type ZoneNodeFragmentHookResult = ReturnType<typeof useZoneNodeFragment>
export function useZoneStatusFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ZoneStatusFragment>({
    fragment: ZoneStatusFragmentDoc,
    fragmentName: 'ZoneStatus',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type ZoneStatusFragmentHookResult = ReturnType<
  typeof useZoneStatusFragment
>
export function useZoneHistoryChangesNodeFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<ZoneHistoryChangesNodeFragment>({
    fragment: ZoneHistoryChangesNodeFragmentDoc,
    fragmentName: 'ZoneHistoryChangesNode',
    from: {
      __typename: 'ZoneHistoryChanges',
      ...identifiers,
    },
  })
}
export type ZoneHistoryChangesNodeFragmentHookResult = ReturnType<
  typeof useZoneHistoryChangesNodeFragment
>
export function useZoneInfoFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ZoneInfoFragment>({
    fragment: ZoneInfoFragmentDoc,
    fragmentName: 'ZoneInfo',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type ZoneInfoFragmentHookResult = ReturnType<typeof useZoneInfoFragment>
export function useZoneNameFragment<F = { id: string }>(identifiers: F) {
  return Apollo.useFragment<ZoneNameFragment>({
    fragment: ZoneNameFragmentDoc,
    fragmentName: 'ZoneName',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type ZoneNameFragmentHookResult = ReturnType<typeof useZoneNameFragment>
export function useZoneCurrentSuspensionFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<ZoneCurrentSuspensionFragment>({
    fragment: ZoneCurrentSuspensionFragmentDoc,
    fragmentName: 'ZoneCurrentSuspension',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type ZoneCurrentSuspensionFragmentHookResult = ReturnType<
  typeof useZoneCurrentSuspensionFragment
>
export function useZoneScheduledSuspensionsFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<ZoneScheduledSuspensionsFragment>({
    fragment: ZoneScheduledSuspensionsFragmentDoc,
    fragmentName: 'ZoneScheduledSuspensions',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type ZoneScheduledSuspensionsFragmentHookResult = ReturnType<
  typeof useZoneScheduledSuspensionsFragment
>
export function useFirstZoneScheduledSuspensionFragment<F = { id: string }>(
  identifiers: F,
) {
  return Apollo.useFragment<FirstZoneScheduledSuspensionFragment>({
    fragment: FirstZoneScheduledSuspensionFragmentDoc,
    fragmentName: 'FirstZoneScheduledSuspension',
    from: {
      __typename: 'Zone',
      ...identifiers,
    },
  })
}
export type FirstZoneScheduledSuspensionFragmentHookResult = ReturnType<
  typeof useFirstZoneScheduledSuspensionFragment
>
export const SchemeAddonListDocument = gql`
  query SchemeAddonList($scheme_id: ID!, $paginate: Paginate) {
    table: all_scheme_addons(scheme_id: $scheme_id, paginate: $paginate) {
      nodes {
        ...AddonSummary
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
    role_types {
      description
    }
  }
  ${AddonSummaryFragmentDoc}
`

/**
 * __useSchemeAddonListQuery__
 *
 * To run a query within a React component, call `useSchemeAddonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeAddonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeAddonListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useSchemeAddonListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeAddonListQuery,
    SchemeAddonListQueryVariables
  > &
    (
      | { variables: SchemeAddonListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchemeAddonListQuery, SchemeAddonListQueryVariables>(
    SchemeAddonListDocument,
    options,
  )
}
export function useSchemeAddonListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeAddonListQuery,
    SchemeAddonListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemeAddonListQuery,
    SchemeAddonListQueryVariables
  >(SchemeAddonListDocument, options)
}
// @ts-ignore
export function useSchemeAddonListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeAddonListQuery,
    SchemeAddonListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeAddonListQuery,
  SchemeAddonListQueryVariables
>
export function useSchemeAddonListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeAddonListQuery,
        SchemeAddonListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeAddonListQuery | undefined,
  SchemeAddonListQueryVariables
>
export function useSchemeAddonListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeAddonListQuery,
        SchemeAddonListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeAddonListQuery,
    SchemeAddonListQueryVariables
  >(SchemeAddonListDocument, options)
}
export type SchemeAddonListQueryHookResult = ReturnType<
  typeof useSchemeAddonListQuery
>
export type SchemeAddonListLazyQueryHookResult = ReturnType<
  typeof useSchemeAddonListLazyQuery
>
export type SchemeAddonListSuspenseQueryHookResult = ReturnType<
  typeof useSchemeAddonListSuspenseQuery
>
export type SchemeAddonListQueryResult = Apollo.QueryResult<
  SchemeAddonListQuery,
  SchemeAddonListQueryVariables
>
export const SchemeAddonDocument = gql`
  query SchemeAddon($schemeAddonId: ID!) {
    scheme_addon(scheme_addon_id: $schemeAddonId) {
      ...AddonSummary
    }
  }
  ${AddonSummaryFragmentDoc}
`

/**
 * __useSchemeAddonQuery__
 *
 * To run a query within a React component, call `useSchemeAddonQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeAddonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeAddonQuery({
 *   variables: {
 *      schemeAddonId: // value for 'schemeAddonId'
 *   },
 * });
 */
export function useSchemeAddonQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeAddonQuery,
    SchemeAddonQueryVariables
  > &
    (
      | { variables: SchemeAddonQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchemeAddonQuery, SchemeAddonQueryVariables>(
    SchemeAddonDocument,
    options,
  )
}
export function useSchemeAddonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeAddonQuery,
    SchemeAddonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SchemeAddonQuery, SchemeAddonQueryVariables>(
    SchemeAddonDocument,
    options,
  )
}
// @ts-ignore
export function useSchemeAddonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeAddonQuery,
    SchemeAddonQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SchemeAddonQuery, SchemeAddonQueryVariables>
export function useSchemeAddonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeAddonQuery,
        SchemeAddonQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeAddonQuery | undefined,
  SchemeAddonQueryVariables
>
export function useSchemeAddonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeAddonQuery,
        SchemeAddonQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SchemeAddonQuery, SchemeAddonQueryVariables>(
    SchemeAddonDocument,
    options,
  )
}
export type SchemeAddonQueryHookResult = ReturnType<typeof useSchemeAddonQuery>
export type SchemeAddonLazyQueryHookResult = ReturnType<
  typeof useSchemeAddonLazyQuery
>
export type SchemeAddonSuspenseQueryHookResult = ReturnType<
  typeof useSchemeAddonSuspenseQuery
>
export type SchemeAddonQueryResult = Apollo.QueryResult<
  SchemeAddonQuery,
  SchemeAddonQueryVariables
>
export const UserAddonListDocument = gql`
  query UserAddonList($scheme_id: ID, $user_id: ID!, $paginate: Paginate) {
    user(user_id: $user_id) {
      id
      table: user_addons(scheme_id: $scheme_id, paginate: $paginate) {
        nodes {
          id
          valid_until
          created_at
          scheme_addon {
            id
            name
            addon_type
            scheme_id
          }
        }
        pagination {
          current: page
          pageSize: per_page
          total
        }
      }
    }
  }
`

/**
 * __useUserAddonListQuery__
 *
 * To run a query within a React component, call `useUserAddonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddonListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      user_id: // value for 'user_id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useUserAddonListQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserAddonListQuery,
    UserAddonListQueryVariables
  > &
    (
      | { variables: UserAddonListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserAddonListQuery, UserAddonListQueryVariables>(
    UserAddonListDocument,
    options,
  )
}
export function useUserAddonListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserAddonListQuery,
    UserAddonListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserAddonListQuery, UserAddonListQueryVariables>(
    UserAddonListDocument,
    options,
  )
}
// @ts-ignore
export function useUserAddonListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserAddonListQuery,
    UserAddonListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserAddonListQuery,
  UserAddonListQueryVariables
>
export function useUserAddonListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserAddonListQuery,
        UserAddonListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserAddonListQuery | undefined,
  UserAddonListQueryVariables
>
export function useUserAddonListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserAddonListQuery,
        UserAddonListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserAddonListQuery,
    UserAddonListQueryVariables
  >(UserAddonListDocument, options)
}
export type UserAddonListQueryHookResult = ReturnType<
  typeof useUserAddonListQuery
>
export type UserAddonListLazyQueryHookResult = ReturnType<
  typeof useUserAddonListLazyQuery
>
export type UserAddonListSuspenseQueryHookResult = ReturnType<
  typeof useUserAddonListSuspenseQuery
>
export type UserAddonListQueryResult = Apollo.QueryResult<
  UserAddonListQuery,
  UserAddonListQueryVariables
>
export const UpdateSchemeAddonDocument = gql`
  mutation UpdateSchemeAddon(
    $schemeAddonId: ID!
    $schemeAddonInput: SchemeAddonInput!
  ) {
    update_scheme_addon(
      scheme_addon_id: $schemeAddonId
      scheme_addon: $schemeAddonInput
    ) {
      id
    }
  }
`
export type UpdateSchemeAddonMutationFn = Apollo.MutationFunction<
  UpdateSchemeAddonMutation,
  UpdateSchemeAddonMutationVariables
>

/**
 * __useUpdateSchemeAddonMutation__
 *
 * To run a mutation, you first call `useUpdateSchemeAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemeAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchemeAddonMutation, { data, loading, error }] = useUpdateSchemeAddonMutation({
 *   variables: {
 *      schemeAddonId: // value for 'schemeAddonId'
 *      schemeAddonInput: // value for 'schemeAddonInput'
 *   },
 * });
 */
export function useUpdateSchemeAddonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchemeAddonMutation,
    UpdateSchemeAddonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchemeAddonMutation,
    UpdateSchemeAddonMutationVariables
  >(UpdateSchemeAddonDocument, options)
}
export type UpdateSchemeAddonMutationHookResult = ReturnType<
  typeof useUpdateSchemeAddonMutation
>
export type UpdateSchemeAddonMutationResult =
  Apollo.MutationResult<UpdateSchemeAddonMutation>
export type UpdateSchemeAddonMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchemeAddonMutation,
  UpdateSchemeAddonMutationVariables
>
export const CreateSchemeAddonDocument = gql`
  mutation CreateSchemeAddon($schemeAddonInput: SchemeAddonInput!) {
    add_scheme_addon(scheme_addon: $schemeAddonInput) {
      id
    }
  }
`
export type CreateSchemeAddonMutationFn = Apollo.MutationFunction<
  CreateSchemeAddonMutation,
  CreateSchemeAddonMutationVariables
>

/**
 * __useCreateSchemeAddonMutation__
 *
 * To run a mutation, you first call `useCreateSchemeAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemeAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemeAddonMutation, { data, loading, error }] = useCreateSchemeAddonMutation({
 *   variables: {
 *      schemeAddonInput: // value for 'schemeAddonInput'
 *   },
 * });
 */
export function useCreateSchemeAddonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchemeAddonMutation,
    CreateSchemeAddonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSchemeAddonMutation,
    CreateSchemeAddonMutationVariables
  >(CreateSchemeAddonDocument, options)
}
export type CreateSchemeAddonMutationHookResult = ReturnType<
  typeof useCreateSchemeAddonMutation
>
export type CreateSchemeAddonMutationResult =
  Apollo.MutationResult<CreateSchemeAddonMutation>
export type CreateSchemeAddonMutationOptions = Apollo.BaseMutationOptions<
  CreateSchemeAddonMutation,
  CreateSchemeAddonMutationVariables
>
export const DeleteSchemeAddonDocument = gql`
  mutation DeleteSchemeAddon($schemeAddonId: ID!) {
    remove_scheme_addon(scheme_addon_id: $schemeAddonId)
  }
`
export type DeleteSchemeAddonMutationFn = Apollo.MutationFunction<
  DeleteSchemeAddonMutation,
  DeleteSchemeAddonMutationVariables
>

/**
 * __useDeleteSchemeAddonMutation__
 *
 * To run a mutation, you first call `useDeleteSchemeAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemeAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemeAddonMutation, { data, loading, error }] = useDeleteSchemeAddonMutation({
 *   variables: {
 *      schemeAddonId: // value for 'schemeAddonId'
 *   },
 * });
 */
export function useDeleteSchemeAddonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSchemeAddonMutation,
    DeleteSchemeAddonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteSchemeAddonMutation,
    DeleteSchemeAddonMutationVariables
  >(DeleteSchemeAddonDocument, options)
}
export type DeleteSchemeAddonMutationHookResult = ReturnType<
  typeof useDeleteSchemeAddonMutation
>
export type DeleteSchemeAddonMutationResult =
  Apollo.MutationResult<DeleteSchemeAddonMutation>
export type DeleteSchemeAddonMutationOptions = Apollo.BaseMutationOptions<
  DeleteSchemeAddonMutation,
  DeleteSchemeAddonMutationVariables
>
export const AutomationFlowsDocument = gql`
  query AutomationFlows {
    sourced_automation_flows {
      id
      tags
      dry_run
      source {
        table_name
        filters {
          not__
          entries
          filter_type
        }
        source_type
      }
      configuration {
        ... on JobAutomationFlowConfiguration {
          task_id
          description
          side_effects
          use_cleanup
        }
        ... on ActionAutomationFlowConfiguration {
          mutation
          mutation_name
          mutation_function_call
        }
        ... on PublishAutomationFlowConfiguration {
          topic_name
          eventType
          message_data
        }
      }
    }
  }
`

/**
 * __useAutomationFlowsQuery__
 *
 * To run a query within a React component, call `useAutomationFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationFlowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomationFlowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AutomationFlowsQuery,
    AutomationFlowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AutomationFlowsQuery, AutomationFlowsQueryVariables>(
    AutomationFlowsDocument,
    options,
  )
}
export function useAutomationFlowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AutomationFlowsQuery,
    AutomationFlowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AutomationFlowsQuery,
    AutomationFlowsQueryVariables
  >(AutomationFlowsDocument, options)
}
// @ts-ignore
export function useAutomationFlowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AutomationFlowsQuery,
    AutomationFlowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AutomationFlowsQuery,
  AutomationFlowsQueryVariables
>
export function useAutomationFlowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AutomationFlowsQuery,
        AutomationFlowsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AutomationFlowsQuery | undefined,
  AutomationFlowsQueryVariables
>
export function useAutomationFlowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AutomationFlowsQuery,
        AutomationFlowsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AutomationFlowsQuery,
    AutomationFlowsQueryVariables
  >(AutomationFlowsDocument, options)
}
export type AutomationFlowsQueryHookResult = ReturnType<
  typeof useAutomationFlowsQuery
>
export type AutomationFlowsLazyQueryHookResult = ReturnType<
  typeof useAutomationFlowsLazyQuery
>
export type AutomationFlowsSuspenseQueryHookResult = ReturnType<
  typeof useAutomationFlowsSuspenseQuery
>
export type AutomationFlowsQueryResult = Apollo.QueryResult<
  AutomationFlowsQuery,
  AutomationFlowsQueryVariables
>
export const DashboardAutomationsDocument = gql`
  query DashboardAutomations($filters: AutomationFilters) {
    automations(filters: $filters) {
      justification_id
      description
      taskId
      side_effects
      jobs {
        uuid
        frame_id
        scheme_id
        created_at
      }
    }
  }
`

/**
 * __useDashboardAutomationsQuery__
 *
 * To run a query within a React component, call `useDashboardAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAutomationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDashboardAutomationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardAutomationsQuery,
    DashboardAutomationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DashboardAutomationsQuery,
    DashboardAutomationsQueryVariables
  >(DashboardAutomationsDocument, options)
}
export function useDashboardAutomationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardAutomationsQuery,
    DashboardAutomationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DashboardAutomationsQuery,
    DashboardAutomationsQueryVariables
  >(DashboardAutomationsDocument, options)
}
// @ts-ignore
export function useDashboardAutomationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DashboardAutomationsQuery,
    DashboardAutomationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DashboardAutomationsQuery,
  DashboardAutomationsQueryVariables
>
export function useDashboardAutomationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DashboardAutomationsQuery,
        DashboardAutomationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DashboardAutomationsQuery | undefined,
  DashboardAutomationsQueryVariables
>
export function useDashboardAutomationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DashboardAutomationsQuery,
        DashboardAutomationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DashboardAutomationsQuery,
    DashboardAutomationsQueryVariables
  >(DashboardAutomationsDocument, options)
}
export type DashboardAutomationsQueryHookResult = ReturnType<
  typeof useDashboardAutomationsQuery
>
export type DashboardAutomationsLazyQueryHookResult = ReturnType<
  typeof useDashboardAutomationsLazyQuery
>
export type DashboardAutomationsSuspenseQueryHookResult = ReturnType<
  typeof useDashboardAutomationsSuspenseQuery
>
export type DashboardAutomationsQueryResult = Apollo.QueryResult<
  DashboardAutomationsQuery,
  DashboardAutomationsQueryVariables
>
export const TriggerDashboardAutomationDocument = gql`
  mutation TriggerDashboardAutomation(
    $justification_id: String!
    $description: String!
    $taskId: String!
    $side_effects: [JobAutomationSideEffect!]!
    $results: [JobAutomationVehicleInput!]!
    $dry_run: Boolean!
  ) {
    job_automation(
      justification_id: $justification_id
      description: $description
      taskId: $taskId
      side_effects: $side_effects
      results: $results
      dry_run: $dry_run
    )
  }
`
export type TriggerDashboardAutomationMutationFn = Apollo.MutationFunction<
  TriggerDashboardAutomationMutation,
  TriggerDashboardAutomationMutationVariables
>

/**
 * __useTriggerDashboardAutomationMutation__
 *
 * To run a mutation, you first call `useTriggerDashboardAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDashboardAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDashboardAutomationMutation, { data, loading, error }] = useTriggerDashboardAutomationMutation({
 *   variables: {
 *      justification_id: // value for 'justification_id'
 *      description: // value for 'description'
 *      taskId: // value for 'taskId'
 *      side_effects: // value for 'side_effects'
 *      results: // value for 'results'
 *      dry_run: // value for 'dry_run'
 *   },
 * });
 */
export function useTriggerDashboardAutomationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerDashboardAutomationMutation,
    TriggerDashboardAutomationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TriggerDashboardAutomationMutation,
    TriggerDashboardAutomationMutationVariables
  >(TriggerDashboardAutomationDocument, options)
}
export type TriggerDashboardAutomationMutationHookResult = ReturnType<
  typeof useTriggerDashboardAutomationMutation
>
export type TriggerDashboardAutomationMutationResult =
  Apollo.MutationResult<TriggerDashboardAutomationMutation>
export type TriggerDashboardAutomationMutationOptions =
  Apollo.BaseMutationOptions<
    TriggerDashboardAutomationMutation,
    TriggerDashboardAutomationMutationVariables
  >
export const SchemeAvailabilityRestrictionsDocument = gql`
  query SchemeAvailabilityRestrictions($schemeId: ID!) {
    scheme(scheme_id: $schemeId) {
      id
      availability_restriction {
        nodes {
          ...AvailabilityRestrictionData
        }
      }
    }
  }
  ${AvailabilityRestrictionDataFragmentDoc}
`

/**
 * __useSchemeAvailabilityRestrictionsQuery__
 *
 * To run a query within a React component, call `useSchemeAvailabilityRestrictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeAvailabilityRestrictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeAvailabilityRestrictionsQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useSchemeAvailabilityRestrictionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeAvailabilityRestrictionsQuery,
    SchemeAvailabilityRestrictionsQueryVariables
  > &
    (
      | {
          variables: SchemeAvailabilityRestrictionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchemeAvailabilityRestrictionsQuery,
    SchemeAvailabilityRestrictionsQueryVariables
  >(SchemeAvailabilityRestrictionsDocument, options)
}
export function useSchemeAvailabilityRestrictionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeAvailabilityRestrictionsQuery,
    SchemeAvailabilityRestrictionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemeAvailabilityRestrictionsQuery,
    SchemeAvailabilityRestrictionsQueryVariables
  >(SchemeAvailabilityRestrictionsDocument, options)
}
// @ts-ignore
export function useSchemeAvailabilityRestrictionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeAvailabilityRestrictionsQuery,
    SchemeAvailabilityRestrictionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeAvailabilityRestrictionsQuery,
  SchemeAvailabilityRestrictionsQueryVariables
>
export function useSchemeAvailabilityRestrictionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeAvailabilityRestrictionsQuery,
        SchemeAvailabilityRestrictionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeAvailabilityRestrictionsQuery | undefined,
  SchemeAvailabilityRestrictionsQueryVariables
>
export function useSchemeAvailabilityRestrictionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeAvailabilityRestrictionsQuery,
        SchemeAvailabilityRestrictionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeAvailabilityRestrictionsQuery,
    SchemeAvailabilityRestrictionsQueryVariables
  >(SchemeAvailabilityRestrictionsDocument, options)
}
export type SchemeAvailabilityRestrictionsQueryHookResult = ReturnType<
  typeof useSchemeAvailabilityRestrictionsQuery
>
export type SchemeAvailabilityRestrictionsLazyQueryHookResult = ReturnType<
  typeof useSchemeAvailabilityRestrictionsLazyQuery
>
export type SchemeAvailabilityRestrictionsSuspenseQueryHookResult = ReturnType<
  typeof useSchemeAvailabilityRestrictionsSuspenseQuery
>
export type SchemeAvailabilityRestrictionsQueryResult = Apollo.QueryResult<
  SchemeAvailabilityRestrictionsQuery,
  SchemeAvailabilityRestrictionsQueryVariables
>
export const AddSchemeAvailabilityRestrictionDocument = gql`
  mutation AddSchemeAvailabilityRestriction(
    $scheme_availability_restriction: SchemeAvailabilityRestrictionInput!
  ) {
    add_scheme_availability_restriction(
      scheme_availability_restriction: $scheme_availability_restriction
    ) {
      ...AvailabilityRestrictionData
    }
  }
  ${AvailabilityRestrictionDataFragmentDoc}
`
export type AddSchemeAvailabilityRestrictionMutationFn =
  Apollo.MutationFunction<
    AddSchemeAvailabilityRestrictionMutation,
    AddSchemeAvailabilityRestrictionMutationVariables
  >

/**
 * __useAddSchemeAvailabilityRestrictionMutation__
 *
 * To run a mutation, you first call `useAddSchemeAvailabilityRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchemeAvailabilityRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchemeAvailabilityRestrictionMutation, { data, loading, error }] = useAddSchemeAvailabilityRestrictionMutation({
 *   variables: {
 *      scheme_availability_restriction: // value for 'scheme_availability_restriction'
 *   },
 * });
 */
export function useAddSchemeAvailabilityRestrictionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSchemeAvailabilityRestrictionMutation,
    AddSchemeAvailabilityRestrictionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AddSchemeAvailabilityRestrictionMutation,
    AddSchemeAvailabilityRestrictionMutationVariables
  >(AddSchemeAvailabilityRestrictionDocument, options)
}
export type AddSchemeAvailabilityRestrictionMutationHookResult = ReturnType<
  typeof useAddSchemeAvailabilityRestrictionMutation
>
export type AddSchemeAvailabilityRestrictionMutationResult =
  Apollo.MutationResult<AddSchemeAvailabilityRestrictionMutation>
export type AddSchemeAvailabilityRestrictionMutationOptions =
  Apollo.BaseMutationOptions<
    AddSchemeAvailabilityRestrictionMutation,
    AddSchemeAvailabilityRestrictionMutationVariables
  >
export const UpdateSchemeAvailabilityRestrictionDocument = gql`
  mutation UpdateSchemeAvailabilityRestriction(
    $id: ID!
    $scheme_availability_restriction: SchemeAvailabilityRestrictionInput!
  ) {
    update_scheme_availability_restriction(
      scheme_availability_restriction_id: $id
      scheme_availability_restriction: $scheme_availability_restriction
    ) {
      ...AvailabilityRestrictionData
    }
  }
  ${AvailabilityRestrictionDataFragmentDoc}
`
export type UpdateSchemeAvailabilityRestrictionMutationFn =
  Apollo.MutationFunction<
    UpdateSchemeAvailabilityRestrictionMutation,
    UpdateSchemeAvailabilityRestrictionMutationVariables
  >

/**
 * __useUpdateSchemeAvailabilityRestrictionMutation__
 *
 * To run a mutation, you first call `useUpdateSchemeAvailabilityRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemeAvailabilityRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchemeAvailabilityRestrictionMutation, { data, loading, error }] = useUpdateSchemeAvailabilityRestrictionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheme_availability_restriction: // value for 'scheme_availability_restriction'
 *   },
 * });
 */
export function useUpdateSchemeAvailabilityRestrictionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchemeAvailabilityRestrictionMutation,
    UpdateSchemeAvailabilityRestrictionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchemeAvailabilityRestrictionMutation,
    UpdateSchemeAvailabilityRestrictionMutationVariables
  >(UpdateSchemeAvailabilityRestrictionDocument, options)
}
export type UpdateSchemeAvailabilityRestrictionMutationHookResult = ReturnType<
  typeof useUpdateSchemeAvailabilityRestrictionMutation
>
export type UpdateSchemeAvailabilityRestrictionMutationResult =
  Apollo.MutationResult<UpdateSchemeAvailabilityRestrictionMutation>
export type UpdateSchemeAvailabilityRestrictionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSchemeAvailabilityRestrictionMutation,
    UpdateSchemeAvailabilityRestrictionMutationVariables
  >
export const RemoveSchemeAvailabilityRestrictionDocument = gql`
  mutation RemoveSchemeAvailabilityRestriction($id: ID!) {
    remove_scheme_availability_restriction(
      scheme_availability_restriction_id: $id
    )
  }
`
export type RemoveSchemeAvailabilityRestrictionMutationFn =
  Apollo.MutationFunction<
    RemoveSchemeAvailabilityRestrictionMutation,
    RemoveSchemeAvailabilityRestrictionMutationVariables
  >

/**
 * __useRemoveSchemeAvailabilityRestrictionMutation__
 *
 * To run a mutation, you first call `useRemoveSchemeAvailabilityRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSchemeAvailabilityRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSchemeAvailabilityRestrictionMutation, { data, loading, error }] = useRemoveSchemeAvailabilityRestrictionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSchemeAvailabilityRestrictionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSchemeAvailabilityRestrictionMutation,
    RemoveSchemeAvailabilityRestrictionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveSchemeAvailabilityRestrictionMutation,
    RemoveSchemeAvailabilityRestrictionMutationVariables
  >(RemoveSchemeAvailabilityRestrictionDocument, options)
}
export type RemoveSchemeAvailabilityRestrictionMutationHookResult = ReturnType<
  typeof useRemoveSchemeAvailabilityRestrictionMutation
>
export type RemoveSchemeAvailabilityRestrictionMutationResult =
  Apollo.MutationResult<RemoveSchemeAvailabilityRestrictionMutation>
export type RemoveSchemeAvailabilityRestrictionMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveSchemeAvailabilityRestrictionMutation,
    RemoveSchemeAvailabilityRestrictionMutationVariables
  >
export const DeploymentListDocument = gql`
  query DeploymentList($paginate: Paginate) {
    table: deployments(paginate: $paginate) {
      nodes {
        id
        created_at
        version {
          name
          formatted_size
        }
        modules {
          nodes {
            id
            created_at
            state
            module {
              id
              vehicle {
                detail {
                  id
                  scheme {
                    id
                  }
                }
              }
            }
          }
        }
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
  }
`

/**
 * __useDeploymentListQuery__
 *
 * To run a query within a React component, call `useDeploymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useDeploymentListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DeploymentListQuery,
    DeploymentListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DeploymentListQuery, DeploymentListQueryVariables>(
    DeploymentListDocument,
    options,
  )
}
export function useDeploymentListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeploymentListQuery,
    DeploymentListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DeploymentListQuery, DeploymentListQueryVariables>(
    DeploymentListDocument,
    options,
  )
}
// @ts-ignore
export function useDeploymentListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DeploymentListQuery,
    DeploymentListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DeploymentListQuery,
  DeploymentListQueryVariables
>
export function useDeploymentListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeploymentListQuery,
        DeploymentListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DeploymentListQuery | undefined,
  DeploymentListQueryVariables
>
export function useDeploymentListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeploymentListQuery,
        DeploymentListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DeploymentListQuery,
    DeploymentListQueryVariables
  >(DeploymentListDocument, options)
}
export type DeploymentListQueryHookResult = ReturnType<
  typeof useDeploymentListQuery
>
export type DeploymentListLazyQueryHookResult = ReturnType<
  typeof useDeploymentListLazyQuery
>
export type DeploymentListSuspenseQueryHookResult = ReturnType<
  typeof useDeploymentListSuspenseQuery
>
export type DeploymentListQueryResult = Apollo.QueryResult<
  DeploymentListQuery,
  DeploymentListQueryVariables
>
export const AllVersionsDocument = gql`
  query AllVersions {
    firmware {
      id
      name
      supported_hardware
      supported_frame_types
    }
  }
`

/**
 * __useAllVersionsQuery__
 *
 * To run a query within a React component, call `useAllVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllVersionsQuery,
    AllVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AllVersionsQuery, AllVersionsQueryVariables>(
    AllVersionsDocument,
    options,
  )
}
export function useAllVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllVersionsQuery,
    AllVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AllVersionsQuery, AllVersionsQueryVariables>(
    AllVersionsDocument,
    options,
  )
}
// @ts-ignore
export function useAllVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllVersionsQuery,
    AllVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AllVersionsQuery, AllVersionsQueryVariables>
export function useAllVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllVersionsQuery,
        AllVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AllVersionsQuery | undefined,
  AllVersionsQueryVariables
>
export function useAllVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllVersionsQuery,
        AllVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AllVersionsQuery, AllVersionsQueryVariables>(
    AllVersionsDocument,
    options,
  )
}
export type AllVersionsQueryHookResult = ReturnType<typeof useAllVersionsQuery>
export type AllVersionsLazyQueryHookResult = ReturnType<
  typeof useAllVersionsLazyQuery
>
export type AllVersionsSuspenseQueryHookResult = ReturnType<
  typeof useAllVersionsSuspenseQuery
>
export type AllVersionsQueryResult = Apollo.QueryResult<
  AllVersionsQuery,
  AllVersionsQueryVariables
>
export const DeploymentDocument = gql`
  query Deployment($id: ID!, $paginate: Paginate) {
    deployment(deployment_id: $id) {
      id
      created_at
      version {
        name
        size
        created_at
      }
      modules(paginate: $paginate) {
        nodes {
          id
          created_at
          state
          module {
            id
            vehicle {
              id
              detail {
                id
                scheme {
                  id
                }
              }
            }
          }
        }
        pagination {
          current: page
          pageSize: per_page
          total
        }
      }
    }
  }
`

/**
 * __useDeploymentQuery__
 *
 * To run a query within a React component, call `useDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useDeploymentQuery(
  baseOptions: Apollo.QueryHookOptions<
    DeploymentQuery,
    DeploymentQueryVariables
  > &
    (
      | { variables: DeploymentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DeploymentQuery, DeploymentQueryVariables>(
    DeploymentDocument,
    options,
  )
}
export function useDeploymentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeploymentQuery,
    DeploymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DeploymentQuery, DeploymentQueryVariables>(
    DeploymentDocument,
    options,
  )
}
// @ts-ignore
export function useDeploymentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DeploymentQuery,
    DeploymentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DeploymentQuery, DeploymentQueryVariables>
export function useDeploymentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeploymentQuery,
        DeploymentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DeploymentQuery | undefined,
  DeploymentQueryVariables
>
export function useDeploymentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeploymentQuery,
        DeploymentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DeploymentQuery, DeploymentQueryVariables>(
    DeploymentDocument,
    options,
  )
}
export type DeploymentQueryHookResult = ReturnType<typeof useDeploymentQuery>
export type DeploymentLazyQueryHookResult = ReturnType<
  typeof useDeploymentLazyQuery
>
export type DeploymentSuspenseQueryHookResult = ReturnType<
  typeof useDeploymentSuspenseQuery
>
export type DeploymentQueryResult = Apollo.QueryResult<
  DeploymentQuery,
  DeploymentQueryVariables
>
export const Start_DeploymentDocument = gql`
  mutation Start_Deployment($module_ids: [ID]!, $version: String!) {
    start_deployment(module_ids: $module_ids, version: $version) {
      id
    }
  }
`
export type Start_DeploymentMutationFn = Apollo.MutationFunction<
  Start_DeploymentMutation,
  Start_DeploymentMutationVariables
>

/**
 * __useStart_DeploymentMutation__
 *
 * To run a mutation, you first call `useStart_DeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStart_DeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDeploymentMutation, { data, loading, error }] = useStart_DeploymentMutation({
 *   variables: {
 *      module_ids: // value for 'module_ids'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useStart_DeploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Start_DeploymentMutation,
    Start_DeploymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Start_DeploymentMutation,
    Start_DeploymentMutationVariables
  >(Start_DeploymentDocument, options)
}
export type Start_DeploymentMutationHookResult = ReturnType<
  typeof useStart_DeploymentMutation
>
export type Start_DeploymentMutationResult =
  Apollo.MutationResult<Start_DeploymentMutation>
export type Start_DeploymentMutationOptions = Apollo.BaseMutationOptions<
  Start_DeploymentMutation,
  Start_DeploymentMutationVariables
>
export const InvoiceDocument = gql`
  query Invoice($id: ID!) {
    invoice(invoice_id: $id) {
      __typename
      id
      created_at
      description
      status
      ... on JourneyInvoice {
        journey {
          id
          initiator
          initiator_app_name
          duration
          scheme {
            id
          }
        }
        minute_refundable {
          ...FormattedAmount
        }
      }
      scheme_product {
        id
        name
        scheme_accounting {
          currency
        }
      }
      user {
        id
        email
        deleted
      }
      minute_debit {
        ...FormattedAmount
      }
      currency_debit {
        ...FormattedAmount
      }
      currency_refundable {
        ...FormattedAmount
      }
      currency_balance {
        ...FormattedAmount
      }
      transactions {
        nodes {
          id
          created_at
          description
          category
          result {
            status
            failure_message
          }
          debit_amount {
            ...FormattedAmount
          }
          credit_amount {
            ...FormattedAmount
          }
          provider_type
          void
          type
          meta {
            descriptor
            failure_reason
            requester_id
            refund_description
            transaction_label
            charge_type
            minutes_charged
            time_increment_cost
          }
          refund_requester {
            id
            email
          }
          result {
            status
          }
          amount_refundable {
            ...FormattedAmount
          }
          amount_refunded {
            ...FormattedAmount
          }
        }
      }
      ... on ProductInvoice {
        minute_refund_calcs {
          currency_amount {
            amount
            formatted_amount
          }
          minute_adjustment_quantity
        }
      }
    }
  }
  ${FormattedAmountFragmentDoc}
`

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(
  baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables> &
    ({ variables: InvoiceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(
    InvoiceDocument,
    options,
  )
}
export function useInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvoiceQuery,
    InvoiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(
    InvoiceDocument,
    options,
  )
}
// @ts-ignore
export function useInvoiceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InvoiceQuery,
    InvoiceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InvoiceQuery, InvoiceQueryVariables>
export function useInvoiceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  InvoiceQuery | undefined,
  InvoiceQueryVariables
>
export function useInvoiceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InvoiceQuery, InvoiceQueryVariables>(
    InvoiceDocument,
    options,
  )
}
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>
export type InvoiceSuspenseQueryHookResult = ReturnType<
  typeof useInvoiceSuspenseQuery
>
export type InvoiceQueryResult = Apollo.QueryResult<
  InvoiceQuery,
  InvoiceQueryVariables
>
export const InvoiceListDocument = gql`
  query InvoiceList(
    $scheme_id: ID
    $user_id: ID
    $paginate: Paginate
    $where: [IInvoiceWhere]
    $order_by: [IInvoiceOrderby]
    $is_mobile: Boolean!
  ) {
    table: invoices(
      scheme_id: $scheme_id
      user_id: $user_id
      where: $where
      paginate: $paginate
      order_by: $order_by
    ) {
      nodes {
        id
        created_at
        status
        description @skip(if: $is_mobile)
        user {
          id
          email
          deleted
        }
        minute_debit {
          formatted_amount
        }
        currency_debit {
          formatted_amount
        }
      }
    }
  }
`

/**
 * __useInvoiceListQuery__
 *
 * To run a query within a React component, call `useInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      user_id: // value for 'user_id'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      is_mobile: // value for 'is_mobile'
 *   },
 * });
 */
export function useInvoiceListQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvoiceListQuery,
    InvoiceListQueryVariables
  > &
    (
      | { variables: InvoiceListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InvoiceListQuery, InvoiceListQueryVariables>(
    InvoiceListDocument,
    options,
  )
}
export function useInvoiceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvoiceListQuery,
    InvoiceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InvoiceListQuery, InvoiceListQueryVariables>(
    InvoiceListDocument,
    options,
  )
}
// @ts-ignore
export function useInvoiceListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InvoiceListQuery,
    InvoiceListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InvoiceListQuery, InvoiceListQueryVariables>
export function useInvoiceListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvoiceListQuery,
        InvoiceListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InvoiceListQuery | undefined,
  InvoiceListQueryVariables
>
export function useInvoiceListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvoiceListQuery,
        InvoiceListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InvoiceListQuery, InvoiceListQueryVariables>(
    InvoiceListDocument,
    options,
  )
}
export type InvoiceListQueryHookResult = ReturnType<typeof useInvoiceListQuery>
export type InvoiceListLazyQueryHookResult = ReturnType<
  typeof useInvoiceListLazyQuery
>
export type InvoiceListSuspenseQueryHookResult = ReturnType<
  typeof useInvoiceListSuspenseQuery
>
export type InvoiceListQueryResult = Apollo.QueryResult<
  InvoiceListQuery,
  InvoiceListQueryVariables
>
export const RefundInvoiceDocument = gql`
  mutation RefundInvoice(
    $id: ID!
    $description: String!
    $reason: String!
    $revoke_product: Boolean!
    $refund_transactions: [RefundInvoiceV2InputTransaction!]!
  ) {
    refund_invoice_v2(
      invoice_id: $id
      refund_invoice: {
        reason: $reason
        description: $description
        revoke_product: $revoke_product
        refund_transactions: $refund_transactions
      }
    ) {
      currency {
        amount
        status
        message
      }
      minutes {
        amount
        status
        message
      }
    }
  }
`
export type RefundInvoiceMutationFn = Apollo.MutationFunction<
  RefundInvoiceMutation,
  RefundInvoiceMutationVariables
>

/**
 * __useRefundInvoiceMutation__
 *
 * To run a mutation, you first call `useRefundInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundInvoiceMutation, { data, loading, error }] = useRefundInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      reason: // value for 'reason'
 *      revoke_product: // value for 'revoke_product'
 *      refund_transactions: // value for 'refund_transactions'
 *   },
 * });
 */
export function useRefundInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefundInvoiceMutation,
    RefundInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RefundInvoiceMutation,
    RefundInvoiceMutationVariables
  >(RefundInvoiceDocument, options)
}
export type RefundInvoiceMutationHookResult = ReturnType<
  typeof useRefundInvoiceMutation
>
export type RefundInvoiceMutationResult =
  Apollo.MutationResult<RefundInvoiceMutation>
export type RefundInvoiceMutationOptions = Apollo.BaseMutationOptions<
  RefundInvoiceMutation,
  RefundInvoiceMutationVariables
>
export const RecalculateJourneyInvoiceDocument = gql`
  mutation RecalculateJourneyInvoice(
    $id: ID!
    $description: String!
    $amendedDuration: Int
  ) {
    recalculate_journey_invoice(
      invoice_id: $id
      refund_request: {
        description: $description
        amended_duration: $amendedDuration
      }
    ) {
      currency {
        amount
        status
        message
      }
    }
  }
`
export type RecalculateJourneyInvoiceMutationFn = Apollo.MutationFunction<
  RecalculateJourneyInvoiceMutation,
  RecalculateJourneyInvoiceMutationVariables
>

/**
 * __useRecalculateJourneyInvoiceMutation__
 *
 * To run a mutation, you first call `useRecalculateJourneyInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateJourneyInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateJourneyInvoiceMutation, { data, loading, error }] = useRecalculateJourneyInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      amendedDuration: // value for 'amendedDuration'
 *   },
 * });
 */
export function useRecalculateJourneyInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecalculateJourneyInvoiceMutation,
    RecalculateJourneyInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecalculateJourneyInvoiceMutation,
    RecalculateJourneyInvoiceMutationVariables
  >(RecalculateJourneyInvoiceDocument, options)
}
export type RecalculateJourneyInvoiceMutationHookResult = ReturnType<
  typeof useRecalculateJourneyInvoiceMutation
>
export type RecalculateJourneyInvoiceMutationResult =
  Apollo.MutationResult<RecalculateJourneyInvoiceMutation>
export type RecalculateJourneyInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    RecalculateJourneyInvoiceMutation,
    RecalculateJourneyInvoiceMutationVariables
  >
export const RefundInvoiceExcessBalanceDocument = gql`
  mutation RefundInvoiceExcessBalance($id: ID!, $description: String!) {
    refund_invoice_excess_balance(
      invoice_id: $id
      refund_request: { description: $description }
    ) {
      currency {
        amount
        status
        message
      }
    }
  }
`
export type RefundInvoiceExcessBalanceMutationFn = Apollo.MutationFunction<
  RefundInvoiceExcessBalanceMutation,
  RefundInvoiceExcessBalanceMutationVariables
>

/**
 * __useRefundInvoiceExcessBalanceMutation__
 *
 * To run a mutation, you first call `useRefundInvoiceExcessBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundInvoiceExcessBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundInvoiceExcessBalanceMutation, { data, loading, error }] = useRefundInvoiceExcessBalanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useRefundInvoiceExcessBalanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefundInvoiceExcessBalanceMutation,
    RefundInvoiceExcessBalanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RefundInvoiceExcessBalanceMutation,
    RefundInvoiceExcessBalanceMutationVariables
  >(RefundInvoiceExcessBalanceDocument, options)
}
export type RefundInvoiceExcessBalanceMutationHookResult = ReturnType<
  typeof useRefundInvoiceExcessBalanceMutation
>
export type RefundInvoiceExcessBalanceMutationResult =
  Apollo.MutationResult<RefundInvoiceExcessBalanceMutation>
export type RefundInvoiceExcessBalanceMutationOptions =
  Apollo.BaseMutationOptions<
    RefundInvoiceExcessBalanceMutation,
    RefundInvoiceExcessBalanceMutationVariables
  >
export const SettleInvoiceOffSessionDocument = gql`
  mutation SettleInvoiceOffSession($id: ID!) {
    settle_invoice_off_session(invoice_id: $id) {
      status
    }
  }
`
export type SettleInvoiceOffSessionMutationFn = Apollo.MutationFunction<
  SettleInvoiceOffSessionMutation,
  SettleInvoiceOffSessionMutationVariables
>

/**
 * __useSettleInvoiceOffSessionMutation__
 *
 * To run a mutation, you first call `useSettleInvoiceOffSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettleInvoiceOffSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settleInvoiceOffSessionMutation, { data, loading, error }] = useSettleInvoiceOffSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettleInvoiceOffSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SettleInvoiceOffSessionMutation,
    SettleInvoiceOffSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SettleInvoiceOffSessionMutation,
    SettleInvoiceOffSessionMutationVariables
  >(SettleInvoiceOffSessionDocument, options)
}
export type SettleInvoiceOffSessionMutationHookResult = ReturnType<
  typeof useSettleInvoiceOffSessionMutation
>
export type SettleInvoiceOffSessionMutationResult =
  Apollo.MutationResult<SettleInvoiceOffSessionMutation>
export type SettleInvoiceOffSessionMutationOptions = Apollo.BaseMutationOptions<
  SettleInvoiceOffSessionMutation,
  SettleInvoiceOffSessionMutationVariables
>
export const SchemeJobAssetsDocument = gql`
  query SchemeJobAssets($scheme_id: ID!) {
    scheme_job_assets(scheme_id: $scheme_id) {
      assetTag
      assetName
      assetCategory
    }
  }
`

/**
 * __useSchemeJobAssetsQuery__
 *
 * To run a query within a React component, call `useSchemeJobAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeJobAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeJobAssetsQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *   },
 * });
 */
export function useSchemeJobAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeJobAssetsQuery,
    SchemeJobAssetsQueryVariables
  > &
    (
      | { variables: SchemeJobAssetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchemeJobAssetsQuery, SchemeJobAssetsQueryVariables>(
    SchemeJobAssetsDocument,
    options,
  )
}
export function useSchemeJobAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeJobAssetsQuery,
    SchemeJobAssetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemeJobAssetsQuery,
    SchemeJobAssetsQueryVariables
  >(SchemeJobAssetsDocument, options)
}
// @ts-ignore
export function useSchemeJobAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeJobAssetsQuery,
    SchemeJobAssetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeJobAssetsQuery,
  SchemeJobAssetsQueryVariables
>
export function useSchemeJobAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeJobAssetsQuery,
        SchemeJobAssetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeJobAssetsQuery | undefined,
  SchemeJobAssetsQueryVariables
>
export function useSchemeJobAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeJobAssetsQuery,
        SchemeJobAssetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeJobAssetsQuery,
    SchemeJobAssetsQueryVariables
  >(SchemeJobAssetsDocument, options)
}
export type SchemeJobAssetsQueryHookResult = ReturnType<
  typeof useSchemeJobAssetsQuery
>
export type SchemeJobAssetsLazyQueryHookResult = ReturnType<
  typeof useSchemeJobAssetsLazyQuery
>
export type SchemeJobAssetsSuspenseQueryHookResult = ReturnType<
  typeof useSchemeJobAssetsSuspenseQuery
>
export type SchemeJobAssetsQueryResult = Apollo.QueryResult<
  SchemeJobAssetsQuery,
  SchemeJobAssetsQueryVariables
>
export const JobListDocument = gql`
  query JobList($paginate: Paginate, $job_filters: JobFiltersInput) {
    table: jobs_v2(paginate: $paginate, job_filters: $job_filters) {
      nodes {
        ...JobBasic
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
  }
  ${JobBasicFragmentDoc}
`

/**
 * __useJobListQuery__
 *
 * To run a query within a React component, call `useJobListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      job_filters: // value for 'job_filters'
 *   },
 * });
 */
export function useJobListQuery(
  baseOptions?: Apollo.QueryHookOptions<JobListQuery, JobListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JobListQuery, JobListQueryVariables>(
    JobListDocument,
    options,
  )
}
export function useJobListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JobListQuery,
    JobListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JobListQuery, JobListQueryVariables>(
    JobListDocument,
    options,
  )
}
// @ts-ignore
export function useJobListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JobListQuery,
    JobListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<JobListQuery, JobListQueryVariables>
export function useJobListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JobListQuery, JobListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  JobListQuery | undefined,
  JobListQueryVariables
>
export function useJobListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JobListQuery, JobListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JobListQuery, JobListQueryVariables>(
    JobListDocument,
    options,
  )
}
export type JobListQueryHookResult = ReturnType<typeof useJobListQuery>
export type JobListLazyQueryHookResult = ReturnType<typeof useJobListLazyQuery>
export type JobListSuspenseQueryHookResult = ReturnType<
  typeof useJobListSuspenseQuery
>
export type JobListQueryResult = Apollo.QueryResult<
  JobListQuery,
  JobListQueryVariables
>
export const JobDocument = gql`
  query Job($job_id: ID!) {
    job(job_uuid: $job_id) {
      ...JobDetailed
    }
  }
  ${JobDetailedFragmentDoc}
`

/**
 * __useJobQuery__
 *
 * To run a query within a React component, call `useJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobQuery({
 *   variables: {
 *      job_id: // value for 'job_id'
 *   },
 * });
 */
export function useJobQuery(
  baseOptions: Apollo.QueryHookOptions<JobQuery, JobQueryVariables> &
    ({ variables: JobQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JobQuery, JobQueryVariables>(JobDocument, options)
}
export function useJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<JobQuery, JobQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JobQuery, JobQueryVariables>(JobDocument, options)
}
// @ts-ignore
export function useJobSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>,
): Apollo.UseSuspenseQueryResult<JobQuery, JobQueryVariables>
export function useJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>,
): Apollo.UseSuspenseQueryResult<JobQuery | undefined, JobQueryVariables>
export function useJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JobQuery, JobQueryVariables>(
    JobDocument,
    options,
  )
}
export type JobQueryHookResult = ReturnType<typeof useJobQuery>
export type JobLazyQueryHookResult = ReturnType<typeof useJobLazyQuery>
export type JobSuspenseQueryHookResult = ReturnType<typeof useJobSuspenseQuery>
export type JobQueryResult = Apollo.QueryResult<JobQuery, JobQueryVariables>
export const ArchiveJobListDocument = gql`
  query ArchiveJobList($paginate: Paginate, $asset_tag: ID!) {
    table: archive_jobs(paginate: $paginate, asset_tag: $asset_tag) {
      nodes {
        ...ArchiveJobBasic
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
  }
  ${ArchiveJobBasicFragmentDoc}
`

/**
 * __useArchiveJobListQuery__
 *
 * To run a query within a React component, call `useArchiveJobListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchiveJobListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      asset_tag: // value for 'asset_tag'
 *   },
 * });
 */
export function useArchiveJobListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArchiveJobListQuery,
    ArchiveJobListQueryVariables
  > &
    (
      | { variables: ArchiveJobListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ArchiveJobListQuery, ArchiveJobListQueryVariables>(
    ArchiveJobListDocument,
    options,
  )
}
export function useArchiveJobListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArchiveJobListQuery,
    ArchiveJobListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ArchiveJobListQuery, ArchiveJobListQueryVariables>(
    ArchiveJobListDocument,
    options,
  )
}
// @ts-ignore
export function useArchiveJobListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArchiveJobListQuery,
    ArchiveJobListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ArchiveJobListQuery,
  ArchiveJobListQueryVariables
>
export function useArchiveJobListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArchiveJobListQuery,
        ArchiveJobListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ArchiveJobListQuery | undefined,
  ArchiveJobListQueryVariables
>
export function useArchiveJobListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArchiveJobListQuery,
        ArchiveJobListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ArchiveJobListQuery,
    ArchiveJobListQueryVariables
  >(ArchiveJobListDocument, options)
}
export type ArchiveJobListQueryHookResult = ReturnType<
  typeof useArchiveJobListQuery
>
export type ArchiveJobListLazyQueryHookResult = ReturnType<
  typeof useArchiveJobListLazyQuery
>
export type ArchiveJobListSuspenseQueryHookResult = ReturnType<
  typeof useArchiveJobListSuspenseQuery
>
export type ArchiveJobListQueryResult = Apollo.QueryResult<
  ArchiveJobListQuery,
  ArchiveJobListQueryVariables
>
export const UnarchiveJobDocument = gql`
  mutation UnarchiveJob($sys_id: ID!) {
    archive_restore(sys_id: $sys_id)
  }
`
export type UnarchiveJobMutationFn = Apollo.MutationFunction<
  UnarchiveJobMutation,
  UnarchiveJobMutationVariables
>

/**
 * __useUnarchiveJobMutation__
 *
 * To run a mutation, you first call `useUnarchiveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveJobMutation, { data, loading, error }] = useUnarchiveJobMutation({
 *   variables: {
 *      sys_id: // value for 'sys_id'
 *   },
 * });
 */
export function useUnarchiveJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveJobMutation,
    UnarchiveJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchiveJobMutation,
    UnarchiveJobMutationVariables
  >(UnarchiveJobDocument, options)
}
export type UnarchiveJobMutationHookResult = ReturnType<
  typeof useUnarchiveJobMutation
>
export type UnarchiveJobMutationResult =
  Apollo.MutationResult<UnarchiveJobMutation>
export type UnarchiveJobMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveJobMutation,
  UnarchiveJobMutationVariables
>
export const JobTypesDocument = gql`
  query JobTypes {
    job_types {
      redistributionDriver {
        ...AssigmentGroup
      }
      onStreetMechanic {
        ...AssigmentGroup
      }
      workshopMechanic {
        ...AssigmentGroup
      }
      securityTeam {
        ...AssigmentGroup
      }
    }
  }
  ${AssigmentGroupFragmentDoc}
`

/**
 * __useJobTypesQuery__
 *
 * To run a query within a React component, call `useJobTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<JobTypesQuery, JobTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JobTypesQuery, JobTypesQueryVariables>(
    JobTypesDocument,
    options,
  )
}
export function useJobTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JobTypesQuery,
    JobTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JobTypesQuery, JobTypesQueryVariables>(
    JobTypesDocument,
    options,
  )
}
// @ts-ignore
export function useJobTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JobTypesQuery,
    JobTypesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<JobTypesQuery, JobTypesQueryVariables>
export function useJobTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JobTypesQuery, JobTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  JobTypesQuery | undefined,
  JobTypesQueryVariables
>
export function useJobTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JobTypesQuery, JobTypesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JobTypesQuery, JobTypesQueryVariables>(
    JobTypesDocument,
    options,
  )
}
export type JobTypesQueryHookResult = ReturnType<typeof useJobTypesQuery>
export type JobTypesLazyQueryHookResult = ReturnType<
  typeof useJobTypesLazyQuery
>
export type JobTypesSuspenseQueryHookResult = ReturnType<
  typeof useJobTypesSuspenseQuery
>
export type JobTypesQueryResult = Apollo.QueryResult<
  JobTypesQuery,
  JobTypesQueryVariables
>
export const TaskCodeDocument = gql`
  query TaskCode {
    task_codes_list {
      code
      description
      vehicle_type
      __typename
    }
  }
`

/**
 * __useTaskCodeQuery__
 *
 * To run a query within a React component, call `useTaskCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCodeQuery(
  baseOptions?: Apollo.QueryHookOptions<TaskCodeQuery, TaskCodeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TaskCodeQuery, TaskCodeQueryVariables>(
    TaskCodeDocument,
    options,
  )
}
export function useTaskCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TaskCodeQuery,
    TaskCodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TaskCodeQuery, TaskCodeQueryVariables>(
    TaskCodeDocument,
    options,
  )
}
// @ts-ignore
export function useTaskCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TaskCodeQuery,
    TaskCodeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TaskCodeQuery, TaskCodeQueryVariables>
export function useTaskCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskCodeQuery, TaskCodeQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TaskCodeQuery | undefined,
  TaskCodeQueryVariables
>
export function useTaskCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskCodeQuery, TaskCodeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TaskCodeQuery, TaskCodeQueryVariables>(
    TaskCodeDocument,
    options,
  )
}
export type TaskCodeQueryHookResult = ReturnType<typeof useTaskCodeQuery>
export type TaskCodeLazyQueryHookResult = ReturnType<
  typeof useTaskCodeLazyQuery
>
export type TaskCodeSuspenseQueryHookResult = ReturnType<
  typeof useTaskCodeSuspenseQuery
>
export type TaskCodeQueryResult = Apollo.QueryResult<
  TaskCodeQuery,
  TaskCodeQueryVariables
>
export const JourneySetDocument = gql`
  query JourneySet($id: ID!, $schemeId: ID) {
    journey_set(id: $id, scheme_id: $schemeId) {
      ...JourneySetDetailed
    }
  }
  ${JourneySetDetailedFragmentDoc}
`

/**
 * __useJourneySetQuery__
 *
 * To run a query within a React component, call `useJourneySetQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneySetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneySetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useJourneySetQuery(
  baseOptions: Apollo.QueryHookOptions<
    JourneySetQuery,
    JourneySetQueryVariables
  > &
    (
      | { variables: JourneySetQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JourneySetQuery, JourneySetQueryVariables>(
    JourneySetDocument,
    options,
  )
}
export function useJourneySetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JourneySetQuery,
    JourneySetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JourneySetQuery, JourneySetQueryVariables>(
    JourneySetDocument,
    options,
  )
}
// @ts-ignore
export function useJourneySetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JourneySetQuery,
    JourneySetQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<JourneySetQuery, JourneySetQueryVariables>
export function useJourneySetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneySetQuery,
        JourneySetQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  JourneySetQuery | undefined,
  JourneySetQueryVariables
>
export function useJourneySetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneySetQuery,
        JourneySetQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JourneySetQuery, JourneySetQueryVariables>(
    JourneySetDocument,
    options,
  )
}
export type JourneySetQueryHookResult = ReturnType<typeof useJourneySetQuery>
export type JourneySetLazyQueryHookResult = ReturnType<
  typeof useJourneySetLazyQuery
>
export type JourneySetSuspenseQueryHookResult = ReturnType<
  typeof useJourneySetSuspenseQuery
>
export type JourneySetQueryResult = Apollo.QueryResult<
  JourneySetQuery,
  JourneySetQueryVariables
>
export const JourneySetMapDocument = gql`
  query JourneySetMap(
    $id: ID!
    $schemeId: ID!
    $location: LocationAreaInput
    $hasLocation: Boolean!
  ) {
    journey_set(id: $id, scheme_id: $schemeId) {
      id
      journeys {
        ...JourneyMap
      }
    }
    vehicles(location: $location) @include(if: $hasLocation) {
      ...VehiclesNodes
    }
    all_zones(location: $location, scheme_id: $schemeId)
      @include(if: $hasLocation) {
      nodes {
        ...ZoneNode
      }
    }
  }
  ${JourneyMapFragmentDoc}
  ${VehiclesNodesFragmentDoc}
  ${ZoneNodeFragmentDoc}
`

/**
 * __useJourneySetMapQuery__
 *
 * To run a query within a React component, call `useJourneySetMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneySetMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneySetMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schemeId: // value for 'schemeId'
 *      location: // value for 'location'
 *      hasLocation: // value for 'hasLocation'
 *   },
 * });
 */
export function useJourneySetMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    JourneySetMapQuery,
    JourneySetMapQueryVariables
  > &
    (
      | { variables: JourneySetMapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JourneySetMapQuery, JourneySetMapQueryVariables>(
    JourneySetMapDocument,
    options,
  )
}
export function useJourneySetMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JourneySetMapQuery,
    JourneySetMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JourneySetMapQuery, JourneySetMapQueryVariables>(
    JourneySetMapDocument,
    options,
  )
}
// @ts-ignore
export function useJourneySetMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JourneySetMapQuery,
    JourneySetMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  JourneySetMapQuery,
  JourneySetMapQueryVariables
>
export function useJourneySetMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneySetMapQuery,
        JourneySetMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  JourneySetMapQuery | undefined,
  JourneySetMapQueryVariables
>
export function useJourneySetMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneySetMapQuery,
        JourneySetMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    JourneySetMapQuery,
    JourneySetMapQueryVariables
  >(JourneySetMapDocument, options)
}
export type JourneySetMapQueryHookResult = ReturnType<
  typeof useJourneySetMapQuery
>
export type JourneySetMapLazyQueryHookResult = ReturnType<
  typeof useJourneySetMapLazyQuery
>
export type JourneySetMapSuspenseQueryHookResult = ReturnType<
  typeof useJourneySetMapSuspenseQuery
>
export type JourneySetMapQueryResult = Apollo.QueryResult<
  JourneySetMapQuery,
  JourneySetMapQueryVariables
>
export const JourneyListDocument = gql`
  query JourneyList(
    $module_id: ID
    $user_id: ID
    $scheme_id: ID
    $paginate: Paginate
    $omit_user: Boolean!
    $where: [JourneyWhere]
  ) {
    table: journeys(
      module_id: $module_id
      user_id: $user_id
      scheme_id: $scheme_id
      where: $where
      paginate: $paginate
    ) {
      nodes {
        id
        ...JourneyPreview
        user @skip(if: $omit_user) {
          id
          email
          deleted
        }
        journey_set {
          id
          journey_count
        }
      }
    }
  }
  ${JourneyPreviewFragmentDoc}
`

/**
 * __useJourneyListQuery__
 *
 * To run a query within a React component, call `useJourneyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyListQuery({
 *   variables: {
 *      module_id: // value for 'module_id'
 *      user_id: // value for 'user_id'
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *      omit_user: // value for 'omit_user'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useJourneyListQuery(
  baseOptions: Apollo.QueryHookOptions<
    JourneyListQuery,
    JourneyListQueryVariables
  > &
    (
      | { variables: JourneyListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JourneyListQuery, JourneyListQueryVariables>(
    JourneyListDocument,
    options,
  )
}
export function useJourneyListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JourneyListQuery,
    JourneyListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JourneyListQuery, JourneyListQueryVariables>(
    JourneyListDocument,
    options,
  )
}
// @ts-ignore
export function useJourneyListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JourneyListQuery,
    JourneyListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<JourneyListQuery, JourneyListQueryVariables>
export function useJourneyListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneyListQuery,
        JourneyListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  JourneyListQuery | undefined,
  JourneyListQueryVariables
>
export function useJourneyListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneyListQuery,
        JourneyListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JourneyListQuery, JourneyListQueryVariables>(
    JourneyListDocument,
    options,
  )
}
export type JourneyListQueryHookResult = ReturnType<typeof useJourneyListQuery>
export type JourneyListLazyQueryHookResult = ReturnType<
  typeof useJourneyListLazyQuery
>
export type JourneyListSuspenseQueryHookResult = ReturnType<
  typeof useJourneyListSuspenseQuery
>
export type JourneyListQueryResult = Apollo.QueryResult<
  JourneyListQuery,
  JourneyListQueryVariables
>
export const JourneyDocument = gql`
  query Journey($id: ID!) {
    journey(journey_id: $id) {
      ...JourneySummary
      ...JourneyHistory
      module {
        id
      }
      user {
        id
      }
      invoice {
        id
      }
      journey_set {
        id
        journey_count
        active_journey_count
        is_complete
      }
    }
  }
  ${JourneySummaryFragmentDoc}
  ${JourneyHistoryFragmentDoc}
`

/**
 * __useJourneyQuery__
 *
 * To run a query within a React component, call `useJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJourneyQuery(
  baseOptions: Apollo.QueryHookOptions<JourneyQuery, JourneyQueryVariables> &
    ({ variables: JourneyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JourneyQuery, JourneyQueryVariables>(
    JourneyDocument,
    options,
  )
}
export function useJourneyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JourneyQuery,
    JourneyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JourneyQuery, JourneyQueryVariables>(
    JourneyDocument,
    options,
  )
}
// @ts-ignore
export function useJourneySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JourneyQuery,
    JourneyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<JourneyQuery, JourneyQueryVariables>
export function useJourneySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  JourneyQuery | undefined,
  JourneyQueryVariables
>
export function useJourneySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JourneyQuery, JourneyQueryVariables>(
    JourneyDocument,
    options,
  )
}
export type JourneyQueryHookResult = ReturnType<typeof useJourneyQuery>
export type JourneyLazyQueryHookResult = ReturnType<typeof useJourneyLazyQuery>
export type JourneySuspenseQueryHookResult = ReturnType<
  typeof useJourneySuspenseQuery
>
export type JourneyQueryResult = Apollo.QueryResult<
  JourneyQuery,
  JourneyQueryVariables
>
export const JourneyMapDocument = gql`
  query JourneyMap(
    $id: ID!
    $schemeId: ID!
    $location: LocationAreaInput
    $hasLocation: Boolean!
  ) {
    journey(journey_id: $id) {
      ...JourneyMap
    }
    vehicles(location: $location) @include(if: $hasLocation) {
      ...VehiclesNodes
    }
    all_zones(location: $location, scheme_id: $schemeId)
      @include(if: $hasLocation) {
      nodes {
        ...ZoneNode
      }
    }
  }
  ${JourneyMapFragmentDoc}
  ${VehiclesNodesFragmentDoc}
  ${ZoneNodeFragmentDoc}
`

/**
 * __useJourneyMapQuery__
 *
 * To run a query within a React component, call `useJourneyMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schemeId: // value for 'schemeId'
 *      location: // value for 'location'
 *      hasLocation: // value for 'hasLocation'
 *   },
 * });
 */
export function useJourneyMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    JourneyMapQuery,
    JourneyMapQueryVariables
  > &
    (
      | { variables: JourneyMapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<JourneyMapQuery, JourneyMapQueryVariables>(
    JourneyMapDocument,
    options,
  )
}
export function useJourneyMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JourneyMapQuery,
    JourneyMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<JourneyMapQuery, JourneyMapQueryVariables>(
    JourneyMapDocument,
    options,
  )
}
// @ts-ignore
export function useJourneyMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JourneyMapQuery,
    JourneyMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<JourneyMapQuery, JourneyMapQueryVariables>
export function useJourneyMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneyMapQuery,
        JourneyMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  JourneyMapQuery | undefined,
  JourneyMapQueryVariables
>
export function useJourneyMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneyMapQuery,
        JourneyMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<JourneyMapQuery, JourneyMapQueryVariables>(
    JourneyMapDocument,
    options,
  )
}
export type JourneyMapQueryHookResult = ReturnType<typeof useJourneyMapQuery>
export type JourneyMapLazyQueryHookResult = ReturnType<
  typeof useJourneyMapLazyQuery
>
export type JourneyMapSuspenseQueryHookResult = ReturnType<
  typeof useJourneyMapSuspenseQuery
>
export type JourneyMapQueryResult = Apollo.QueryResult<
  JourneyMapQuery,
  JourneyMapQueryVariables
>
export const JourneyParkingPhotoDocument = gql`
  query JourneyParkingPhoto($journeyId: ID!) {
    journey(journey_id: $journeyId) {
      id
      ...ParkingPhoto
    }
  }
  ${ParkingPhotoFragmentDoc}
`

/**
 * __useJourneyParkingPhotoQuery__
 *
 * To run a query within a React component, call `useJourneyParkingPhotoQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyParkingPhotoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyParkingPhotoQuery({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *   },
 * });
 */
export function useJourneyParkingPhotoQuery(
  baseOptions: Apollo.QueryHookOptions<
    JourneyParkingPhotoQuery,
    JourneyParkingPhotoQueryVariables
  > &
    (
      | { variables: JourneyParkingPhotoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    JourneyParkingPhotoQuery,
    JourneyParkingPhotoQueryVariables
  >(JourneyParkingPhotoDocument, options)
}
export function useJourneyParkingPhotoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JourneyParkingPhotoQuery,
    JourneyParkingPhotoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    JourneyParkingPhotoQuery,
    JourneyParkingPhotoQueryVariables
  >(JourneyParkingPhotoDocument, options)
}
// @ts-ignore
export function useJourneyParkingPhotoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JourneyParkingPhotoQuery,
    JourneyParkingPhotoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  JourneyParkingPhotoQuery,
  JourneyParkingPhotoQueryVariables
>
export function useJourneyParkingPhotoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneyParkingPhotoQuery,
        JourneyParkingPhotoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  JourneyParkingPhotoQuery | undefined,
  JourneyParkingPhotoQueryVariables
>
export function useJourneyParkingPhotoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JourneyParkingPhotoQuery,
        JourneyParkingPhotoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    JourneyParkingPhotoQuery,
    JourneyParkingPhotoQueryVariables
  >(JourneyParkingPhotoDocument, options)
}
export type JourneyParkingPhotoQueryHookResult = ReturnType<
  typeof useJourneyParkingPhotoQuery
>
export type JourneyParkingPhotoLazyQueryHookResult = ReturnType<
  typeof useJourneyParkingPhotoLazyQuery
>
export type JourneyParkingPhotoSuspenseQueryHookResult = ReturnType<
  typeof useJourneyParkingPhotoSuspenseQuery
>
export type JourneyParkingPhotoQueryResult = Apollo.QueryResult<
  JourneyParkingPhotoQuery,
  JourneyParkingPhotoQueryVariables
>
export const StartJourneyByModuleIdDocument = gql`
  mutation StartJourneyByModuleId($moduleId: ID!) {
    start_journey_by_module_id(module_id: $moduleId) {
      id
      is_complete
      state {
        message
        time
        id
      }
    }
  }
`
export type StartJourneyByModuleIdMutationFn = Apollo.MutationFunction<
  StartJourneyByModuleIdMutation,
  StartJourneyByModuleIdMutationVariables
>

/**
 * __useStartJourneyByModuleIdMutation__
 *
 * To run a mutation, you first call `useStartJourneyByModuleIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartJourneyByModuleIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startJourneyByModuleIdMutation, { data, loading, error }] = useStartJourneyByModuleIdMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useStartJourneyByModuleIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartJourneyByModuleIdMutation,
    StartJourneyByModuleIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StartJourneyByModuleIdMutation,
    StartJourneyByModuleIdMutationVariables
  >(StartJourneyByModuleIdDocument, options)
}
export type StartJourneyByModuleIdMutationHookResult = ReturnType<
  typeof useStartJourneyByModuleIdMutation
>
export type StartJourneyByModuleIdMutationResult =
  Apollo.MutationResult<StartJourneyByModuleIdMutation>
export type StartJourneyByModuleIdMutationOptions = Apollo.BaseMutationOptions<
  StartJourneyByModuleIdMutation,
  StartJourneyByModuleIdMutationVariables
>
export const AdjustEndJourneyDocument = gql`
  mutation AdjustEndJourney(
    $journeyId: ID!
    $actionType: EndJourneyActionType!
    $extraActions: [EndJourneyExtraAction!]!
    $parkingStatus: ParkingStatus
    $vehicleLockState: VehicleLockState
    $endedAt: DateTime
  ) {
    adjust_end_journey(
      journey_id: $journeyId
      action: $actionType
      adjustments: {
        extra_actions: $extraActions
        parking_status: $parkingStatus
        vehicle_lock_state: $vehicleLockState
        ended_at: $endedAt
      }
    ) {
      id
      ...JourneyPreview
    }
  }
  ${JourneyPreviewFragmentDoc}
`
export type AdjustEndJourneyMutationFn = Apollo.MutationFunction<
  AdjustEndJourneyMutation,
  AdjustEndJourneyMutationVariables
>

/**
 * __useAdjustEndJourneyMutation__
 *
 * To run a mutation, you first call `useAdjustEndJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustEndJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustEndJourneyMutation, { data, loading, error }] = useAdjustEndJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      actionType: // value for 'actionType'
 *      extraActions: // value for 'extraActions'
 *      parkingStatus: // value for 'parkingStatus'
 *      vehicleLockState: // value for 'vehicleLockState'
 *      endedAt: // value for 'endedAt'
 *   },
 * });
 */
export function useAdjustEndJourneyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdjustEndJourneyMutation,
    AdjustEndJourneyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdjustEndJourneyMutation,
    AdjustEndJourneyMutationVariables
  >(AdjustEndJourneyDocument, options)
}
export type AdjustEndJourneyMutationHookResult = ReturnType<
  typeof useAdjustEndJourneyMutation
>
export type AdjustEndJourneyMutationResult =
  Apollo.MutationResult<AdjustEndJourneyMutation>
export type AdjustEndJourneyMutationOptions = Apollo.BaseMutationOptions<
  AdjustEndJourneyMutation,
  AdjustEndJourneyMutationVariables
>
export const AllModulesDocument = gql`
  query AllModules(
    $scheme_id: ID
    $paginate: Paginate
    $where: [ModuleWhere]
    $order_by: [ModuleOrderby]
  ) {
    table: modules(
      scheme_id: $scheme_id
      paginate: $paginate
      where: $where
      order_by: $order_by
    ) {
      nodes {
        ...ModuleBasic
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
  }
  ${ModuleBasicFragmentDoc}
`

/**
 * __useAllModulesQuery__
 *
 * To run a query within a React component, call `useAllModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllModulesQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useAllModulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllModulesQuery,
    AllModulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AllModulesQuery, AllModulesQueryVariables>(
    AllModulesDocument,
    options,
  )
}
export function useAllModulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllModulesQuery,
    AllModulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AllModulesQuery, AllModulesQueryVariables>(
    AllModulesDocument,
    options,
  )
}
// @ts-ignore
export function useAllModulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllModulesQuery,
    AllModulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AllModulesQuery, AllModulesQueryVariables>
export function useAllModulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllModulesQuery,
        AllModulesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AllModulesQuery | undefined,
  AllModulesQueryVariables
>
export function useAllModulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllModulesQuery,
        AllModulesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AllModulesQuery, AllModulesQueryVariables>(
    AllModulesDocument,
    options,
  )
}
export type AllModulesQueryHookResult = ReturnType<typeof useAllModulesQuery>
export type AllModulesLazyQueryHookResult = ReturnType<
  typeof useAllModulesLazyQuery
>
export type AllModulesSuspenseQueryHookResult = ReturnType<
  typeof useAllModulesSuspenseQuery
>
export type AllModulesQueryResult = Apollo.QueryResult<
  AllModulesQuery,
  AllModulesQueryVariables
>
export const ModuleVehicleCommissionedDocument = gql`
  query ModuleVehicleCommissioned($module_id: ID!) {
    module(module_id: $module_id) {
      hardware_type
      id
      vehicle {
        id
        frame_id
        frame_type
        detail {
          id
          lock_configuration
          vehicle_unlock_id
          scheme {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useModuleVehicleCommissionedQuery__
 *
 * To run a query within a React component, call `useModuleVehicleCommissionedQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleVehicleCommissionedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleVehicleCommissionedQuery({
 *   variables: {
 *      module_id: // value for 'module_id'
 *   },
 * });
 */
export function useModuleVehicleCommissionedQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModuleVehicleCommissionedQuery,
    ModuleVehicleCommissionedQueryVariables
  > &
    (
      | { variables: ModuleVehicleCommissionedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ModuleVehicleCommissionedQuery,
    ModuleVehicleCommissionedQueryVariables
  >(ModuleVehicleCommissionedDocument, options)
}
export function useModuleVehicleCommissionedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModuleVehicleCommissionedQuery,
    ModuleVehicleCommissionedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ModuleVehicleCommissionedQuery,
    ModuleVehicleCommissionedQueryVariables
  >(ModuleVehicleCommissionedDocument, options)
}
// @ts-ignore
export function useModuleVehicleCommissionedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModuleVehicleCommissionedQuery,
    ModuleVehicleCommissionedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ModuleVehicleCommissionedQuery,
  ModuleVehicleCommissionedQueryVariables
>
export function useModuleVehicleCommissionedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleVehicleCommissionedQuery,
        ModuleVehicleCommissionedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ModuleVehicleCommissionedQuery | undefined,
  ModuleVehicleCommissionedQueryVariables
>
export function useModuleVehicleCommissionedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleVehicleCommissionedQuery,
        ModuleVehicleCommissionedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ModuleVehicleCommissionedQuery,
    ModuleVehicleCommissionedQueryVariables
  >(ModuleVehicleCommissionedDocument, options)
}
export type ModuleVehicleCommissionedQueryHookResult = ReturnType<
  typeof useModuleVehicleCommissionedQuery
>
export type ModuleVehicleCommissionedLazyQueryHookResult = ReturnType<
  typeof useModuleVehicleCommissionedLazyQuery
>
export type ModuleVehicleCommissionedSuspenseQueryHookResult = ReturnType<
  typeof useModuleVehicleCommissionedSuspenseQuery
>
export type ModuleVehicleCommissionedQueryResult = Apollo.QueryResult<
  ModuleVehicleCommissionedQuery,
  ModuleVehicleCommissionedQueryVariables
>
export const ModuleVehicleDocument = gql`
  query ModuleVehicle($module_id: ID!) {
    module(module_id: $module_id) {
      vehicle {
        id
        frame_id
        frame_type
        hardware_type
        detail {
          id
          scheme {
            id
            name
          }
          module {
            id
          }
        }
      }
    }
  }
`

/**
 * __useModuleVehicleQuery__
 *
 * To run a query within a React component, call `useModuleVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleVehicleQuery({
 *   variables: {
 *      module_id: // value for 'module_id'
 *   },
 * });
 */
export function useModuleVehicleQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModuleVehicleQuery,
    ModuleVehicleQueryVariables
  > &
    (
      | { variables: ModuleVehicleQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ModuleVehicleQuery, ModuleVehicleQueryVariables>(
    ModuleVehicleDocument,
    options,
  )
}
export function useModuleVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModuleVehicleQuery,
    ModuleVehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ModuleVehicleQuery, ModuleVehicleQueryVariables>(
    ModuleVehicleDocument,
    options,
  )
}
// @ts-ignore
export function useModuleVehicleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModuleVehicleQuery,
    ModuleVehicleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ModuleVehicleQuery,
  ModuleVehicleQueryVariables
>
export function useModuleVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleVehicleQuery,
        ModuleVehicleQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ModuleVehicleQuery | undefined,
  ModuleVehicleQueryVariables
>
export function useModuleVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleVehicleQuery,
        ModuleVehicleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ModuleVehicleQuery,
    ModuleVehicleQueryVariables
  >(ModuleVehicleDocument, options)
}
export type ModuleVehicleQueryHookResult = ReturnType<
  typeof useModuleVehicleQuery
>
export type ModuleVehicleLazyQueryHookResult = ReturnType<
  typeof useModuleVehicleLazyQuery
>
export type ModuleVehicleSuspenseQueryHookResult = ReturnType<
  typeof useModuleVehicleSuspenseQuery
>
export type ModuleVehicleQueryResult = Apollo.QueryResult<
  ModuleVehicleQuery,
  ModuleVehicleQueryVariables
>
export const ModuleSummaryDocument = gql`
  query ModuleSummary($id: ID!) {
    module(module_id: $id) {
      id
      hardware_type
      unlock_id
      vehicle {
        id
        frame_id
        frame_type
        frame_model
        detail {
          id
          scheme {
            id
            config {
              is_vehicle_rewards_enabled
            }
          }
          lock_configuration
        }
        state {
          id
          state
        }
        rewards {
          type
        }
      }
      module_state {
        id
        ... on ModuleState {
          firmware_version
          power_mode
          drive_id
          battery_id
          orientation
          dock_nfc_tag_id
          assist_config
        }
        ... on ScooterModuleState {
          battery_id
          max_speed
          ecu_error {
            id
            code
            name
            cause
            solution
            protection
          }
          orientation
        }
      }
      lock_state {
        id
        time
        overall_state
        vehicle_lock_state
      }
      dock_state {
        id
        time
        message
      }
      availability {
        id
        status
      }
      connectivity {
        is_online
      }
      location {
        id
        time
      }
      telemetry {
        id
        battery_percent
        drive {
          battery_percent
        }
      }
      tags {
        id
        name
        created_at
      }
    }
  }
`

/**
 * __useModuleSummaryQuery__
 *
 * To run a query within a React component, call `useModuleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModuleSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModuleSummaryQuery,
    ModuleSummaryQueryVariables
  > &
    (
      | { variables: ModuleSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ModuleSummaryQuery, ModuleSummaryQueryVariables>(
    ModuleSummaryDocument,
    options,
  )
}
export function useModuleSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModuleSummaryQuery,
    ModuleSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ModuleSummaryQuery, ModuleSummaryQueryVariables>(
    ModuleSummaryDocument,
    options,
  )
}
// @ts-ignore
export function useModuleSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModuleSummaryQuery,
    ModuleSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ModuleSummaryQuery,
  ModuleSummaryQueryVariables
>
export function useModuleSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleSummaryQuery,
        ModuleSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ModuleSummaryQuery | undefined,
  ModuleSummaryQueryVariables
>
export function useModuleSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleSummaryQuery,
        ModuleSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ModuleSummaryQuery,
    ModuleSummaryQueryVariables
  >(ModuleSummaryDocument, options)
}
export type ModuleSummaryQueryHookResult = ReturnType<
  typeof useModuleSummaryQuery
>
export type ModuleSummaryLazyQueryHookResult = ReturnType<
  typeof useModuleSummaryLazyQuery
>
export type ModuleSummarySuspenseQueryHookResult = ReturnType<
  typeof useModuleSummarySuspenseQuery
>
export type ModuleSummaryQueryResult = Apollo.QueryResult<
  ModuleSummaryQuery,
  ModuleSummaryQueryVariables
>
export const CommissionVehicleDocument = gql`
  mutation CommissionVehicle(
    $module_id: ID!
    $frame_id: ID!
    $scheme_id: ID!
    $lock_configuration: LockConfiguration!
    $frame_type: FrameType!
    $vehicle_unlock_id: ID
    $hardware_subtype: ModuleHardwareSubtype
  ) {
    commission_V2(
      module_id: $module_id
      frame_id: $frame_id
      scheme_id: $scheme_id
      lock_configuration: $lock_configuration
      frame_type: $frame_type
      vehicle_unlock_id: $vehicle_unlock_id
      hardware_subtype: $hardware_subtype
    ) {
      id
      detail {
        id
        lock_configuration
        vehicle_unlock_id
        scheme {
          id
        }
      }
      frame_id
    }
  }
`
export type CommissionVehicleMutationFn = Apollo.MutationFunction<
  CommissionVehicleMutation,
  CommissionVehicleMutationVariables
>

/**
 * __useCommissionVehicleMutation__
 *
 * To run a mutation, you first call `useCommissionVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommissionVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commissionVehicleMutation, { data, loading, error }] = useCommissionVehicleMutation({
 *   variables: {
 *      module_id: // value for 'module_id'
 *      frame_id: // value for 'frame_id'
 *      scheme_id: // value for 'scheme_id'
 *      lock_configuration: // value for 'lock_configuration'
 *      frame_type: // value for 'frame_type'
 *      vehicle_unlock_id: // value for 'vehicle_unlock_id'
 *      hardware_subtype: // value for 'hardware_subtype'
 *   },
 * });
 */
export function useCommissionVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommissionVehicleMutation,
    CommissionVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CommissionVehicleMutation,
    CommissionVehicleMutationVariables
  >(CommissionVehicleDocument, options)
}
export type CommissionVehicleMutationHookResult = ReturnType<
  typeof useCommissionVehicleMutation
>
export type CommissionVehicleMutationResult =
  Apollo.MutationResult<CommissionVehicleMutation>
export type CommissionVehicleMutationOptions = Apollo.BaseMutationOptions<
  CommissionVehicleMutation,
  CommissionVehicleMutationVariables
>
export const DecommissionVehicleDocument = gql`
  mutation DecommissionVehicle($module_id: ID!) {
    decommission(module_id: $module_id)
  }
`
export type DecommissionVehicleMutationFn = Apollo.MutationFunction<
  DecommissionVehicleMutation,
  DecommissionVehicleMutationVariables
>

/**
 * __useDecommissionVehicleMutation__
 *
 * To run a mutation, you first call `useDecommissionVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecommissionVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decommissionVehicleMutation, { data, loading, error }] = useDecommissionVehicleMutation({
 *   variables: {
 *      module_id: // value for 'module_id'
 *   },
 * });
 */
export function useDecommissionVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DecommissionVehicleMutation,
    DecommissionVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DecommissionVehicleMutation,
    DecommissionVehicleMutationVariables
  >(DecommissionVehicleDocument, options)
}
export type DecommissionVehicleMutationHookResult = ReturnType<
  typeof useDecommissionVehicleMutation
>
export type DecommissionVehicleMutationResult =
  Apollo.MutationResult<DecommissionVehicleMutation>
export type DecommissionVehicleMutationOptions = Apollo.BaseMutationOptions<
  DecommissionVehicleMutation,
  DecommissionVehicleMutationVariables
>
export const MoveSchemeDocument = gql`
  mutation MoveScheme($module_id: ID!, $scheme_id: ID!) {
    move_scheme(module_id: $module_id, scheme_id: $scheme_id) {
      id
    }
  }
`
export type MoveSchemeMutationFn = Apollo.MutationFunction<
  MoveSchemeMutation,
  MoveSchemeMutationVariables
>

/**
 * __useMoveSchemeMutation__
 *
 * To run a mutation, you first call `useMoveSchemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveSchemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveSchemeMutation, { data, loading, error }] = useMoveSchemeMutation({
 *   variables: {
 *      module_id: // value for 'module_id'
 *      scheme_id: // value for 'scheme_id'
 *   },
 * });
 */
export function useMoveSchemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveSchemeMutation,
    MoveSchemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveSchemeMutation, MoveSchemeMutationVariables>(
    MoveSchemeDocument,
    options,
  )
}
export type MoveSchemeMutationHookResult = ReturnType<
  typeof useMoveSchemeMutation
>
export type MoveSchemeMutationResult = Apollo.MutationResult<MoveSchemeMutation>
export type MoveSchemeMutationOptions = Apollo.BaseMutationOptions<
  MoveSchemeMutation,
  MoveSchemeMutationVariables
>
export const ModuleHistoryDocument = gql`
  query ModuleHistory($id: ID!, $paginate: Paginate) {
    node: module(module_id: $id) {
      id
      lock_state_history(paginate: $paginate) {
        nodes {
          id
          time
          overall_state
          vehicle_lock_state
          front_lock_state
          rear_lock_state
          source
        }
        pagination {
          current: page
          pageSize: per_page
          total
        }
      }
    }
  }
`

/**
 * __useModuleHistoryQuery__
 *
 * To run a query within a React component, call `useModuleHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useModuleHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModuleHistoryQuery,
    ModuleHistoryQueryVariables
  > &
    (
      | { variables: ModuleHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ModuleHistoryQuery, ModuleHistoryQueryVariables>(
    ModuleHistoryDocument,
    options,
  )
}
export function useModuleHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModuleHistoryQuery,
    ModuleHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ModuleHistoryQuery, ModuleHistoryQueryVariables>(
    ModuleHistoryDocument,
    options,
  )
}
// @ts-ignore
export function useModuleHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModuleHistoryQuery,
    ModuleHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ModuleHistoryQuery,
  ModuleHistoryQueryVariables
>
export function useModuleHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleHistoryQuery,
        ModuleHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ModuleHistoryQuery | undefined,
  ModuleHistoryQueryVariables
>
export function useModuleHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleHistoryQuery,
        ModuleHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ModuleHistoryQuery,
    ModuleHistoryQueryVariables
  >(ModuleHistoryDocument, options)
}
export type ModuleHistoryQueryHookResult = ReturnType<
  typeof useModuleHistoryQuery
>
export type ModuleHistoryLazyQueryHookResult = ReturnType<
  typeof useModuleHistoryLazyQuery
>
export type ModuleHistorySuspenseQueryHookResult = ReturnType<
  typeof useModuleHistorySuspenseQuery
>
export type ModuleHistoryQueryResult = Apollo.QueryResult<
  ModuleHistoryQuery,
  ModuleHistoryQueryVariables
>
export const OTADeviceInformationDocument = gql`
  query OTADeviceInformation($module_id: ID!) {
    ota_device_information(module_id: $module_id) {
      hardware_versions {
        ecu
        meter
        iot
        repeater
        helmet_lock
      }
      firmware_versions {
        ecu
        meter
        iot
        repeater
        helmet_lock
      }
      required_firmware_versions {
        ecu
        meter
        iot
        repeater
        helmet_lock
      }
      server_address
      server_port
      config_set_at
      scheme_config_set_at
      time
    }
  }
`

/**
 * __useOTADeviceInformationQuery__
 *
 * To run a query within a React component, call `useOTADeviceInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOTADeviceInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOTADeviceInformationQuery({
 *   variables: {
 *      module_id: // value for 'module_id'
 *   },
 * });
 */
export function useOTADeviceInformationQuery(
  baseOptions: Apollo.QueryHookOptions<
    OTADeviceInformationQuery,
    OTADeviceInformationQueryVariables
  > &
    (
      | { variables: OTADeviceInformationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OTADeviceInformationQuery,
    OTADeviceInformationQueryVariables
  >(OTADeviceInformationDocument, options)
}
export function useOTADeviceInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OTADeviceInformationQuery,
    OTADeviceInformationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OTADeviceInformationQuery,
    OTADeviceInformationQueryVariables
  >(OTADeviceInformationDocument, options)
}
// @ts-ignore
export function useOTADeviceInformationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OTADeviceInformationQuery,
    OTADeviceInformationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OTADeviceInformationQuery,
  OTADeviceInformationQueryVariables
>
export function useOTADeviceInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTADeviceInformationQuery,
        OTADeviceInformationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OTADeviceInformationQuery | undefined,
  OTADeviceInformationQueryVariables
>
export function useOTADeviceInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTADeviceInformationQuery,
        OTADeviceInformationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OTADeviceInformationQuery,
    OTADeviceInformationQueryVariables
  >(OTADeviceInformationDocument, options)
}
export type OTADeviceInformationQueryHookResult = ReturnType<
  typeof useOTADeviceInformationQuery
>
export type OTADeviceInformationLazyQueryHookResult = ReturnType<
  typeof useOTADeviceInformationLazyQuery
>
export type OTADeviceInformationSuspenseQueryHookResult = ReturnType<
  typeof useOTADeviceInformationSuspenseQuery
>
export type OTADeviceInformationQueryResult = Apollo.QueryResult<
  OTADeviceInformationQuery,
  OTADeviceInformationQueryVariables
>
export const OTAFirmwaresDocument = gql`
  query OTAFirmwares {
    ota_firmwares {
      ...FullOTAFirmware
    }
  }
  ${FullOTAFirmwareFragmentDoc}
`

/**
 * __useOTAFirmwaresQuery__
 *
 * To run a query within a React component, call `useOTAFirmwaresQuery` and pass it any options that fit your needs.
 * When your component renders, `useOTAFirmwaresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOTAFirmwaresQuery({
 *   variables: {
 *   },
 * });
 */
export function useOTAFirmwaresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OTAFirmwaresQuery,
    OTAFirmwaresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OTAFirmwaresQuery, OTAFirmwaresQueryVariables>(
    OTAFirmwaresDocument,
    options,
  )
}
export function useOTAFirmwaresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OTAFirmwaresQuery,
    OTAFirmwaresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OTAFirmwaresQuery, OTAFirmwaresQueryVariables>(
    OTAFirmwaresDocument,
    options,
  )
}
// @ts-ignore
export function useOTAFirmwaresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OTAFirmwaresQuery,
    OTAFirmwaresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OTAFirmwaresQuery, OTAFirmwaresQueryVariables>
export function useOTAFirmwaresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTAFirmwaresQuery,
        OTAFirmwaresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OTAFirmwaresQuery | undefined,
  OTAFirmwaresQueryVariables
>
export function useOTAFirmwaresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTAFirmwaresQuery,
        OTAFirmwaresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OTAFirmwaresQuery, OTAFirmwaresQueryVariables>(
    OTAFirmwaresDocument,
    options,
  )
}
export type OTAFirmwaresQueryHookResult = ReturnType<
  typeof useOTAFirmwaresQuery
>
export type OTAFirmwaresLazyQueryHookResult = ReturnType<
  typeof useOTAFirmwaresLazyQuery
>
export type OTAFirmwaresSuspenseQueryHookResult = ReturnType<
  typeof useOTAFirmwaresSuspenseQuery
>
export type OTAFirmwaresQueryResult = Apollo.QueryResult<
  OTAFirmwaresQuery,
  OTAFirmwaresQueryVariables
>
export const CompatibleOTAFirmwaresDocument = gql`
  query CompatibleOTAFirmwares($module_id: ID!) {
    compatible_ota_firmwares(module_id: $module_id) {
      ...FullOTAFirmware
    }
  }
  ${FullOTAFirmwareFragmentDoc}
`

/**
 * __useCompatibleOTAFirmwaresQuery__
 *
 * To run a query within a React component, call `useCompatibleOTAFirmwaresQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompatibleOTAFirmwaresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompatibleOTAFirmwaresQuery({
 *   variables: {
 *      module_id: // value for 'module_id'
 *   },
 * });
 */
export function useCompatibleOTAFirmwaresQuery(
  baseOptions: Apollo.QueryHookOptions<
    CompatibleOTAFirmwaresQuery,
    CompatibleOTAFirmwaresQueryVariables
  > &
    (
      | { variables: CompatibleOTAFirmwaresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CompatibleOTAFirmwaresQuery,
    CompatibleOTAFirmwaresQueryVariables
  >(CompatibleOTAFirmwaresDocument, options)
}
export function useCompatibleOTAFirmwaresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompatibleOTAFirmwaresQuery,
    CompatibleOTAFirmwaresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CompatibleOTAFirmwaresQuery,
    CompatibleOTAFirmwaresQueryVariables
  >(CompatibleOTAFirmwaresDocument, options)
}
// @ts-ignore
export function useCompatibleOTAFirmwaresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompatibleOTAFirmwaresQuery,
    CompatibleOTAFirmwaresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CompatibleOTAFirmwaresQuery,
  CompatibleOTAFirmwaresQueryVariables
>
export function useCompatibleOTAFirmwaresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CompatibleOTAFirmwaresQuery,
        CompatibleOTAFirmwaresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CompatibleOTAFirmwaresQuery | undefined,
  CompatibleOTAFirmwaresQueryVariables
>
export function useCompatibleOTAFirmwaresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CompatibleOTAFirmwaresQuery,
        CompatibleOTAFirmwaresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CompatibleOTAFirmwaresQuery,
    CompatibleOTAFirmwaresQueryVariables
  >(CompatibleOTAFirmwaresDocument, options)
}
export type CompatibleOTAFirmwaresQueryHookResult = ReturnType<
  typeof useCompatibleOTAFirmwaresQuery
>
export type CompatibleOTAFirmwaresLazyQueryHookResult = ReturnType<
  typeof useCompatibleOTAFirmwaresLazyQuery
>
export type CompatibleOTAFirmwaresSuspenseQueryHookResult = ReturnType<
  typeof useCompatibleOTAFirmwaresSuspenseQuery
>
export type CompatibleOTAFirmwaresQueryResult = Apollo.QueryResult<
  CompatibleOTAFirmwaresQuery,
  CompatibleOTAFirmwaresQueryVariables
>
export const OTAListBucketFirmwaresDocument = gql`
  query OTAListBucketFirmwares {
    list_ota_bucket_firmwares
  }
`

/**
 * __useOTAListBucketFirmwaresQuery__
 *
 * To run a query within a React component, call `useOTAListBucketFirmwaresQuery` and pass it any options that fit your needs.
 * When your component renders, `useOTAListBucketFirmwaresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOTAListBucketFirmwaresQuery({
 *   variables: {
 *   },
 * });
 */
export function useOTAListBucketFirmwaresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OTAListBucketFirmwaresQuery,
    OTAListBucketFirmwaresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OTAListBucketFirmwaresQuery,
    OTAListBucketFirmwaresQueryVariables
  >(OTAListBucketFirmwaresDocument, options)
}
export function useOTAListBucketFirmwaresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OTAListBucketFirmwaresQuery,
    OTAListBucketFirmwaresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OTAListBucketFirmwaresQuery,
    OTAListBucketFirmwaresQueryVariables
  >(OTAListBucketFirmwaresDocument, options)
}
// @ts-ignore
export function useOTAListBucketFirmwaresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OTAListBucketFirmwaresQuery,
    OTAListBucketFirmwaresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OTAListBucketFirmwaresQuery,
  OTAListBucketFirmwaresQueryVariables
>
export function useOTAListBucketFirmwaresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTAListBucketFirmwaresQuery,
        OTAListBucketFirmwaresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OTAListBucketFirmwaresQuery | undefined,
  OTAListBucketFirmwaresQueryVariables
>
export function useOTAListBucketFirmwaresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTAListBucketFirmwaresQuery,
        OTAListBucketFirmwaresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OTAListBucketFirmwaresQuery,
    OTAListBucketFirmwaresQueryVariables
  >(OTAListBucketFirmwaresDocument, options)
}
export type OTAListBucketFirmwaresQueryHookResult = ReturnType<
  typeof useOTAListBucketFirmwaresQuery
>
export type OTAListBucketFirmwaresLazyQueryHookResult = ReturnType<
  typeof useOTAListBucketFirmwaresLazyQuery
>
export type OTAListBucketFirmwaresSuspenseQueryHookResult = ReturnType<
  typeof useOTAListBucketFirmwaresSuspenseQuery
>
export type OTAListBucketFirmwaresQueryResult = Apollo.QueryResult<
  OTAListBucketFirmwaresQuery,
  OTAListBucketFirmwaresQueryVariables
>
export const UpsertOTAFirmwareDocument = gql`
  mutation UpsertOTAFirmware($input: OTAFirmwareInput!) {
    upsert_ota_firmware(input: $input) {
      ...FullOTAFirmware
    }
  }
  ${FullOTAFirmwareFragmentDoc}
`
export type UpsertOTAFirmwareMutationFn = Apollo.MutationFunction<
  UpsertOTAFirmwareMutation,
  UpsertOTAFirmwareMutationVariables
>

/**
 * __useUpsertOTAFirmwareMutation__
 *
 * To run a mutation, you first call `useUpsertOTAFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOTAFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOtaFirmwareMutation, { data, loading, error }] = useUpsertOTAFirmwareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOTAFirmwareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertOTAFirmwareMutation,
    UpsertOTAFirmwareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertOTAFirmwareMutation,
    UpsertOTAFirmwareMutationVariables
  >(UpsertOTAFirmwareDocument, options)
}
export type UpsertOTAFirmwareMutationHookResult = ReturnType<
  typeof useUpsertOTAFirmwareMutation
>
export type UpsertOTAFirmwareMutationResult =
  Apollo.MutationResult<UpsertOTAFirmwareMutation>
export type UpsertOTAFirmwareMutationOptions = Apollo.BaseMutationOptions<
  UpsertOTAFirmwareMutation,
  UpsertOTAFirmwareMutationVariables
>
export const PromoteOTAFirmwareDocument = gql`
  mutation PromoteOTAFirmware($id: Int!, $status: FirmwareStatus!) {
    promote_ota_firmware(id: $id, status: $status) {
      ...FullOTAFirmware
    }
  }
  ${FullOTAFirmwareFragmentDoc}
`
export type PromoteOTAFirmwareMutationFn = Apollo.MutationFunction<
  PromoteOTAFirmwareMutation,
  PromoteOTAFirmwareMutationVariables
>

/**
 * __usePromoteOTAFirmwareMutation__
 *
 * To run a mutation, you first call `usePromoteOTAFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteOTAFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteOtaFirmwareMutation, { data, loading, error }] = usePromoteOTAFirmwareMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function usePromoteOTAFirmwareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PromoteOTAFirmwareMutation,
    PromoteOTAFirmwareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PromoteOTAFirmwareMutation,
    PromoteOTAFirmwareMutationVariables
  >(PromoteOTAFirmwareDocument, options)
}
export type PromoteOTAFirmwareMutationHookResult = ReturnType<
  typeof usePromoteOTAFirmwareMutation
>
export type PromoteOTAFirmwareMutationResult =
  Apollo.MutationResult<PromoteOTAFirmwareMutation>
export type PromoteOTAFirmwareMutationOptions = Apollo.BaseMutationOptions<
  PromoteOTAFirmwareMutation,
  PromoteOTAFirmwareMutationVariables
>
export const DeleteOTAFirmwareDocument = gql`
  mutation DeleteOTAFirmware($id: Int!) {
    delete_ota_firmware(id: $id) {
      ...FullOTAFirmware
    }
  }
  ${FullOTAFirmwareFragmentDoc}
`
export type DeleteOTAFirmwareMutationFn = Apollo.MutationFunction<
  DeleteOTAFirmwareMutation,
  DeleteOTAFirmwareMutationVariables
>

/**
 * __useDeleteOTAFirmwareMutation__
 *
 * To run a mutation, you first call `useDeleteOTAFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOTAFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOtaFirmwareMutation, { data, loading, error }] = useDeleteOTAFirmwareMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOTAFirmwareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOTAFirmwareMutation,
    DeleteOTAFirmwareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteOTAFirmwareMutation,
    DeleteOTAFirmwareMutationVariables
  >(DeleteOTAFirmwareDocument, options)
}
export type DeleteOTAFirmwareMutationHookResult = ReturnType<
  typeof useDeleteOTAFirmwareMutation
>
export type DeleteOTAFirmwareMutationResult =
  Apollo.MutationResult<DeleteOTAFirmwareMutation>
export type DeleteOTAFirmwareMutationOptions = Apollo.BaseMutationOptions<
  DeleteOTAFirmwareMutation,
  DeleteOTAFirmwareMutationVariables
>
export const OTAConfigurationCommandsDocument = gql`
  query OTAConfigurationCommands {
    ota_configuration_commands {
      ...FullOTAConfigurationCommand
    }
  }
  ${FullOTAConfigurationCommandFragmentDoc}
`

/**
 * __useOTAConfigurationCommandsQuery__
 *
 * To run a query within a React component, call `useOTAConfigurationCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOTAConfigurationCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOTAConfigurationCommandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOTAConfigurationCommandsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OTAConfigurationCommandsQuery,
    OTAConfigurationCommandsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OTAConfigurationCommandsQuery,
    OTAConfigurationCommandsQueryVariables
  >(OTAConfigurationCommandsDocument, options)
}
export function useOTAConfigurationCommandsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OTAConfigurationCommandsQuery,
    OTAConfigurationCommandsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OTAConfigurationCommandsQuery,
    OTAConfigurationCommandsQueryVariables
  >(OTAConfigurationCommandsDocument, options)
}
// @ts-ignore
export function useOTAConfigurationCommandsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OTAConfigurationCommandsQuery,
    OTAConfigurationCommandsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OTAConfigurationCommandsQuery,
  OTAConfigurationCommandsQueryVariables
>
export function useOTAConfigurationCommandsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTAConfigurationCommandsQuery,
        OTAConfigurationCommandsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OTAConfigurationCommandsQuery | undefined,
  OTAConfigurationCommandsQueryVariables
>
export function useOTAConfigurationCommandsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OTAConfigurationCommandsQuery,
        OTAConfigurationCommandsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OTAConfigurationCommandsQuery,
    OTAConfigurationCommandsQueryVariables
  >(OTAConfigurationCommandsDocument, options)
}
export type OTAConfigurationCommandsQueryHookResult = ReturnType<
  typeof useOTAConfigurationCommandsQuery
>
export type OTAConfigurationCommandsLazyQueryHookResult = ReturnType<
  typeof useOTAConfigurationCommandsLazyQuery
>
export type OTAConfigurationCommandsSuspenseQueryHookResult = ReturnType<
  typeof useOTAConfigurationCommandsSuspenseQuery
>
export type OTAConfigurationCommandsQueryResult = Apollo.QueryResult<
  OTAConfigurationCommandsQuery,
  OTAConfigurationCommandsQueryVariables
>
export const InsertConfigCommandDocument = gql`
  mutation InsertConfigCommand($input: OTAConfigurationCommandInput!) {
    insert_ota_configuration_command(input: $input) {
      ...FullOTAConfigurationCommand
    }
  }
  ${FullOTAConfigurationCommandFragmentDoc}
`
export type InsertConfigCommandMutationFn = Apollo.MutationFunction<
  InsertConfigCommandMutation,
  InsertConfigCommandMutationVariables
>

/**
 * __useInsertConfigCommandMutation__
 *
 * To run a mutation, you first call `useInsertConfigCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertConfigCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertConfigCommandMutation, { data, loading, error }] = useInsertConfigCommandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertConfigCommandMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InsertConfigCommandMutation,
    InsertConfigCommandMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    InsertConfigCommandMutation,
    InsertConfigCommandMutationVariables
  >(InsertConfigCommandDocument, options)
}
export type InsertConfigCommandMutationHookResult = ReturnType<
  typeof useInsertConfigCommandMutation
>
export type InsertConfigCommandMutationResult =
  Apollo.MutationResult<InsertConfigCommandMutation>
export type InsertConfigCommandMutationOptions = Apollo.BaseMutationOptions<
  InsertConfigCommandMutation,
  InsertConfigCommandMutationVariables
>
export const DeleteOTAConfigurationCommandDocument = gql`
  mutation DeleteOTAConfigurationCommand($id: Int!) {
    delete_ota_configuration_command(id: $id) {
      ...FullOTAConfigurationCommand
    }
  }
  ${FullOTAConfigurationCommandFragmentDoc}
`
export type DeleteOTAConfigurationCommandMutationFn = Apollo.MutationFunction<
  DeleteOTAConfigurationCommandMutation,
  DeleteOTAConfigurationCommandMutationVariables
>

/**
 * __useDeleteOTAConfigurationCommandMutation__
 *
 * To run a mutation, you first call `useDeleteOTAConfigurationCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOTAConfigurationCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOtaConfigurationCommandMutation, { data, loading, error }] = useDeleteOTAConfigurationCommandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOTAConfigurationCommandMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOTAConfigurationCommandMutation,
    DeleteOTAConfigurationCommandMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteOTAConfigurationCommandMutation,
    DeleteOTAConfigurationCommandMutationVariables
  >(DeleteOTAConfigurationCommandDocument, options)
}
export type DeleteOTAConfigurationCommandMutationHookResult = ReturnType<
  typeof useDeleteOTAConfigurationCommandMutation
>
export type DeleteOTAConfigurationCommandMutationResult =
  Apollo.MutationResult<DeleteOTAConfigurationCommandMutation>
export type DeleteOTAConfigurationCommandMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteOTAConfigurationCommandMutation,
    DeleteOTAConfigurationCommandMutationVariables
  >
export const SideloadOTAFirmwareDocument = gql`
  mutation SideloadOTAFirmware($module_id: ID!, $firmware_id: Int!) {
    sideload_module_firmware(module_id: $module_id, firmware_id: $firmware_id)
  }
`
export type SideloadOTAFirmwareMutationFn = Apollo.MutationFunction<
  SideloadOTAFirmwareMutation,
  SideloadOTAFirmwareMutationVariables
>

/**
 * __useSideloadOTAFirmwareMutation__
 *
 * To run a mutation, you first call `useSideloadOTAFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSideloadOTAFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sideloadOtaFirmwareMutation, { data, loading, error }] = useSideloadOTAFirmwareMutation({
 *   variables: {
 *      module_id: // value for 'module_id'
 *      firmware_id: // value for 'firmware_id'
 *   },
 * });
 */
export function useSideloadOTAFirmwareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SideloadOTAFirmwareMutation,
    SideloadOTAFirmwareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SideloadOTAFirmwareMutation,
    SideloadOTAFirmwareMutationVariables
  >(SideloadOTAFirmwareDocument, options)
}
export type SideloadOTAFirmwareMutationHookResult = ReturnType<
  typeof useSideloadOTAFirmwareMutation
>
export type SideloadOTAFirmwareMutationResult =
  Apollo.MutationResult<SideloadOTAFirmwareMutation>
export type SideloadOTAFirmwareMutationOptions = Apollo.BaseMutationOptions<
  SideloadOTAFirmwareMutation,
  SideloadOTAFirmwareMutationVariables
>
export const SchemeProductListDocument = gql`
  query SchemeProductList($scheme_id: ID!, $paginate: Paginate) {
    table: all_scheme_products(scheme_id: $scheme_id, paginate: $paginate) {
      nodes {
        ...ProductSummary
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
    role_types {
      description
    }
  }
  ${ProductSummaryFragmentDoc}
`

/**
 * __useSchemeProductListQuery__
 *
 * To run a query within a React component, call `useSchemeProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeProductListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useSchemeProductListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeProductListQuery,
    SchemeProductListQueryVariables
  > &
    (
      | { variables: SchemeProductListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchemeProductListQuery,
    SchemeProductListQueryVariables
  >(SchemeProductListDocument, options)
}
export function useSchemeProductListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeProductListQuery,
    SchemeProductListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemeProductListQuery,
    SchemeProductListQueryVariables
  >(SchemeProductListDocument, options)
}
// @ts-ignore
export function useSchemeProductListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeProductListQuery,
    SchemeProductListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeProductListQuery,
  SchemeProductListQueryVariables
>
export function useSchemeProductListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeProductListQuery,
        SchemeProductListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeProductListQuery | undefined,
  SchemeProductListQueryVariables
>
export function useSchemeProductListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeProductListQuery,
        SchemeProductListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeProductListQuery,
    SchemeProductListQueryVariables
  >(SchemeProductListDocument, options)
}
export type SchemeProductListQueryHookResult = ReturnType<
  typeof useSchemeProductListQuery
>
export type SchemeProductListLazyQueryHookResult = ReturnType<
  typeof useSchemeProductListLazyQuery
>
export type SchemeProductListSuspenseQueryHookResult = ReturnType<
  typeof useSchemeProductListSuspenseQuery
>
export type SchemeProductListQueryResult = Apollo.QueryResult<
  SchemeProductListQuery,
  SchemeProductListQueryVariables
>
export const SchemeProductConfigListDocument = gql`
  query SchemeProductConfigList($schemeId: ID!) {
    all_scheme_products(
      scheme_id: $schemeId
      paginate: { page: 1, per_page: 100 }
    ) {
      nodes {
        id
        product_type
        ...ProductConfigs
      }
    }
  }
  ${ProductConfigsFragmentDoc}
`

/**
 * __useSchemeProductConfigListQuery__
 *
 * To run a query within a React component, call `useSchemeProductConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeProductConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeProductConfigListQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useSchemeProductConfigListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeProductConfigListQuery,
    SchemeProductConfigListQueryVariables
  > &
    (
      | { variables: SchemeProductConfigListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchemeProductConfigListQuery,
    SchemeProductConfigListQueryVariables
  >(SchemeProductConfigListDocument, options)
}
export function useSchemeProductConfigListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeProductConfigListQuery,
    SchemeProductConfigListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemeProductConfigListQuery,
    SchemeProductConfigListQueryVariables
  >(SchemeProductConfigListDocument, options)
}
// @ts-ignore
export function useSchemeProductConfigListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeProductConfigListQuery,
    SchemeProductConfigListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeProductConfigListQuery,
  SchemeProductConfigListQueryVariables
>
export function useSchemeProductConfigListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeProductConfigListQuery,
        SchemeProductConfigListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeProductConfigListQuery | undefined,
  SchemeProductConfigListQueryVariables
>
export function useSchemeProductConfigListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeProductConfigListQuery,
        SchemeProductConfigListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeProductConfigListQuery,
    SchemeProductConfigListQueryVariables
  >(SchemeProductConfigListDocument, options)
}
export type SchemeProductConfigListQueryHookResult = ReturnType<
  typeof useSchemeProductConfigListQuery
>
export type SchemeProductConfigListLazyQueryHookResult = ReturnType<
  typeof useSchemeProductConfigListLazyQuery
>
export type SchemeProductConfigListSuspenseQueryHookResult = ReturnType<
  typeof useSchemeProductConfigListSuspenseQuery
>
export type SchemeProductConfigListQueryResult = Apollo.QueryResult<
  SchemeProductConfigListQuery,
  SchemeProductConfigListQueryVariables
>
export const SchemeProductDocument = gql`
  query SchemeProduct($schemeProductId: ID!) {
    scheme_product(scheme_product_id: $schemeProductId) {
      ...ProductSummary
      ...ProductVersions
      ...ProductDetails
      ...ProductConfigs
    }
  }
  ${ProductSummaryFragmentDoc}
  ${ProductVersionsFragmentDoc}
  ${ProductDetailsFragmentDoc}
  ${ProductConfigsFragmentDoc}
`

/**
 * __useSchemeProductQuery__
 *
 * To run a query within a React component, call `useSchemeProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeProductQuery({
 *   variables: {
 *      schemeProductId: // value for 'schemeProductId'
 *   },
 * });
 */
export function useSchemeProductQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeProductQuery,
    SchemeProductQueryVariables
  > &
    (
      | { variables: SchemeProductQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchemeProductQuery, SchemeProductQueryVariables>(
    SchemeProductDocument,
    options,
  )
}
export function useSchemeProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeProductQuery,
    SchemeProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SchemeProductQuery, SchemeProductQueryVariables>(
    SchemeProductDocument,
    options,
  )
}
// @ts-ignore
export function useSchemeProductSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeProductQuery,
    SchemeProductQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeProductQuery,
  SchemeProductQueryVariables
>
export function useSchemeProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeProductQuery,
        SchemeProductQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeProductQuery | undefined,
  SchemeProductQueryVariables
>
export function useSchemeProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeProductQuery,
        SchemeProductQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeProductQuery,
    SchemeProductQueryVariables
  >(SchemeProductDocument, options)
}
export type SchemeProductQueryHookResult = ReturnType<
  typeof useSchemeProductQuery
>
export type SchemeProductLazyQueryHookResult = ReturnType<
  typeof useSchemeProductLazyQuery
>
export type SchemeProductSuspenseQueryHookResult = ReturnType<
  typeof useSchemeProductSuspenseQuery
>
export type SchemeProductQueryResult = Apollo.QueryResult<
  SchemeProductQuery,
  SchemeProductQueryVariables
>
export const UserProductListDocument = gql`
  query UserProductList($scheme_id: ID, $user_id: ID!, $paginate: Paginate) {
    user(user_id: $user_id) {
      id
      table: user_products(scheme_id: $scheme_id, paginate: $paginate) {
        nodes {
          id
          valid_until
          created_at
          is_bonus
          balances {
            total_balance {
              formatted_amount
              amount
              unit
            }
            current_balance {
              formatted_amount
              amount
              unit
            }
          }
          period_pass_unlocks {
            hardware_type
            used
            limit
            period
          }
          scheme_product {
            id
            name
            product_type
            scheme_id
          }
          billable_journey_cap {
            limit
            used
            period
            is_billable
          }
        }
        pagination {
          current: page
          pageSize: per_page
          total
        }
      }
    }
  }
`

/**
 * __useUserProductListQuery__
 *
 * To run a query within a React component, call `useUserProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProductListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      user_id: // value for 'user_id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useUserProductListQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProductListQuery,
    UserProductListQueryVariables
  > &
    (
      | { variables: UserProductListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProductListQuery, UserProductListQueryVariables>(
    UserProductListDocument,
    options,
  )
}
export function useUserProductListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProductListQuery,
    UserProductListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserProductListQuery,
    UserProductListQueryVariables
  >(UserProductListDocument, options)
}
// @ts-ignore
export function useUserProductListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserProductListQuery,
    UserProductListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserProductListQuery,
  UserProductListQueryVariables
>
export function useUserProductListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserProductListQuery,
        UserProductListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserProductListQuery | undefined,
  UserProductListQueryVariables
>
export function useUserProductListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserProductListQuery,
        UserProductListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserProductListQuery,
    UserProductListQueryVariables
  >(UserProductListDocument, options)
}
export type UserProductListQueryHookResult = ReturnType<
  typeof useUserProductListQuery
>
export type UserProductListLazyQueryHookResult = ReturnType<
  typeof useUserProductListLazyQuery
>
export type UserProductListSuspenseQueryHookResult = ReturnType<
  typeof useUserProductListSuspenseQuery
>
export type UserProductListQueryResult = Apollo.QueryResult<
  UserProductListQuery,
  UserProductListQueryVariables
>
export const UpdateSchemeProductDocument = gql`
  mutation UpdateSchemeProduct(
    $schemeProductId: ID!
    $schemeProductInput: SchemeProductInput!
  ) {
    update_scheme_product(
      scheme_product_id: $schemeProductId
      scheme_product: $schemeProductInput
    ) {
      id
    }
  }
`
export type UpdateSchemeProductMutationFn = Apollo.MutationFunction<
  UpdateSchemeProductMutation,
  UpdateSchemeProductMutationVariables
>

/**
 * __useUpdateSchemeProductMutation__
 *
 * To run a mutation, you first call `useUpdateSchemeProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemeProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchemeProductMutation, { data, loading, error }] = useUpdateSchemeProductMutation({
 *   variables: {
 *      schemeProductId: // value for 'schemeProductId'
 *      schemeProductInput: // value for 'schemeProductInput'
 *   },
 * });
 */
export function useUpdateSchemeProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchemeProductMutation,
    UpdateSchemeProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchemeProductMutation,
    UpdateSchemeProductMutationVariables
  >(UpdateSchemeProductDocument, options)
}
export type UpdateSchemeProductMutationHookResult = ReturnType<
  typeof useUpdateSchemeProductMutation
>
export type UpdateSchemeProductMutationResult =
  Apollo.MutationResult<UpdateSchemeProductMutation>
export type UpdateSchemeProductMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchemeProductMutation,
  UpdateSchemeProductMutationVariables
>
export const CreateSchemeProductDocument = gql`
  mutation CreateSchemeProduct($schemeProductInput: SchemeProductInput!) {
    add_scheme_product(scheme_product: $schemeProductInput) {
      id
    }
  }
`
export type CreateSchemeProductMutationFn = Apollo.MutationFunction<
  CreateSchemeProductMutation,
  CreateSchemeProductMutationVariables
>

/**
 * __useCreateSchemeProductMutation__
 *
 * To run a mutation, you first call `useCreateSchemeProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemeProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchemeProductMutation, { data, loading, error }] = useCreateSchemeProductMutation({
 *   variables: {
 *      schemeProductInput: // value for 'schemeProductInput'
 *   },
 * });
 */
export function useCreateSchemeProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchemeProductMutation,
    CreateSchemeProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSchemeProductMutation,
    CreateSchemeProductMutationVariables
  >(CreateSchemeProductDocument, options)
}
export type CreateSchemeProductMutationHookResult = ReturnType<
  typeof useCreateSchemeProductMutation
>
export type CreateSchemeProductMutationResult =
  Apollo.MutationResult<CreateSchemeProductMutation>
export type CreateSchemeProductMutationOptions = Apollo.BaseMutationOptions<
  CreateSchemeProductMutation,
  CreateSchemeProductMutationVariables
>
export const ListValidationRulesDocument = gql`
  query ListValidationRules {
    table: promotion_validation_rules {
      nodes {
        ...ValidationRule
      }
      ...Pagination
    }
  }
  ${ValidationRuleFragmentDoc}
  ${PaginationFragmentDoc}
`

/**
 * __useListValidationRulesQuery__
 *
 * To run a query within a React component, call `useListValidationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListValidationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListValidationRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListValidationRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListValidationRulesQuery,
    ListValidationRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListValidationRulesQuery,
    ListValidationRulesQueryVariables
  >(ListValidationRulesDocument, options)
}
export function useListValidationRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListValidationRulesQuery,
    ListValidationRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListValidationRulesQuery,
    ListValidationRulesQueryVariables
  >(ListValidationRulesDocument, options)
}
// @ts-ignore
export function useListValidationRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListValidationRulesQuery,
    ListValidationRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListValidationRulesQuery,
  ListValidationRulesQueryVariables
>
export function useListValidationRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListValidationRulesQuery,
        ListValidationRulesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListValidationRulesQuery | undefined,
  ListValidationRulesQueryVariables
>
export function useListValidationRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListValidationRulesQuery,
        ListValidationRulesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ListValidationRulesQuery,
    ListValidationRulesQueryVariables
  >(ListValidationRulesDocument, options)
}
export type ListValidationRulesQueryHookResult = ReturnType<
  typeof useListValidationRulesQuery
>
export type ListValidationRulesLazyQueryHookResult = ReturnType<
  typeof useListValidationRulesLazyQuery
>
export type ListValidationRulesSuspenseQueryHookResult = ReturnType<
  typeof useListValidationRulesSuspenseQuery
>
export type ListValidationRulesQueryResult = Apollo.QueryResult<
  ListValidationRulesQuery,
  ListValidationRulesQueryVariables
>
export const ListCampaignsDocument = gql`
  query ListCampaigns($schemeId: ID!) {
    table: campaigns(scheme_id: $schemeId) {
      nodes {
        campaign_type
        type
        id
        name
        active
        created_at
      }
      ...Pagination
    }
  }
  ${PaginationFragmentDoc}
`

/**
 * __useListCampaignsQuery__
 *
 * To run a query within a React component, call `useListCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCampaignsQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useListCampaignsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCampaignsQuery,
    ListCampaignsQueryVariables
  > &
    (
      | { variables: ListCampaignsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCampaignsQuery, ListCampaignsQueryVariables>(
    ListCampaignsDocument,
    options,
  )
}
export function useListCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCampaignsQuery,
    ListCampaignsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCampaignsQuery, ListCampaignsQueryVariables>(
    ListCampaignsDocument,
    options,
  )
}
// @ts-ignore
export function useListCampaignsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListCampaignsQuery,
    ListCampaignsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListCampaignsQuery,
  ListCampaignsQueryVariables
>
export function useListCampaignsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCampaignsQuery,
        ListCampaignsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListCampaignsQuery | undefined,
  ListCampaignsQueryVariables
>
export function useListCampaignsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCampaignsQuery,
        ListCampaignsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ListCampaignsQuery,
    ListCampaignsQueryVariables
  >(ListCampaignsDocument, options)
}
export type ListCampaignsQueryHookResult = ReturnType<
  typeof useListCampaignsQuery
>
export type ListCampaignsLazyQueryHookResult = ReturnType<
  typeof useListCampaignsLazyQuery
>
export type ListCampaignsSuspenseQueryHookResult = ReturnType<
  typeof useListCampaignsSuspenseQuery
>
export type ListCampaignsQueryResult = Apollo.QueryResult<
  ListCampaignsQuery,
  ListCampaignsQueryVariables
>
export const ListMetadataSchemasDocument = gql`
  query ListMetadataSchemas {
    metadata_schemas {
      nodes {
        related_object
        properties {
          name
          type
          array
          optional
        }
      }
    }
  }
`

/**
 * __useListMetadataSchemasQuery__
 *
 * To run a query within a React component, call `useListMetadataSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetadataSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMetadataSchemasQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMetadataSchemasQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListMetadataSchemasQuery,
    ListMetadataSchemasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListMetadataSchemasQuery,
    ListMetadataSchemasQueryVariables
  >(ListMetadataSchemasDocument, options)
}
export function useListMetadataSchemasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListMetadataSchemasQuery,
    ListMetadataSchemasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListMetadataSchemasQuery,
    ListMetadataSchemasQueryVariables
  >(ListMetadataSchemasDocument, options)
}
// @ts-ignore
export function useListMetadataSchemasSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMetadataSchemasQuery,
    ListMetadataSchemasQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListMetadataSchemasQuery,
  ListMetadataSchemasQueryVariables
>
export function useListMetadataSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMetadataSchemasQuery,
        ListMetadataSchemasQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListMetadataSchemasQuery | undefined,
  ListMetadataSchemasQueryVariables
>
export function useListMetadataSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMetadataSchemasQuery,
        ListMetadataSchemasQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ListMetadataSchemasQuery,
    ListMetadataSchemasQueryVariables
  >(ListMetadataSchemasDocument, options)
}
export type ListMetadataSchemasQueryHookResult = ReturnType<
  typeof useListMetadataSchemasQuery
>
export type ListMetadataSchemasLazyQueryHookResult = ReturnType<
  typeof useListMetadataSchemasLazyQuery
>
export type ListMetadataSchemasSuspenseQueryHookResult = ReturnType<
  typeof useListMetadataSchemasSuspenseQuery
>
export type ListMetadataSchemasQueryResult = Apollo.QueryResult<
  ListMetadataSchemasQuery,
  ListMetadataSchemasQueryVariables
>
export const GetCampaignDocument = gql`
  query GetCampaign($schemeId: ID!, $campaignId: ID!) {
    campaign(scheme_id: $schemeId, campaign_id: $campaignId) {
      ... on CampaignSummary {
        id
        name
        campaign_type
        active
        created_at
      }
      ... on EoJPromotion {
        __typename
        id
        name
        campaign_type
        active
        created_at
        description
        banner
        start_date
        expiration_date
        validation_rule_ids
        scheme_ids
        hardware_types
        vehicle_categories
        unlock_fee_percent_off
        journey_first_free_minutes
        journey_percent_off_time_based_charges
        discount {
          type
          percent_off
        }
      }
    }
  }
`

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCampaignQuery,
    GetCampaignQueryVariables
  > &
    (
      | { variables: GetCampaignQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(
    GetCampaignDocument,
    options,
  )
}
export function useGetCampaignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCampaignQuery,
    GetCampaignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(
    GetCampaignDocument,
    options,
  )
}
// @ts-ignore
export function useGetCampaignSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCampaignQuery,
    GetCampaignQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCampaignQuery, GetCampaignQueryVariables>
export function useGetCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCampaignQuery,
        GetCampaignQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCampaignQuery | undefined,
  GetCampaignQueryVariables
>
export function useGetCampaignSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCampaignQuery,
        GetCampaignQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCampaignQuery, GetCampaignQueryVariables>(
    GetCampaignDocument,
    options,
  )
}
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>
export type GetCampaignLazyQueryHookResult = ReturnType<
  typeof useGetCampaignLazyQuery
>
export type GetCampaignSuspenseQueryHookResult = ReturnType<
  typeof useGetCampaignSuspenseQuery
>
export type GetCampaignQueryResult = Apollo.QueryResult<
  GetCampaignQuery,
  GetCampaignQueryVariables
>
export const CreateEoJPromotionDocument = gql`
  mutation CreateEoJPromotion($promotion: EoJPromotionInput!) {
    create_eoj_promotion(promotion: $promotion) {
      id
      name
    }
  }
`
export type CreateEoJPromotionMutationFn = Apollo.MutationFunction<
  CreateEoJPromotionMutation,
  CreateEoJPromotionMutationVariables
>

/**
 * __useCreateEoJPromotionMutation__
 *
 * To run a mutation, you first call `useCreateEoJPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEoJPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEoJPromotionMutation, { data, loading, error }] = useCreateEoJPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *   },
 * });
 */
export function useCreateEoJPromotionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEoJPromotionMutation,
    CreateEoJPromotionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateEoJPromotionMutation,
    CreateEoJPromotionMutationVariables
  >(CreateEoJPromotionDocument, options)
}
export type CreateEoJPromotionMutationHookResult = ReturnType<
  typeof useCreateEoJPromotionMutation
>
export type CreateEoJPromotionMutationResult =
  Apollo.MutationResult<CreateEoJPromotionMutation>
export type CreateEoJPromotionMutationOptions = Apollo.BaseMutationOptions<
  CreateEoJPromotionMutation,
  CreateEoJPromotionMutationVariables
>
export const CreateValidationRulesDocument = gql`
  mutation CreateValidationRules($validationRules: ValidationRulesInput!) {
    create_validation_rule(validation_rules: $validationRules) {
      ...ValidationRule
    }
  }
  ${ValidationRuleFragmentDoc}
`
export type CreateValidationRulesMutationFn = Apollo.MutationFunction<
  CreateValidationRulesMutation,
  CreateValidationRulesMutationVariables
>

/**
 * __useCreateValidationRulesMutation__
 *
 * To run a mutation, you first call `useCreateValidationRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateValidationRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createValidationRulesMutation, { data, loading, error }] = useCreateValidationRulesMutation({
 *   variables: {
 *      validationRules: // value for 'validationRules'
 *   },
 * });
 */
export function useCreateValidationRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateValidationRulesMutation,
    CreateValidationRulesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateValidationRulesMutation,
    CreateValidationRulesMutationVariables
  >(CreateValidationRulesDocument, options)
}
export type CreateValidationRulesMutationHookResult = ReturnType<
  typeof useCreateValidationRulesMutation
>
export type CreateValidationRulesMutationResult =
  Apollo.MutationResult<CreateValidationRulesMutation>
export type CreateValidationRulesMutationOptions = Apollo.BaseMutationOptions<
  CreateValidationRulesMutation,
  CreateValidationRulesMutationVariables
>
export const SchemePickerDocument = gql`
  query SchemePicker {
    schemes(paginate: { per_page: 100 }) {
      nodes {
        ...SchemePickerFields
      }
    }
  }
  ${SchemePickerFieldsFragmentDoc}
`

/**
 * __useSchemePickerQuery__
 *
 * To run a query within a React component, call `useSchemePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemePickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchemePickerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchemePickerQuery,
    SchemePickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchemePickerQuery, SchemePickerQueryVariables>(
    SchemePickerDocument,
    options,
  )
}
export function useSchemePickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemePickerQuery,
    SchemePickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SchemePickerQuery, SchemePickerQueryVariables>(
    SchemePickerDocument,
    options,
  )
}
// @ts-ignore
export function useSchemePickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemePickerQuery,
    SchemePickerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SchemePickerQuery, SchemePickerQueryVariables>
export function useSchemePickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemePickerQuery,
        SchemePickerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemePickerQuery | undefined,
  SchemePickerQueryVariables
>
export function useSchemePickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemePickerQuery,
        SchemePickerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SchemePickerQuery, SchemePickerQueryVariables>(
    SchemePickerDocument,
    options,
  )
}
export type SchemePickerQueryHookResult = ReturnType<
  typeof useSchemePickerQuery
>
export type SchemePickerLazyQueryHookResult = ReturnType<
  typeof useSchemePickerLazyQuery
>
export type SchemePickerSuspenseQueryHookResult = ReturnType<
  typeof useSchemePickerSuspenseQuery
>
export type SchemePickerQueryResult = Apollo.QueryResult<
  SchemePickerQuery,
  SchemePickerQueryVariables
>
export const SchemeServiceAreaDocument = gql`
  query SchemeServiceArea($schemeId: ID!) {
    scheme(scheme_id: $schemeId) {
      id
      service_areas(paginate: { per_page: 200 }) {
        geojson
      }
    }
  }
`

/**
 * __useSchemeServiceAreaQuery__
 *
 * To run a query within a React component, call `useSchemeServiceAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeServiceAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeServiceAreaQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useSchemeServiceAreaQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeServiceAreaQuery,
    SchemeServiceAreaQueryVariables
  > &
    (
      | { variables: SchemeServiceAreaQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchemeServiceAreaQuery,
    SchemeServiceAreaQueryVariables
  >(SchemeServiceAreaDocument, options)
}
export function useSchemeServiceAreaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeServiceAreaQuery,
    SchemeServiceAreaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemeServiceAreaQuery,
    SchemeServiceAreaQueryVariables
  >(SchemeServiceAreaDocument, options)
}
// @ts-ignore
export function useSchemeServiceAreaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeServiceAreaQuery,
    SchemeServiceAreaQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemeServiceAreaQuery,
  SchemeServiceAreaQueryVariables
>
export function useSchemeServiceAreaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeServiceAreaQuery,
        SchemeServiceAreaQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeServiceAreaQuery | undefined,
  SchemeServiceAreaQueryVariables
>
export function useSchemeServiceAreaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeServiceAreaQuery,
        SchemeServiceAreaQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemeServiceAreaQuery,
    SchemeServiceAreaQueryVariables
  >(SchemeServiceAreaDocument, options)
}
export type SchemeServiceAreaQueryHookResult = ReturnType<
  typeof useSchemeServiceAreaQuery
>
export type SchemeServiceAreaLazyQueryHookResult = ReturnType<
  typeof useSchemeServiceAreaLazyQuery
>
export type SchemeServiceAreaSuspenseQueryHookResult = ReturnType<
  typeof useSchemeServiceAreaSuspenseQuery
>
export type SchemeServiceAreaQueryResult = Apollo.QueryResult<
  SchemeServiceAreaQuery,
  SchemeServiceAreaQueryVariables
>
export const SchemePermittedVehiclesDocument = gql`
  query SchemePermittedVehicles($schemeId: ID!) {
    permitted_vehicle_models(scheme_id: $schemeId) {
      frame_type
      supported_hardware_types
    }
  }
`

/**
 * __useSchemePermittedVehiclesQuery__
 *
 * To run a query within a React component, call `useSchemePermittedVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemePermittedVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemePermittedVehiclesQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useSchemePermittedVehiclesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemePermittedVehiclesQuery,
    SchemePermittedVehiclesQueryVariables
  > &
    (
      | { variables: SchemePermittedVehiclesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchemePermittedVehiclesQuery,
    SchemePermittedVehiclesQueryVariables
  >(SchemePermittedVehiclesDocument, options)
}
export function useSchemePermittedVehiclesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemePermittedVehiclesQuery,
    SchemePermittedVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchemePermittedVehiclesQuery,
    SchemePermittedVehiclesQueryVariables
  >(SchemePermittedVehiclesDocument, options)
}
// @ts-ignore
export function useSchemePermittedVehiclesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemePermittedVehiclesQuery,
    SchemePermittedVehiclesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemePermittedVehiclesQuery,
  SchemePermittedVehiclesQueryVariables
>
export function useSchemePermittedVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemePermittedVehiclesQuery,
        SchemePermittedVehiclesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemePermittedVehiclesQuery | undefined,
  SchemePermittedVehiclesQueryVariables
>
export function useSchemePermittedVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemePermittedVehiclesQuery,
        SchemePermittedVehiclesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchemePermittedVehiclesQuery,
    SchemePermittedVehiclesQueryVariables
  >(SchemePermittedVehiclesDocument, options)
}
export type SchemePermittedVehiclesQueryHookResult = ReturnType<
  typeof useSchemePermittedVehiclesQuery
>
export type SchemePermittedVehiclesLazyQueryHookResult = ReturnType<
  typeof useSchemePermittedVehiclesLazyQuery
>
export type SchemePermittedVehiclesSuspenseQueryHookResult = ReturnType<
  typeof useSchemePermittedVehiclesSuspenseQuery
>
export type SchemePermittedVehiclesQueryResult = Apollo.QueryResult<
  SchemePermittedVehiclesQuery,
  SchemePermittedVehiclesQueryVariables
>
export const SchemeConfigDocument = gql`
  query SchemeConfig($schemeId: ID!) {
    scheme(scheme_id: $schemeId) {
      ...SchemeConfig
    }
  }
  ${SchemeConfigFragmentDoc}
`

/**
 * __useSchemeConfigQuery__
 *
 * To run a query within a React component, call `useSchemeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemeConfigQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useSchemeConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemeConfigQuery,
    SchemeConfigQueryVariables
  > &
    (
      | { variables: SchemeConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SchemeConfigQuery, SchemeConfigQueryVariables>(
    SchemeConfigDocument,
    options,
  )
}
export function useSchemeConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemeConfigQuery,
    SchemeConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SchemeConfigQuery, SchemeConfigQueryVariables>(
    SchemeConfigDocument,
    options,
  )
}
// @ts-ignore
export function useSchemeConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemeConfigQuery,
    SchemeConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SchemeConfigQuery, SchemeConfigQueryVariables>
export function useSchemeConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeConfigQuery,
        SchemeConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemeConfigQuery | undefined,
  SchemeConfigQueryVariables
>
export function useSchemeConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemeConfigQuery,
        SchemeConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SchemeConfigQuery, SchemeConfigQueryVariables>(
    SchemeConfigDocument,
    options,
  )
}
export type SchemeConfigQueryHookResult = ReturnType<
  typeof useSchemeConfigQuery
>
export type SchemeConfigLazyQueryHookResult = ReturnType<
  typeof useSchemeConfigLazyQuery
>
export type SchemeConfigSuspenseQueryHookResult = ReturnType<
  typeof useSchemeConfigSuspenseQuery
>
export type SchemeConfigQueryResult = Apollo.QueryResult<
  SchemeConfigQuery,
  SchemeConfigQueryVariables
>
export const ServiceAreaPolicyDocument = gql`
  query ServiceAreaPolicy($id: ID!) {
    service_area(service_area_id: $id) {
      id
      name
      scheme {
        id
      }
      ...ServiceAreaPolicy
    }
  }
  ${ServiceAreaPolicyFragmentDoc}
`

/**
 * __useServiceAreaPolicyQuery__
 *
 * To run a query within a React component, call `useServiceAreaPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAreaPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAreaPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceAreaPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceAreaPolicyQuery,
    ServiceAreaPolicyQueryVariables
  > &
    (
      | { variables: ServiceAreaPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ServiceAreaPolicyQuery,
    ServiceAreaPolicyQueryVariables
  >(ServiceAreaPolicyDocument, options)
}
export function useServiceAreaPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceAreaPolicyQuery,
    ServiceAreaPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceAreaPolicyQuery,
    ServiceAreaPolicyQueryVariables
  >(ServiceAreaPolicyDocument, options)
}
// @ts-ignore
export function useServiceAreaPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceAreaPolicyQuery,
    ServiceAreaPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreaPolicyQuery,
  ServiceAreaPolicyQueryVariables
>
export function useServiceAreaPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreaPolicyQuery,
        ServiceAreaPolicyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreaPolicyQuery | undefined,
  ServiceAreaPolicyQueryVariables
>
export function useServiceAreaPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreaPolicyQuery,
        ServiceAreaPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ServiceAreaPolicyQuery,
    ServiceAreaPolicyQueryVariables
  >(ServiceAreaPolicyDocument, options)
}
export type ServiceAreaPolicyQueryHookResult = ReturnType<
  typeof useServiceAreaPolicyQuery
>
export type ServiceAreaPolicyLazyQueryHookResult = ReturnType<
  typeof useServiceAreaPolicyLazyQuery
>
export type ServiceAreaPolicySuspenseQueryHookResult = ReturnType<
  typeof useServiceAreaPolicySuspenseQuery
>
export type ServiceAreaPolicyQueryResult = Apollo.QueryResult<
  ServiceAreaPolicyQuery,
  ServiceAreaPolicyQueryVariables
>
export const UpdateServiceAreaPolicyDocument = gql`
  mutation UpdateServiceAreaPolicy(
    $service_area_id: ID!
    $service_area_policy: ServiceAreaPolicyInput!
  ) {
    update_service_area_policy(
      service_area_id: $service_area_id
      service_area_policy: $service_area_policy
    ) {
      id
      speed_limit
      service_area_type
      is_parking_allowed
      is_visible
      effective_from
      effective_to
      applies_to
    }
  }
`
export type UpdateServiceAreaPolicyMutationFn = Apollo.MutationFunction<
  UpdateServiceAreaPolicyMutation,
  UpdateServiceAreaPolicyMutationVariables
>

/**
 * __useUpdateServiceAreaPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateServiceAreaPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceAreaPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceAreaPolicyMutation, { data, loading, error }] = useUpdateServiceAreaPolicyMutation({
 *   variables: {
 *      service_area_id: // value for 'service_area_id'
 *      service_area_policy: // value for 'service_area_policy'
 *   },
 * });
 */
export function useUpdateServiceAreaPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateServiceAreaPolicyMutation,
    UpdateServiceAreaPolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateServiceAreaPolicyMutation,
    UpdateServiceAreaPolicyMutationVariables
  >(UpdateServiceAreaPolicyDocument, options)
}
export type UpdateServiceAreaPolicyMutationHookResult = ReturnType<
  typeof useUpdateServiceAreaPolicyMutation
>
export type UpdateServiceAreaPolicyMutationResult =
  Apollo.MutationResult<UpdateServiceAreaPolicyMutation>
export type UpdateServiceAreaPolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdateServiceAreaPolicyMutation,
  UpdateServiceAreaPolicyMutationVariables
>
export const ServiceAreasListDocument = gql`
  query ServiceAreasList($scheme_id: ID, $paginate: Paginate) {
    table: all_service_areas(scheme_id: $scheme_id, paginate: $paginate) {
      nodes {
        id
        name
        scheme {
          id
        }
        ...ServiceAreaPolicy
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
  }
  ${ServiceAreaPolicyFragmentDoc}
`

/**
 * __useServiceAreasListQuery__
 *
 * To run a query within a React component, call `useServiceAreasListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAreasListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAreasListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useServiceAreasListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ServiceAreasListQuery,
    ServiceAreasListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ServiceAreasListQuery, ServiceAreasListQueryVariables>(
    ServiceAreasListDocument,
    options,
  )
}
export function useServiceAreasListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceAreasListQuery,
    ServiceAreasListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceAreasListQuery,
    ServiceAreasListQueryVariables
  >(ServiceAreasListDocument, options)
}
// @ts-ignore
export function useServiceAreasListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceAreasListQuery,
    ServiceAreasListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreasListQuery,
  ServiceAreasListQueryVariables
>
export function useServiceAreasListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreasListQuery,
        ServiceAreasListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreasListQuery | undefined,
  ServiceAreasListQueryVariables
>
export function useServiceAreasListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreasListQuery,
        ServiceAreasListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ServiceAreasListQuery,
    ServiceAreasListQueryVariables
  >(ServiceAreasListDocument, options)
}
export type ServiceAreasListQueryHookResult = ReturnType<
  typeof useServiceAreasListQuery
>
export type ServiceAreasListLazyQueryHookResult = ReturnType<
  typeof useServiceAreasListLazyQuery
>
export type ServiceAreasListSuspenseQueryHookResult = ReturnType<
  typeof useServiceAreasListSuspenseQuery
>
export type ServiceAreasListQueryResult = Apollo.QueryResult<
  ServiceAreasListQuery,
  ServiceAreasListQueryVariables
>
export const ServiceAreaDiffDocument = gql`
  query ServiceAreaDiff($id: ID!) {
    service_area(service_area_id: $id) {
      id
      name
      geom
    }
  }
`

/**
 * __useServiceAreaDiffQuery__
 *
 * To run a query within a React component, call `useServiceAreaDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAreaDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAreaDiffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceAreaDiffQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceAreaDiffQuery,
    ServiceAreaDiffQueryVariables
  > &
    (
      | { variables: ServiceAreaDiffQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ServiceAreaDiffQuery, ServiceAreaDiffQueryVariables>(
    ServiceAreaDiffDocument,
    options,
  )
}
export function useServiceAreaDiffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceAreaDiffQuery,
    ServiceAreaDiffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceAreaDiffQuery,
    ServiceAreaDiffQueryVariables
  >(ServiceAreaDiffDocument, options)
}
// @ts-ignore
export function useServiceAreaDiffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceAreaDiffQuery,
    ServiceAreaDiffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreaDiffQuery,
  ServiceAreaDiffQueryVariables
>
export function useServiceAreaDiffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreaDiffQuery,
        ServiceAreaDiffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreaDiffQuery | undefined,
  ServiceAreaDiffQueryVariables
>
export function useServiceAreaDiffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreaDiffQuery,
        ServiceAreaDiffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ServiceAreaDiffQuery,
    ServiceAreaDiffQueryVariables
  >(ServiceAreaDiffDocument, options)
}
export type ServiceAreaDiffQueryHookResult = ReturnType<
  typeof useServiceAreaDiffQuery
>
export type ServiceAreaDiffLazyQueryHookResult = ReturnType<
  typeof useServiceAreaDiffLazyQuery
>
export type ServiceAreaDiffSuspenseQueryHookResult = ReturnType<
  typeof useServiceAreaDiffSuspenseQuery
>
export type ServiceAreaDiffQueryResult = Apollo.QueryResult<
  ServiceAreaDiffQuery,
  ServiceAreaDiffQueryVariables
>
export const ServiceAreasSyncDocument = gql`
  mutation ServiceAreasSync($scheme_id: ID!, $dry_run: Boolean) {
    sync_service_areas(scheme_id: $scheme_id, dry_run: $dry_run) {
      added {
        ... on DraftServiceArea {
          name
          geom
        }
      }
      updated {
        id
        name
        geom
      }
      deleted {
        id
        geom
        name
      }
    }
  }
`
export type ServiceAreasSyncMutationFn = Apollo.MutationFunction<
  ServiceAreasSyncMutation,
  ServiceAreasSyncMutationVariables
>

/**
 * __useServiceAreasSyncMutation__
 *
 * To run a mutation, you first call `useServiceAreasSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceAreasSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceAreasSyncMutation, { data, loading, error }] = useServiceAreasSyncMutation({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      dry_run: // value for 'dry_run'
 *   },
 * });
 */
export function useServiceAreasSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ServiceAreasSyncMutation,
    ServiceAreasSyncMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ServiceAreasSyncMutation,
    ServiceAreasSyncMutationVariables
  >(ServiceAreasSyncDocument, options)
}
export type ServiceAreasSyncMutationHookResult = ReturnType<
  typeof useServiceAreasSyncMutation
>
export type ServiceAreasSyncMutationResult =
  Apollo.MutationResult<ServiceAreasSyncMutation>
export type ServiceAreasSyncMutationOptions = Apollo.BaseMutationOptions<
  ServiceAreasSyncMutation,
  ServiceAreasSyncMutationVariables
>
export const UserSubscriptionListDocument = gql`
  query UserSubscriptionList($scheme_id: ID, $user_id: ID!) {
    user(user_id: $user_id) {
      id
      user_subscriptions(scheme_id: $scheme_id) {
        id
        status
        created_at
        current_period_end
        cancel_at
        amount {
          formatted_amount
        }
        scheme_product {
          id
          scheme_id
          name
          scheme_accounting {
            id
            currency
          }
        }
      }
    }
  }
`

/**
 * __useUserSubscriptionListQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUserSubscriptionListQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserSubscriptionListQuery,
    UserSubscriptionListQueryVariables
  > &
    (
      | { variables: UserSubscriptionListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserSubscriptionListQuery,
    UserSubscriptionListQueryVariables
  >(UserSubscriptionListDocument, options)
}
export function useUserSubscriptionListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSubscriptionListQuery,
    UserSubscriptionListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserSubscriptionListQuery,
    UserSubscriptionListQueryVariables
  >(UserSubscriptionListDocument, options)
}
// @ts-ignore
export function useUserSubscriptionListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserSubscriptionListQuery,
    UserSubscriptionListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserSubscriptionListQuery,
  UserSubscriptionListQueryVariables
>
export function useUserSubscriptionListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSubscriptionListQuery,
        UserSubscriptionListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserSubscriptionListQuery | undefined,
  UserSubscriptionListQueryVariables
>
export function useUserSubscriptionListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSubscriptionListQuery,
        UserSubscriptionListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserSubscriptionListQuery,
    UserSubscriptionListQueryVariables
  >(UserSubscriptionListDocument, options)
}
export type UserSubscriptionListQueryHookResult = ReturnType<
  typeof useUserSubscriptionListQuery
>
export type UserSubscriptionListLazyQueryHookResult = ReturnType<
  typeof useUserSubscriptionListLazyQuery
>
export type UserSubscriptionListSuspenseQueryHookResult = ReturnType<
  typeof useUserSubscriptionListSuspenseQuery
>
export type UserSubscriptionListQueryResult = Apollo.QueryResult<
  UserSubscriptionListQuery,
  UserSubscriptionListQueryVariables
>
export const CancelUserSubscriptionDocument = gql`
  mutation CancelUserSubscription(
    $user_id: ID!
    $subscription_id: ID!
    $prorate_refund: Boolean
    $refund_amount: Int
  ) {
    cancel_user_subscription(
      user_id: $user_id
      subscription_id: $subscription_id
      prorate_refund: $prorate_refund
      refund_amount: $refund_amount
    ) {
      id
      status
      cancel_at
      current_period_end
      cancellation_refund {
        formatted_amount
      }
    }
  }
`
export type CancelUserSubscriptionMutationFn = Apollo.MutationFunction<
  CancelUserSubscriptionMutation,
  CancelUserSubscriptionMutationVariables
>

/**
 * __useCancelUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUserSubscriptionMutation, { data, loading, error }] = useCancelUserSubscriptionMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      subscription_id: // value for 'subscription_id'
 *      prorate_refund: // value for 'prorate_refund'
 *      refund_amount: // value for 'refund_amount'
 *   },
 * });
 */
export function useCancelUserSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelUserSubscriptionMutation,
    CancelUserSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CancelUserSubscriptionMutation,
    CancelUserSubscriptionMutationVariables
  >(CancelUserSubscriptionDocument, options)
}
export type CancelUserSubscriptionMutationHookResult = ReturnType<
  typeof useCancelUserSubscriptionMutation
>
export type CancelUserSubscriptionMutationResult =
  Apollo.MutationResult<CancelUserSubscriptionMutation>
export type CancelUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CancelUserSubscriptionMutation,
  CancelUserSubscriptionMutationVariables
>
export const UsersListDocument = gql`
  query UsersList(
    $where: [UserWhere]
    $order_by: [UserOrderby]
    $paginate: Paginate
  ) {
    table: users(paginate: $paginate, where: $where, order_by: $order_by) {
      ...UserList
    }
  }
  ${UserListFragmentDoc}
`

/**
 * __useUsersListQuery__
 *
 * To run a query within a React component, call `useUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useUsersListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UsersListQuery,
    UsersListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UsersListQuery, UsersListQueryVariables>(
    UsersListDocument,
    options,
  )
}
export function useUsersListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UsersListQuery,
    UsersListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UsersListQuery, UsersListQueryVariables>(
    UsersListDocument,
    options,
  )
}
// @ts-ignore
export function useUsersListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UsersListQuery,
    UsersListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UsersListQuery, UsersListQueryVariables>
export function useUsersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsersListQuery, UsersListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  UsersListQuery | undefined,
  UsersListQueryVariables
>
export function useUsersListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsersListQuery, UsersListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UsersListQuery, UsersListQueryVariables>(
    UsersListDocument,
    options,
  )
}
export type UsersListQueryHookResult = ReturnType<typeof useUsersListQuery>
export type UsersListLazyQueryHookResult = ReturnType<
  typeof useUsersListLazyQuery
>
export type UsersListSuspenseQueryHookResult = ReturnType<
  typeof useUsersListSuspenseQuery
>
export type UsersListQueryResult = Apollo.QueryResult<
  UsersListQuery,
  UsersListQueryVariables
>
export const StaffListDocument = gql`
  query StaffList(
    $schemeId: ID!
    $where: [UserWhere]
    $order_by: [UserOrderby]
    $paginate: Paginate
  ) {
    table: staff(
      scheme_id: $schemeId
      paginate: $paginate
      where: $where
      order_by: $order_by
    ) {
      ...UserList
    }
  }
  ${UserListFragmentDoc}
`

/**
 * __useStaffListQuery__
 *
 * To run a query within a React component, call `useStaffListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffListQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useStaffListQuery(
  baseOptions: Apollo.QueryHookOptions<
    StaffListQuery,
    StaffListQueryVariables
  > &
    (
      | { variables: StaffListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StaffListQuery, StaffListQueryVariables>(
    StaffListDocument,
    options,
  )
}
export function useStaffListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StaffListQuery,
    StaffListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StaffListQuery, StaffListQueryVariables>(
    StaffListDocument,
    options,
  )
}
// @ts-ignore
export function useStaffListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StaffListQuery,
    StaffListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<StaffListQuery, StaffListQueryVariables>
export function useStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StaffListQuery, StaffListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  StaffListQuery | undefined,
  StaffListQueryVariables
>
export function useStaffListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StaffListQuery, StaffListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StaffListQuery, StaffListQueryVariables>(
    StaffListDocument,
    options,
  )
}
export type StaffListQueryHookResult = ReturnType<typeof useStaffListQuery>
export type StaffListLazyQueryHookResult = ReturnType<
  typeof useStaffListLazyQuery
>
export type StaffListSuspenseQueryHookResult = ReturnType<
  typeof useStaffListSuspenseQuery
>
export type StaffListQueryResult = Apollo.QueryResult<
  StaffListQuery,
  StaffListQueryVariables
>
export const CustomerListDocument = gql`
  query CustomerList(
    $schemeId: ID!
    $where: [UserWhere]
    $order_by: [UserOrderby]
    $paginate: Paginate
  ) {
    table: customers(
      scheme_id: $schemeId
      paginate: $paginate
      where: $where
      order_by: $order_by
    ) {
      ...UserList
    }
  }
  ${UserListFragmentDoc}
`

/**
 * __useCustomerListQuery__
 *
 * To run a query within a React component, call `useCustomerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerListQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useCustomerListQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomerListQuery,
    CustomerListQueryVariables
  > &
    (
      | { variables: CustomerListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CustomerListQuery, CustomerListQueryVariables>(
    CustomerListDocument,
    options,
  )
}
export function useCustomerListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerListQuery,
    CustomerListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CustomerListQuery, CustomerListQueryVariables>(
    CustomerListDocument,
    options,
  )
}
// @ts-ignore
export function useCustomerListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CustomerListQuery,
    CustomerListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CustomerListQuery, CustomerListQueryVariables>
export function useCustomerListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CustomerListQuery,
        CustomerListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CustomerListQuery | undefined,
  CustomerListQueryVariables
>
export function useCustomerListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CustomerListQuery,
        CustomerListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CustomerListQuery, CustomerListQueryVariables>(
    CustomerListDocument,
    options,
  )
}
export type CustomerListQueryHookResult = ReturnType<
  typeof useCustomerListQuery
>
export type CustomerListLazyQueryHookResult = ReturnType<
  typeof useCustomerListLazyQuery
>
export type CustomerListSuspenseQueryHookResult = ReturnType<
  typeof useCustomerListSuspenseQuery
>
export type CustomerListQueryResult = Apollo.QueryResult<
  CustomerListQuery,
  CustomerListQueryVariables
>
export const UserSummaryDocument = gql`
  query UserSummary($id: ID!, $schemeId: ID!) {
    user(user_id: $id) {
      ...UserSummaryFields
      charge_exemptions(scheme_id: $schemeId) {
        charge_type
      }
    }
  }
  ${UserSummaryFieldsFragmentDoc}
`

/**
 * __useUserSummaryQuery__
 *
 * To run a query within a React component, call `useUserSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useUserSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserSummaryQuery,
    UserSummaryQueryVariables
  > &
    (
      | { variables: UserSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserSummaryQuery, UserSummaryQueryVariables>(
    UserSummaryDocument,
    options,
  )
}
export function useUserSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSummaryQuery,
    UserSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserSummaryQuery, UserSummaryQueryVariables>(
    UserSummaryDocument,
    options,
  )
}
// @ts-ignore
export function useUserSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserSummaryQuery,
    UserSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserSummaryQuery, UserSummaryQueryVariables>
export function useUserSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSummaryQuery,
        UserSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserSummaryQuery | undefined,
  UserSummaryQueryVariables
>
export function useUserSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSummaryQuery,
        UserSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserSummaryQuery, UserSummaryQueryVariables>(
    UserSummaryDocument,
    options,
  )
}
export type UserSummaryQueryHookResult = ReturnType<typeof useUserSummaryQuery>
export type UserSummaryLazyQueryHookResult = ReturnType<
  typeof useUserSummaryLazyQuery
>
export type UserSummarySuspenseQueryHookResult = ReturnType<
  typeof useUserSummarySuspenseQuery
>
export type UserSummaryQueryResult = Apollo.QueryResult<
  UserSummaryQuery,
  UserSummaryQueryVariables
>
export const UserActionsDocument = gql`
  query UserActions($user_id: ID!) {
    user(user_id: $user_id) {
      id
      email
      is_blocked
      has_valid_licence
      persona_enrolled
      phone_number
      roles {
        id
        scheme {
          id
          name
        }
        org {
          id
          name
        }
        type {
          id
          description
        }
      }
    }
  }
`

/**
 * __useUserActionsQuery__
 *
 * To run a query within a React component, call `useUserActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActionsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUserActionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserActionsQuery,
    UserActionsQueryVariables
  > &
    (
      | { variables: UserActionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserActionsQuery, UserActionsQueryVariables>(
    UserActionsDocument,
    options,
  )
}
export function useUserActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserActionsQuery,
    UserActionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserActionsQuery, UserActionsQueryVariables>(
    UserActionsDocument,
    options,
  )
}
// @ts-ignore
export function useUserActionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserActionsQuery,
    UserActionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserActionsQuery, UserActionsQueryVariables>
export function useUserActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserActionsQuery,
        UserActionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserActionsQuery | undefined,
  UserActionsQueryVariables
>
export function useUserActionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserActionsQuery,
        UserActionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserActionsQuery, UserActionsQueryVariables>(
    UserActionsDocument,
    options,
  )
}
export type UserActionsQueryHookResult = ReturnType<typeof useUserActionsQuery>
export type UserActionsLazyQueryHookResult = ReturnType<
  typeof useUserActionsLazyQuery
>
export type UserActionsSuspenseQueryHookResult = ReturnType<
  typeof useUserActionsSuspenseQuery
>
export type UserActionsQueryResult = Apollo.QueryResult<
  UserActionsQuery,
  UserActionsQueryVariables
>
export const UserSchemesDocument = gql`
  query UserSchemes($userId: ID!) {
    user(user_id: $userId) {
      id
      user_schemes {
        scheme_id
        scheme {
          name
        }
      }
    }
  }
`

/**
 * __useUserSchemesQuery__
 *
 * To run a query within a React component, call `useUserSchemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSchemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSchemesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSchemesQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserSchemesQuery,
    UserSchemesQueryVariables
  > &
    (
      | { variables: UserSchemesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserSchemesQuery, UserSchemesQueryVariables>(
    UserSchemesDocument,
    options,
  )
}
export function useUserSchemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSchemesQuery,
    UserSchemesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserSchemesQuery, UserSchemesQueryVariables>(
    UserSchemesDocument,
    options,
  )
}
// @ts-ignore
export function useUserSchemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserSchemesQuery,
    UserSchemesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserSchemesQuery, UserSchemesQueryVariables>
export function useUserSchemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSchemesQuery,
        UserSchemesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserSchemesQuery | undefined,
  UserSchemesQueryVariables
>
export function useUserSchemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSchemesQuery,
        UserSchemesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserSchemesQuery, UserSchemesQueryVariables>(
    UserSchemesDocument,
    options,
  )
}
export type UserSchemesQueryHookResult = ReturnType<typeof useUserSchemesQuery>
export type UserSchemesLazyQueryHookResult = ReturnType<
  typeof useUserSchemesLazyQuery
>
export type UserSchemesSuspenseQueryHookResult = ReturnType<
  typeof useUserSchemesSuspenseQuery
>
export type UserSchemesQueryResult = Apollo.QueryResult<
  UserSchemesQuery,
  UserSchemesQueryVariables
>
export const BlockUserDocument = gql`
  mutation BlockUser($user_id: ID!) {
    block_user_identity_platform_account(user_id: $user_id)
  }
`
export type BlockUserMutationFn = Apollo.MutationFunction<
  BlockUserMutation,
  BlockUserMutationVariables
>

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useBlockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BlockUserMutation,
    BlockUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(
    BlockUserDocument,
    options,
  )
}
export type BlockUserMutationHookResult = ReturnType<
  typeof useBlockUserMutation
>
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<
  BlockUserMutation,
  BlockUserMutationVariables
>
export const UnBlockUserDocument = gql`
  mutation UnBlockUser($user_id: ID!) {
    unblock_user_identity_platform_account(user_id: $user_id)
  }
`
export type UnBlockUserMutationFn = Apollo.MutationFunction<
  UnBlockUserMutation,
  UnBlockUserMutationVariables
>

/**
 * __useUnBlockUserMutation__
 *
 * To run a mutation, you first call `useUnBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unBlockUserMutation, { data, loading, error }] = useUnBlockUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUnBlockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnBlockUserMutation,
    UnBlockUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnBlockUserMutation, UnBlockUserMutationVariables>(
    UnBlockUserDocument,
    options,
  )
}
export type UnBlockUserMutationHookResult = ReturnType<
  typeof useUnBlockUserMutation
>
export type UnBlockUserMutationResult =
  Apollo.MutationResult<UnBlockUserMutation>
export type UnBlockUserMutationOptions = Apollo.BaseMutationOptions<
  UnBlockUserMutation,
  UnBlockUserMutationVariables
>
export const BlockUserCardFingerprintDocument = gql`
  mutation BlockUserCardFingerprint($user_id: ID!) {
    block_user_card_fingerprint(user_id: $user_id)
  }
`
export type BlockUserCardFingerprintMutationFn = Apollo.MutationFunction<
  BlockUserCardFingerprintMutation,
  BlockUserCardFingerprintMutationVariables
>

/**
 * __useBlockUserCardFingerprintMutation__
 *
 * To run a mutation, you first call `useBlockUserCardFingerprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserCardFingerprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserCardFingerprintMutation, { data, loading, error }] = useBlockUserCardFingerprintMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useBlockUserCardFingerprintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BlockUserCardFingerprintMutation,
    BlockUserCardFingerprintMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BlockUserCardFingerprintMutation,
    BlockUserCardFingerprintMutationVariables
  >(BlockUserCardFingerprintDocument, options)
}
export type BlockUserCardFingerprintMutationHookResult = ReturnType<
  typeof useBlockUserCardFingerprintMutation
>
export type BlockUserCardFingerprintMutationResult =
  Apollo.MutationResult<BlockUserCardFingerprintMutation>
export type BlockUserCardFingerprintMutationOptions =
  Apollo.BaseMutationOptions<
    BlockUserCardFingerprintMutation,
    BlockUserCardFingerprintMutationVariables
  >
export const UnBlockUserCardFingerptintDocument = gql`
  mutation UnBlockUserCardFingerptint($user_id: ID!) {
    unblock_user_card_fingerprint(user_id: $user_id)
  }
`
export type UnBlockUserCardFingerptintMutationFn = Apollo.MutationFunction<
  UnBlockUserCardFingerptintMutation,
  UnBlockUserCardFingerptintMutationVariables
>

/**
 * __useUnBlockUserCardFingerptintMutation__
 *
 * To run a mutation, you first call `useUnBlockUserCardFingerptintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnBlockUserCardFingerptintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unBlockUserCardFingerptintMutation, { data, loading, error }] = useUnBlockUserCardFingerptintMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUnBlockUserCardFingerptintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnBlockUserCardFingerptintMutation,
    UnBlockUserCardFingerptintMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnBlockUserCardFingerptintMutation,
    UnBlockUserCardFingerptintMutationVariables
  >(UnBlockUserCardFingerptintDocument, options)
}
export type UnBlockUserCardFingerptintMutationHookResult = ReturnType<
  typeof useUnBlockUserCardFingerptintMutation
>
export type UnBlockUserCardFingerptintMutationResult =
  Apollo.MutationResult<UnBlockUserCardFingerptintMutation>
export type UnBlockUserCardFingerptintMutationOptions =
  Apollo.BaseMutationOptions<
    UnBlockUserCardFingerptintMutation,
    UnBlockUserCardFingerptintMutationVariables
  >
export const ForceAddUserPhoneNumberDocument = gql`
  mutation ForceAddUserPhoneNumber($userId: ID!, $phoneNumber: String!) {
    force_add_user_phone_number(user_id: $userId, phone_number: $phoneNumber)
  }
`
export type ForceAddUserPhoneNumberMutationFn = Apollo.MutationFunction<
  ForceAddUserPhoneNumberMutation,
  ForceAddUserPhoneNumberMutationVariables
>

/**
 * __useForceAddUserPhoneNumberMutation__
 *
 * To run a mutation, you first call `useForceAddUserPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceAddUserPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceAddUserPhoneNumberMutation, { data, loading, error }] = useForceAddUserPhoneNumberMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useForceAddUserPhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ForceAddUserPhoneNumberMutation,
    ForceAddUserPhoneNumberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ForceAddUserPhoneNumberMutation,
    ForceAddUserPhoneNumberMutationVariables
  >(ForceAddUserPhoneNumberDocument, options)
}
export type ForceAddUserPhoneNumberMutationHookResult = ReturnType<
  typeof useForceAddUserPhoneNumberMutation
>
export type ForceAddUserPhoneNumberMutationResult =
  Apollo.MutationResult<ForceAddUserPhoneNumberMutation>
export type ForceAddUserPhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  ForceAddUserPhoneNumberMutation,
  ForceAddUserPhoneNumberMutationVariables
>
export const UpdateUserLicenceExpiryDateDocument = gql`
  mutation UpdateUserLicenceExpiryDate($userId: ID!, $expiryDate: String!) {
    update_licence_expiry_date(user_id: $userId, expiry_date: $expiryDate)
  }
`
export type UpdateUserLicenceExpiryDateMutationFn = Apollo.MutationFunction<
  UpdateUserLicenceExpiryDateMutation,
  UpdateUserLicenceExpiryDateMutationVariables
>

/**
 * __useUpdateUserLicenceExpiryDateMutation__
 *
 * To run a mutation, you first call `useUpdateUserLicenceExpiryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLicenceExpiryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLicenceExpiryDateMutation, { data, loading, error }] = useUpdateUserLicenceExpiryDateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      expiryDate: // value for 'expiryDate'
 *   },
 * });
 */
export function useUpdateUserLicenceExpiryDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserLicenceExpiryDateMutation,
    UpdateUserLicenceExpiryDateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserLicenceExpiryDateMutation,
    UpdateUserLicenceExpiryDateMutationVariables
  >(UpdateUserLicenceExpiryDateDocument, options)
}
export type UpdateUserLicenceExpiryDateMutationHookResult = ReturnType<
  typeof useUpdateUserLicenceExpiryDateMutation
>
export type UpdateUserLicenceExpiryDateMutationResult =
  Apollo.MutationResult<UpdateUserLicenceExpiryDateMutation>
export type UpdateUserLicenceExpiryDateMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserLicenceExpiryDateMutation,
    UpdateUserLicenceExpiryDateMutationVariables
  >
export const RemoveRoleDocument = gql`
  mutation RemoveRole($role_id: ID!) {
    remove_role(role_id: $role_id)
  }
`
export type RemoveRoleMutationFn = Apollo.MutationFunction<
  RemoveRoleMutation,
  RemoveRoleMutationVariables
>

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      role_id: // value for 'role_id'
 *   },
 * });
 */
export function useRemoveRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveRoleMutation,
    RemoveRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(
    RemoveRoleDocument,
    options,
  )
}
export type RemoveRoleMutationHookResult = ReturnType<
  typeof useRemoveRoleMutation
>
export type RemoveRoleMutationResult = Apollo.MutationResult<RemoveRoleMutation>
export type RemoveRoleMutationOptions = Apollo.BaseMutationOptions<
  RemoveRoleMutation,
  RemoveRoleMutationVariables
>
export const SubscribeToTopicDocument = gql`
  mutation SubscribeToTopic($userId: ID!, $topic: String!) {
    subscribe_to_topic(user_id: $userId, topic: $topic)
  }
`
export type SubscribeToTopicMutationFn = Apollo.MutationFunction<
  SubscribeToTopicMutation,
  SubscribeToTopicMutationVariables
>

/**
 * __useSubscribeToTopicMutation__
 *
 * To run a mutation, you first call `useSubscribeToTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToTopicMutation, { data, loading, error }] = useSubscribeToTopicMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useSubscribeToTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscribeToTopicMutation,
    SubscribeToTopicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SubscribeToTopicMutation,
    SubscribeToTopicMutationVariables
  >(SubscribeToTopicDocument, options)
}
export type SubscribeToTopicMutationHookResult = ReturnType<
  typeof useSubscribeToTopicMutation
>
export type SubscribeToTopicMutationResult =
  Apollo.MutationResult<SubscribeToTopicMutation>
export type SubscribeToTopicMutationOptions = Apollo.BaseMutationOptions<
  SubscribeToTopicMutation,
  SubscribeToTopicMutationVariables
>
export const SendCustomNotificationDocument = gql`
  mutation SendCustomNotification(
    $userId: ID!
    $title: String!
    $body: String!
  ) {
    send_custom_notification(
      user_id: $userId
      title: $title
      body: $body
      show_in_app: true
    )
  }
`
export type SendCustomNotificationMutationFn = Apollo.MutationFunction<
  SendCustomNotificationMutation,
  SendCustomNotificationMutationVariables
>

/**
 * __useSendCustomNotificationMutation__
 *
 * To run a mutation, you first call `useSendCustomNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomNotificationMutation, { data, loading, error }] = useSendCustomNotificationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendCustomNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendCustomNotificationMutation,
    SendCustomNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SendCustomNotificationMutation,
    SendCustomNotificationMutationVariables
  >(SendCustomNotificationDocument, options)
}
export type SendCustomNotificationMutationHookResult = ReturnType<
  typeof useSendCustomNotificationMutation
>
export type SendCustomNotificationMutationResult =
  Apollo.MutationResult<SendCustomNotificationMutation>
export type SendCustomNotificationMutationOptions = Apollo.BaseMutationOptions<
  SendCustomNotificationMutation,
  SendCustomNotificationMutationVariables
>
export const GetAllVehiclesDocument = gql`
  query GetAllVehicles {
    vehicles(vehicle_type: scooter, paginate: { page: 1, per_page: 5000 }) {
      nodes {
        frame_id
      }
      pagination {
        total
        page
        pages
      }
    }
  }
`

/**
 * __useGetAllVehiclesQuery__
 *
 * To run a query within a React component, call `useGetAllVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVehiclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVehiclesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAllVehiclesQuery, GetAllVehiclesQueryVariables>(
    GetAllVehiclesDocument,
    options,
  )
}
export function useGetAllVehiclesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAllVehiclesQuery, GetAllVehiclesQueryVariables>(
    GetAllVehiclesDocument,
    options,
  )
}
// @ts-ignore
export function useGetAllVehiclesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAllVehiclesQuery,
  GetAllVehiclesQueryVariables
>
export function useGetAllVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllVehiclesQuery,
        GetAllVehiclesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAllVehiclesQuery | undefined,
  GetAllVehiclesQueryVariables
>
export function useGetAllVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllVehiclesQuery,
        GetAllVehiclesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >(GetAllVehiclesDocument, options)
}
export type GetAllVehiclesQueryHookResult = ReturnType<
  typeof useGetAllVehiclesQuery
>
export type GetAllVehiclesLazyQueryHookResult = ReturnType<
  typeof useGetAllVehiclesLazyQuery
>
export type GetAllVehiclesSuspenseQueryHookResult = ReturnType<
  typeof useGetAllVehiclesSuspenseQuery
>
export type GetAllVehiclesQueryResult = Apollo.QueryResult<
  GetAllVehiclesQuery,
  GetAllVehiclesQueryVariables
>
export const VehicleDocument = gql`
  query Vehicle($vehicle_id: GUID!) {
    vehicle(vehicle_id: $vehicle_id) {
      id
      frame_id
      frame_type
      hardware_type
      vehicle_category
      detail {
        module {
          id
        }
        scheme {
          id
          name
        }
        module {
          id
        }
      }
    }
  }
`

/**
 * __useVehicleQuery__
 *
 * To run a query within a React component, call `useVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleQuery({
 *   variables: {
 *      vehicle_id: // value for 'vehicle_id'
 *   },
 * });
 */
export function useVehicleQuery(
  baseOptions: Apollo.QueryHookOptions<VehicleQuery, VehicleQueryVariables> &
    ({ variables: VehicleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VehicleQuery, VehicleQueryVariables>(
    VehicleDocument,
    options,
  )
}
export function useVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehicleQuery,
    VehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VehicleQuery, VehicleQueryVariables>(
    VehicleDocument,
    options,
  )
}
// @ts-ignore
export function useVehicleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehicleQuery,
    VehicleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VehicleQuery, VehicleQueryVariables>
export function useVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VehicleQuery, VehicleQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VehicleQuery | undefined,
  VehicleQueryVariables
>
export function useVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VehicleQuery, VehicleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VehicleQuery, VehicleQueryVariables>(
    VehicleDocument,
    options,
  )
}
export type VehicleQueryHookResult = ReturnType<typeof useVehicleQuery>
export type VehicleLazyQueryHookResult = ReturnType<typeof useVehicleLazyQuery>
export type VehicleSuspenseQueryHookResult = ReturnType<
  typeof useVehicleSuspenseQuery
>
export type VehicleQueryResult = Apollo.QueryResult<
  VehicleQuery,
  VehicleQueryVariables
>
export const VehiclesMapDocument = gql`
  query VehiclesMap(
    $location: LocationAreaInput
    $scheme_id: ID
    $in_zone: Boolean
    $vehicle_lock_state: [VehicleLockState!]
    $vehicle_category: [VehicleCategory!]
    $vehicle_state: [VehicleState!]
    $suspended: Boolean
  ) {
    vehicles(
      location: $location
      scheme_id: $scheme_id
      is_in_zone: $in_zone
      vehicle_lock_state: $vehicle_lock_state
      vehicle_category: $vehicle_category
      vehicle_state: $vehicle_state
      paginate: { page: 1, per_page: 100 }
    ) {
      ...VehiclesNodes
    }
    all_zones(
      location: $location
      scheme_id: $scheme_id
      is_suspended: $suspended
      paginate: { page: 1, per_page: 800 }
    ) {
      nodes {
        ...ZoneNode
      }
    }
  }
  ${VehiclesNodesFragmentDoc}
  ${ZoneNodeFragmentDoc}
`

/**
 * __useVehiclesMapQuery__
 *
 * To run a query within a React component, call `useVehiclesMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesMapQuery({
 *   variables: {
 *      location: // value for 'location'
 *      scheme_id: // value for 'scheme_id'
 *      in_zone: // value for 'in_zone'
 *      vehicle_lock_state: // value for 'vehicle_lock_state'
 *      vehicle_category: // value for 'vehicle_category'
 *      vehicle_state: // value for 'vehicle_state'
 *      suspended: // value for 'suspended'
 *   },
 * });
 */
export function useVehiclesMapQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VehiclesMapQuery,
    VehiclesMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VehiclesMapQuery, VehiclesMapQueryVariables>(
    VehiclesMapDocument,
    options,
  )
}
export function useVehiclesMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehiclesMapQuery,
    VehiclesMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VehiclesMapQuery, VehiclesMapQueryVariables>(
    VehiclesMapDocument,
    options,
  )
}
// @ts-ignore
export function useVehiclesMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehiclesMapQuery,
    VehiclesMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VehiclesMapQuery, VehiclesMapQueryVariables>
export function useVehiclesMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehiclesMapQuery,
        VehiclesMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehiclesMapQuery | undefined,
  VehiclesMapQueryVariables
>
export function useVehiclesMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehiclesMapQuery,
        VehiclesMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VehiclesMapQuery, VehiclesMapQueryVariables>(
    VehiclesMapDocument,
    options,
  )
}
export type VehiclesMapQueryHookResult = ReturnType<typeof useVehiclesMapQuery>
export type VehiclesMapLazyQueryHookResult = ReturnType<
  typeof useVehiclesMapLazyQuery
>
export type VehiclesMapSuspenseQueryHookResult = ReturnType<
  typeof useVehiclesMapSuspenseQuery
>
export type VehiclesMapQueryResult = Apollo.QueryResult<
  VehiclesMapQuery,
  VehiclesMapQueryVariables
>
export const VehicleMapDocument = gql`
  query VehicleMap(
    $id: ID!
    $schemeId: ID
    $location: LocationAreaInput
    $hasLocation: Boolean!
    $lacksLocation: Boolean!
    $showSuspendedBays: Boolean!
  ) {
    vehicle_by_module_id(module_id: $id) {
      ...VehicleNode
    }
    vehicles(location: $location) @include(if: $hasLocation) {
      ...VehiclesNodes
    }
    all_zones(location: $location, scheme_id: $schemeId)
      @skip(if: $lacksLocation)
      @include(if: $showSuspendedBays) {
      nodes {
        ...ZoneNode
      }
    }
    zones(location: $location, scheme_id: $schemeId)
      @skip(if: $showSuspendedBays)
      @include(if: $hasLocation) {
      nodes {
        ...ZoneNode
      }
    }
  }
  ${VehicleNodeFragmentDoc}
  ${VehiclesNodesFragmentDoc}
  ${ZoneNodeFragmentDoc}
`

/**
 * __useVehicleMapQuery__
 *
 * To run a query within a React component, call `useVehicleMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schemeId: // value for 'schemeId'
 *      location: // value for 'location'
 *      hasLocation: // value for 'hasLocation'
 *      lacksLocation: // value for 'lacksLocation'
 *      showSuspendedBays: // value for 'showSuspendedBays'
 *   },
 * });
 */
export function useVehicleMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    VehicleMapQuery,
    VehicleMapQueryVariables
  > &
    (
      | { variables: VehicleMapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VehicleMapQuery, VehicleMapQueryVariables>(
    VehicleMapDocument,
    options,
  )
}
export function useVehicleMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehicleMapQuery,
    VehicleMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VehicleMapQuery, VehicleMapQueryVariables>(
    VehicleMapDocument,
    options,
  )
}
// @ts-ignore
export function useVehicleMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehicleMapQuery,
    VehicleMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VehicleMapQuery, VehicleMapQueryVariables>
export function useVehicleMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleMapQuery,
        VehicleMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehicleMapQuery | undefined,
  VehicleMapQueryVariables
>
export function useVehicleMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleMapQuery,
        VehicleMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VehicleMapQuery, VehicleMapQueryVariables>(
    VehicleMapDocument,
    options,
  )
}
export type VehicleMapQueryHookResult = ReturnType<typeof useVehicleMapQuery>
export type VehicleMapLazyQueryHookResult = ReturnType<
  typeof useVehicleMapLazyQuery
>
export type VehicleMapSuspenseQueryHookResult = ReturnType<
  typeof useVehicleMapSuspenseQuery
>
export type VehicleMapQueryResult = Apollo.QueryResult<
  VehicleMapQuery,
  VehicleMapQueryVariables
>
export const ZoneVehiclesListDocument = gql`
  query ZoneVehiclesList($zone_id: ID!) {
    zone(zone_id: $zone_id) {
      id
      table: all_commissioned_vehicles {
        ...VehicleNode
      }
    }
  }
  ${VehicleNodeFragmentDoc}
`

/**
 * __useZoneVehiclesListQuery__
 *
 * To run a query within a React component, call `useZoneVehiclesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneVehiclesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneVehiclesListQuery({
 *   variables: {
 *      zone_id: // value for 'zone_id'
 *   },
 * });
 */
export function useZoneVehiclesListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZoneVehiclesListQuery,
    ZoneVehiclesListQueryVariables
  > &
    (
      | { variables: ZoneVehiclesListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZoneVehiclesListQuery, ZoneVehiclesListQueryVariables>(
    ZoneVehiclesListDocument,
    options,
  )
}
export function useZoneVehiclesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneVehiclesListQuery,
    ZoneVehiclesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ZoneVehiclesListQuery,
    ZoneVehiclesListQueryVariables
  >(ZoneVehiclesListDocument, options)
}
// @ts-ignore
export function useZoneVehiclesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneVehiclesListQuery,
    ZoneVehiclesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ZoneVehiclesListQuery,
  ZoneVehiclesListQueryVariables
>
export function useZoneVehiclesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneVehiclesListQuery,
        ZoneVehiclesListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZoneVehiclesListQuery | undefined,
  ZoneVehiclesListQueryVariables
>
export function useZoneVehiclesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneVehiclesListQuery,
        ZoneVehiclesListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ZoneVehiclesListQuery,
    ZoneVehiclesListQueryVariables
  >(ZoneVehiclesListDocument, options)
}
export type ZoneVehiclesListQueryHookResult = ReturnType<
  typeof useZoneVehiclesListQuery
>
export type ZoneVehiclesListLazyQueryHookResult = ReturnType<
  typeof useZoneVehiclesListLazyQuery
>
export type ZoneVehiclesListSuspenseQueryHookResult = ReturnType<
  typeof useZoneVehiclesListSuspenseQuery
>
export type ZoneVehiclesListQueryResult = Apollo.QueryResult<
  ZoneVehiclesListQuery,
  ZoneVehiclesListQueryVariables
>
export const VehiclesListDocument = gql`
  query VehiclesList(
    $scheme_id: ID
    $paginate: Paginate
    $is_mobile: Boolean!
    $lean_query: Boolean!
    $vehicle_lock_state: [VehicleLockState!]
    $vehicle_category: [VehicleCategory!]
    $vehicle_state: [VehicleState!]
    $frame_id__like: String
    $unlock_id__like: String
    $module_id__like: String
    $vehicle_id__like: String
    $frame_type: [FrameType!]
  ) {
    table: vehicles(
      scheme_id: $scheme_id
      paginate: $paginate
      vehicle_lock_state: $vehicle_lock_state
      vehicle_category: $vehicle_category
      vehicle_state: $vehicle_state
      frame_id__like: $frame_id__like
      unlock_id__like: $unlock_id__like
      module_id__like: $module_id__like
      vehicle_id__like: $vehicle_id__like
      frame_type: $frame_type
    ) {
      ...VehicleList
    }
  }
  ${VehicleListFragmentDoc}
`

/**
 * __useVehiclesListQuery__
 *
 * To run a query within a React component, call `useVehiclesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *      is_mobile: // value for 'is_mobile'
 *      lean_query: // value for 'lean_query'
 *      vehicle_lock_state: // value for 'vehicle_lock_state'
 *      vehicle_category: // value for 'vehicle_category'
 *      vehicle_state: // value for 'vehicle_state'
 *      frame_id__like: // value for 'frame_id__like'
 *      unlock_id__like: // value for 'unlock_id__like'
 *      module_id__like: // value for 'module_id__like'
 *      vehicle_id__like: // value for 'vehicle_id__like'
 *      frame_type: // value for 'frame_type'
 *   },
 * });
 */
export function useVehiclesListQuery(
  baseOptions: Apollo.QueryHookOptions<
    VehiclesListQuery,
    VehiclesListQueryVariables
  > &
    (
      | { variables: VehiclesListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VehiclesListQuery, VehiclesListQueryVariables>(
    VehiclesListDocument,
    options,
  )
}
export function useVehiclesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehiclesListQuery,
    VehiclesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VehiclesListQuery, VehiclesListQueryVariables>(
    VehiclesListDocument,
    options,
  )
}
// @ts-ignore
export function useVehiclesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehiclesListQuery,
    VehiclesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VehiclesListQuery, VehiclesListQueryVariables>
export function useVehiclesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehiclesListQuery,
        VehiclesListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehiclesListQuery | undefined,
  VehiclesListQueryVariables
>
export function useVehiclesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehiclesListQuery,
        VehiclesListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VehiclesListQuery, VehiclesListQueryVariables>(
    VehiclesListDocument,
    options,
  )
}
export type VehiclesListQueryHookResult = ReturnType<
  typeof useVehiclesListQuery
>
export type VehiclesListLazyQueryHookResult = ReturnType<
  typeof useVehiclesListLazyQuery
>
export type VehiclesListSuspenseQueryHookResult = ReturnType<
  typeof useVehiclesListSuspenseQuery
>
export type VehiclesListQueryResult = Apollo.QueryResult<
  VehiclesListQuery,
  VehiclesListQueryVariables
>
export const VehicleLegendDocument = gql`
  query VehicleLegend($module_id: ID!) {
    vehicle_by_module_id(module_id: $module_id) {
      ...VehicleLegendNode
    }
  }
  ${VehicleLegendNodeFragmentDoc}
`

/**
 * __useVehicleLegendQuery__
 *
 * To run a query within a React component, call `useVehicleLegendQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleLegendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleLegendQuery({
 *   variables: {
 *      module_id: // value for 'module_id'
 *   },
 * });
 */
export function useVehicleLegendQuery(
  baseOptions: Apollo.QueryHookOptions<
    VehicleLegendQuery,
    VehicleLegendQueryVariables
  > &
    (
      | { variables: VehicleLegendQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VehicleLegendQuery, VehicleLegendQueryVariables>(
    VehicleLegendDocument,
    options,
  )
}
export function useVehicleLegendLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehicleLegendQuery,
    VehicleLegendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VehicleLegendQuery, VehicleLegendQueryVariables>(
    VehicleLegendDocument,
    options,
  )
}
// @ts-ignore
export function useVehicleLegendSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehicleLegendQuery,
    VehicleLegendQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VehicleLegendQuery,
  VehicleLegendQueryVariables
>
export function useVehicleLegendSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleLegendQuery,
        VehicleLegendQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehicleLegendQuery | undefined,
  VehicleLegendQueryVariables
>
export function useVehicleLegendSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleLegendQuery,
        VehicleLegendQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    VehicleLegendQuery,
    VehicleLegendQueryVariables
  >(VehicleLegendDocument, options)
}
export type VehicleLegendQueryHookResult = ReturnType<
  typeof useVehicleLegendQuery
>
export type VehicleLegendLazyQueryHookResult = ReturnType<
  typeof useVehicleLegendLazyQuery
>
export type VehicleLegendSuspenseQueryHookResult = ReturnType<
  typeof useVehicleLegendSuspenseQuery
>
export type VehicleLegendQueryResult = Apollo.QueryResult<
  VehicleLegendQuery,
  VehicleLegendQueryVariables
>
export const ZoneSummaryDocument = gql`
  query ZoneSummary($id: ID!) {
    zone(zone_id: $id) {
      id
      ...ZoneName
      ...ZoneStatus
      ...ZoneCurrentSuspension
      ...FirstZoneScheduledSuspension
      centre
      capacity
      notes
      hireable_vehicles_count
      hireable_bikes: hireable_vehicles_count(
        vehicle_type: bike
        propulsion_type: human
      )
      hireable_ebikes: hireable_vehicles_count(
        vehicle_type: bike
        propulsion_type: electric_assist
      )
      hireable_scooters: hireable_vehicles_count(
        vehicle_type: scooter
        propulsion_type: electric
      )
      all_commissioned_modules_count
      bikes: all_commissioned_vehicles_count(
        vehicle_type: bike
        propulsion_type: human
      )
      ebikes: all_commissioned_vehicles_count(
        vehicle_type: bike
        propulsion_type: electric_assist
      )
      scooters: all_commissioned_vehicles_count(
        vehicle_type: scooter
        propulsion_type: electric
      )
      parking_capacity_status
      hiring_capacity_status
      permitted_vehicles
      docked_vehicles_count
      zone_type
    }
  }
  ${ZoneNameFragmentDoc}
  ${ZoneStatusFragmentDoc}
  ${ZoneCurrentSuspensionFragmentDoc}
  ${FirstZoneScheduledSuspensionFragmentDoc}
`

/**
 * __useZoneSummaryQuery__
 *
 * To run a query within a React component, call `useZoneSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoneSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZoneSummaryQuery,
    ZoneSummaryQueryVariables
  > &
    (
      | { variables: ZoneSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZoneSummaryQuery, ZoneSummaryQueryVariables>(
    ZoneSummaryDocument,
    options,
  )
}
export function useZoneSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneSummaryQuery,
    ZoneSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZoneSummaryQuery, ZoneSummaryQueryVariables>(
    ZoneSummaryDocument,
    options,
  )
}
// @ts-ignore
export function useZoneSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneSummaryQuery,
    ZoneSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZoneSummaryQuery, ZoneSummaryQueryVariables>
export function useZoneSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneSummaryQuery,
        ZoneSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZoneSummaryQuery | undefined,
  ZoneSummaryQueryVariables
>
export function useZoneSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneSummaryQuery,
        ZoneSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZoneSummaryQuery, ZoneSummaryQueryVariables>(
    ZoneSummaryDocument,
    options,
  )
}
export type ZoneSummaryQueryHookResult = ReturnType<typeof useZoneSummaryQuery>
export type ZoneSummaryLazyQueryHookResult = ReturnType<
  typeof useZoneSummaryLazyQuery
>
export type ZoneSummarySuspenseQueryHookResult = ReturnType<
  typeof useZoneSummarySuspenseQuery
>
export type ZoneSummaryQueryResult = Apollo.QueryResult<
  ZoneSummaryQuery,
  ZoneSummaryQueryVariables
>
export const ZoneDiffDocument = gql`
  query ZoneDiff($id: ID!) {
    zone(zone_id: $id) {
      id
      name
      centre
      capacity
      geom
      centre
      permitted_vehicles
      ...ZoneStatus
    }
  }
  ${ZoneStatusFragmentDoc}
`

/**
 * __useZoneDiffQuery__
 *
 * To run a query within a React component, call `useZoneDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneDiffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoneDiffQuery(
  baseOptions: Apollo.QueryHookOptions<ZoneDiffQuery, ZoneDiffQueryVariables> &
    ({ variables: ZoneDiffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZoneDiffQuery, ZoneDiffQueryVariables>(
    ZoneDiffDocument,
    options,
  )
}
export function useZoneDiffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneDiffQuery,
    ZoneDiffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZoneDiffQuery, ZoneDiffQueryVariables>(
    ZoneDiffDocument,
    options,
  )
}
// @ts-ignore
export function useZoneDiffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneDiffQuery,
    ZoneDiffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZoneDiffQuery, ZoneDiffQueryVariables>
export function useZoneDiffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZoneDiffQuery, ZoneDiffQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ZoneDiffQuery | undefined,
  ZoneDiffQueryVariables
>
export function useZoneDiffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZoneDiffQuery, ZoneDiffQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZoneDiffQuery, ZoneDiffQueryVariables>(
    ZoneDiffDocument,
    options,
  )
}
export type ZoneDiffQueryHookResult = ReturnType<typeof useZoneDiffQuery>
export type ZoneDiffLazyQueryHookResult = ReturnType<
  typeof useZoneDiffLazyQuery
>
export type ZoneDiffSuspenseQueryHookResult = ReturnType<
  typeof useZoneDiffSuspenseQuery
>
export type ZoneDiffQueryResult = Apollo.QueryResult<
  ZoneDiffQuery,
  ZoneDiffQueryVariables
>
export const ZoneHistoryChangesDocument = gql`
  query ZoneHistoryChanges($id: ID!, $page: Int = 1, $per_page: Int = 10) {
    zone_history_changes(
      zone_id: $id
      paginate: { page: $page, per_page: $per_page }
    ) {
      nodes {
        ...ZoneHistoryChangesNode
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
  }
  ${ZoneHistoryChangesNodeFragmentDoc}
`

/**
 * __useZoneHistoryChangesQuery__
 *
 * To run a query within a React component, call `useZoneHistoryChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneHistoryChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneHistoryChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useZoneHistoryChangesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZoneHistoryChangesQuery,
    ZoneHistoryChangesQueryVariables
  > &
    (
      | { variables: ZoneHistoryChangesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ZoneHistoryChangesQuery,
    ZoneHistoryChangesQueryVariables
  >(ZoneHistoryChangesDocument, options)
}
export function useZoneHistoryChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneHistoryChangesQuery,
    ZoneHistoryChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ZoneHistoryChangesQuery,
    ZoneHistoryChangesQueryVariables
  >(ZoneHistoryChangesDocument, options)
}
// @ts-ignore
export function useZoneHistoryChangesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneHistoryChangesQuery,
    ZoneHistoryChangesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ZoneHistoryChangesQuery,
  ZoneHistoryChangesQueryVariables
>
export function useZoneHistoryChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneHistoryChangesQuery,
        ZoneHistoryChangesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZoneHistoryChangesQuery | undefined,
  ZoneHistoryChangesQueryVariables
>
export function useZoneHistoryChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneHistoryChangesQuery,
        ZoneHistoryChangesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ZoneHistoryChangesQuery,
    ZoneHistoryChangesQueryVariables
  >(ZoneHistoryChangesDocument, options)
}
export type ZoneHistoryChangesQueryHookResult = ReturnType<
  typeof useZoneHistoryChangesQuery
>
export type ZoneHistoryChangesLazyQueryHookResult = ReturnType<
  typeof useZoneHistoryChangesLazyQuery
>
export type ZoneHistoryChangesSuspenseQueryHookResult = ReturnType<
  typeof useZoneHistoryChangesSuspenseQuery
>
export type ZoneHistoryChangesQueryResult = Apollo.QueryResult<
  ZoneHistoryChangesQuery,
  ZoneHistoryChangesQueryVariables
>
export const ZoneMapDocument = gql`
  query ZoneMap(
    $id: ID!
    $zone_id: String!
    $hasLocation: Boolean!
    $location: LocationAreaInput
  ) {
    zone(zone_id: $id) {
      ...ZoneName
      ...ZoneInfo
      ...ZoneStatus
      all_commissioned_vehicles {
        ...VehicleNode
      }
    }
    zones(location: $location, where: { id: { ne: $zone_id } })
      @include(if: $hasLocation) {
      nodes {
        ...ZoneName
        ...ZoneInfo
        ...ZoneStatus
      }
    }
  }
  ${ZoneNameFragmentDoc}
  ${ZoneInfoFragmentDoc}
  ${ZoneStatusFragmentDoc}
  ${VehicleNodeFragmentDoc}
`

/**
 * __useZoneMapQuery__
 *
 * To run a query within a React component, call `useZoneMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *      zone_id: // value for 'zone_id'
 *      hasLocation: // value for 'hasLocation'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useZoneMapQuery(
  baseOptions: Apollo.QueryHookOptions<ZoneMapQuery, ZoneMapQueryVariables> &
    ({ variables: ZoneMapQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZoneMapQuery, ZoneMapQueryVariables>(
    ZoneMapDocument,
    options,
  )
}
export function useZoneMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneMapQuery,
    ZoneMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZoneMapQuery, ZoneMapQueryVariables>(
    ZoneMapDocument,
    options,
  )
}
// @ts-ignore
export function useZoneMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneMapQuery,
    ZoneMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZoneMapQuery, ZoneMapQueryVariables>
export function useZoneMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZoneMapQuery, ZoneMapQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ZoneMapQuery | undefined,
  ZoneMapQueryVariables
>
export function useZoneMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZoneMapQuery, ZoneMapQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZoneMapQuery, ZoneMapQueryVariables>(
    ZoneMapDocument,
    options,
  )
}
export type ZoneMapQueryHookResult = ReturnType<typeof useZoneMapQuery>
export type ZoneMapLazyQueryHookResult = ReturnType<typeof useZoneMapLazyQuery>
export type ZoneMapSuspenseQueryHookResult = ReturnType<
  typeof useZoneMapSuspenseQuery
>
export type ZoneMapQueryResult = Apollo.QueryResult<
  ZoneMapQuery,
  ZoneMapQueryVariables
>
export const ZonesListDocument = gql`
  query ZonesList(
    $scheme_id: ID
    $paginate: Paginate
    $where: [ZoneWhere]
    $is_suspended: Boolean
  ) {
    table: all_zones(
      scheme_id: $scheme_id
      paginate: $paginate
      where: $where
      is_suspended: $is_suspended
    ) {
      nodes {
        id
        ...ZoneName
        ...ZoneStatus
        ...FirstZoneScheduledSuspension
        all_commissioned_modules_count
        hireable_vehicles_count
        capacity
        permitted_vehicles
        zone_type
      }
      pagination {
        current: page
        pageSize: per_page
        total
      }
    }
    enabled_zones: all_zones(scheme_id: $scheme_id, is_suspended: false) {
      pagination {
        total
      }
    }
    suspended_zones: all_zones(scheme_id: $scheme_id, is_suspended: true) {
      pagination {
        total
      }
    }
  }
  ${ZoneNameFragmentDoc}
  ${ZoneStatusFragmentDoc}
  ${FirstZoneScheduledSuspensionFragmentDoc}
`

/**
 * __useZonesListQuery__
 *
 * To run a query within a React component, call `useZonesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesListQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      paginate: // value for 'paginate'
 *      where: // value for 'where'
 *      is_suspended: // value for 'is_suspended'
 *   },
 * });
 */
export function useZonesListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ZonesListQuery,
    ZonesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZonesListQuery, ZonesListQueryVariables>(
    ZonesListDocument,
    options,
  )
}
export function useZonesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonesListQuery,
    ZonesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZonesListQuery, ZonesListQueryVariables>(
    ZonesListDocument,
    options,
  )
}
// @ts-ignore
export function useZonesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZonesListQuery,
    ZonesListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZonesListQuery, ZonesListQueryVariables>
export function useZonesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZonesListQuery, ZonesListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ZonesListQuery | undefined,
  ZonesListQueryVariables
>
export function useZonesListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZonesListQuery, ZonesListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZonesListQuery, ZonesListQueryVariables>(
    ZonesListDocument,
    options,
  )
}
export type ZonesListQueryHookResult = ReturnType<typeof useZonesListQuery>
export type ZonesListLazyQueryHookResult = ReturnType<
  typeof useZonesListLazyQuery
>
export type ZonesListSuspenseQueryHookResult = ReturnType<
  typeof useZonesListSuspenseQuery
>
export type ZonesListQueryResult = Apollo.QueryResult<
  ZonesListQuery,
  ZonesListQueryVariables
>
export const ZoneSuspensionsListDocument = gql`
  query ZoneSuspensionsList($zone_id: ID!) {
    zone(zone_id: $zone_id) {
      id
      ...ZoneCurrentSuspension
      ...ZoneScheduledSuspensions
    }
  }
  ${ZoneCurrentSuspensionFragmentDoc}
  ${ZoneScheduledSuspensionsFragmentDoc}
`

/**
 * __useZoneSuspensionsListQuery__
 *
 * To run a query within a React component, call `useZoneSuspensionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneSuspensionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneSuspensionsListQuery({
 *   variables: {
 *      zone_id: // value for 'zone_id'
 *   },
 * });
 */
export function useZoneSuspensionsListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZoneSuspensionsListQuery,
    ZoneSuspensionsListQueryVariables
  > &
    (
      | { variables: ZoneSuspensionsListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ZoneSuspensionsListQuery,
    ZoneSuspensionsListQueryVariables
  >(ZoneSuspensionsListDocument, options)
}
export function useZoneSuspensionsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneSuspensionsListQuery,
    ZoneSuspensionsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ZoneSuspensionsListQuery,
    ZoneSuspensionsListQueryVariables
  >(ZoneSuspensionsListDocument, options)
}
// @ts-ignore
export function useZoneSuspensionsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneSuspensionsListQuery,
    ZoneSuspensionsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ZoneSuspensionsListQuery,
  ZoneSuspensionsListQueryVariables
>
export function useZoneSuspensionsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneSuspensionsListQuery,
        ZoneSuspensionsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZoneSuspensionsListQuery | undefined,
  ZoneSuspensionsListQueryVariables
>
export function useZoneSuspensionsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneSuspensionsListQuery,
        ZoneSuspensionsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ZoneSuspensionsListQuery,
    ZoneSuspensionsListQueryVariables
  >(ZoneSuspensionsListDocument, options)
}
export type ZoneSuspensionsListQueryHookResult = ReturnType<
  typeof useZoneSuspensionsListQuery
>
export type ZoneSuspensionsListLazyQueryHookResult = ReturnType<
  typeof useZoneSuspensionsListLazyQuery
>
export type ZoneSuspensionsListSuspenseQueryHookResult = ReturnType<
  typeof useZoneSuspensionsListSuspenseQuery
>
export type ZoneSuspensionsListQueryResult = Apollo.QueryResult<
  ZoneSuspensionsListQuery,
  ZoneSuspensionsListQueryVariables
>
export const ZoneLegendDocument = gql`
  query ZoneLegend($zone_id: ID!) {
    zone(zone_id: $zone_id) {
      id
      name
      capacity
      geom
      all_commissioned_modules_count
      docked_vehicles_count
      zone_type
      ...ZoneStatus
      bikes: all_commissioned_vehicles_count(
        vehicle_type: bike
        propulsion_type: human
      )
      ebikes: all_commissioned_vehicles_count(
        vehicle_type: bike
        propulsion_type: electric_assist
      )
      scooters: all_commissioned_vehicles_count(
        vehicle_type: scooter
        propulsion_type: electric
      )
      all_commissioned_vehicles {
        id
        frame_id
        frame_type
        hardware_type
        detail {
          id
          module {
            id
            availability {
              id
              status
            }
          }
        }
      }
      scheme {
        id
      }
    }
  }
  ${ZoneStatusFragmentDoc}
`

/**
 * __useZoneLegendQuery__
 *
 * To run a query within a React component, call `useZoneLegendQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneLegendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneLegendQuery({
 *   variables: {
 *      zone_id: // value for 'zone_id'
 *   },
 * });
 */
export function useZoneLegendQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZoneLegendQuery,
    ZoneLegendQueryVariables
  > &
    (
      | { variables: ZoneLegendQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZoneLegendQuery, ZoneLegendQueryVariables>(
    ZoneLegendDocument,
    options,
  )
}
export function useZoneLegendLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneLegendQuery,
    ZoneLegendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZoneLegendQuery, ZoneLegendQueryVariables>(
    ZoneLegendDocument,
    options,
  )
}
// @ts-ignore
export function useZoneLegendSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneLegendQuery,
    ZoneLegendQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZoneLegendQuery, ZoneLegendQueryVariables>
export function useZoneLegendSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneLegendQuery,
        ZoneLegendQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZoneLegendQuery | undefined,
  ZoneLegendQueryVariables
>
export function useZoneLegendSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneLegendQuery,
        ZoneLegendQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZoneLegendQuery, ZoneLegendQueryVariables>(
    ZoneLegendDocument,
    options,
  )
}
export type ZoneLegendQueryHookResult = ReturnType<typeof useZoneLegendQuery>
export type ZoneLegendLazyQueryHookResult = ReturnType<
  typeof useZoneLegendLazyQuery
>
export type ZoneLegendSuspenseQueryHookResult = ReturnType<
  typeof useZoneLegendSuspenseQuery
>
export type ZoneLegendQueryResult = Apollo.QueryResult<
  ZoneLegendQuery,
  ZoneLegendQueryVariables
>
export const ZoneOptionsDocument = gql`
  query ZoneOptions($scheme_id: ID, $suspended: Boolean) {
    all_zones(
      scheme_id: $scheme_id
      is_suspended: $suspended
      paginate: { page: 1, per_page: 800 }
    ) {
      nodes {
        id
        ...ZoneName
        ...ZoneStatus
        zone_type
      }
    }
  }
  ${ZoneNameFragmentDoc}
  ${ZoneStatusFragmentDoc}
`

/**
 * __useZoneOptionsQuery__
 *
 * To run a query within a React component, call `useZoneOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneOptionsQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      suspended: // value for 'suspended'
 *   },
 * });
 */
export function useZoneOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ZoneOptionsQuery,
    ZoneOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZoneOptionsQuery, ZoneOptionsQueryVariables>(
    ZoneOptionsDocument,
    options,
  )
}
export function useZoneOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZoneOptionsQuery,
    ZoneOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZoneOptionsQuery, ZoneOptionsQueryVariables>(
    ZoneOptionsDocument,
    options,
  )
}
// @ts-ignore
export function useZoneOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZoneOptionsQuery,
    ZoneOptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZoneOptionsQuery, ZoneOptionsQueryVariables>
export function useZoneOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneOptionsQuery,
        ZoneOptionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZoneOptionsQuery | undefined,
  ZoneOptionsQueryVariables
>
export function useZoneOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZoneOptionsQuery,
        ZoneOptionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZoneOptionsQuery, ZoneOptionsQueryVariables>(
    ZoneOptionsDocument,
    options,
  )
}
export type ZoneOptionsQueryHookResult = ReturnType<typeof useZoneOptionsQuery>
export type ZoneOptionsLazyQueryHookResult = ReturnType<
  typeof useZoneOptionsLazyQuery
>
export type ZoneOptionsSuspenseQueryHookResult = ReturnType<
  typeof useZoneOptionsSuspenseQuery
>
export type ZoneOptionsQueryResult = Apollo.QueryResult<
  ZoneOptionsQuery,
  ZoneOptionsQueryVariables
>
export const ZonesMapDocument = gql`
  query ZonesMap($scheme_id: ID, $suspended: Boolean) {
    all_zones(
      scheme_id: $scheme_id
      is_suspended: $suspended
      paginate: { page: 1, per_page: 800 }
    ) {
      nodes {
        id
        ...ZoneName
        ...ZoneInfo
        ...ZoneStatus
      }
    }
  }
  ${ZoneNameFragmentDoc}
  ${ZoneInfoFragmentDoc}
  ${ZoneStatusFragmentDoc}
`

/**
 * __useZonesMapQuery__
 *
 * To run a query within a React component, call `useZonesMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesMapQuery({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      suspended: // value for 'suspended'
 *   },
 * });
 */
export function useZonesMapQuery(
  baseOptions?: Apollo.QueryHookOptions<ZonesMapQuery, ZonesMapQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ZonesMapQuery, ZonesMapQueryVariables>(
    ZonesMapDocument,
    options,
  )
}
export function useZonesMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonesMapQuery,
    ZonesMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ZonesMapQuery, ZonesMapQueryVariables>(
    ZonesMapDocument,
    options,
  )
}
// @ts-ignore
export function useZonesMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZonesMapQuery,
    ZonesMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ZonesMapQuery, ZonesMapQueryVariables>
export function useZonesMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZonesMapQuery, ZonesMapQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ZonesMapQuery | undefined,
  ZonesMapQueryVariables
>
export function useZonesMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ZonesMapQuery, ZonesMapQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ZonesMapQuery, ZonesMapQueryVariables>(
    ZonesMapDocument,
    options,
  )
}
export type ZonesMapQueryHookResult = ReturnType<typeof useZonesMapQuery>
export type ZonesMapLazyQueryHookResult = ReturnType<
  typeof useZonesMapLazyQuery
>
export type ZonesMapSuspenseQueryHookResult = ReturnType<
  typeof useZonesMapSuspenseQuery
>
export type ZonesMapQueryResult = Apollo.QueryResult<
  ZonesMapQuery,
  ZonesMapQueryVariables
>
export const ZoneEnableDocument = gql`
  mutation ZoneEnable($id: ID!) {
    updated_zone: enable_zone(zone_id: $id) {
      id
    }
  }
`
export type ZoneEnableMutationFn = Apollo.MutationFunction<
  ZoneEnableMutation,
  ZoneEnableMutationVariables
>

/**
 * __useZoneEnableMutation__
 *
 * To run a mutation, you first call `useZoneEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoneEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoneEnableMutation, { data, loading, error }] = useZoneEnableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoneEnableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZoneEnableMutation,
    ZoneEnableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ZoneEnableMutation, ZoneEnableMutationVariables>(
    ZoneEnableDocument,
    options,
  )
}
export type ZoneEnableMutationHookResult = ReturnType<
  typeof useZoneEnableMutation
>
export type ZoneEnableMutationResult = Apollo.MutationResult<ZoneEnableMutation>
export type ZoneEnableMutationOptions = Apollo.BaseMutationOptions<
  ZoneEnableMutation,
  ZoneEnableMutationVariables
>
export const ZoneSuspendDocument = gql`
  mutation ZoneSuspend($id: ID!) {
    updated_zone: suspend_zone(zone_id: $id) {
      id
    }
  }
`
export type ZoneSuspendMutationFn = Apollo.MutationFunction<
  ZoneSuspendMutation,
  ZoneSuspendMutationVariables
>

/**
 * __useZoneSuspendMutation__
 *
 * To run a mutation, you first call `useZoneSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoneSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoneSuspendMutation, { data, loading, error }] = useZoneSuspendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZoneSuspendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZoneSuspendMutation,
    ZoneSuspendMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ZoneSuspendMutation, ZoneSuspendMutationVariables>(
    ZoneSuspendDocument,
    options,
  )
}
export type ZoneSuspendMutationHookResult = ReturnType<
  typeof useZoneSuspendMutation
>
export type ZoneSuspendMutationResult =
  Apollo.MutationResult<ZoneSuspendMutation>
export type ZoneSuspendMutationOptions = Apollo.BaseMutationOptions<
  ZoneSuspendMutation,
  ZoneSuspendMutationVariables
>
export const ZoneSuspendWithReasonDocument = gql`
  mutation ZoneSuspendWithReason(
    $id: ID!
    $suspension_reason: ZoneSuspensionInfoInput!
  ) {
    suspend_zone_with_reason(
      zone_id: $id
      suspension_reason: $suspension_reason
    ) {
      id
      current_suspension {
        id
        author_id
        scheme_id
        reason
        notes
      }
    }
  }
`
export type ZoneSuspendWithReasonMutationFn = Apollo.MutationFunction<
  ZoneSuspendWithReasonMutation,
  ZoneSuspendWithReasonMutationVariables
>

/**
 * __useZoneSuspendWithReasonMutation__
 *
 * To run a mutation, you first call `useZoneSuspendWithReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoneSuspendWithReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoneSuspendWithReasonMutation, { data, loading, error }] = useZoneSuspendWithReasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      suspension_reason: // value for 'suspension_reason'
 *   },
 * });
 */
export function useZoneSuspendWithReasonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZoneSuspendWithReasonMutation,
    ZoneSuspendWithReasonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ZoneSuspendWithReasonMutation,
    ZoneSuspendWithReasonMutationVariables
  >(ZoneSuspendWithReasonDocument, options)
}
export type ZoneSuspendWithReasonMutationHookResult = ReturnType<
  typeof useZoneSuspendWithReasonMutation
>
export type ZoneSuspendWithReasonMutationResult =
  Apollo.MutationResult<ZoneSuspendWithReasonMutation>
export type ZoneSuspendWithReasonMutationOptions = Apollo.BaseMutationOptions<
  ZoneSuspendWithReasonMutation,
  ZoneSuspendWithReasonMutationVariables
>
export const ZoneScheduledSuspendDocument = gql`
  mutation ZoneScheduledSuspend(
    $end_time: DateTime!
    $reason: ZoneSuspensionReasonInput!
    $notes: String
    $scheme_id: ID!
    $start_time: DateTime!
    $zone_ids: [ID]!
  ) {
    create_scheduled_zone_suspension(
      input: {
        end_time: $end_time
        notes: $notes
        reason: $reason
        scheme_id: $scheme_id
        start_time: $start_time
        zone_ids: $zone_ids
      }
    ) {
      id
      author_id
      scheme_id
      reason
      notes
      start_time
      end_time
      schedule_status
      status_updated_at
    }
  }
`
export type ZoneScheduledSuspendMutationFn = Apollo.MutationFunction<
  ZoneScheduledSuspendMutation,
  ZoneScheduledSuspendMutationVariables
>

/**
 * __useZoneScheduledSuspendMutation__
 *
 * To run a mutation, you first call `useZoneScheduledSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoneScheduledSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoneScheduledSuspendMutation, { data, loading, error }] = useZoneScheduledSuspendMutation({
 *   variables: {
 *      end_time: // value for 'end_time'
 *      reason: // value for 'reason'
 *      notes: // value for 'notes'
 *      scheme_id: // value for 'scheme_id'
 *      start_time: // value for 'start_time'
 *      zone_ids: // value for 'zone_ids'
 *   },
 * });
 */
export function useZoneScheduledSuspendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZoneScheduledSuspendMutation,
    ZoneScheduledSuspendMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ZoneScheduledSuspendMutation,
    ZoneScheduledSuspendMutationVariables
  >(ZoneScheduledSuspendDocument, options)
}
export type ZoneScheduledSuspendMutationHookResult = ReturnType<
  typeof useZoneScheduledSuspendMutation
>
export type ZoneScheduledSuspendMutationResult =
  Apollo.MutationResult<ZoneScheduledSuspendMutation>
export type ZoneScheduledSuspendMutationOptions = Apollo.BaseMutationOptions<
  ZoneScheduledSuspendMutation,
  ZoneScheduledSuspendMutationVariables
>
export const ZoneSetPromotionalDocument = gql`
  mutation ZoneSetPromotional($id: ID!, $is_promotional: Boolean!) {
    updated_zone: set_zone_promotional(
      zone_id: $id
      is_promotional: $is_promotional
    ) {
      id
    }
  }
`
export type ZoneSetPromotionalMutationFn = Apollo.MutationFunction<
  ZoneSetPromotionalMutation,
  ZoneSetPromotionalMutationVariables
>

/**
 * __useZoneSetPromotionalMutation__
 *
 * To run a mutation, you first call `useZoneSetPromotionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoneSetPromotionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoneSetPromotionalMutation, { data, loading, error }] = useZoneSetPromotionalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_promotional: // value for 'is_promotional'
 *   },
 * });
 */
export function useZoneSetPromotionalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZoneSetPromotionalMutation,
    ZoneSetPromotionalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ZoneSetPromotionalMutation,
    ZoneSetPromotionalMutationVariables
  >(ZoneSetPromotionalDocument, options)
}
export type ZoneSetPromotionalMutationHookResult = ReturnType<
  typeof useZoneSetPromotionalMutation
>
export type ZoneSetPromotionalMutationResult =
  Apollo.MutationResult<ZoneSetPromotionalMutation>
export type ZoneSetPromotionalMutationOptions = Apollo.BaseMutationOptions<
  ZoneSetPromotionalMutation,
  ZoneSetPromotionalMutationVariables
>
export const ZoneSetPriorityDocument = gql`
  mutation ZoneSetPriority($id: ID!, $is_priority: Boolean!) {
    updated_zone: set_zone_priority(zone_id: $id, is_priority: $is_priority) {
      id
    }
  }
`
export type ZoneSetPriorityMutationFn = Apollo.MutationFunction<
  ZoneSetPriorityMutation,
  ZoneSetPriorityMutationVariables
>

/**
 * __useZoneSetPriorityMutation__
 *
 * To run a mutation, you first call `useZoneSetPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoneSetPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoneSetPriorityMutation, { data, loading, error }] = useZoneSetPriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_priority: // value for 'is_priority'
 *   },
 * });
 */
export function useZoneSetPriorityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZoneSetPriorityMutation,
    ZoneSetPriorityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ZoneSetPriorityMutation,
    ZoneSetPriorityMutationVariables
  >(ZoneSetPriorityDocument, options)
}
export type ZoneSetPriorityMutationHookResult = ReturnType<
  typeof useZoneSetPriorityMutation
>
export type ZoneSetPriorityMutationResult =
  Apollo.MutationResult<ZoneSetPriorityMutation>
export type ZoneSetPriorityMutationOptions = Apollo.BaseMutationOptions<
  ZoneSetPriorityMutation,
  ZoneSetPriorityMutationVariables
>
export const ZonesSyncDocument = gql`
  mutation ZonesSync($scheme_id: ID!, $dry_run: Boolean) {
    sync_zones(scheme_id: $scheme_id, dry_run: $dry_run) {
      added {
        capacity
        geom
        centre
        permitted_vehicles
        zone_type
        ... on DraftZone {
          name
        }
      }
      updated {
        id
        name
        capacity
        geom
        centre
        permitted_vehicles
        zone_type
      }
      deleted {
        capacity
        geom
        centre
        permitted_vehicles
        zone_type
        ... on Zone {
          id
          name
        }
      }
    }
  }
`
export type ZonesSyncMutationFn = Apollo.MutationFunction<
  ZonesSyncMutation,
  ZonesSyncMutationVariables
>

/**
 * __useZonesSyncMutation__
 *
 * To run a mutation, you first call `useZonesSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZonesSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zonesSyncMutation, { data, loading, error }] = useZonesSyncMutation({
 *   variables: {
 *      scheme_id: // value for 'scheme_id'
 *      dry_run: // value for 'dry_run'
 *   },
 * });
 */
export function useZonesSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ZonesSyncMutation,
    ZonesSyncMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ZonesSyncMutation, ZonesSyncMutationVariables>(
    ZonesSyncDocument,
    options,
  )
}
export type ZonesSyncMutationHookResult = ReturnType<
  typeof useZonesSyncMutation
>
export type ZonesSyncMutationResult = Apollo.MutationResult<ZonesSyncMutation>
export type ZonesSyncMutationOptions = Apollo.BaseMutationOptions<
  ZonesSyncMutation,
  ZonesSyncMutationVariables
>
